import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  accountSettings: AccountSettings;
  accountSettingsId: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dataWarehouse?: Maybe<DataWarehouse>;
  dataWarehouseConnectionId?: Maybe<Scalars['String']['output']>;
  dataWarehouseSubTitle?: Maybe<Scalars['String']['output']>;
  dataWarehouseTitle?: Maybe<Scalars['String']['output']>;
  deletedAt: Scalars['DateTime']['output'];
  domain?: Maybe<Scalars['String']['output']>;
  dwhFairUsageViolatedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isTest: Scalars['Boolean']['output'];
  members: Array<AccountMember>;
  name?: Maybe<Scalars['String']['output']>;
  notificationEmails: Array<Scalars['String']['output']>;
  scheduledForDeletionAt?: Maybe<Scalars['DateTime']['output']>;
  slackNotificationInfo?: Maybe<SlackNotificationInfo>;
  slug: Scalars['String']['output'];
  stripeCustomer?: Maybe<Customer>;
  stripeSubscription?: Maybe<StripeSubscription>;
  trialEndsAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AccountMember = {
  __typename?: 'AccountMember';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  role: Role;
};

export type AccountSettings = {
  __typename?: 'AccountSettings';
  deactivateELTSyncs: Scalars['Boolean']['output'];
  deactivateReverseELTSyncs: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  maxBillableRows?: Maybe<Scalars['Float']['output']>;
};

export type AccountUsageSummary = {
  __typename?: 'AccountUsageSummary';
  connectors: Scalars['Float']['output'];
  eltSyncs: Scalars['Float']['output'];
  reverseEtlSyncs: Scalars['Float']['output'];
  uniqueIntegrationIds: Array<Scalars['String']['output']>;
};

export type ActivateError = {
  __typename?: 'ActivateError';
  error: Scalars['String']['output'];
  objectId: Scalars['String']['output'];
  scheduledJobId: Scalars['String']['output'];
  syncId: Scalars['String']['output'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type AliasMetadata = {
  __typename?: 'AliasMetadata';
  documentationUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ApiKeyResponse = {
  __typename?: 'ApiKeyResponse';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum AsyncJobStatusEnum {
  Cancelled = 'cancelled',
  Done = 'done',
  Empty = 'empty',
  Error = 'error',
  Processing = 'processing'
}

export type AsyncQueryResultResponse = {
  __typename?: 'AsyncQueryResultResponse';
  numRowsTotal: Scalars['Int']['output'];
  rows: Array<Scalars['JSONObject']['output']>;
};

export type AsyncQueryStatusResponse = {
  __typename?: 'AsyncQueryStatusResponse';
  status: QueryResultStatusEnum;
};

export type AsyncStreamsStatus = {
  __typename?: 'AsyncStreamsStatus';
  errorMessage?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['Float']['output']>;
  status: AsyncJobStatusEnum;
  streams?: Maybe<Array<Stream>>;
};

export type AttachEltTemplateInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  eltSyncId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};

export enum AuditLogType {
  Auth = 'AUTH',
  Operations = 'OPERATIONS'
}

export type AvailableAuditLog = {
  __typename?: 'AvailableAuditLog';
  count: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  type: AuditLogType;
};

export type AvailableIntegration = {
  __typename?: 'AvailableIntegration';
  abilities: Array<IntegrationAbility>;
  activateDestination?: Maybe<DataConnectorMetadata>;
  aliasFor?: Maybe<Scalars['String']['output']>;
  aliasMetadata?: Maybe<AliasMetadata>;
  baseId: Scalars['String']['output'];
  biTool?: Maybe<DataConnectorMetadata>;
  categories: Array<Scalars['String']['output']>;
  config?: Maybe<IntegrationConfiguration>;
  dataWarehouse?: Maybe<DataConnectorMetadata>;
  description: Scalars['String']['output'];
  documentationUrl?: Maybe<Scalars['String']['output']>;
  eltSource?: Maybe<DataConnectorMetadata>;
  id: Scalars['String']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isUtilityConnector: Scalars['Boolean']['output'];
  logo: IntegrationLogoVariants;
  meetsPlanRequirement: Scalars['Boolean']['output'];
  minRequiredPlan?: Maybe<PlanName>;
  name: Scalars['String']['output'];
  requiresAdmin?: Maybe<Scalars['Boolean']['output']>;
};

export type AvroSchemaFieldDto = {
  __typename?: 'AvroSchemaFieldDto';
  name: Scalars['String']['output'];
  nullable: Scalars['Boolean']['output'];
  type: Array<Scalars['String']['output']>;
};

export type BqUsage = {
  __typename?: 'BQUsage';
  bqBilledUsd: Scalars['Float']['output'];
  datasetId: Scalars['String']['output'];
  metabaseUsage?: Maybe<QueryUsage>;
  path: Scalars['String']['output'];
  queryUsage?: Maybe<QueryUsage>;
  tableId: Scalars['String']['output'];
  totalBytesBilled: Scalars['Float']['output'];
  totalBytesProcessed: Scalars['Float']['output'];
};

export type BackofficeConnection = {
  __typename?: 'BackofficeConnection';
  active: Scalars['Boolean']['output'];
  connectedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  eltSyncs: Array<BackofficeEltSync>;
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  label: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BackofficeEltSync = {
  __typename?: 'BackofficeEltSync';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  destinationConnectionId: Scalars['String']['output'];
  destinationIntegrationId: Scalars['String']['output'];
  destinationSchemaName?: Maybe<Scalars['String']['output']>;
  flaggedForGCPMigration: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  migrationResult: EltSyncMigrationResult;
  operationMode: Scalars['String']['output'];
  sourceConnectionId: Scalars['String']['output'];
  sourceIntegrationId: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  syncInterval?: Maybe<Scalars['String']['output']>;
  targetCloudProvider: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BackofficeSyncStats = {
  __typename?: 'BackofficeSyncStats';
  numBillableRows: Scalars['Float']['output'];
  numRowsSynced: Scalars['Float']['output'];
};

export type BackofficeWorkspaceUsageStats = {
  __typename?: 'BackofficeWorkspaceUsageStats';
  date: Scalars['DateTime']['output'];
  elt: BackofficeSyncStats;
  numBillableRows: Scalars['Float']['output'];
  numRowsSynced: Scalars['Float']['output'];
  reverseElt: BackofficeSyncStats;
};

export type BaseProduct = {
  __typename?: 'BaseProduct';
  active: Scalars['Boolean']['output'];
  addOnType?: Maybe<WeldAddOnType>;
  description?: Maybe<Scalars['String']['output']>;
  features: StripePlanFeatures;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: WeldProductType;
};

export type BatchJobStatus = {
  __typename?: 'BatchJobStatus';
  runDuration: Scalars['JSONObject']['output'];
  state: Scalars['String']['output'];
  statusEvents: Array<BatchJobStatusLogEntry>;
};

export type BatchJobStatusLogEntry = {
  __typename?: 'BatchJobStatusLogEntry';
  description: Scalars['String']['output'];
  eventTime: Scalars['JSONObject']['output'];
  taskExecution?: Maybe<Scalars['String']['output']>;
  taskState: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type BestFitPlan = {
  __typename?: 'BestFitPlan';
  integrationIds: Array<Scalars['String']['output']>;
  plan: WeldPlan;
  workspaceStats: WorkspaceStats;
};

export type BigQueryStats = {
  __typename?: 'BigQueryStats';
  data: Array<BqUsage>;
};

export type BillingDetailsInput = {
  address: AddressInput;
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export enum BillingScheme {
  PerUnit = 'PerUnit',
  Tiered = 'Tiered'
}

export type CancelSubscriptionInput = {
  cancellationDetails?: InputMaybe<CancellationDetails>;
  limitUsageToCurrentTier?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionId: Scalars['String']['input'];
};

export type CancelSubscriptionResponse = {
  __typename?: 'CancelSubscriptionResponse';
  id: Scalars['String']['output'];
};

export type CancellationDetails = {
  comment?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<CancellationFeedback>;
};

export enum CancellationFeedback {
  CustomerService = 'CustomerService',
  LowQuality = 'LowQuality',
  MissingFeatures = 'MissingFeatures',
  Other = 'Other',
  SwitchedService = 'SwitchedService',
  TooComplex = 'TooComplex',
  TooExpensive = 'TooExpensive',
  Unused = 'Unused'
}

export type Card = {
  __typename?: 'Card';
  brand: CardBrand;
  expirationMonth: Scalars['Int']['output'];
  expirationYear: Scalars['Int']['output'];
  last4: Scalars['String']['output'];
};

export enum CardBrand {
  Amex = 'Amex',
  Diners = 'Diners',
  Discover = 'Discover',
  Jcb = 'JCB',
  Mastercard = 'Mastercard',
  UnionPay = 'UnionPay',
  Unknown = 'Unknown',
  Visa = 'Visa'
}

export type ChatMessage = {
  __typename?: 'ChatMessage';
  accountId: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  role: ChatRole;
  threadId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export enum ChatRole {
  Assistant = 'Assistant',
  System = 'System',
  User = 'User'
}

export type ChatThread = {
  __typename?: 'ChatThread';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  initialModelContext?: Maybe<Scalars['JSONObject']['output']>;
  numMessages: Scalars['Float']['output'];
  tableReferences: Scalars['JSONObject']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Config = {
  __typename?: 'Config';
  destinationSettings?: Maybe<Scalars['JSONObject']['output']>;
};

export type ConfigurableLimits = {
  __typename?: 'ConfigurableLimits';
  maxConnectors?: Maybe<Scalars['Float']['output']>;
  maxUsers?: Maybe<Scalars['Float']['output']>;
};

export type Connection = {
  __typename?: 'Connection';
  active: Scalars['Boolean']['output'];
  connectedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  credentials: Scalars['JSONObject']['output'];
  customInput?: Maybe<Scalars['JSONObject']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  eltSyncs: Array<EltSync>;
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  label: Scalars['String']['output'];
  reverseEltSyncs: Array<Sync>;
  updatedAt: Scalars['DateTime']['output'];
  usageSummary: ConnectionUsageSummary;
  user?: Maybe<User>;
};

export type ConnectionBridgeResponse = {
  __typename?: 'ConnectionBridgeResponse';
  authorizeUrl: Scalars['String']['output'];
  connectionId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type ConnectionUsageSummary = {
  __typename?: 'ConnectionUsageSummary';
  numEltSyncs: Scalars['Int']['output'];
  numRevEltSyncs: Scalars['Int']['output'];
  totalSyncs: Scalars['Int']['output'];
};

export type ConnectorMetadata = {
  __typename?: 'ConnectorMetadata';
  isAvailable: Scalars['Boolean']['output'];
  isListedOnWebsite: Scalars['Boolean']['output'];
  minRequiredPlan?: Maybe<PlanName>;
  status?: Maybe<DevStatus>;
  tags: Array<Scalars['String']['output']>;
};

export type ConnectorPlanValidationResult = {
  __typename?: 'ConnectorPlanValidationResult';
  connectionCount: Scalars['Float']['output'];
  dataWarehouseViolation?: Maybe<ConnectorPlanViolation>;
  isConnectorLimitExceeded: Scalars['Boolean']['output'];
  maxConnections: Scalars['Float']['output'];
  valid: Scalars['Boolean']['output'];
  violations: Array<ConnectorPlanViolation>;
};

export type ConnectorPlanViolation = {
  __typename?: 'ConnectorPlanViolation';
  id: Scalars['String']['output'];
  minRequiredPlan: PlanName;
  name: Scalars['String']['output'];
};

export enum ConnectorType {
  ActivateDestination = 'ACTIVATE_DESTINATION',
  BiTool = 'BI_TOOL',
  DataWarehouse = 'DATA_WAREHOUSE',
  EltSource = 'ELT_SOURCE',
  Utility = 'UTILITY'
}

export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  dial_code: Scalars['String']['output'];
  emoji: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CreateAccountInput = {
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateApiKeyInput = {
  name: Scalars['String']['input'];
};

export type CreateAsyncQueryPreviewResponse = {
  __typename?: 'CreateAsyncQueryPreviewResponse';
  dwSql: Scalars['String']['output'];
  queryExecutionId: Scalars['String']['output'];
};

export type CreateConnectionBridgeInput = {
  connectionId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

export type CreateConnectionInput = {
  integrationId: Scalars['String']['input'];
  label: Scalars['String']['input'];
  payload: Scalars['String']['input'];
};

export type CreateDraftModelInput = {
  dashboardId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sourceConnectionId: Scalars['String']['input'];
  weldSql: Scalars['String']['input'];
};

export type CreateEltSyncInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  destinationConnectionId: Scalars['String']['input'];
  destinationSchemaName?: InputMaybe<Scalars['String']['input']>;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  schedulerType?: OrchestrationSchedulerType;
  sourceConnectionId: Scalars['String']['input'];
  sourceStreams: Array<SourceStreamInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  syncInterval?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExampleConnectionInput = {
  SampleDataName: ExampleDatabaseTypes;
};

export type CreateFolderInput = {
  DWName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFromTemplateInput = {
  dependencies: Array<QueryDependencyInput>;
  modelFolderId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sourceConnectionId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  weldSql: Scalars['String']['input'];
};

export type CreateManagedWorkspaceInput = {
  dataWarehouseLocation: Scalars['String']['input'];
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceName: Scalars['String']['input'];
};

export type CreateMappingInput = {
  destinationPropertyId: Scalars['String']['input'];
  destinationPropertyName: Scalars['String']['input'];
  destinationPropertyType: Scalars['String']['input'];
  object: Scalars['String']['input'];
  operation: OperationModes;
  primaryKey: Scalars['Boolean']['input'];
  readonly: Scalars['Boolean']['input'];
  sourcePropertyId: Scalars['String']['input'];
  sourcePropertyName: Scalars['String']['input'];
  sourcePropertyType: Scalars['String']['input'];
  type: OperationTypes;
};

export type CreateModelTestInput = {
  column: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  testType: TestType;
};

export type CreateNotificationInput = {
  accountId: Scalars['String']['input'];
  accountName: Scalars['String']['input'];
  detail: Array<Scalars['JSONObject']['input']>;
  entityId: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  entityType: NotificationEntityType;
  eventId?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
  isDismissable?: Scalars['Boolean']['input'];
  isLock?: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  notificationLevel: Scalars['String']['input'];
  show?: Scalars['Boolean']['input'];
  source: NotificationSources;
  type: Scalars['String']['input'];
};

export type CreateOAuthFlowInput = {
  connectionId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['String']['input'];
  payload: Scalars['String']['input'];
};

export type CreateOperationInput = {
  id: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
  mappings: Array<CreateMappingInput>;
  objectType: Scalars['String']['input'];
};

export type CreateOrUpdateCustomerInput = {
  address: AddressInput;
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  taxIdData?: InputMaybe<TaxIdInput>;
};

export type CreatePaymentMethodCheckoutSessionInput = {
  cancelUrl: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
};

export type CreateSetupIntentResponse = {
  __typename?: 'CreateSetupIntentResponse';
  clientSecret: Scalars['String']['output'];
};

export type CreateSubscriptionResponse = {
  __typename?: 'CreateSubscriptionResponse';
  id: Scalars['String']['output'];
};

export type CreateSyncInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  destinationConnectionId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  operations: Array<CreateOperationInput>;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  primaryObject: Scalars['String']['input'];
  schedulerType?: OrchestrationSchedulerType;
  sourceConnectionId: Scalars['String']['input'];
  syncInterval?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWebhookInput = {
  data: Scalars['JSONObject']['input'];
  dependencies: Array<DependencyInput>;
  externalSystem: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orchestrationWorkflowId?: InputMaybe<Scalars['String']['input']>;
};

export type CurrencyOption = {
  __typename?: 'CurrencyOption';
  currency: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  tiers?: Maybe<Array<Tier>>;
};

export type CurrentUser = {
  __typename?: 'CurrentUser';
  accounts?: Maybe<Array<Account>>;
  email: Scalars['String']['output'];
  emailValidated: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  role?: Maybe<Scalars['String']['output']>;
  weldSuperAdmin?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomFormInput = {
  connectionId: Scalars['String']['input'];
  dependencies: Scalars['String']['input'];
};

export type CustomFormValidationInput = {
  connectionId: Scalars['String']['input'];
  payload: Scalars['String']['input'];
};

export type CustomFormValidationResult = {
  __typename?: 'CustomFormValidationResult';
  customFormValidationResult: Scalars['JSONObject']['output'];
};

export type CustomFormValues = {
  __typename?: 'CustomFormValues';
  customFormValues: Scalars['JSONObject']['output'];
};

export type Customer = {
  __typename?: 'Customer';
  accountId: Scalars['String']['output'];
  address?: Maybe<Address>;
  companyName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  defaultPaymentMethod?: Maybe<PaymentMethod>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  taxId?: Maybe<TaxId>;
};

export enum DwMigrationStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Started = 'STARTED',
  SyncingData = 'SYNCING_DATA',
  SyncingModels = 'SYNCING_MODELS'
}

export type DataColoumn = {
  __typename?: 'DataColoumn';
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DataConnectorMetadata = {
  __typename?: 'DataConnectorMetadata';
  isAvailable: Scalars['Boolean']['output'];
  isListedOnWebsite: Scalars['Boolean']['output'];
  minRequiredPlan?: Maybe<PlanName>;
  status: DevStatus;
  tags: Array<Scalars['String']['output']>;
};

export type DataSchema = {
  __typename?: 'DataSchema';
  name: Scalars['String']['output'];
  nullable: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type DataWarehouse = {
  __typename?: 'DataWarehouse';
  connectionId: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  subTitle?: Maybe<Scalars['String']['output']>;
  supportsAsyncQuery: Scalars['Boolean']['output'];
  supportsMaterializedTable: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type DatawarehouseMigration = {
  __typename?: 'DatawarehouseMigration';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pendingSyncs: Array<Scalars['String']['output']>;
  prevDWIntegrationId: Scalars['String']['output'];
  status: DwMigrationStatus;
  userId: Scalars['String']['output'];
};

export enum DeleteAccountFeedback {
  CustomerService = 'CustomerService',
  LowQuality = 'LowQuality',
  MissingFeatures = 'MissingFeatures',
  Other = 'Other',
  SwitchedService = 'SwitchedService',
  TooComplex = 'TooComplex',
  TooExpensive = 'TooExpensive',
  Unused = 'Unused'
}

export type DeleteAccountInput = {
  deletionDetails?: InputMaybe<DeletionDetails>;
  id: Scalars['String']['input'];
};

export type DeletionDetails = {
  comment?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<DeleteAccountFeedback>;
};

export type DependencyInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export enum DependencyType {
  EltSync = 'elt_sync',
  MaterializedTable = 'materialized_table',
  MissingReference = 'missing_reference',
  ModelView = 'model_view',
  RawView = 'raw_view',
  ReverseEltSync = 'reverse_elt_sync',
  SourceStream = 'source_stream'
}

/** Destination object type settings that needs to be selected */
export type DestinationObjectTypeSettings = {
  __typename?: 'DestinationObjectTypeSettings';
  settings?: Maybe<Scalars['JSONObject']['output']>;
};

export type DestinationPropertiesInput = {
  destinationConnectionId: Scalars['String']['input'];
  modelId?: InputMaybe<Scalars['String']['input']>;
  objectType: Scalars['String']['input'];
  operationMode: Scalars['String']['input'];
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DevStatus {
  Beta = 'Beta',
  None = 'None',
  Production = 'Production'
}

export type DevStatusInput = {
  devNotes: Scalars['String']['input'];
  devStatus: Scalars['String']['input'];
  eltSyncId: Scalars['String']['input'];
  scheduledJobId: Scalars['String']['input'];
};

export type Directory = {
  __typename?: 'Directory';
  children: Array<Scalars['String']['output']>;
  hasNext: Scalars['Boolean']['output'];
  typename: Scalars['String']['output'];
};

export type DiscountItem = {
  __typename?: 'DiscountItem';
  amount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type DwDirectoryItem = {
  __typename?: 'DwDirectoryItem';
  error?: Maybe<Scalars['String']['output']>;
  path: Array<Scalars['String']['output']>;
};

export type EltConfig = {
  __typename?: 'EltConfig';
  sourceSettings?: Maybe<Scalars['JSONObject']['output']>;
};

export type EltFromTemplateInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  sourceConnectionId: Scalars['String']['input'];
  sourceIntegrationId: Scalars['String']['input'];
  sourceStreams: Array<SourceStreamInput>;
  syncInterval: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};

export type EltPartialConfig = {
  __typename?: 'EltPartialConfig';
  destinationSchemaName?: Maybe<Scalars['String']['output']>;
  sourceStreams: Array<TemplateSourceStream>;
};

export type EltSync = {
  __typename?: 'EltSync';
  account?: Maybe<Account>;
  accountId: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  config?: Maybe<EltConfig>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  destinationConnection?: Maybe<Connection>;
  destinationConnectionId: Scalars['String']['output'];
  destinationIntegrationId: Scalars['String']['output'];
  destinationSchemaName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  operationMode: Scalars['String']['output'];
  orchestrationWorkflow?: Maybe<OrchestrationWorkflow>;
  schedulerType: OrchestrationSchedulerType;
  sourceConnection?: Maybe<Connection>;
  sourceConnectionId: Scalars['String']['output'];
  sourceIntegrationId: Scalars['String']['output'];
  sourceStreams: Array<SourceStream>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  syncInterval?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EltSyncHistoryStat = {
  __typename?: 'EltSyncHistoryStat';
  details?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  estimatedTotalCount?: Maybe<Scalars['Float']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  fullSyncTrigger: FullSyncTrigger;
  isChunk?: Maybe<Scalars['Boolean']['output']>;
  operationMode?: Maybe<OperationMode>;
  rowsSynced: Scalars['Int']['output'];
  rowsSyncedMb: Scalars['Float']['output'];
  sourceStreamName?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<SyncJobStatus>;
};

export type EltSyncHistoryStatsResponse = {
  __typename?: 'EltSyncHistoryStatsResponse';
  limit?: Maybe<Scalars['Int']['output']>;
  stats: Array<EltSyncHistoryStat>;
};

export type EltSyncJobResponse = {
  __typename?: 'EltSyncJobResponse';
  accountId?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['JSONObject']['output']>;
  destinationIntegrationId?: Maybe<Scalars['String']['output']>;
  devName?: Maybe<Scalars['String']['output']>;
  devNotes?: Maybe<Scalars['String']['output']>;
  devStatus?: Maybe<Scalars['String']['output']>;
  devTimestamp?: Maybe<Scalars['String']['output']>;
  errorsSinceLastSuccessfulRun?: Maybe<Scalars['Float']['output']>;
  forceFullSync?: Maybe<Scalars['Boolean']['output']>;
  isQuarantined?: Maybe<Scalars['Boolean']['output']>;
  lastFullSync?: Maybe<Scalars['String']['output']>;
  lastRun?: Maybe<Scalars['Float']['output']>;
  lastStartedAt: Scalars['String']['output'];
  locks?: Maybe<Array<LockResponse>>;
  nextRun?: Maybe<Scalars['Float']['output']>;
  running?: Maybe<Scalars['Boolean']['output']>;
  scheduledJobId?: Maybe<Scalars['String']['output']>;
  sourceIntegrationId?: Maybe<Scalars['String']['output']>;
  sourceSecretId?: Maybe<Scalars['String']['output']>;
  sourceStreamName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  syncId?: Maybe<Scalars['String']['output']>;
  targetCloudProvider?: Maybe<Scalars['String']['output']>;
};

export type EltSyncMigrationResult = {
  __typename?: 'EltSyncMigrationResult';
  error?: Maybe<Scalars['String']['output']>;
  jobMigrationResults: Array<JobMigrationResult>;
  migrated: Scalars['Boolean']['output'];
};

export type EltSyncSnapshotState = {
  __typename?: 'EltSyncSnapshotState';
  sourceStreams: Array<SourceStreamSnapshotStates>;
  syncId: Scalars['String']['output'];
};

export type EnhancedDataConnector = {
  __typename?: 'EnhancedDataConnector';
  aliasFor?: Maybe<Scalars['String']['output']>;
  baseId: Scalars['String']['output'];
  categories: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  documentationUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isUtilityConnector: Scalars['Boolean']['output'];
  logo: IntegrationLogoVariants;
  minRequiredPlan?: Maybe<PlanName>;
  name: Scalars['String']['output'];
  requiresAdmin?: Maybe<Scalars['Boolean']['output']>;
  status: DevStatus;
  tags: Array<Scalars['String']['output']>;
  type: ConnectorType;
};

export type EnhancedIntegration = {
  __typename?: 'EnhancedIntegration';
  abilities: Array<IntegrationAbility>;
  activateDestination?: Maybe<DataConnectorMetadata>;
  aliasFor?: Maybe<Scalars['String']['output']>;
  aliasMetadata?: Maybe<AliasMetadata>;
  baseId: Scalars['String']['output'];
  biTool?: Maybe<DataConnectorMetadata>;
  categories: Array<Scalars['String']['output']>;
  config?: Maybe<IntegrationConfiguration>;
  dataWarehouse?: Maybe<DataConnectorMetadata>;
  description: Scalars['String']['output'];
  documentationUrl?: Maybe<Scalars['String']['output']>;
  eltSource?: Maybe<DataConnectorMetadata>;
  id: Scalars['String']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isUtilityConnector: Scalars['Boolean']['output'];
  logo: IntegrationLogoVariants;
  minRequiredPlan?: Maybe<PlanName>;
  name: Scalars['String']['output'];
  requiresAdmin?: Maybe<Scalars['Boolean']['output']>;
};

export type ErdEdge = {
  __typename?: 'ErdEdge';
  id: Scalars['String']['output'];
  markerEnd?: Maybe<Scalars['JSONObject']['output']>;
  source: Scalars['String']['output'];
  style?: Maybe<Scalars['JSONObject']['output']>;
  target: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ErdField = {
  __typename?: 'ErdField';
  foreignKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isPrimaryKey: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ErdFieldInput = {
  foreignKey?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isPrimaryKey: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ErdNode = {
  __typename?: 'ErdNode';
  data: NodeData;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  parentNode?: Maybe<Scalars['String']['output']>;
  position: NodePosition;
  type: Scalars['String']['output'];
  width?: Maybe<Scalars['Float']['output']>;
};

export type ErrorLogsResponse = {
  __typename?: 'ErrorLogsResponse';
  error_code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  log_origin?: Maybe<Scalars['String']['output']>;
  logger?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export enum ExampleDatabaseTypes {
  ECommerceSample = 'e_commerce_sample'
}

export enum ExternalSystem {
  Api = 'API',
  DbtCloud = 'DBT_CLOUD'
}

export type FailedTablesResponse = {
  __typename?: 'FailedTablesResponse';
  errorMessage: Scalars['String']['output'];
  finishedAt: Scalars['String']['output'];
  lastSynced: Scalars['Float']['output'];
  sourceStreamName: Scalars['String']['output'];
  status: SyncJobStatus;
};

export type FeatureLimit = {
  __typename?: 'FeatureLimit';
  isSoftLimit?: Maybe<Scalars['Boolean']['output']>;
  value: Scalars['Float']['output'];
};

export type FeatureSet = {
  __typename?: 'FeatureSet';
  aiAssistantHistoryEnabled: Scalars['Boolean']['output'];
  auditLogsEnabled: Scalars['Boolean']['output'];
  columnHashingEnabled: Scalars['Boolean']['output'];
  customConnectorEnabled: Scalars['Boolean']['output'];
  externalAuthorizationEnabled: Scalars['Boolean']['output'];
  limitConnectors: FeatureLimit;
  limitRows: FeatureLimit;
  limitUsers: FeatureLimit;
  limitWorkspaces: FeatureLimit;
  lineageEnabled: Scalars['Boolean']['output'];
  minSyncIntervalInMinutes: Scalars['Int']['output'];
  modelTestingEnabled: Scalars['Boolean']['output'];
  onDemandSyncsEnabled: Scalars['Boolean']['output'];
  orchestrationEnabled: Scalars['Boolean']['output'];
};

export type FieldMetadata = {
  __typename?: 'FieldMetadata';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type FindAllAvailableAuditLogsResponse = {
  __typename?: 'FindAllAvailableAuditLogsResponse';
  logs: Array<AvailableAuditLog>;
};

export type FindAvailableOperationsResponse = {
  __typename?: 'FindAvailableOperationsResponse';
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  operationMode: OperationModes;
  operationType: OperationTypes;
  primaryKeyRequired: Scalars['Boolean']['output'];
};

export type FindFailedSyncsResponse = {
  __typename?: 'FindFailedSyncsResponse';
  destinationSchemaName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  sourceIntegrationId: Scalars['String']['output'];
  tables: Array<FailedTablesResponse>;
};

export type FindSyncHistoryResponse = {
  __typename?: 'FindSyncHistoryResponse';
  details?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  estimatedTotalCount?: Maybe<Scalars['Float']['output']>;
  failedRecords?: Maybe<Scalars['Float']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  fullSyncTrigger?: Maybe<FullSyncTrigger>;
  isChunk?: Maybe<Scalars['Boolean']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  newRecords?: Maybe<Scalars['Float']['output']>;
  operationMode?: Maybe<OperationMode>;
  scheduledJobId?: Maybe<Scalars['String']['output']>;
  sizeSyncedMb?: Maybe<Scalars['Float']['output']>;
  sourceStreamName?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['String']['output'];
  status?: Maybe<SyncJobStatus>;
  syncId: Scalars['String']['output'];
  syncedRecords?: Maybe<Scalars['Float']['output']>;
  totalRecords?: Maybe<Scalars['Float']['output']>;
};

export type ForecastedDataPoint = {
  __typename?: 'ForecastedDataPoint';
  date: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export enum FullSyncTrigger {
  AlwaysFull = 'ALWAYS_FULL',
  Error = 'ERROR',
  InitialSync = 'INITIAL_SYNC',
  Lookback = 'LOOKBACK',
  Midnight = 'MIDNIGHT',
  Migration = 'MIGRATION',
  None = 'NONE',
  SchemaChange = 'SCHEMA_CHANGE',
  User = 'USER'
}

export type GcpBatchJob = {
  __typename?: 'GcpBatchJob';
  createTime: Scalars['JSONObject']['output'];
  eltScheduledJob?: Maybe<Scalars['JSONObject']['output']>;
  labels: Scalars['JSONObject']['output'];
  mongoEntryId?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<Array<Scalars['String']['output']>>;
  path: Scalars['String']['output'];
  queue: Scalars['String']['output'];
  status: BatchJobStatus;
  uid: Scalars['String']['output'];
  updateTime: Scalars['JSONObject']['output'];
};

export type GcpBatchJobs = {
  __typename?: 'GcpBatchJobs';
  jobs: Array<GcpBatchJob>;
  pageInfo?: Maybe<PageInfo>;
};

export type GetAllAvroSchemasResponse = {
  __typename?: 'GetAllAvroSchemasResponse';
  schemas: Array<SchemaDto>;
};

/** Response type when getting all tables. */
export type GetAllTablesResponse = {
  __typename?: 'GetAllTablesResponse';
  response: Array<Scalars['JSONObject']['output']>;
};

export type GetDwDirectoryInput = {
  connectionId: Scalars['String']['input'];
  path?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetDwDirectoryItemsInput = {
  connectionId: Scalars['String']['input'];
  path: Array<Scalars['String']['input']>;
};

export type GetEltSyncMigrationRequest = {
  id: Scalars['String']['input'];
};

export type GetJobLogsResponse = {
  __typename?: 'GetJobLogsResponse';
  jobId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: JobLoggingMessageStatus;
  timestamp: Scalars['String']['output'];
};

export type GetSettingsInput = {
  formValues?: InputMaybe<Scalars['JSONObject']['input']>;
  id: Scalars['String']['input'];
};

export type GetSignupQuestionnaireResponse = {
  __typename?: 'GetSignupQuestionnaireResponse';
  result?: Maybe<SignupQuestionnaireResult>;
};

export type GetSourceStreamJobResponse = {
  __typename?: 'GetSourceStreamJobResponse';
  errorsSinceLastSuccessfulRun?: Maybe<Scalars['Float']['output']>;
  forceFullSync?: Maybe<Scalars['Boolean']['output']>;
  fullSyncAlways?: Maybe<Scalars['Boolean']['output']>;
  isQuarantined?: Maybe<Scalars['Boolean']['output']>;
  lastFullSync?: Maybe<Scalars['String']['output']>;
  lastRun?: Maybe<Scalars['Float']['output']>;
  lastStartedAt?: Maybe<Scalars['String']['output']>;
  nextRun?: Maybe<Scalars['Float']['output']>;
  running?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GetViewDetailsInput = {
  path: Array<Scalars['String']['input']>;
};

export type GoogleProject = {
  __typename?: 'GoogleProject';
  displayName: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
};

export type HasDeletedModelsResponse = {
  __typename?: 'HasDeletedModelsResponse';
  value: Scalars['Boolean']['output'];
};

export type HistoricalValue = {
  __typename?: 'HistoricalValue';
  date: Scalars['DateTime']['output'];
  numBillableRows: Scalars['Float']['output'];
};

export type ImportDwDirectoryInput = {
  connectionId: Scalars['String']['input'];
  database?: InputMaybe<Scalars['String']['input']>;
  schema: Scalars['String']['input'];
  tables: Array<Scalars['String']['input']>;
};

export type Incident = {
  __typename?: 'Incident';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  impact: Scalars['String']['output'];
  incidentUpdates: Array<IncidentUpdate>;
  name: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  scheduledFor: Scalars['DateTime']['output'];
  scheduledUntil: Scalars['DateTime']['output'];
  shortlink: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type IncidentUpdate = {
  __typename?: 'IncidentUpdate';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  displayAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  incidentId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum InitialSyncStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  Running = 'Running',
  Scheduled = 'Scheduled'
}

export type InitialSyncStatusResponse = {
  __typename?: 'InitialSyncStatusResponse';
  duration?: Maybe<Scalars['Float']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  integrationId: Scalars['String']['output'];
  isChunkedSync: Scalars['Boolean']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: InitialSyncStatus;
  syncId: Scalars['String']['output'];
  tableStats: InitialSyncTableStats;
};

export type InitialSyncTableStats = {
  __typename?: 'InitialSyncTableStats';
  bytesSynced: Scalars['Float']['output'];
  completed: Scalars['Float']['output'];
  failed: Scalars['Float']['output'];
  recordsSynced: Scalars['Float']['output'];
  running: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type Integration = {
  __typename?: 'Integration';
  abilities: Array<IntegrationAbility>;
  integrationId: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum IntegrationAbility {
  ActivateDestination = 'ActivateDestination',
  ActivateSource = 'ActivateSource',
  DataWarehouse = 'DataWarehouse',
  EltDestination = 'EltDestination',
  EltSource = 'EltSource',
  Utility = 'Utility',
  WebHook = 'WebHook'
}

export type IntegrationConfiguration = {
  __typename?: 'IntegrationConfiguration';
  form: Scalars['JSONObject']['output'];
  forms: Array<Scalars['JSONObject']['output']>;
  hideSelectAllTables?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  supportsStartDate?: Maybe<Scalars['Boolean']['output']>;
  usesAsyncStreams?: Maybe<Scalars['Boolean']['output']>;
  usesLazySchemas?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationDataConnectorInput = {
  isAvailable: Scalars['Boolean']['input'];
  isListedOnWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  minRequiredPlan?: InputMaybe<PlanName>;
  status?: InputMaybe<DevStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IntegrationLogoVariants = {
  __typename?: 'IntegrationLogoVariants';
  dark?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['String']['output']>;
};

export type IntegrationMetadata = {
  __typename?: 'IntegrationMetadata';
  activateDestination?: Maybe<ConnectorMetadata>;
  aliasFor?: Maybe<Scalars['String']['output']>;
  baseId?: Maybe<Scalars['String']['output']>;
  biTool?: Maybe<ConnectorMetadata>;
  categories: Array<Scalars['String']['output']>;
  dataWarehouse?: Maybe<ConnectorMetadata>;
  description?: Maybe<Scalars['String']['output']>;
  documentationUrl?: Maybe<Scalars['String']['output']>;
  eltSource?: Maybe<ConnectorMetadata>;
  integrationId: Scalars['String']['output'];
  isAvailable: Scalars['Boolean']['output'];
  logo?: Maybe<LogoConfig>;
  name?: Maybe<Scalars['String']['output']>;
  requiresAdmin?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationResource = {
  __typename?: 'IntegrationResource';
  id: Scalars['String']['output'];
  integration?: Maybe<Integration>;
  metadata?: Maybe<IntegrationMetadata>;
};

/** Integration specific settings that needs to be selected */
export type IntegrationSettings = {
  __typename?: 'IntegrationSettings';
  connectionSettings?: Maybe<Scalars['JSONObject']['output']>;
};

export type IntegrationSyncStats = {
  __typename?: 'IntegrationSyncStats';
  elt: SyncStats;
  integrationId: Scalars['String']['output'];
  numBillableRows: Scalars['Float']['output'];
  numRowsSynced: Scalars['Float']['output'];
  reverseElt: SyncStats;
};

export type IntegrationSyncStatsResponse = {
  __typename?: 'IntegrationSyncStatsResponse';
  data: Array<IntegrationSyncStats>;
  period: StatsPeriod;
};

export type IntegrationTemplate = {
  __typename?: 'IntegrationTemplate';
  config: EltPartialConfig;
  models: Array<TemplateModel>;
  required: Scalars['Boolean']['output'];
  sourceIntegationId: Scalars['String']['output'];
};

export type Invitation = {
  __typename?: 'Invitation';
  account: Account;
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  role?: Maybe<Role>;
  updatedAt: Scalars['DateTime']['output'];
  used: Scalars['Boolean']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  billingDate: Scalars['DateTime']['output'];
  chargeFailureMessage?: Maybe<Scalars['String']['output']>;
  chargeStatus?: Maybe<StripeChargeStatus>;
  currency: Scalars['String']['output'];
  dueDate: Scalars['DateTime']['output'];
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metadata: InvoiceMetadata;
  number?: Maybe<Scalars['String']['output']>;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  status?: Maybe<InvoiceStatus>;
  total: Scalars['Int']['output'];
};

export type InvoiceBreakdownItem = {
  __typename?: 'InvoiceBreakdownItem';
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceMetadata = {
  __typename?: 'InvoiceMetadata';
  lastSettlementDate?: Maybe<Scalars['DateTime']['output']>;
};

export type InvoicePreviewInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  numConnectors: Scalars['Float']['input'];
  numUsers: Scalars['Float']['input'];
  priceId: Scalars['String']['input'];
};

export enum InvoiceStatus {
  Draft = 'Draft',
  Open = 'Open',
  Paid = 'Paid',
  Uncollectible = 'Uncollectible',
  Void = 'Void'
}

export type InvoiceTaxes = {
  __typename?: 'InvoiceTaxes';
  amount: Scalars['Float']['output'];
  displayName: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export enum JobLoggingMessageStatus {
  Error = 'ERROR',
  Log = 'LOG',
  Warn = 'WARN'
}

export type JobMigrationResult = {
  __typename?: 'JobMigrationResult';
  error?: Maybe<Scalars['String']['output']>;
  migrated: Scalars['Boolean']['output'];
  running?: Maybe<Scalars['Boolean']['output']>;
  scheduledJobId: Scalars['String']['output'];
};

export type LocalMaterializationJob = {
  __typename?: 'LocalMaterializationJob';
  cronExpression: Scalars['String']['output'];
  lastRun?: Maybe<Scalars['Float']['output']>;
  latestErrorMessage?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  nextRun: Scalars['Float']['output'];
  queryId: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export enum LockReason {
  AccountInactivityNotice_2D = 'ACCOUNT_INACTIVITY_NOTICE_2D',
  AccountInactivityNotice_14D = 'ACCOUNT_INACTIVITY_NOTICE_14D',
  ActivateBadQuery = 'ACTIVATE_BAD_QUERY',
  ActivateQuarantine = 'ACTIVATE_QUARANTINE',
  AirtableTableNotFound = 'AIRTABLE_TABLE_NOT_FOUND',
  ApiNotEnoughPermissions = 'API_NOT_ENOUGH_PERMISSIONS',
  BigqueryBilling = 'BIGQUERY_BILLING',
  BigqueryNotEnabled = 'BIGQUERY_NOT_ENABLED',
  BusinessCentralDataUpgradeNeeded = 'BUSINESS_CENTRAL_DATA_UPGRADE_NEEDED',
  ChargebeeApiRestricted = 'CHARGEBEE_API_RESTRICTED',
  ConnectionCreatedByExternalUser = 'CONNECTION_CREATED_BY_EXTERNAL_USER',
  ConnectionUpdatedByExternalUser = 'CONNECTION_UPDATED_BY_EXTERNAL_USER',
  ConnectorAccountNotFound = 'CONNECTOR_ACCOUNT_NOT_FOUND',
  ConnectorBadApiKey = 'CONNECTOR_BAD_API_KEY',
  ConnectorBadOauth = 'CONNECTOR_BAD_OAUTH',
  ConnectorPlanRequirementViolation = 'CONNECTOR_PLAN_REQUIREMENT_VIOLATION',
  CreateRawViewFailed = 'CREATE_RAW_VIEW_FAILED',
  CustomConnectorFailedRequest = 'CUSTOM_CONNECTOR_FAILED_REQUEST',
  CustomConnectorMissingSchema = 'CUSTOM_CONNECTOR_MISSING_SCHEMA',
  CustomConnectorWrongSchema = 'CUSTOM_CONNECTOR_WRONG_SCHEMA',
  DatabaseAuthError = 'DATABASE_AUTH_ERROR',
  DatabaseConnectionError = 'DATABASE_CONNECTION_ERROR',
  DatabaseIncrementalMisconfigured = 'DATABASE_INCREMENTAL_MISCONFIGURED',
  DatabaseTableNotExist = 'DATABASE_TABLE_NOT_EXIST',
  DatabaseTableNotFound = 'DATABASE_TABLE_NOT_FOUND',
  DynamoDbStreamNotEnabled = 'DYNAMO_DB_STREAM_NOT_ENABLED',
  Example = 'EXAMPLE',
  ExcelDatasetNotFound = 'EXCEL_DATASET_NOT_FOUND',
  ExcelDatasetTooLarge = 'EXCEL_DATASET_TOO_LARGE',
  ExcelOverlappingTables = 'EXCEL_OVERLAPPING_TABLES',
  FacebookAdsLostAdAccountAccess = 'FACEBOOK_ADS_LOST_AD_ACCOUNT_ACCESS',
  FreeTrialExpired = 'FREE_TRIAL_EXPIRED',
  FtpAuthError = 'FTP_AUTH_ERROR',
  GoogleInvalidGrant = 'GOOGLE_INVALID_GRANT',
  GoogleSheetsBadNamedRange = 'GOOGLE_SHEETS_BAD_NAMED_RANGE',
  IncompatibleSchemaForHistoryTable = 'INCOMPATIBLE_SCHEMA_FOR_HISTORY_TABLE',
  InstagramAuthError = 'INSTAGRAM_AUTH_ERROR',
  LinkedinMissingAccount = 'LINKEDIN_MISSING_ACCOUNT',
  ManagedBqUsageExceededLock = 'MANAGED_BQ_USAGE_EXCEEDED_LOCK',
  ManagedBqUsageExceededSoftLimit = 'MANAGED_BQ_USAGE_EXCEEDED_SOFT_LIMIT',
  MandatoryAccountTrialStarted = 'MANDATORY_ACCOUNT_TRIAL_STARTED',
  MaterialisationFailure = 'MATERIALISATION_FAILURE',
  MaxRowCountExceeded = 'MAX_ROW_COUNT_EXCEEDED',
  MaxRowCountExceededYearly = 'MAX_ROW_COUNT_EXCEEDED_YEARLY',
  ModelBadQuery = 'MODEL_BAD_QUERY',
  NetsuiteConcurrencyLimitExceededError = 'NETSUITE_CONCURRENCY_LIMIT_EXCEEDED_ERROR',
  OrchestrationWorkflowRunFailed = 'ORCHESTRATION_WORKFLOW_RUN_FAILED',
  OverdueInvoiceReminder = 'OVERDUE_INVOICE_REMINDER',
  OverdueInvoiceServiceSuspension = 'OVERDUE_INVOICE_SERVICE_SUSPENSION',
  PostgresDatabaseInsufficientPrivilege = 'POSTGRES_DATABASE_INSUFFICIENT_PRIVILEGE',
  PostgresFailedConnection = 'POSTGRES_FAILED_CONNECTION',
  PostgresTableInsufficientPrivilege = 'POSTGRES_TABLE_INSUFFICIENT_PRIVILEGE',
  PrimaryKeyNotUnique = 'PRIMARY_KEY_NOT_UNIQUE',
  ProtectedStreamFullSync = 'PROTECTED_STREAM_FULL_SYNC',
  Quarantine = 'QUARANTINE',
  ShopifyPaymentRequired = 'SHOPIFY_PAYMENT_REQUIRED',
  SnowflakeAccountBilling = 'SNOWFLAKE_ACCOUNT_BILLING',
  SnowflakeAccountLocked = 'SNOWFLAKE_ACCOUNT_LOCKED',
  StreamIsDeprecated = 'STREAM_IS_DEPRECATED',
  SubscriptionCancelationReverted = 'SUBSCRIPTION_CANCELATION_REVERTED',
  SubscriptionCanceled = 'SUBSCRIPTION_CANCELED',
  SubscriptionCreated = 'SUBSCRIPTION_CREATED',
  SubscriptionPlanMigrationConfirmation = 'SUBSCRIPTION_PLAN_MIGRATION_CONFIRMATION',
  SubscriptionUpgraded = 'SUBSCRIPTION_UPGRADED',
  SyncFrequencyForced = 'SYNC_FREQUENCY_FORCED',
  TemplateReady = 'TEMPLATE_READY',
  Unknown = 'UNKNOWN'
}

export type LockResponse = {
  __typename?: 'LockResponse';
  id: Scalars['String']['output'];
  reasons: Array<LockReason>;
  target: Scalars['String']['output'];
};

export type LogoConfig = {
  __typename?: 'LogoConfig';
  dark?: Maybe<Scalars['String']['output']>;
  light?: Maybe<Scalars['String']['output']>;
};

export type LogoConfigInput = {
  dark?: InputMaybe<Scalars['String']['input']>;
  light?: InputMaybe<Scalars['String']['input']>;
};

export type MfaInfoResult = {
  __typename?: 'MFAInfoResult';
  hasMFA: Scalars['Boolean']['output'];
  mfaMethods: Array<MfaMetod>;
};

export type MfaMetod = {
  __typename?: 'MFAMetod';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Mapping = {
  __typename?: 'Mapping';
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  destinationPropertyId: Scalars['String']['output'];
  destinationPropertyName: Scalars['String']['output'];
  destinationPropertyType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  object: Scalars['String']['output'];
  operationMode: Operation;
  primaryKey: Scalars['Boolean']['output'];
  readonly: Scalars['Boolean']['output'];
  sourcePropertyId: Scalars['String']['output'];
  sourcePropertyName: Scalars['String']['output'];
  sourcePropertyType: Scalars['String']['output'];
  sync: Sync;
};

export enum MaterialisationStatus {
  Failed = 'FAILED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

export enum MaterializationType {
  Table = 'table',
  View = 'view'
}

export type MaterializedTableReference = {
  __typename?: 'MaterializedTableReference';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  dwSqlReference: Scalars['String']['output'];
  latestCreated?: Maybe<TableReference>;
  latestRunErrorMessage?: Maybe<Scalars['String']['output']>;
  latestSyncTime?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  modelTestRuns: Array<ModelTestRun>;
  path: Array<Scalars['String']['output']>;
  queryId: Scalars['String']['output'];
  status?: Maybe<MaterialisationStatus>;
  tableMetadata?: Maybe<TableMetadata>;
  type: DependencyType;
  weldTag: Scalars['String']['output'];
};

export type MetricColumn = {
  __typename?: 'MetricColumn';
  columnName: Scalars['String']['output'];
  columnType: MetricColumnType;
  description: Scalars['String']['output'];
};

export enum MetricColumnType {
  Dimension = 'Dimension',
  MetricAvg = 'MetricAvg',
  MetricSum = 'MetricSum'
}

export type MetricConfig = {
  __typename?: 'MetricConfig';
  folderName: Scalars['String']['output'];
  templateItemId: Scalars['String']['output'];
};

export type MigrateAccountsRequest = {
  ids: Array<Scalars['String']['input']>;
};

export type MigrateEltSyncRequest = {
  ids: Array<Scalars['String']['input']>;
};

export type MigrateSecretsForAccountRequest = {
  accountId: Scalars['String']['input'];
  runAll?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Model = {
  __typename?: 'Model';
  account: Account;
  createdAt: Scalars['DateTime']['output'];
  dashboardId?: Maybe<Scalars['String']['output']>;
  deletedAt: Scalars['DateTime']['output'];
  documentation?: Maybe<Scalars['String']['output']>;
  dwSync?: Maybe<ModelViewReference>;
  dwTable?: Maybe<MaterializedTableReference>;
  emoji?: Maybe<Scalars['String']['output']>;
  folder?: Maybe<ModelFolder>;
  folderId?: Maybe<Scalars['String']['output']>;
  folderPath?: Maybe<Array<ModelFolder>>;
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  localMaterializationJob?: Maybe<LocalMaterializationJob>;
  materializationSchedule?: Maybe<Scalars['String']['output']>;
  materializationType: MaterializationType;
  modelTests: Array<ModelTest>;
  name: Scalars['String']['output'];
  orchestrationScheduler?: Maybe<OrchestrationSchedulerType>;
  orchestrationWorkflow?: Maybe<OrchestrationWorkflow>;
  publishedQuery?: Maybe<SqlQuery>;
  publishedQueryId?: Maybe<Scalars['String']['output']>;
  sourceConnection: Connection;
  sourceConnectionId: Scalars['String']['output'];
  sqlQueries: Array<SqlQuery>;
  syncs?: Maybe<Array<Sync>>;
  template?: Maybe<Template>;
  templateId?: Maybe<Scalars['String']['output']>;
  templateItemId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ModelType>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ModelFolder = {
  __typename?: 'ModelFolder';
  DWName: Scalars['String']['output'];
  account?: Maybe<Account>;
  deletedAt: Scalars['DateTime']['output'];
  emoji?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  models?: Maybe<Array<Model>>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ModelType>;
};

export type ModelTest = {
  __typename?: 'ModelTest';
  column: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  type: TestType;
};

export type ModelTestResult = {
  __typename?: 'ModelTestResult';
  error?: Maybe<Scalars['String']['output']>;
  failedRows?: Maybe<Array<Scalars['JSONObject']['output']>>;
  modelTestId: Scalars['String']['output'];
  modelTestWeldSql?: Maybe<Scalars['String']['output']>;
  queryExecutionId?: Maybe<Scalars['String']['output']>;
  status: TestStatus;
};

export type ModelTestRun = {
  __typename?: 'ModelTestRun';
  modelTest: ModelTest;
  modelTestId: Scalars['ID']['output'];
  result?: Maybe<ModelTestRunResult>;
  workflowRunId: Scalars['ID']['output'];
};

export type ModelTestRunResult = {
  __typename?: 'ModelTestRunResult';
  error?: Maybe<Scalars['String']['output']>;
  numRowsTotal?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Scalars['JSONObject']['output']>>;
  status: ModelTestStatus;
};

export enum ModelTestStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Running = 'RUNNING'
}

export enum ModelType {
  Analytics = 'analytics',
  Core = 'core',
  Staging = 'staging'
}

export type ModelUsageSummaryDto = {
  __typename?: 'ModelUsageSummaryDto';
  draftModels: Scalars['Float']['output'];
  publishedModels: Scalars['Float']['output'];
};

export type ModelViewReference = {
  __typename?: 'ModelViewReference';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  dwSqlReference: Scalars['String']['output'];
  latestSyncTime: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  modelTestRuns: Array<ModelTestRun>;
  path: Array<Scalars['String']['output']>;
  queryId: Scalars['String']['output'];
  type: DependencyType;
  weldTag: Scalars['String']['output'];
};

export type MoveModelInput = {
  id: Scalars['String']['input'];
  modelFolderId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addCurrentUserToAccountBackoffice: Scalars['Boolean']['output'];
  addNotificationEmail: Account;
  attachEltSyncToTemplate: EltSync;
  batchSwitchPlanPrice: SubscriptionAdminResult;
  blockELTSyncsForAccountBackoffice: Account;
  blockReverseELTSyncsForAccountBackoffice: Account;
  cancelCurrentWorkflowRun: OrchestrationWorkflow;
  cancelStreamsAsyncJob: AsyncStreamsStatus;
  cancelWeldSubscription: CancelSubscriptionResponse;
  createAccount: Account;
  createApiKey: ApiKeyResponse;
  createAsyncQueryPreview: CreateAsyncQueryPreviewResponse;
  createConnection: Connection;
  createConnectionBridge: ConnectionBridgeResponse;
  createDraftModel: Model;
  createEltSync: EltSync;
  createEltSyncFromTemplate: EltSync;
  createExampleConnection: Connection;
  createFuturePaymentsSetupIntent: CreateSetupIntentResponse;
  createIntegrationMetadataBackoffice: Scalars['Boolean']['output'];
  createModelFolder: ModelFolder;
  createModelFromTemplate: TemplatePublished;
  createModelTest: ModelTest;
  createNotificationBackoffice: Notification;
  createNotificationThroughQueueBackoffice: Scalars['Boolean']['output'];
  createOrUpdateCustomer: Customer;
  createOrUpdateWeldSubscription: CreateSubscriptionResponse;
  createPaymentMethodCheckoutSession: CheckoutSession;
  createSecretBackoffice: Scalars['String']['output'];
  createSync: Sync;
  createTemplate: Template;
  createWebhook: WebhookResponse;
  createWeldSubscription: CreateSubscriptionResponse;
  createWorkflow: OrchestrationWorkflow;
  createWorkspaceWithManagedDatawarehouse: Account;
  declineOwnInvitation: Invitation;
  deleteAccount: Account;
  deleteApiKey?: Maybe<Scalars['Boolean']['output']>;
  deleteConnectionBridge: Scalars['Boolean']['output'];
  deleteFolderWithContent: Scalars['String']['output'];
  deleteIntegrationMetadataBackoffice: Scalars['Boolean']['output'];
  deleteInvitation: Invitation;
  deleteModelFolder: ModelFolder;
  deleteOnboardingConnection: Scalars['Boolean']['output'];
  deleteRawView?: Maybe<Scalars['Boolean']['output']>;
  deleteUser: User;
  deleteWebhook: Scalars['Boolean']['output'];
  deleteWorkflow: Scalars['ID']['output'];
  disconnectSlackNotifications: Account;
  dismissAllNotifications: Scalars['Boolean']['output'];
  dismissProductNPS: SurveyResponse;
  editWorkflow: OrchestrationWorkflow;
  importDWDirectory: Array<DwDirectoryItem>;
  initiateModelFolders: Array<ModelFolder>;
  invalidateIntegrationsCacheBackoffice: Scalars['Boolean']['output'];
  migrateAccountsBackToAWSBackoffice: Scalars['Boolean']['output'];
  migrateAccountsBackoffice: Scalars['Boolean']['output'];
  migrateAllDwMaterialisationJobs: Scalars['Boolean']['output'];
  migrateEltSyncBackoffice: Scalars['Boolean']['output'];
  migrateEltSyncDirectlyBackoffice: EltSyncMigrationResult;
  migrateSecretsBackoffice: Scalars['Boolean']['output'];
  migrateSecretsForAccountBackoffice: Scalars['Boolean']['output'];
  moveModel: Model;
  processOverdueInvoicesOnCustomer: Scalars['JSONObject']['output'];
  publishModelAsync: Scalars['String']['output'];
  recreateDestinationView: RecreateViewResponse;
  recreateSubscriptionInCurrency: SubscriptionAdminResult;
  recreateSubscriptionWithBillingCycleAnchoredToMidnightUTC: SubscriptionAdminResult;
  refreshDestination: Connection;
  rematerializeNow: Model;
  removeConnection: Connection;
  removeCurrentUserFromAccountBackoffice: Scalars['Boolean']['output'];
  removeDashboardModels: Array<Model>;
  removeEltSync: RemoveEltSyncResponse;
  removeModel: Model;
  removeModelTest: ModelTest;
  removeNotification: Notification;
  removeNotificationBackoffice: Scalars['String']['output'];
  removeNotificationEmail: Account;
  removeSync: Sync;
  removeTableFromSync: RemoveTableResponse;
  renameModelFolder: ModelFolder;
  requestBetaConnectorAccess: Scalars['Boolean']['output'];
  requestConnector: Scalars['Boolean']['output'];
  requestDestination: Scalars['Boolean']['output'];
  resendOwnInvitation: Invitation;
  resetAllErrors: Scalars['Boolean']['output'];
  resetErrors: Scalars['Boolean']['output'];
  resetSyncBackOffice: ResetSyncResponse;
  restoreDeletedModel: Model;
  revertCloudProviderOnSourceStreams: Scalars['Boolean']['output'];
  revertSubscriptionCancelation: CancelSubscriptionResponse;
  runJobNow?: Maybe<Scalars['Boolean']['output']>;
  runOrchestrationWorkflowNow: OrchestrationWorkflow;
  runOrchestrationWorkflowNowBackoffice: OrchestrationWorkflow;
  runSyncNow?: Maybe<Scalars['Boolean']['output']>;
  saveErdForIntegration: StoredErd;
  saveSignupQuestionnaireResult: Scalars['Boolean']['output'];
  seedDataWarehouse: SeedDatawarehouseResponse;
  sendInvitation: Invitation;
  sessionStarted: Scalars['Boolean']['output'];
  setDatawarehouse: Scalars['Boolean']['output'];
  setDevStatus: Scalars['JSONObject']['output'];
  setMFA: Scalars['Boolean']['output'];
  setMaxBillableRows: Account;
  setNextSyncToFullSync: SourceStream;
  setOnboardingConnections: Array<OnboardingConnection>;
  setTrialEndDateBackoffice: Account;
  setupSlackNotifications: Account;
  setupTemplate: Scalars['Boolean']['output'];
  startDatawarehouseMigration: DatawarehouseMigration;
  startEltSync: StartEltSyncResponse;
  startEltSyncBackoffice: Scalars['String']['output'];
  startSelfOnboardingProcess: Scalars['Boolean']['output'];
  startSync: Sync;
  stopEltSync: StopEltSyncResponse;
  stopEltSyncBackoffice: Scalars['String']['output'];
  stopSync: Sync;
  submitProductNPS: SurveyResponse;
  syncUserDetails: Scalars['Boolean']['output'];
  terminateGcpBatchJob: Scalars['Boolean']['output'];
  unpublishModel: Model;
  updateBillingDetails: Customer;
  updateConnection: Connection;
  updateDataWarehouseConnectionIdHack: Account;
  updateDraftModelName: Model;
  updateEltSync: EltSync;
  updateFolderEmoji: Scalars['Boolean']['output'];
  updateIntegrationMetadataBackoffice: Scalars['Boolean']['output'];
  updateModelDocumentation: Model;
  updateModelEmoji: Model;
  updateModelTest: ModelTest;
  updatePublishedModelMaterialization: Model;
  updatePublishedModelQueryAsync: Scalars['String']['output'];
  updateSourceStream: SourceStream;
  updateSubscriptionAddOns: UpdateSubscriptionResponse;
  updateSync: Sync;
  updateUnpublishedModelSqlQuery: SqlQuery;
  updateUser: User;
  updateUserAccountRole: User;
  upsertUserSignupInfo: UserSignupInfo;
  useInvitation: UseInvitationResponse;
};


export type MutationAddCurrentUserToAccountBackofficeArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationAddNotificationEmailArgs = {
  input: NotificationEmailInput;
};


export type MutationAttachEltSyncToTemplateArgs = {
  input: AttachEltTemplateInput;
};


export type MutationBatchSwitchPlanPriceArgs = {
  currentPriceId: Scalars['String']['input'];
  newPriceId: Scalars['String']['input'];
};


export type MutationBlockEltSyncsForAccountBackofficeArgs = {
  accountId: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};


export type MutationBlockReverseEltSyncsForAccountBackofficeArgs = {
  accountId: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};


export type MutationCancelCurrentWorkflowRunArgs = {
  workflowId: Scalars['ID']['input'];
};


export type MutationCancelStreamsAsyncJobArgs = {
  connectionId: Scalars['String']['input'];
};


export type MutationCancelWeldSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};


export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};


export type MutationCreateAsyncQueryPreviewArgs = {
  dependencies: Array<QueryDependencyInput>;
  sourceConnectionId: Scalars['ID']['input'];
  weldSql: Scalars['String']['input'];
};


export type MutationCreateConnectionArgs = {
  input: CreateConnectionInput;
};


export type MutationCreateConnectionBridgeArgs = {
  input: CreateConnectionBridgeInput;
};


export type MutationCreateDraftModelArgs = {
  input: CreateDraftModelInput;
};


export type MutationCreateEltSyncArgs = {
  input: CreateEltSyncInput;
};


export type MutationCreateEltSyncFromTemplateArgs = {
  input: EltFromTemplateInput;
};


export type MutationCreateExampleConnectionArgs = {
  input: CreateExampleConnectionInput;
};


export type MutationCreateFuturePaymentsSetupIntentArgs = {
  customerId: Scalars['String']['input'];
};


export type MutationCreateIntegrationMetadataBackofficeArgs = {
  input: SaveIntegrationMetadataInput;
};


export type MutationCreateModelFolderArgs = {
  createFolderInput: CreateFolderInput;
};


export type MutationCreateModelFromTemplateArgs = {
  input: CreateFromTemplateInput;
};


export type MutationCreateModelTestArgs = {
  createModelTestInput: CreateModelTestInput;
};


export type MutationCreateNotificationBackofficeArgs = {
  input: CreateNotificationInput;
};


export type MutationCreateOrUpdateCustomerArgs = {
  input: CreateOrUpdateCustomerInput;
};


export type MutationCreateOrUpdateWeldSubscriptionArgs = {
  currency: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  numConnectors: Scalars['Int']['input'];
  numUsers: Scalars['Int']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  priceId: Scalars['String']['input'];
};


export type MutationCreatePaymentMethodCheckoutSessionArgs = {
  input: CreatePaymentMethodCheckoutSessionInput;
};


export type MutationCreateSecretBackofficeArgs = {
  secretName: Scalars['String']['input'];
  secretString: Scalars['String']['input'];
};


export type MutationCreateSyncArgs = {
  input: CreateSyncInput;
};


export type MutationCreateTemplateArgs = {
  accountId: Scalars['String']['input'];
  template: TemplatesEnum;
};


export type MutationCreateWebhookArgs = {
  data: CreateWebhookInput;
};


export type MutationCreateWeldSubscriptionArgs = {
  currency: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  numConnectors: Scalars['Int']['input'];
  numUsers: Scalars['Int']['input'];
  paymentMethodId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
};


export type MutationCreateWorkflowArgs = {
  cronExpression: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateWorkspaceWithManagedDatawarehouseArgs = {
  input: CreateManagedWorkspaceInput;
};


export type MutationDeclineOwnInvitationArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type MutationDeleteApiKeyArgs = {
  apiKeyId: Scalars['String']['input'];
};


export type MutationDeleteConnectionBridgeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteFolderWithContentArgs = {
  folderId: Scalars['String']['input'];
};


export type MutationDeleteIntegrationMetadataBackofficeArgs = {
  integrationId: Scalars['String']['input'];
};


export type MutationDeleteInvitationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteModelFolderArgs = {
  folderId: Scalars['String']['input'];
};


export type MutationDeleteOnboardingConnectionArgs = {
  integrationId: Scalars['String']['input'];
};


export type MutationDeleteRawViewArgs = {
  viewId: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteWebhookArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteWorkflowArgs = {
  cronSchedule: Scalars['String']['input'];
  workflowId: Scalars['ID']['input'];
};


export type MutationEditWorkflowArgs = {
  cronExpression?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  workflowId: Scalars['ID']['input'];
};


export type MutationImportDwDirectoryArgs = {
  input: ImportDwDirectoryInput;
};


export type MutationInitiateModelFoldersArgs = {
  initiateFoldersInput: Array<CreateFolderInput>;
};


export type MutationMigrateAccountsBackToAwsBackofficeArgs = {
  input: MigrateAccountsRequest;
};


export type MutationMigrateAccountsBackofficeArgs = {
  input: MigrateAccountsRequest;
};


export type MutationMigrateEltSyncBackofficeArgs = {
  input: MigrateEltSyncRequest;
};


export type MutationMigrateEltSyncDirectlyBackofficeArgs = {
  input: GetEltSyncMigrationRequest;
};


export type MutationMigrateSecretsForAccountBackofficeArgs = {
  input: MigrateSecretsForAccountRequest;
};


export type MutationMoveModelArgs = {
  input: MoveModelInput;
};


export type MutationProcessOverdueInvoicesOnCustomerArgs = {
  customerId: Scalars['String']['input'];
  referenceDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationPublishModelAsyncArgs = {
  input: PublishModelInput;
};


export type MutationRecreateDestinationViewArgs = {
  eltSyncId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
};


export type MutationRecreateSubscriptionInCurrencyArgs = {
  currency: Scalars['String']['input'];
  priceId?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['String']['input'];
};


export type MutationRecreateSubscriptionWithBillingCycleAnchoredToMidnightUtcArgs = {
  subscriptionIds: Array<Scalars['String']['input']>;
};


export type MutationRefreshDestinationArgs = {
  id: Scalars['String']['input'];
};


export type MutationRematerializeNowArgs = {
  modelId: Scalars['String']['input'];
};


export type MutationRemoveConnectionArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveCurrentUserFromAccountBackofficeArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationRemoveDashboardModelsArgs = {
  dashboardId: Scalars['String']['input'];
};


export type MutationRemoveEltSyncArgs = {
  input: RemoveEltSyncInput;
};


export type MutationRemoveModelArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveModelTestArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveNotificationArgs = {
  input: RemoveNotificationInput;
};


export type MutationRemoveNotificationBackofficeArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveNotificationEmailArgs = {
  input: NotificationEmailInput;
};


export type MutationRemoveSyncArgs = {
  input: StartSyncInput;
};


export type MutationRemoveTableFromSyncArgs = {
  input: RemoveTableFromSyncInput;
};


export type MutationRenameModelFolderArgs = {
  updateFolderInput: UpdateFolderInput;
};


export type MutationRequestBetaConnectorAccessArgs = {
  integrationId: Scalars['String']['input'];
};


export type MutationRequestConnectorArgs = {
  integrationName: Scalars['String']['input'];
  integrationTypes: Array<Scalars['String']['input']>;
};


export type MutationRequestDestinationArgs = {
  integrationId: Scalars['String']['input'];
};


export type MutationResendOwnInvitationArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationResetAllErrorsArgs = {
  id: Scalars['String']['input'];
};


export type MutationResetErrorsArgs = {
  id: Scalars['String']['input'];
  objectIds: Array<Scalars['String']['input']>;
};


export type MutationResetSyncBackOfficeArgs = {
  input: ResetEltSyncInput;
};


export type MutationRestoreDeletedModelArgs = {
  id: Scalars['String']['input'];
};


export type MutationRevertCloudProviderOnSourceStreamsArgs = {
  input: RevertSourceStreamInput;
};


export type MutationRevertSubscriptionCancelationArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type MutationRunJobNowArgs = {
  input: RunJobNowInput;
};


export type MutationRunOrchestrationWorkflowNowArgs = {
  workflowId: Scalars['ID']['input'];
};


export type MutationRunOrchestrationWorkflowNowBackofficeArgs = {
  workflowId: Scalars['ID']['input'];
};


export type MutationRunSyncNowArgs = {
  input: StartSyncInput;
};


export type MutationSaveErdForIntegrationArgs = {
  input: StoredErdInput;
};


export type MutationSaveSignupQuestionnaireResultArgs = {
  input: SaveSignupQuestionnaireResultInput;
};


export type MutationSendInvitationArgs = {
  input: SendInvitationInput;
};


export type MutationSetDatawarehouseArgs = {
  createConnectionInput: CreateConnectionInput;
};


export type MutationSetDevStatusArgs = {
  input: DevStatusInput;
};


export type MutationSetMfaArgs = {
  use_mfa: Scalars['Boolean']['input'];
};


export type MutationSetMaxBillableRowsArgs = {
  maxRows?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetNextSyncToFullSyncArgs = {
  forceFullSync: Scalars['Boolean']['input'];
  sourceStreamId: Scalars['String']['input'];
};


export type MutationSetOnboardingConnectionsArgs = {
  accountId: Scalars['String']['input'];
  integrationIds: Array<Scalars['String']['input']>;
};


export type MutationSetTrialEndDateBackofficeArgs = {
  accountId: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
};


export type MutationSetupSlackNotificationsArgs = {
  input: SetupSlackInput;
};


export type MutationSetupTemplateArgs = {
  templateId: Scalars['String']['input'];
};


export type MutationStartDatawarehouseMigrationArgs = {
  createConnectionInput: CreateConnectionInput;
};


export type MutationStartEltSyncArgs = {
  input: StartEltSyncInput;
};


export type MutationStartEltSyncBackofficeArgs = {
  accountId: Scalars['String']['input'];
  eltSyncId: Scalars['String']['input'];
};


export type MutationStartSelfOnboardingProcessArgs = {
  location: Scalars['String']['input'];
};


export type MutationStartSyncArgs = {
  input: StartSyncInput;
};


export type MutationStopEltSyncArgs = {
  input: StartEltSyncInput;
};


export type MutationStopEltSyncBackofficeArgs = {
  accountId: Scalars['String']['input'];
  eltSyncId: Scalars['String']['input'];
};


export type MutationStopSyncArgs = {
  input: StartSyncInput;
};


export type MutationSubmitProductNpsArgs = {
  input: SubmitSurveyInput;
};


export type MutationTerminateGcpBatchJobArgs = {
  id: Scalars['String']['input'];
};


export type MutationUnpublishModelArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateBillingDetailsArgs = {
  billingDetails: BillingDetailsInput;
  customerId: Scalars['ID']['input'];
};


export type MutationUpdateConnectionArgs = {
  input: UpdateConnectionInput;
};


export type MutationUpdateDataWarehouseConnectionIdHackArgs = {
  dataWarehouseConnectionId: Scalars['String']['input'];
};


export type MutationUpdateDraftModelNameArgs = {
  input: UpdateDraftModelNameInput;
};


export type MutationUpdateEltSyncArgs = {
  input: UpdateEltSyncInput;
};


export type MutationUpdateFolderEmojiArgs = {
  emoji?: InputMaybe<Scalars['String']['input']>;
  folderId: Scalars['String']['input'];
};


export type MutationUpdateIntegrationMetadataBackofficeArgs = {
  input: SaveIntegrationMetadataInput;
};


export type MutationUpdateModelDocumentationArgs = {
  input: UpdateModelDocumentationInput;
};


export type MutationUpdateModelEmojiArgs = {
  emoji?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
};


export type MutationUpdateModelTestArgs = {
  updateModelTestInput: UpdateModelTestInput;
};


export type MutationUpdatePublishedModelMaterializationArgs = {
  input: UpdatePublishedModelMaterializationInput;
};


export type MutationUpdatePublishedModelQueryAsyncArgs = {
  input: UpdateModelQueryInput;
};


export type MutationUpdateSourceStreamArgs = {
  input: UpdateSourceStreamInput;
  sourceStreamId: Scalars['String']['input'];
};


export type MutationUpdateSubscriptionAddOnsArgs = {
  input: UpdateSubscriptionAddOnsInput;
  subscriptionId: Scalars['String']['input'];
};


export type MutationUpdateSyncArgs = {
  input: UpdateSyncInput;
};


export type MutationUpdateUnpublishedModelSqlQueryArgs = {
  input: UpdateModelQueryInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserAccountRoleArgs = {
  role: Role;
  userId: Scalars['String']['input'];
};


export type MutationUpsertUserSignupInfoArgs = {
  input: UpsertUserSignupInfoInput;
};


export type MutationUseInvitationArgs = {
  invitationId: Scalars['String']['input'];
};

export type NodeData = {
  __typename?: 'NodeData';
  childOf?: Maybe<Scalars['String']['output']>;
  fields: Array<ErdField>;
  isSubTable?: Maybe<Scalars['Boolean']['output']>;
  tableName: Scalars['String']['output'];
};

export type NodeDataInput = {
  childOf?: InputMaybe<Scalars['String']['input']>;
  fields: Array<ErdFieldInput>;
  isSubTable?: InputMaybe<Scalars['Boolean']['input']>;
  tableName: Scalars['String']['input'];
};

export type NodePosition = {
  __typename?: 'NodePosition';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type NodePositionInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type Notification = {
  __typename?: 'Notification';
  accountId: Scalars['String']['output'];
  accountName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  detail: Scalars['JSONObject']['output'];
  entityId: Scalars['String']['output'];
  entityName?: Maybe<Scalars['String']['output']>;
  entityType: NotificationEntityType;
  expiration?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isDismissable: Scalars['Boolean']['output'];
  isLock: Scalars['Boolean']['output'];
  lastOccurence: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
  messageData?: Maybe<Scalars['JSONObject']['output']>;
  notificationLevel: NotificationLevel;
  source: NotificationSources;
  type: NotificationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationEmailInput = {
  notificationEmail: Scalars['String']['input'];
};

export enum NotificationEntityType {
  Account = 'ACCOUNT',
  Connector = 'CONNECTOR',
  Materialisation = 'MATERIALISATION',
  Stream = 'STREAM',
  Sync = 'SYNC',
  Template = 'TEMPLATE',
  Workflow = 'WORKFLOW'
}

export enum NotificationLevel {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export enum NotificationSources {
  ActivateDestinationWorker = 'ACTIVATE_DESTINATION_WORKER',
  ActivateScheduler = 'ACTIVATE_SCHEDULER',
  ActivateSourceWorker = 'ACTIVATE_SOURCE_WORKER',
  Backend = 'BACKEND',
  BillingApi = 'BILLING_API',
  DataWarehouseApi = 'DATA_WAREHOUSE_API',
  EltDestinationWorker = 'ELT_DESTINATION_WORKER',
  EltScheduler = 'ELT_SCHEDULER',
  EltSourceWorker = 'ELT_SOURCE_WORKER',
  Global = 'GLOBAL',
  NotificationApi = 'NOTIFICATION_API',
  Orchestrator = 'ORCHESTRATOR',
  Test = 'TEST'
}

export enum NotificationType {
  AccountInactivityNotice_2D = 'ACCOUNT_INACTIVITY_NOTICE_2D',
  AccountInactivityNotice_14D = 'ACCOUNT_INACTIVITY_NOTICE_14D',
  ActivateBadQuery = 'ACTIVATE_BAD_QUERY',
  ActivateQuarantine = 'ACTIVATE_QUARANTINE',
  AirtableTableNotFound = 'AIRTABLE_TABLE_NOT_FOUND',
  ApiNotEnoughPermissions = 'API_NOT_ENOUGH_PERMISSIONS',
  BigqueryBilling = 'BIGQUERY_BILLING',
  BigqueryNotEnabled = 'BIGQUERY_NOT_ENABLED',
  BusinessCentralDataUpgradeNeeded = 'BUSINESS_CENTRAL_DATA_UPGRADE_NEEDED',
  ChargebeeApiRestricted = 'CHARGEBEE_API_RESTRICTED',
  ConnectionCreatedByExternalUser = 'CONNECTION_CREATED_BY_EXTERNAL_USER',
  ConnectionUpdatedByExternalUser = 'CONNECTION_UPDATED_BY_EXTERNAL_USER',
  ConnectorAccountNotFound = 'CONNECTOR_ACCOUNT_NOT_FOUND',
  ConnectorBadApiKey = 'CONNECTOR_BAD_API_KEY',
  ConnectorBadOauth = 'CONNECTOR_BAD_OAUTH',
  ConnectorPlanRequirementViolation = 'CONNECTOR_PLAN_REQUIREMENT_VIOLATION',
  CreateRawViewFailed = 'CREATE_RAW_VIEW_FAILED',
  CustomConnectorFailedRequest = 'CUSTOM_CONNECTOR_FAILED_REQUEST',
  CustomConnectorMissingSchema = 'CUSTOM_CONNECTOR_MISSING_SCHEMA',
  CustomConnectorWrongSchema = 'CUSTOM_CONNECTOR_WRONG_SCHEMA',
  DatabaseAuthError = 'DATABASE_AUTH_ERROR',
  DatabaseConnectionError = 'DATABASE_CONNECTION_ERROR',
  DatabaseIncrementalMisconfigured = 'DATABASE_INCREMENTAL_MISCONFIGURED',
  DatabaseTableNotExist = 'DATABASE_TABLE_NOT_EXIST',
  DatabaseTableNotFound = 'DATABASE_TABLE_NOT_FOUND',
  DynamoDbStreamNotEnabled = 'DYNAMO_DB_STREAM_NOT_ENABLED',
  Example = 'EXAMPLE',
  ExcelDatasetNotFound = 'EXCEL_DATASET_NOT_FOUND',
  ExcelDatasetTooLarge = 'EXCEL_DATASET_TOO_LARGE',
  ExcelOverlappingTables = 'EXCEL_OVERLAPPING_TABLES',
  FacebookAdsLostAdAccountAccess = 'FACEBOOK_ADS_LOST_AD_ACCOUNT_ACCESS',
  FreeTrialExpired = 'FREE_TRIAL_EXPIRED',
  FtpAuthError = 'FTP_AUTH_ERROR',
  GoogleInvalidGrant = 'GOOGLE_INVALID_GRANT',
  GoogleSheetsBadNamedRange = 'GOOGLE_SHEETS_BAD_NAMED_RANGE',
  IncompatibleSchemaForHistoryTable = 'INCOMPATIBLE_SCHEMA_FOR_HISTORY_TABLE',
  InstagramAuthError = 'INSTAGRAM_AUTH_ERROR',
  LinkedinMissingAccount = 'LINKEDIN_MISSING_ACCOUNT',
  ManagedBqUsageExceededLock = 'MANAGED_BQ_USAGE_EXCEEDED_LOCK',
  ManagedBqUsageExceededSoftLimit = 'MANAGED_BQ_USAGE_EXCEEDED_SOFT_LIMIT',
  MandatoryAccountTrialStarted = 'MANDATORY_ACCOUNT_TRIAL_STARTED',
  MaterialisationFailure = 'MATERIALISATION_FAILURE',
  MaxRowCountExceeded = 'MAX_ROW_COUNT_EXCEEDED',
  MaxRowCountExceededYearly = 'MAX_ROW_COUNT_EXCEEDED_YEARLY',
  ModelBadQuery = 'MODEL_BAD_QUERY',
  NetsuiteConcurrencyLimitExceededError = 'NETSUITE_CONCURRENCY_LIMIT_EXCEEDED_ERROR',
  OrchestrationWorkflowRunFailed = 'ORCHESTRATION_WORKFLOW_RUN_FAILED',
  OverdueInvoiceReminder = 'OVERDUE_INVOICE_REMINDER',
  OverdueInvoiceServiceSuspension = 'OVERDUE_INVOICE_SERVICE_SUSPENSION',
  PostgresDatabaseInsufficientPrivilege = 'POSTGRES_DATABASE_INSUFFICIENT_PRIVILEGE',
  PostgresFailedConnection = 'POSTGRES_FAILED_CONNECTION',
  PostgresTableInsufficientPrivilege = 'POSTGRES_TABLE_INSUFFICIENT_PRIVILEGE',
  PrimaryKeyNotUnique = 'PRIMARY_KEY_NOT_UNIQUE',
  ProtectedStreamFullSync = 'PROTECTED_STREAM_FULL_SYNC',
  Quarantine = 'QUARANTINE',
  ShopifyPaymentRequired = 'SHOPIFY_PAYMENT_REQUIRED',
  SnowflakeAccountBilling = 'SNOWFLAKE_ACCOUNT_BILLING',
  SnowflakeAccountLocked = 'SNOWFLAKE_ACCOUNT_LOCKED',
  StreamIsDeprecated = 'STREAM_IS_DEPRECATED',
  SubscriptionCancelationReverted = 'SUBSCRIPTION_CANCELATION_REVERTED',
  SubscriptionCanceled = 'SUBSCRIPTION_CANCELED',
  SubscriptionCreated = 'SUBSCRIPTION_CREATED',
  SubscriptionPlanMigrationConfirmation = 'SUBSCRIPTION_PLAN_MIGRATION_CONFIRMATION',
  SubscriptionUpgraded = 'SUBSCRIPTION_UPGRADED',
  SyncFrequencyForced = 'SYNC_FREQUENCY_FORCED',
  TemplateReady = 'TEMPLATE_READY',
  Unknown = 'UNKNOWN'
}

export type ObjectType = {
  __typename?: 'ObjectType';
  associations: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  objectName: Scalars['String']['output'];
  objectTypeId: Scalars['String']['output'];
  supportedDestinationMapping: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type OnDemandReverseEtlSyncEligibilityResponse = {
  __typename?: 'OnDemandReverseETLSyncEligibilityResponse';
  possible: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type OnDemandSyncEligibilityResponse = {
  __typename?: 'OnDemandSyncEligibilityResponse';
  possible: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type OnboardingConnection = {
  __typename?: 'OnboardingConnection';
  integrationId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type Operation = {
  __typename?: 'Operation';
  availableOperationId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  mappings: Array<Mapping>;
  objectType: Scalars['String']['output'];
  operationMode: OperationModes;
  operationType: OperationTypes;
  primaryKeyMapping?: Maybe<Mapping>;
  primaryKeyMappingId?: Maybe<Scalars['String']['output']>;
  primaryKeyRequired: Scalars['Boolean']['output'];
  sync: Sync;
  updatedAt: Scalars['DateTime']['output'];
};

export enum OperationMode {
  Append = 'APPEND',
  Full = 'FULL',
  Incremental = 'INCREMENTAL'
}

export enum OperationModes {
  Insert = 'insert',
  Mirror = 'mirror',
  Update = 'update',
  Upsert = 'upsert'
}

export enum OperationTypes {
  Association = 'association',
  Primary = 'primary'
}

export enum OrchestrationSchedulerType {
  Global = 'global',
  Local = 'local'
}

export type OrchestrationWorkflow = {
  __typename?: 'OrchestrationWorkflow';
  accountId: Scalars['ID']['output'];
  cronExpression: Scalars['String']['output'];
  currentRun?: Maybe<OrchestrationWorkflowRun>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nextRun?: Maybe<OrchestrationWorkflowRun>;
  runs: Array<OrchestrationWorkflowRun>;
};


export type OrchestrationWorkflowRunsArgs = {
  offset?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};

export type OrchestrationWorkflowRun = {
  __typename?: 'OrchestrationWorkflowRun';
  dueAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<WorkflowRunFailureReason>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  jobs: Array<WorkflowJob>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: WorkflowRunStatus;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  card: Card;
};

export type PlanLimitsStatus = {
  __typename?: 'PlanLimitsStatus';
  isConnectionsLimitReached: Scalars['Boolean']['output'];
  isUsersLimitReached: Scalars['Boolean']['output'];
};

export enum PlanName {
  Basic = 'Basic',
  Business = 'Business',
  Core = 'Core',
  Custom = 'Custom',
  Enterprise = 'Enterprise',
  Essential = 'Essential',
  FreeTrial = 'FreeTrial',
  Growth = 'Growth',
  Premium = 'Premium',
  Pro = 'Pro'
}

export type PlanValidationResult = {
  __typename?: 'PlanValidationResult';
  result: Scalars['Boolean']['output'];
};

export type PreviewQueryInput = {
  dependencies: Array<QueryDependencyInput>;
  sourceConnectionId: Scalars['String']['input'];
  weldSql: Scalars['String']['input'];
};

/** Response type when previewing a query. */
export type PreviewQueryResponse = {
  __typename?: 'PreviewQueryResponse';
  dwSql: Scalars['String']['output'];
  response: Array<Scalars['JSONObject']['output']>;
};

export type Price = {
  __typename?: 'Price';
  billingScheme: BillingScheme;
  currency: Scalars['String']['output'];
  currencyOptions: Array<CurrencyOption>;
  id: Scalars['String']['output'];
  lookupKey?: Maybe<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  recurring?: Maybe<Recurring>;
  tiers?: Maybe<Array<Tier>>;
  tiersMode?: Maybe<TiersMode>;
};

export type PriceLookupKeyMap = {
  __typename?: 'PriceLookupKeyMap';
  monthly: Scalars['String']['output'];
  yearly: Scalars['String']['output'];
};

export type Product = {
  __typename?: 'Product';
  active: Scalars['Boolean']['output'];
  addOnType?: Maybe<WeldAddOnType>;
  description?: Maybe<Scalars['String']['output']>;
  features: StripePlanFeatures;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price: Price;
  type: WeldProductType;
};

export type PromptableSurveyResponse = {
  __typename?: 'PromptableSurveyResponse';
  survey?: Maybe<Survey>;
};

export type Property = {
  __typename?: 'Property';
  automapMatchAny: Scalars['Boolean']['output'];
  connection: Connection;
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  isPrimaryKey: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  object?: Maybe<Scalars['String']['output']>;
  propertyId: Scalars['String']['output'];
  propertyName: Scalars['String']['output'];
  propertyType: Scalars['String']['output'];
  readonly: Scalars['Boolean']['output'];
};

export type PublishModelInput = {
  id: Scalars['String']['input'];
  isUnsavedModel: Scalars['Boolean']['input'];
  materializationSchedule?: InputMaybe<Scalars['String']['input']>;
  materializationType: MaterializationType;
  modelFolderId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orchestrationScheduler?: InputMaybe<OrchestrationSchedulerType>;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  query: QueryInput;
  sourceConnectionId: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  accountById: Account;
  accountBySlug: Account;
  accountBySlugBackoffice: Account;
  accountUsageSummary: AccountUsageSummary;
  activeInitialSyncs: Array<EltSync>;
  allDestinationIntegrations: Array<EnhancedIntegration>;
  allErds: Array<StoredErd>;
  allNotificationsBackoffice: Array<Notification>;
  allWeldPlans: Array<WeldPlan>;
  apiKeys: Array<ApiKeyResponse>;
  apiSecretKey: Scalars['String']['output'];
  asyncQueryPreviewResult?: Maybe<AsyncQueryResultResponse>;
  asyncQueryStatus?: Maybe<AsyncQueryStatusResponse>;
  availableIntegrations: Array<AvailableIntegration>;
  backofficeDailyUsageState: Array<BackofficeWorkspaceUsageStats>;
  backofficeUsageForecastTrainingData: Array<HistoricalValue>;
  bestFitPlan: BestFitPlan;
  bigQueryUsageStats: BigQueryStats;
  canAddConnection: PlanValidationResult;
  chatMessages: Array<ChatMessage>;
  chatThread: ChatThread;
  chatThreads: Array<ChatThread>;
  checkOnDemandReverseEtlSyncEligibility: OnDemandReverseEtlSyncEligibilityResponse;
  checkOnDemandSyncEligibility: OnDemandSyncEligibilityResponse;
  connection: Connection;
  connectionBridges: Array<ConnectionBridgeResponse>;
  connections: Array<Connection>;
  connectors: Array<Connection>;
  countries: Array<Country>;
  current: CurrentUser;
  currentMonthUsageForecast: UsageForecastResponse;
  currentPlan: WeldPlan;
  currentSubscriptionState: SubscriptionState;
  customer?: Maybe<Customer>;
  dailyUsageStatsForMonth: WorkspaceSyncStatsResponse;
  datawarehouseMigration?: Maybe<DatawarehouseMigration>;
  deletedModels: Array<Model>;
  destinationIntegrations: Array<AvailableIntegration>;
  destinationProperties: Array<Property>;
  eltJobsCompletionStats: SyncJobsCompletionMetricResponse;
  eltSync: EltSync;
  eltSyncSnapshotState: EltSyncSnapshotState;
  eltSyncSnapshotStateBackoffice: EltSyncSnapshotState;
  eltSyncStatsHistoric: EltSyncHistoryStatsResponse;
  eltSyncStatsRecent: EltSyncHistoryStatsResponse;
  eltSyncs: Array<EltSync>;
  failedSyncs: Array<FindFailedSyncsResponse>;
  failedTables: Array<MaterializedTableReference>;
  findAllAvailableAuditLogs: FindAllAvailableAuditLogsResponse;
  findAllAvailableOperations: Array<FindAvailableOperationsResponse>;
  findAllConnectionsBackoffice: Array<BackofficeConnection>;
  findAllMappingsBySyncId: Array<Mapping>;
  findEltSyncLatestHistory: Array<FindSyncHistoryResponse>;
  findManyEltSyncHistory: Array<FindSyncHistoryResponse>;
  findManyEltSyncHistoryBackoffice: Array<FindSyncHistoryResponse>;
  findMapping: Mapping;
  findOneSync: Sync;
  findRedisKeys: Array<Scalars['String']['output']>;
  findReverseEltSyncHistory: Array<FindSyncHistoryResponse>;
  firebaseToken: Scalars['String']['output'];
  generateConnectionLabel: Scalars['String']['output'];
  getAccountBackoffice: Account;
  getAccountsWithSyncsBlockedBackoffice: Array<Account>;
  getAccountsWithoutBillingBackoffice: Array<Account>;
  getActivateSettings: IntegrationSettings;
  getAddOnProductsByIds: Array<Product>;
  getAllAccounts: Array<Account>;
  getAllAccountsBackoffice: Array<Account>;
  getAllAvroSchemas: GetAllAvroSchemasResponse;
  getAllTables: GetAllTablesResponse;
  getAvailableAddOnProducts: Array<Product>;
  getCheckoutPreview: UpcomingInvoice;
  getCustomFormValues: CustomFormValues;
  getDWCredentials: Scalars['String']['output'];
  getDWDirectory: Directory;
  getDWDirectoryItems: Array<DwDirectoryItem>;
  getDatawarehouseSetupStatus: SetDataWarehouseResult;
  getEltSettings: IntegrationSettings;
  getEltSyncDetailsBackoffice?: Maybe<EltSync>;
  getErdForIntegration: RawErdResponse;
  getErrorLogs: Array<ErrorLogsResponse>;
  getErrorLogsBackOffice: Array<ErrorLogsResponse>;
  getErrors: Array<ActivateError>;
  getGcpBatchJobs: GcpBatchJobs;
  getIntegrationIdsForErd: Array<Scalars['String']['output']>;
  getJobLogs: Array<GetJobLogsResponse>;
  getMFA: MfaInfoResult;
  getMigrationResult: EltSyncMigrationResult;
  getOAuthURL: Scalars['String']['output'];
  getObjectTypeSettings: DestinationObjectTypeSettings;
  getOnboardingConnections: Array<OnboardingConnection>;
  getPendingOnboardingConnections: Array<OnboardingConnection>;
  getPlanLimitsStatus: PlanLimitsStatus;
  getPlanProduct?: Maybe<Product>;
  getProductPrice: Price;
  getProductPriceByLookupKey: Price;
  getPromptableProductNPSSurvey: PromptableSurveyResponse;
  getRawViews: Array<RawViewReference>;
  getSelfOnboardingProcessStatus: SelfOnboardingStatus;
  getSetupGuideUrl?: Maybe<Scalars['String']['output']>;
  getSignupQuestionnaireResult: GetSignupQuestionnaireResponse;
  getSlackChannels: Array<SlackChannel>;
  getStaticPreview: UpcomingInvoice;
  getStaticPreviewByLookupKey: UpcomingInvoice;
  getStoredErdForIntegration?: Maybe<StoredErd>;
  getStreams: Array<Stream>;
  getStreamsAsync: AsyncStreamsStatus;
  getStreamsAsyncJobStatus: AsyncStreamsStatus;
  getSubscriptionsWithMisconfiguredBillingCycles: Array<Scalars['String']['output']>;
  getTemplates: Array<Template>;
  getTestResult: ModelTestResult;
  getViewDetails: ViewDetails;
  getWebhookData: WebhookDataResponse;
  hasDeletedModels: HasDeletedModelsResponse;
  initialSyncsStatus: Array<InitialSyncStatusResponse>;
  integration: Scalars['JSONObject']['output'];
  integrationConfiguration: IntegrationConfiguration;
  integrations: Array<Scalars['JSONObject']['output']>;
  integrationsBackoffice: Array<IntegrationResource>;
  invitations: Array<Invitation>;
  invoices: Array<Invoice>;
  latestUsageRecordSummaryBackoffice?: Maybe<UsageRecordSummary>;
  listEltSyncsBackoffice: Array<EltSync>;
  listFailedSyncsBackoffice: Array<EltSyncJobResponse>;
  listModelFolders: Array<ModelFolder>;
  listTemplateConfigurations: Array<TemplateConfig>;
  listWebhoooks: Array<WebhookResponse>;
  materializedTableReference?: Maybe<MaterializedTableReference>;
  model: Model;
  modelTest: ModelTest;
  modelTestRun?: Maybe<ModelTestRun>;
  modelUsageSummary: ModelUsageSummaryDto;
  modelViewReference?: Maybe<MaterializedTableReference>;
  models: Array<Model>;
  modelsByIds: Array<Model>;
  mostRecentPublishedModels: Array<Model>;
  notifications: Array<Notification>;
  notificationsByAccountBackoffice: Array<Notification>;
  objectTypes: Array<ObjectType>;
  openInvitations: Array<Invitation>;
  orchestrationWorkflow?: Maybe<OrchestrationWorkflow>;
  orchestrationWorkflowRun: OrchestrationWorkflowRun;
  orchestrationWorkflows: Array<OrchestrationWorkflow>;
  overdueInvoices: Array<Invoice>;
  previewQuery: PreviewQueryResponse;
  publishedModels: Array<Model>;
  queryModel: QueryModelResponse;
  rawViewStats: RawViewsStats;
  resolveCountryFromTimeZone: ResolveCountryResponse;
  retrieveRedisKey: Scalars['JSONObject']['output'];
  retrieveSecretByArn: Scalars['String']['output'];
  retrieveSecretBySyncId: Scalars['String']['output'];
  reverseEtlJobsCompletionStats: SyncJobsCompletionMetricResponse;
  savedDrafts: Array<Model>;
  scheduledIncidents: Array<Incident>;
  searchAccountsBackoffice: Array<Account>;
  searchModels: Array<Model>;
  sendSubscriptionPlanMigrationConfirmation: Scalars['JSONObject']['output'];
  slugAvailability: SlugAvailabilityResponse;
  sourceProperties: ViewDetails;
  sourceStreamSyncStates: SourceStreamSyncStatesResponse;
  sourceStreamsWithSubStreams: Array<Stream>;
  sqlQuery: SqlQuery;
  startTest: ModelTestResult;
  subscriptionBackoffice?: Maybe<StripeSubscriptionDetails>;
  subscriptionDetails?: Maybe<StripeSubscriptionDetails>;
  syncs: Array<Sync>;
  taxIdsData: Array<TaxIdData>;
  throwError: Scalars['Boolean']['output'];
  unresolvedIncidents: Array<Incident>;
  upcomingInvoice: UpcomingInvoice;
  usageStatsLast30Days: WorkspaceSyncStatsLast30DaysResponse;
  user: User;
  users: Array<User>;
  validateConnectionAddition: ValidationResult;
  validateCurrentConnectionUsageAgainstPlan: ConnectorPlanValidationResult;
  validateCustomForm: CustomFormValidationResult;
  verifyUnpublishedChanges: VerifyUnpublishedChangesResponse;
  websiteConnectors: Array<EnhancedDataConnector>;
  websiteIntegrations: Array<EnhancedIntegration>;
  weldPlan: WeldPlan;
  workspaceStats: WorkspaceStats;
  workspaceSyncStats: WorkspaceSyncStatsResponse;
  workspaceSyncStatsByIntegration: IntegrationSyncStatsResponse;
  workspaceSyncStatsBySourceStream: SourceStreamSyncStatsResponse;
};


export type QueryAccountByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryAccountBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryAccountBySlugBackofficeArgs = {
  slug: Scalars['String']['input'];
};


export type QueryAccountUsageSummaryArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryApiSecretKeyArgs = {
  apiKeyId: Scalars['String']['input'];
};


export type QueryAsyncQueryPreviewResultArgs = {
  queryExecutionId: Scalars['ID']['input'];
  sourceConnectionId: Scalars['ID']['input'];
};


export type QueryAsyncQueryStatusArgs = {
  queryExecutionId: Scalars['ID']['input'];
  sourceConnectionId: Scalars['ID']['input'];
};


export type QueryBackofficeDailyUsageStateArgs = {
  accountId: Scalars['String']['input'];
  historicalDataLookbackDays: Scalars['Float']['input'];
  referenceDate: Scalars['DateTime']['input'];
};


export type QueryBackofficeUsageForecastTrainingDataArgs = {
  accountId: Scalars['String']['input'];
  historicalDataLookbackDays: Scalars['Float']['input'];
  referenceDate: Scalars['DateTime']['input'];
};


export type QueryCanAddConnectionArgs = {
  integrationId: Scalars['String']['input'];
};


export type QueryChatMessagesArgs = {
  threadId: Scalars['String']['input'];
};


export type QueryChatThreadArgs = {
  id: Scalars['String']['input'];
};


export type QueryChatThreadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCheckOnDemandReverseEtlSyncEligibilityArgs = {
  input: StartSyncInput;
};


export type QueryCheckOnDemandSyncEligibilityArgs = {
  input: RunJobNowInput;
};


export type QueryConnectionArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryDailyUsageStatsForMonthArgs = {
  referenceDate: Scalars['DateTime']['input'];
};


export type QueryDestinationPropertiesArgs = {
  input: DestinationPropertiesInput;
};


export type QueryEltJobsCompletionStatsArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryEltSyncArgs = {
  id: Scalars['String']['input'];
};


export type QueryEltSyncSnapshotStateArgs = {
  syncId: Scalars['String']['input'];
};


export type QueryEltSyncSnapshotStateBackofficeArgs = {
  accountId: Scalars['String']['input'];
  syncId: Scalars['String']['input'];
};


export type QueryEltSyncStatsHistoricArgs = {
  from: Scalars['DateTime']['input'];
  sourceStreamName?: InputMaybe<Scalars['String']['input']>;
  syncId: Scalars['String']['input'];
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryEltSyncStatsRecentArgs = {
  from: Scalars['DateTime']['input'];
  sourceStreamName?: InputMaybe<Scalars['String']['input']>;
  syncId: Scalars['String']['input'];
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryFindAllAvailableOperationsArgs = {
  connectionId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
};


export type QueryFindAllConnectionsBackofficeArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryFindAllMappingsBySyncIdArgs = {
  syncId: Scalars['String']['input'];
};


export type QueryFindEltSyncLatestHistoryArgs = {
  syncId: Scalars['String']['input'];
};


export type QueryFindManyEltSyncHistoryArgs = {
  excludeEmpty?: Scalars['Boolean']['input'];
  sourceStreamName: Scalars['String']['input'];
  syncId: Scalars['String']['input'];
};


export type QueryFindManyEltSyncHistoryBackofficeArgs = {
  accountId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
  syncId: Scalars['String']['input'];
};


export type QueryFindMappingArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindOneSyncArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindRedisKeysArgs = {
  pattern: Scalars['String']['input'];
};


export type QueryFindReverseEltSyncHistoryArgs = {
  syncId: Scalars['String']['input'];
};


export type QueryGenerateConnectionLabelArgs = {
  baseLabel: Scalars['String']['input'];
};


export type QueryGetAccountBackofficeArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryGetActivateSettingsArgs = {
  input: GetSettingsInput;
};


export type QueryGetAddOnProductsByIdsArgs = {
  productIds: Array<Scalars['String']['input']>;
};


export type QueryGetAllAvroSchemasArgs = {
  connectionSettings: Scalars['JSONObject']['input'];
  sourceConnectionId: Scalars['String']['input'];
  sourceStreamNames: Array<Scalars['String']['input']>;
};


export type QueryGetAllTablesArgs = {
  input: Scalars['String']['input'];
};


export type QueryGetCheckoutPreviewArgs = {
  input: InvoicePreviewInput;
};


export type QueryGetCustomFormValuesArgs = {
  input: CustomFormInput;
};


export type QueryGetDwDirectoryArgs = {
  input: GetDwDirectoryInput;
};


export type QueryGetDwDirectoryItemsArgs = {
  input: GetDwDirectoryItemsInput;
};


export type QueryGetEltSettingsArgs = {
  input: GetSettingsInput;
};


export type QueryGetEltSyncDetailsBackofficeArgs = {
  eltSyncId: Scalars['String']['input'];
};


export type QueryGetErdForIntegrationArgs = {
  integrationId: Scalars['String']['input'];
};


export type QueryGetErrorLogsArgs = {
  eltSyncId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
};


export type QueryGetErrorLogsBackOfficeArgs = {
  scheduledJobId: Scalars['String']['input'];
};


export type QueryGetErrorsArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetGcpBatchJobsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Float']['input'];
};


export type QueryGetJobLogsArgs = {
  jobId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMigrationResultArgs = {
  input: GetEltSyncMigrationRequest;
};


export type QueryGetOAuthUrlArgs = {
  input: CreateOAuthFlowInput;
};


export type QueryGetObjectTypeSettingsArgs = {
  connectionId: Scalars['String']['input'];
  formValues?: InputMaybe<Scalars['JSONObject']['input']>;
  objectType: Scalars['String']['input'];
};


export type QueryGetPlanProductArgs = {
  planName: Scalars['String']['input'];
};


export type QueryGetProductPriceArgs = {
  currency: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
};


export type QueryGetProductPriceByLookupKeyArgs = {
  currency: Scalars['String']['input'];
  lookupKey: Scalars['String']['input'];
};


export type QueryGetSetupGuideUrlArgs = {
  integrationId: Scalars['String']['input'];
  isDatawarehouse: Scalars['Boolean']['input'];
};


export type QueryGetSlackChannelsArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryGetStaticPreviewArgs = {
  input: StaticInvoicePreviewInput;
};


export type QueryGetStaticPreviewByLookupKeyArgs = {
  input: StaticInvoicePreviewByLookupKeyInput;
};


export type QueryGetStoredErdForIntegrationArgs = {
  integrationId: Scalars['String']['input'];
};


export type QueryGetStreamsArgs = {
  connectionId: Scalars['String']['input'];
  eltSyncId?: InputMaybe<Scalars['String']['input']>;
  sourceSettings: Scalars['JSONObject']['input'];
};


export type QueryGetStreamsAsyncArgs = {
  connectionId: Scalars['String']['input'];
  sourceSettings: Scalars['JSONObject']['input'];
};


export type QueryGetStreamsAsyncJobStatusArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryGetTestResultArgs = {
  modelTestId: Scalars['ID']['input'];
  queryExecutionId: Scalars['String']['input'];
  sourceConnectionId: Scalars['String']['input'];
};


export type QueryGetViewDetailsArgs = {
  input: GetViewDetailsInput;
};


export type QueryGetWebhookDataArgs = {
  type: Scalars['String']['input'];
};


export type QueryInitialSyncsStatusArgs = {
  syncIds: Array<Scalars['String']['input']>;
};


export type QueryIntegrationArgs = {
  integrationId: Scalars['String']['input'];
};


export type QueryIntegrationConfigurationArgs = {
  integrationId: Scalars['String']['input'];
};


export type QueryInvitationsArgs = {
  getUsed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInvoicesArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryLatestUsageRecordSummaryBackofficeArgs = {
  subscriptionItemId: Scalars['String']['input'];
};


export type QueryListEltSyncsBackofficeArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryListFailedSyncsBackofficeArgs = {
  minFailures?: Scalars['Float']['input'];
};


export type QueryListWebhoooksArgs = {
  orchestrationWorkflowId: Scalars['String']['input'];
};


export type QueryMaterializedTableReferenceArgs = {
  modelId: Scalars['String']['input'];
};


export type QueryModelArgs = {
  id: Scalars['String']['input'];
};


export type QueryModelTestArgs = {
  id: Scalars['String']['input'];
};


export type QueryModelTestRunArgs = {
  modelTestId: Scalars['ID']['input'];
  workflowRunId: Scalars['ID']['input'];
};


export type QueryModelViewReferenceArgs = {
  modelId: Scalars['String']['input'];
};


export type QueryModelsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryNotificationsByAccountBackofficeArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryObjectTypesArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryOrchestrationWorkflowArgs = {
  workflowId: Scalars['ID']['input'];
};


export type QueryOrchestrationWorkflowRunArgs = {
  runId: Scalars['ID']['input'];
};


export type QueryOverdueInvoicesArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryPreviewQueryArgs = {
  input: PreviewQueryInput;
};


export type QueryQueryModelArgs = {
  modelId: Scalars['String']['input'];
};


export type QueryResolveCountryFromTimeZoneArgs = {
  timeZone: Scalars['String']['input'];
};


export type QueryRetrieveRedisKeyArgs = {
  key: Scalars['String']['input'];
};


export type QueryRetrieveSecretByArnArgs = {
  secretArn: Scalars['String']['input'];
};


export type QueryRetrieveSecretBySyncIdArgs = {
  eltSyncId: Scalars['String']['input'];
};


export type QueryReverseEtlJobsCompletionStatsArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QuerySearchAccountsBackofficeArgs = {
  search: Scalars['String']['input'];
};


export type QuerySearchModelsArgs = {
  publishedOnly: Scalars['Boolean']['input'];
  query: Scalars['String']['input'];
};


export type QuerySendSubscriptionPlanMigrationConfirmationArgs = {
  customerId: Scalars['String']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  prevPlanName: PlanName;
  startDate: Scalars['DateTime']['input'];
};


export type QuerySlugAvailabilityArgs = {
  slug: Scalars['String']['input'];
};


export type QuerySourcePropertiesArgs = {
  modelId: Scalars['String']['input'];
};


export type QuerySourceStreamSyncStatesArgs = {
  syncId: Scalars['String']['input'];
};


export type QuerySourceStreamsWithSubStreamsArgs = {
  connectionId: Scalars['String']['input'];
  eltSyncId: Scalars['String']['input'];
  sourceStreamNames: Array<Scalars['String']['input']>;
};


export type QuerySqlQueryArgs = {
  id: Scalars['String']['input'];
};


export type QueryStartTestArgs = {
  modelTestId: Scalars['ID']['input'];
};


export type QuerySubscriptionBackofficeArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type QuerySubscriptionDetailsArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type QueryUpcomingInvoiceArgs = {
  customerId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
};


export type QueryUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryValidateConnectionAdditionArgs = {
  integrationId: Scalars['String']['input'];
};


export type QueryValidateCurrentConnectionUsageAgainstPlanArgs = {
  planName: PlanName;
};


export type QueryValidateCustomFormArgs = {
  input: CustomFormValidationInput;
};


export type QueryVerifyUnpublishedChangesArgs = {
  modelId: Scalars['String']['input'];
};


export type QueryWeldPlanArgs = {
  planName: Scalars['String']['input'];
};


export type QueryWorkspaceSyncStatsArgs = {
  fromMonth: Scalars['DateTime']['input'];
  toMonth?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryWorkspaceSyncStatsByIntegrationArgs = {
  month: Scalars['DateTime']['input'];
};


export type QueryWorkspaceSyncStatsBySourceStreamArgs = {
  month: Scalars['DateTime']['input'];
};

export type QueryDependencyEntity = {
  __typename?: 'QueryDependencyEntity';
  dwItemId: Scalars['String']['output'];
  sqlQueryId: Scalars['String']['output'];
  type: DependencyType;
  weldTag: Scalars['String']['output'];
};

export type QueryDependencyInput = {
  dwItemId: Scalars['String']['input'];
  type: DependencyType;
  weldTag: Scalars['String']['input'];
};

export type QueryInput = {
  dependencies: Array<QueryDependencyInput>;
  weldSql: Scalars['String']['input'];
};

/** Response type when querying by Model. */
export type QueryModelResponse = {
  __typename?: 'QueryModelResponse';
  dwSql: Scalars['String']['output'];
  id: Scalars['String']['output'];
  response: Array<Scalars['JSONObject']['output']>;
};

export enum QueryResultStatusEnum {
  Done = 'DONE',
  Failed = 'FAILED',
  Running = 'RUNNING'
}

export type QueryUsage = {
  __typename?: 'QueryUsage';
  bqBilledUsd: Scalars['Float']['output'];
  bytesBilled: Scalars['Float']['output'];
  bytesProcessed: Scalars['Float']['output'];
};

export type RawErdResponse = {
  __typename?: 'RawErdResponse';
  edges: Array<ErdEdge>;
  integrationId: Scalars['String']['output'];
  nodes: Array<ErdNode>;
};

export type RawViewReference = {
  __typename?: 'RawViewReference';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  dwSqlReference: Scalars['String']['output'];
  eltTableSqlRef: Scalars['String']['output'];
  firstSyncCompleted: Scalars['Boolean']['output'];
  integrationId?: Maybe<Scalars['String']['output']>;
  latestSyncTime: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  scheduledJobId?: Maybe<Scalars['String']['output']>;
  schema: Scalars['String']['output'];
  sourceStream: Scalars['String']['output'];
  syncId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  viewId: Scalars['String']['output'];
  weldTag: Scalars['String']['output'];
};

export type RawViewsStats = {
  __typename?: 'RawViewsStats';
  numFirstSyncCompleted: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RecreateViewResponse = {
  __typename?: 'RecreateViewResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum RecurrenceInterval {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
  Year = 'Year'
}

export enum RecurrenceUsageType {
  Licensed = 'Licensed',
  Metered = 'Metered'
}

export type Recurring = {
  __typename?: 'Recurring';
  interval: RecurrenceInterval;
  intervalCount: Scalars['Int']['output'];
  usageType: RecurrenceUsageType;
};

export type RemoveEltSyncInput = {
  eltSyncId: Scalars['String']['input'];
  removeDataReferences?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemoveEltSyncResponse = {
  __typename?: 'RemoveEltSyncResponse';
  destinationConnectionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  sourceConnectionId: Scalars['String']['output'];
  sourceStreamNames: Array<Scalars['String']['output']>;
};

export type RemoveNotificationInput = {
  id: Scalars['String']['input'];
};

export type RemoveTableFromSyncInput = {
  sourceStreamName: Scalars['String']['input'];
  syncId: Scalars['String']['input'];
  viewId?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveTableResponse = {
  __typename?: 'RemoveTableResponse';
  sourceStreamName: Scalars['String']['output'];
};

export type ResetEltSyncInput = {
  eltSyncId: Scalars['String']['input'];
  numberOfErrors?: InputMaybe<Scalars['Float']['input']>;
  resetIncrementalPointer?: Scalars['Boolean']['input'];
  sourceIntegrationId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
};

export type ResetSyncResponse = {
  __typename?: 'ResetSyncResponse';
  job: Scalars['JSONObject']['output'];
  reason: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ResolveCountryResponse = {
  __typename?: 'ResolveCountryResponse';
  country?: Maybe<Country>;
};

export type ReverseEtlJobResponse = {
  __typename?: 'ReverseEtlJobResponse';
  isQuarantined?: Maybe<Scalars['Boolean']['output']>;
  lastRun?: Maybe<Scalars['Float']['output']>;
  nextRun?: Maybe<Scalars['Float']['output']>;
  running?: Maybe<Scalars['Boolean']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type RevertSourceStreamInput = {
  eltSyncId: Scalars['String']['input'];
  names: Array<Scalars['String']['input']>;
};

export enum Role {
  Admin = 'admin',
  Analyst = 'analyst',
  None = 'none'
}

export type RunJobNowInput = {
  eltSyncId: Scalars['String']['input'];
  sourceIntegrationId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
};

export type SaveIntegrationMetadataInput = {
  activateDestination?: InputMaybe<IntegrationDataConnectorInput>;
  aliasFor?: InputMaybe<Scalars['String']['input']>;
  baseId?: InputMaybe<Scalars['String']['input']>;
  biTool?: InputMaybe<IntegrationDataConnectorInput>;
  categories: Array<Scalars['String']['input']>;
  dataWarehouse?: InputMaybe<IntegrationDataConnectorInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentationUrl?: InputMaybe<Scalars['String']['input']>;
  eltSource?: InputMaybe<IntegrationDataConnectorInput>;
  integrationId: Scalars['String']['input'];
  isAvailable: Scalars['Boolean']['input'];
  logo?: InputMaybe<LogoConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiresAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveSignupQuestionnaireResultInput = {
  result: Scalars['JSONObject']['input'];
};

export type SchemaDto = {
  __typename?: 'SchemaDto';
  cursor?: Maybe<Scalars['String']['output']>;
  fields: Array<AvroSchemaFieldDto>;
  primaryKeys?: Maybe<Array<Scalars['String']['output']>>;
  sourceStreamName: Scalars['String']['output'];
};

export type SeedDatawarehouseResponse = {
  __typename?: 'SeedDatawarehouseResponse';
  models: Array<SeededModel>;
};

export type SeededModel = {
  __typename?: 'SeededModel';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SelfOnboardingStatus = {
  __typename?: 'SelfOnboardingStatus';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<GoogleProject>;
  status: Scalars['String']['output'];
};

export type SendInvitationInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role: Role;
};

export type SetDataWarehouseResult = {
  __typename?: 'SetDataWarehouseResult';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type SetupSlackInput = {
  channelId: Scalars['String']['input'];
  channelName: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
};

export type SignupQuestionnaireResult = {
  __typename?: 'SignupQuestionnaireResult';
  result: Scalars['JSONObject']['output'];
  timestamp: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
};

export type SlackChannel = {
  __typename?: 'SlackChannel';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SlackNotificationInfo = {
  __typename?: 'SlackNotificationInfo';
  channelId: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  connectionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type SlugAvailabilityResponse = {
  __typename?: 'SlugAvailabilityResponse';
  isAvailable: Scalars['Boolean']['output'];
};

export type SourceStream = {
  __typename?: 'SourceStream';
  createdAt: Scalars['DateTime']['output'];
  dataFilters: Array<SourceStreamDataFilter>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  eltSync: EltSync;
  fullSyncAlways: Scalars['Boolean']['output'];
  fullSyncAtMidnight: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  incrementalPointerId?: Maybe<Scalars['String']['output']>;
  incrementalPrimaryKeyName?: Maybe<Array<Scalars['String']['output']>>;
  job?: Maybe<GetSourceStreamJobResponse>;
  name: Scalars['String']['output'];
  operationMode: Scalars['String']['output'];
  protectedFromFullSync: Scalars['Boolean']['output'];
  substreams: Array<Substream>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SourceStreamDataFilter = {
  __typename?: 'SourceStreamDataFilter';
  sourceStreamObjectKey: Scalars['String']['output'];
  transformation: Scalars['String']['output'];
};

export type SourceStreamInput = {
  excludedColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  fullSyncAlways: Scalars['Boolean']['input'];
  fullSyncAtMidnight: Scalars['Boolean']['input'];
  hashedColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  incrementalPointerId: Scalars['String']['input'];
  mode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  protectedFromFullSync?: InputMaybe<Scalars['Boolean']['input']>;
  substreams: Array<SubstreamInput>;
};

export type SourceStreamSnapshot = {
  __typename?: 'SourceStreamSnapshot';
  bytesSynced: Scalars['Float']['output'];
  details?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  estimatedTotalCount?: Maybe<Scalars['Float']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  fullSyncTrigger?: Maybe<FullSyncTrigger>;
  isChunk?: Maybe<Scalars['Boolean']['output']>;
  operationMode?: Maybe<OperationMode>;
  recordsSynced?: Maybe<Scalars['Float']['output']>;
  retryAttempt?: Maybe<Scalars['Float']['output']>;
  scheduledJobId?: Maybe<Scalars['String']['output']>;
  sourceStreamName?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SyncJobStatus>;
  syncId?: Maybe<Scalars['String']['output']>;
};

export type SourceStreamSnapshotStates = {
  __typename?: 'SourceStreamSnapshotStates';
  activeSync?: Maybe<SourceStreamSnapshot>;
  latestSync?: Maybe<SourceStreamSnapshot>;
  name: Scalars['String']['output'];
  scheduledJobId: Scalars['String']['output'];
};

export type SourceStreamSyncState = {
  __typename?: 'SourceStreamSyncState';
  activeSync?: Maybe<FindSyncHistoryResponse>;
  latestSync?: Maybe<FindSyncHistoryResponse>;
  name: Scalars['String']['output'];
  scheduledJobId: Scalars['String']['output'];
};

export type SourceStreamSyncStatesResponse = {
  __typename?: 'SourceStreamSyncStatesResponse';
  sourceStreams: Array<SourceStreamSyncState>;
  syncId: Scalars['String']['output'];
};

export type SourceStreamSyncStats = {
  __typename?: 'SourceStreamSyncStats';
  integrationId: Scalars['String']['output'];
  numBillableRows: Scalars['Float']['output'];
  numRowsSynced: Scalars['Float']['output'];
  sourceStreamName: Scalars['String']['output'];
};

export type SourceStreamSyncStatsResponse = {
  __typename?: 'SourceStreamSyncStatsResponse';
  data: Array<SourceStreamSyncStats>;
  period: StatsPeriod;
};

export type SqlQuery = {
  __typename?: 'SqlQuery';
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['String']['output'];
  deletedAt: Scalars['DateTime']['output'];
  dependencies?: Maybe<Array<QueryDependencyEntity>>;
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
  weldSql: Scalars['String']['output'];
};

export type StartEltSyncInput = {
  eltSyncId: Scalars['String']['input'];
};

export type StartEltSyncResponse = {
  __typename?: 'StartEltSyncResponse';
  active: Scalars['Boolean']['output'];
  destinationConnectionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  sourceConnectionId: Scalars['String']['output'];
  sourceStreamNames: Array<Scalars['String']['output']>;
};

export type StartSyncInput = {
  id: Scalars['String']['input'];
};

export type StaticInvoicePreviewByLookupKeyInput = {
  currency: Scalars['String']['input'];
  numConnectors: Scalars['Float']['input'];
  numUsers: Scalars['Float']['input'];
  priceLookupKey: Scalars['String']['input'];
};

export type StaticInvoicePreviewInput = {
  currency: Scalars['String']['input'];
  numConnectors: Scalars['Float']['input'];
  numUsers: Scalars['Float']['input'];
  priceId: Scalars['String']['input'];
};

export type StatsPeriod = {
  __typename?: 'StatsPeriod';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type StopEltSyncResponse = {
  __typename?: 'StopEltSyncResponse';
  active: Scalars['Boolean']['output'];
  destinationConnectionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  sourceConnectionId: Scalars['String']['output'];
  sourceStreamNames: Array<Scalars['String']['output']>;
};

export type StoredErd = {
  __typename?: 'StoredErd';
  createdAt: Scalars['String']['output'];
  edges: Array<ErdEdge>;
  hideDiagram?: Maybe<Scalars['Boolean']['output']>;
  integrationId: Scalars['String']['output'];
  nodes: Array<ErdNode>;
  updatedAt: Scalars['String']['output'];
};

export type StoredErdEdgeInput = {
  id: Scalars['String']['input'];
  markerEnd?: InputMaybe<Scalars['JSONObject']['input']>;
  source: Scalars['String']['input'];
  style?: InputMaybe<Scalars['JSONObject']['input']>;
  target: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type StoredErdInput = {
  edges: Array<StoredErdEdgeInput>;
  hideDiagram?: InputMaybe<Scalars['Boolean']['input']>;
  integrationId: Scalars['String']['input'];
  nodes: Array<StoredErdNodeInput>;
};

export type StoredErdNodeInput = {
  data: NodeDataInput;
  height: Scalars['Float']['input'];
  id: Scalars['String']['input'];
  parentNode?: InputMaybe<Scalars['String']['input']>;
  position: NodePositionInput;
  type: Scalars['String']['input'];
  width: Scalars['Float']['input'];
};

export type Stream = {
  __typename?: 'Stream';
  configurableIncremental: Scalars['Boolean']['output'];
  defaultConfig: Scalars['JSONObject']['output'];
  name: Scalars['String']['output'];
  notSelectableExplanation?: Maybe<Scalars['String']['output']>;
  preselect: Scalars['Boolean']['output'];
  selectable: Scalars['Boolean']['output'];
  substreams: Array<SubStream>;
  supportedModes: Array<OperationMode>;
};

export enum StripeChargeStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Succeeded = 'Succeeded'
}

export type StripePlanFeatures = {
  __typename?: 'StripePlanFeatures';
  columnHashingEnabled?: Maybe<Scalars['Boolean']['output']>;
  limitConnectors?: Maybe<Scalars['Int']['output']>;
  limitRows?: Maybe<Scalars['Int']['output']>;
  limitUsers?: Maybe<Scalars['Int']['output']>;
  minSyncIntervalInMinutes?: Maybe<Scalars['Int']['output']>;
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  stripeSubscriptionDetails: StripeSubscriptionDetails;
};

export type StripeSubscriptionDetails = {
  __typename?: 'StripeSubscriptionDetails';
  cancelDate?: Maybe<Scalars['DateTime']['output']>;
  createdDate: Scalars['DateTime']['output'];
  currentPeriodEndDate: Scalars['DateTime']['output'];
  currentPeriodStartDate: Scalars['DateTime']['output'];
  customerId: Scalars['ID']['output'];
  features: StripePlanFeatures;
  id: Scalars['ID']['output'];
  items: Array<StripeSubscriptionItem>;
  planName: PlanName;
  status: StripeSubscriptionStatus;
  trialEndDate?: Maybe<Scalars['DateTime']['output']>;
};

export type StripeSubscriptionItem = {
  __typename?: 'StripeSubscriptionItem';
  id: Scalars['ID']['output'];
  price: StripeSubscriptionItemPrice;
  quantity: Scalars['Int']['output'];
  tier?: Maybe<Tier>;
};

export type StripeSubscriptionItemPrice = {
  __typename?: 'StripeSubscriptionItemPrice';
  billingScheme: BillingScheme;
  currency: Scalars['String']['output'];
  currencyOptions: Array<CurrencyOption>;
  id: Scalars['String']['output'];
  lookupKey?: Maybe<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  product: BaseProduct;
  recurring?: Maybe<Recurring>;
  tiers?: Maybe<Array<Tier>>;
  tiersMode?: Maybe<TiersMode>;
};

export enum StripeSubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Incomplete = 'Incomplete',
  IncompleteExpired = 'IncompleteExpired',
  PastDue = 'PastDue',
  Paused = 'Paused',
  Trialing = 'Trialing',
  Unpaid = 'Unpaid'
}

export type SubStream = {
  __typename?: 'SubStream';
  avroSchema: Scalars['JSONObject']['output'];
  destinationTableName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type SubmitSurveyInput = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Int']['input'];
  surveyId: Scalars['String']['input'];
};

export type SubscriptionAdminResult = {
  __typename?: 'SubscriptionAdminResult';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SubscriptionState = {
  __typename?: 'SubscriptionState';
  customerId?: Maybe<Scalars['String']['output']>;
  status: SubscriptionStatus;
  subscriptionId?: Maybe<Scalars['String']['output']>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Freemium = 'FREEMIUM'
}

export type Substream = {
  __typename?: 'Substream';
  excludedColumns: Array<Scalars['String']['output']>;
  hashedColumns: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type SubstreamInput = {
  excludedColumns: Array<Scalars['String']['input']>;
  hashedColumns: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type Survey = {
  __typename?: 'Survey';
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  accountId: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  score?: Maybe<Scalars['Int']['output']>;
  surveyId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type Sync = {
  __typename?: 'Sync';
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['ID']['output']>;
  active: Scalars['Boolean']['output'];
  config?: Maybe<Config>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  destinationConnection: Connection;
  destinationConnectionId: Scalars['String']['output'];
  destinationIntegrationId: Scalars['String']['output'];
  errorCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  job?: Maybe<ReverseEtlJobResponse>;
  lastSync: Scalars['DateTime']['output'];
  mappings: Array<Mapping>;
  model?: Maybe<Model>;
  nextSync: Scalars['DateTime']['output'];
  operations: Array<Operation>;
  orchestrationWorkflow?: Maybe<OrchestrationWorkflow>;
  primaryObject: Scalars['String']['output'];
  schedulerType: OrchestrationSchedulerType;
  sourceConnection?: Maybe<Connection>;
  sourceConnectionId: Scalars['String']['output'];
  sourceIntegrationId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  syncInterval?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum SyncJobStatus {
  Completed = 'COMPLETED',
  Delayed = 'DELAYED',
  Failed = 'FAILED',
  Retrying = 'RETRYING',
  Running = 'RUNNING',
  Scheduled = 'SCHEDULED'
}

export type SyncJobsCompletionMetric = {
  __typename?: 'SyncJobsCompletionMetric';
  failureCount: Scalars['Float']['output'];
  failurePercent: Scalars['Float']['output'];
  successCount: Scalars['Float']['output'];
  successPercent: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type SyncJobsCompletionMetricResponse = {
  __typename?: 'SyncJobsCompletionMetricResponse';
  stats?: Maybe<SyncJobsCompletionMetric>;
};

export type SyncStats = {
  __typename?: 'SyncStats';
  numBillableRows: Scalars['Float']['output'];
  numRowsSynced: Scalars['Float']['output'];
};

export type TableMetadata = {
  __typename?: 'TableMetadata';
  description?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Scalars['JSONObject']['output']>;
  schema?: Maybe<TableMetadataSchema>;
};

export type TableMetadataSchema = {
  __typename?: 'TableMetadataSchema';
  fields?: Maybe<Array<FieldMetadata>>;
};

export type TableReference = {
  __typename?: 'TableReference';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  dwSqlReference: Scalars['String']['output'];
  latestRunErrorMessage?: Maybe<Scalars['String']['output']>;
  latestSyncTime?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  queryId: Scalars['String']['output'];
  tableMetadata?: Maybe<TableMetadata>;
  type: DependencyType;
  weldTag: Scalars['String']['output'];
};

export type TaxId = {
  __typename?: 'TaxId';
  country: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TaxIdData = {
  __typename?: 'TaxIdData';
  country: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /** The type of tax ID - matches Stripe.TaxId.Type */
  enum: Scalars['String']['output'];
  example: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export type TaxIdInput = {
  country: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Template = {
  __typename?: 'Template';
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  models?: Maybe<Array<Model>>;
  name: TemplatesEnum;
  templateEltSync: Array<TemplateEltSync>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TemplateConfig = {
  __typename?: 'TemplateConfig';
  integrations: Array<IntegrationTemplate>;
  metrics: Array<TemplateMetric>;
  useCase: TemplatesEnum;
};

export type TemplateEltSync = {
  __typename?: 'TemplateEltSync';
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  eltSync: EltSync;
  eltSyncId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  sourceIntegrationId: Scalars['String']['output'];
  template: Template;
  templateId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TemplateMetric = {
  __typename?: 'TemplateMetric';
  aiInsights: Array<Scalars['String']['output']>;
  columns?: Maybe<Array<MetricColumn>>;
  config: MetricConfig;
  description: Scalars['String']['output'];
  folder: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TemplateModel = {
  __typename?: 'TemplateModel';
  description: Scalars['String']['output'];
  folder: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  templateItemId: Scalars['String']['output'];
};

export type TemplatePublished = {
  __typename?: 'TemplatePublished';
  modelId: Scalars['String']['output'];
  weldTag: Scalars['String']['output'];
};

export type TemplateSourceStream = {
  __typename?: 'TemplateSourceStream';
  excludedColumns?: Maybe<Array<Scalars['String']['output']>>;
  fullSyncAlways: Scalars['Boolean']['output'];
  fullSyncAtMidnight: Scalars['Boolean']['output'];
  hashedColumns?: Maybe<Array<Scalars['String']['output']>>;
  incrementalPointerId: Scalars['String']['output'];
  mode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  primaryKeys?: Maybe<Array<Scalars['String']['output']>>;
  substreams: Array<TemplateSubstream>;
};

export type TemplateSubstream = {
  __typename?: 'TemplateSubstream';
  excludedColumns: Array<Scalars['String']['output']>;
  hashedColumns: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum TemplatesEnum {
  Marketing = 'MARKETING'
}

export enum TestStatus {
  ExecutionError = 'executionError',
  Failed = 'failed',
  Passed = 'passed',
  Running = 'running'
}

export enum TestType {
  NotNull = 'not_null',
  Uniqueness = 'uniqueness'
}

export type Tier = {
  __typename?: 'Tier';
  price?: Maybe<Scalars['Int']['output']>;
  unitAmount?: Maybe<Scalars['Int']['output']>;
  upTo?: Maybe<Scalars['Int']['output']>;
};

export enum TiersMode {
  Graduated = 'Graduated',
  Volume = 'Volume'
}

export type UpcomingInvoice = {
  __typename?: 'UpcomingInvoice';
  breakdown?: Maybe<Array<InvoiceBreakdownItem>>;
  createdDate: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  discounts: Array<DiscountItem>;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  subTotal: Scalars['Float']['output'];
  subscriptionStatus?: Maybe<StripeSubscriptionStatus>;
  taxes: Array<InvoiceTaxes>;
  total: Scalars['Float']['output'];
  trialEnd?: Maybe<Scalars['DateTime']['output']>;
};

export type UpdateConnectionInput = {
  connectionId: Scalars['String']['input'];
  payload: Scalars['String']['input'];
};

export type UpdateDraftModelNameInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateEltSyncInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  eltSyncId: Scalars['String']['input'];
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  schedulerType?: InputMaybe<OrchestrationSchedulerType>;
  sourceStreams: Array<SourceStreamInput>;
  syncInterval?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFolderInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateModelDocumentationInput = {
  documentation: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type UpdateModelQueryInput = {
  id: Scalars['String']['input'];
  query: QueryInput;
};

export type UpdateModelTestInput = {
  column: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  testType: Scalars['String']['input'];
};

export type UpdatePublishedModelMaterializationInput = {
  id: Scalars['String']['input'];
  materializationSchedule?: InputMaybe<Scalars['String']['input']>;
  materializationType: MaterializationType;
  orchestrationScheduler?: InputMaybe<OrchestrationSchedulerType>;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSourceStreamInput = {
  protectedFromFullSync?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSubscriptionAddOnsInput = {
  addedItems?: InputMaybe<Array<Scalars['String']['input']>>;
  removedItems?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSubscriptionResponse = {
  __typename?: 'UpdateSubscriptionResponse';
  id: Scalars['String']['output'];
};

export type UpdateSyncInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  operations: Array<CreateOperationInput>;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  schedulerType?: InputMaybe<OrchestrationSchedulerType>;
  syncId: Scalars['String']['input'];
  syncInterval?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  receiveEmails?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Role>;
};

export type UpsertUserSignupInfoInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  companySize?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  receiveEmails?: InputMaybe<Scalars['Boolean']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
  weldLandingPageLastPage?: InputMaybe<Scalars['String']['input']>;
  weldLandingPageReferrer?: InputMaybe<Scalars['String']['input']>;
};

export type UsageForecastResponse = {
  __typename?: 'UsageForecastResponse';
  data?: Maybe<Array<ForecastedDataPoint>>;
};

export type UsageRecordSummary = {
  __typename?: 'UsageRecordSummary';
  invoice?: Maybe<Scalars['String']['output']>;
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  totalUsage: Scalars['Int']['output'];
};

export type UseInvitationResponse = {
  __typename?: 'UseInvitationResponse';
  accountId: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  accounts?: Maybe<Array<Account>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  emailValidated: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  lastLogin: Scalars['DateTime']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  receiveEmails: Scalars['Boolean']['output'];
  role: Scalars['String']['output'];
  socialLoginProvider?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userSignupInfo?: Maybe<UserSignupInfo>;
  userSignupInfoId?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
};

export type UserSignupInfo = {
  __typename?: 'UserSignupInfo';
  companyName?: Maybe<Scalars['String']['output']>;
  companySize?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmContent?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
  utmTerm?: Maybe<Scalars['String']['output']>;
  weldLandingPageLastPage?: Maybe<Scalars['String']['output']>;
  weldLandingPageReferrer?: Maybe<Scalars['String']['output']>;
};

export enum ValidationErrorCode {
  ConnectorLimitReached = 'ConnectorLimitReached',
  ConnectorNotFound = 'ConnectorNotFound',
  InsufficientPermission = 'InsufficientPermission',
  InsufficientPlan = 'InsufficientPlan'
}

export type ValidationErrorItem = {
  __typename?: 'ValidationErrorItem';
  errorCode?: Maybe<ValidationErrorCode>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type ValidationResult = {
  __typename?: 'ValidationResult';
  errors: Array<ValidationErrorItem>;
  valid: Scalars['Boolean']['output'];
};

export type VerifyUnpublishedChangesResponse = {
  __typename?: 'VerifyUnpublishedChangesResponse';
  hasUnpublishedChanges: Scalars['Boolean']['output'];
};

export type ViewDetails = {
  __typename?: 'ViewDetails';
  dataSchema: Array<DataSchema>;
};

export type Webhook = {
  __typename?: 'Webhook';
  account_id: Scalars['String']['output'];
  connection_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  dependencies: WebhookDependency;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  params: Scalars['JSONObject']['output'];
  type: ExternalSystem;
  updated_at: Scalars['DateTime']['output'];
};

export type WebhookDataResponse = {
  __typename?: 'WebhookDataResponse';
  accountId: Scalars['String']['output'];
  data: Scalars['JSONObject']['output'];
  type: Scalars['String']['output'];
};

export type WebhookDependency = {
  __typename?: 'WebhookDependency';
  account_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  item_id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  webhook: Webhook;
  webhook_id: Scalars['String']['output'];
};

export type WebhookDependencyResponse = {
  __typename?: 'WebhookDependencyResponse';
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type WebhookResponse = {
  __typename?: 'WebhookResponse';
  connectionId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dependencies: Array<WebhookDependencyResponse>;
  name: Scalars['String']['output'];
  orchestrationWorkflowId?: Maybe<Scalars['String']['output']>;
  type: ExternalSystem;
  updatedAt: Scalars['DateTime']['output'];
  webhookId: Scalars['String']['output'];
};

export enum WeldAddOnType {
  SyncFrequency = 'SyncFrequency',
  Unknown = 'Unknown'
}

export type WeldPlan = {
  __typename?: 'WeldPlan';
  billingPeriod?: Maybe<RecurrenceInterval>;
  configurableLimits?: Maybe<ConfigurableLimits>;
  features: FeatureSet;
  isConsumptionPlan?: Maybe<Scalars['Boolean']['output']>;
  isEnterprisePlan?: Maybe<Scalars['Boolean']['output']>;
  isLegacyPlan?: Maybe<Scalars['Boolean']['output']>;
  name: PlanName;
  priceLookupKeys?: Maybe<PriceLookupKeyMap>;
  userPriceLookupKeys?: Maybe<PriceLookupKeyMap>;
};

export enum WeldProductType {
  AddOn = 'AddOn',
  Unknown = 'Unknown',
  WeldPlan = 'WeldPlan'
}

export type WorkflowJob = {
  __typename?: 'WorkflowJob';
  errorMessage?: Maybe<Scalars['String']['output']>;
  incomingDependencies: Array<Scalars['ID']['output']>;
  itemId: Scalars['ID']['output'];
  lastEventHandledAt?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  outgoingDependencies: Array<Scalars['ID']['output']>;
  status: WorkflowJobStatus;
  target?: Maybe<WorkflowJobTarget>;
};

export enum WorkflowJobStatus {
  Canceled = 'CANCELED',
  Done = 'DONE',
  Failed = 'FAILED',
  NotReady = 'NOT_READY',
  Ready = 'READY',
  Running = 'RUNNING'
}

export type WorkflowJobTarget = MaterializedTableReference | ModelViewReference | RawViewReference | SourceStream | Sync | Webhook;

export enum WorkflowRunFailureReason {
  FailedToStart = 'FAILED_TO_START',
  JobFailed = 'JOB_FAILED',
  KilledByStaleMonitor = 'KILLED_BY_STALE_MONITOR'
}

export enum WorkflowRunStatus {
  Canceled = 'CANCELED',
  Done = 'DONE',
  Failed = 'FAILED',
  NotStarted = 'NOT_STARTED',
  Running = 'RUNNING',
  Starting = 'STARTING'
}

export type WorkspaceStats = {
  __typename?: 'WorkspaceStats';
  numConnections: Scalars['Int']['output'];
  numUsers: Scalars['Int']['output'];
};

export type WorkspaceSyncStats = {
  __typename?: 'WorkspaceSyncStats';
  date: Scalars['DateTime']['output'];
  elt: SyncStats;
  numBillableRows: Scalars['Float']['output'];
  numRowsSynced: Scalars['Float']['output'];
  reverseElt: SyncStats;
};

export type WorkspaceSyncStatsLast30Days = {
  __typename?: 'WorkspaceSyncStatsLast30Days';
  elt: Scalars['Float']['output'];
  eltPercentage: Scalars['Float']['output'];
  reverseElt: Scalars['Float']['output'];
  reverseEltPercentage: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type WorkspaceSyncStatsLast30DaysResponse = {
  __typename?: 'WorkspaceSyncStatsLast30DaysResponse';
  data: WorkspaceSyncStatsLast30Days;
  period: StatsPeriod;
};

export type WorkspaceSyncStatsResponse = {
  __typename?: 'WorkspaceSyncStatsResponse';
  data: Array<WorkspaceSyncStats>;
  period: StatsPeriod;
};

export type AccountFragment = { __typename?: 'Account', id: string, dataWarehouseConnectionId?: string | null, name?: string | null, slug: string, notificationEmails: Array<string>, createdAt: any, trialEndsAt?: any | null, dataWarehouse?: { __typename?: 'DataWarehouse', connectionId: string, title?: string | null, subTitle?: string | null, supportsAsyncQuery: boolean, supportsMaterializedTable: boolean, integrationId: string } | null, accountSettings: { __typename?: 'AccountSettings', id: string, deactivateELTSyncs: boolean, deactivateReverseELTSyncs: boolean, maxBillableRows?: number | null }, slackNotificationInfo?: { __typename?: 'SlackNotificationInfo', id: string, connectionId: string, channelId: string, channelName: string } | null };

export type UpdateDataWarehouseConnectionIdHackMutationVariables = Exact<{
  dataWarehouseConnectionId: Scalars['String']['input'];
}>;


export type UpdateDataWarehouseConnectionIdHackMutation = { __typename?: 'Mutation', updateDataWarehouseConnectionIdHack: { __typename?: 'Account', id: string } };

export type CurrentUserWithAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserWithAccountsQuery = { __typename?: 'Query', current: { __typename?: 'CurrentUser', id: string, firstName?: string | null, lastName?: string | null, email: string, weldSuperAdmin?: boolean | null, accounts?: Array<{ __typename?: 'Account', id: string, dataWarehouseConnectionId?: string | null, name?: string | null, slug: string, notificationEmails: Array<string>, createdAt: any, trialEndsAt?: any | null, dataWarehouse?: { __typename?: 'DataWarehouse', connectionId: string, title?: string | null, subTitle?: string | null, supportsAsyncQuery: boolean, supportsMaterializedTable: boolean, integrationId: string } | null, accountSettings: { __typename?: 'AccountSettings', id: string, deactivateELTSyncs: boolean, deactivateReverseELTSyncs: boolean, maxBillableRows?: number | null }, slackNotificationInfo?: { __typename?: 'SlackNotificationInfo', id: string, connectionId: string, channelId: string, channelName: string } | null }> | null } };

export type CurrentUserRoleQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserRoleQuery = { __typename?: 'Query', current: { __typename?: 'CurrentUser', id: string, role?: string | null } };

export type GetCurrentUserPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserPermissionsQuery = { __typename?: 'Query', current: { __typename?: 'CurrentUser', id: string, permissions?: Array<string> | null } };

export type UserSignupInfoQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type UserSignupInfoQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, userSignupInfo?: { __typename?: 'UserSignupInfo', jobTitle?: string | null, companyName?: string | null } | null } };

export type FirebaseTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type FirebaseTokenQuery = { __typename?: 'Query', firebaseToken: string };

export type UserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, updatedAt: any, createdAt: any, role: string } };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, updatedAt: any, createdAt: any, role: string }> };

export type RemoveUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type RemoveUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'User', id: string } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string } };

export type UpdateUserAccountRoleMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  role: Role;
}>;


export type UpdateUserAccountRoleMutation = { __typename?: 'Mutation', updateUserAccountRole: { __typename?: 'User', id: string, role: string, firstName?: string | null, lastName?: string | null } };

export type UpsertUserSignupInfoMutationVariables = Exact<{
  input: UpsertUserSignupInfoInput;
}>;


export type UpsertUserSignupInfoMutation = { __typename?: 'Mutation', upsertUserSignupInfo: { __typename?: 'UserSignupInfo', id: string, companyName?: string | null } };

export type GetSlugAvailabilityQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetSlugAvailabilityQuery = { __typename?: 'Query', slugAvailability: { __typename?: 'SlugAvailabilityResponse', isAvailable: boolean } };

export type GetAccountIdQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetAccountIdQuery = { __typename?: 'Query', accountBySlug: { __typename?: 'Account', id: string } };

export type GetAccountSlugQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAccountSlugQuery = { __typename?: 'Query', accountById: { __typename?: 'Account', slug: string } };

export type InvitationsQueryVariables = Exact<{
  getUsed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InvitationsQuery = { __typename?: 'Query', invitations: Array<{ __typename?: 'Invitation', id: string, email: string, firstName: string, lastName: string, used: boolean, expiresAt: any, updatedAt: any, createdAt: any, role?: Role | null }> };

export type OpenInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OpenInvitationsQuery = { __typename?: 'Query', openInvitations: Array<{ __typename?: 'Invitation', id: string, email: string, firstName: string, lastName: string, used: boolean, expiresAt: any, updatedAt: any, createdAt: any, role?: Role | null, account: { __typename?: 'Account', id: string, name?: string | null } }> };

export type SendInvitationMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role: Role;
}>;


export type SendInvitationMutation = { __typename?: 'Mutation', sendInvitation: { __typename?: 'Invitation', id: string } };

export type ResendOwnInvitationMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type ResendOwnInvitationMutation = { __typename?: 'Mutation', resendOwnInvitation: { __typename?: 'Invitation', id: string } };

export type AcceptInvitationMutationVariables = Exact<{
  invitationId: Scalars['String']['input'];
}>;


export type AcceptInvitationMutation = { __typename?: 'Mutation', useInvitation: { __typename?: 'UseInvitationResponse', accountId: string } };

export type DeclineOwnInvitationMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type DeclineOwnInvitationMutation = { __typename?: 'Mutation', declineOwnInvitation: { __typename?: 'Invitation', id: string } };

export type RemoveInvitationMutationVariables = Exact<{
  invitationId: Scalars['String']['input'];
}>;


export type RemoveInvitationMutation = { __typename?: 'Mutation', deleteInvitation: { __typename?: 'Invitation', id: string } };

export type CreateAccountMutationVariables = Exact<{
  name: Scalars['String']['input'];
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount: { __typename?: 'Account', id: string, slug: string, name?: string | null } };

export type SetDatawarehouseMutationVariables = Exact<{
  createConnectionInput: CreateConnectionInput;
}>;


export type SetDatawarehouseMutation = { __typename?: 'Mutation', setDatawarehouse: boolean };

export type GetDatawarehouseSetupStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDatawarehouseSetupStatusQuery = { __typename?: 'Query', getDatawarehouseSetupStatus: { __typename?: 'SetDataWarehouseResult', status: string, error?: string | null } };

export type DeleteAccountMutationVariables = Exact<{
  input: DeleteAccountInput;
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: { __typename?: 'Account', id: string } };

export type CreateWorkspaceWithManagedDatawarehouseMutationVariables = Exact<{
  workspaceName: Scalars['String']['input'];
  dataWarehouseLocation: Scalars['String']['input'];
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateWorkspaceWithManagedDatawarehouseMutation = { __typename?: 'Mutation', createWorkspaceWithManagedDatawarehouse: { __typename?: 'Account', id: string, slug: string, name?: string | null } };

export type StartSelfOnboardingProcessMutationVariables = Exact<{
  location: Scalars['String']['input'];
}>;


export type StartSelfOnboardingProcessMutation = { __typename?: 'Mutation', startSelfOnboardingProcess: boolean };

export type GetSelfOnboardingProcessStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSelfOnboardingProcessStatusQuery = { __typename?: 'Query', getSelfOnboardingProcessStatus: { __typename?: 'SelfOnboardingStatus', status: string, error?: string | null } };

export type AddNotificationEmailMutationVariables = Exact<{
  notificationEmail: Scalars['String']['input'];
}>;


export type AddNotificationEmailMutation = { __typename?: 'Mutation', addNotificationEmail: { __typename?: 'Account', id: string } };

export type RemoveNotificationEmailMutationVariables = Exact<{
  notificationEmail: Scalars['String']['input'];
}>;


export type RemoveNotificationEmailMutation = { __typename?: 'Mutation', removeNotificationEmail: { __typename?: 'Account', id: string } };

export type SessionStartedMutationVariables = Exact<{ [key: string]: never; }>;


export type SessionStartedMutation = { __typename?: 'Mutation', sessionStarted: boolean };

export type SeedDataWarehouseMutationVariables = Exact<{ [key: string]: never; }>;


export type SeedDataWarehouseMutation = { __typename?: 'Mutation', seedDataWarehouse: { __typename?: 'SeedDatawarehouseResponse', models: Array<{ __typename?: 'SeededModel', id: string, name: string }> } };

export type GetSlackChannelsQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type GetSlackChannelsQuery = { __typename?: 'Query', getSlackChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string }> };

export type SetupSlackNotificationsMutationVariables = Exact<{
  connectionId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  channelName: Scalars['String']['input'];
}>;


export type SetupSlackNotificationsMutation = { __typename?: 'Mutation', setupSlackNotifications: { __typename?: 'Account', id: string, slackNotificationInfo?: { __typename?: 'SlackNotificationInfo', id: string, connectionId: string, channelId: string, channelName: string } | null } };

export type DisconnectSlackNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectSlackNotificationsMutation = { __typename?: 'Mutation', disconnectSlackNotifications: { __typename?: 'Account', id: string } };

export type SetMaxBillableRowsMutationVariables = Exact<{
  maxRows?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SetMaxBillableRowsMutation = { __typename?: 'Mutation', setMaxBillableRows: { __typename?: 'Account', id: string, accountSettings: { __typename?: 'AccountSettings', id: string, maxBillableRows?: number | null } } };

export type GetMfaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMfaQuery = { __typename?: 'Query', getMFA: { __typename?: 'MFAInfoResult', hasMFA: boolean, mfaMethods: Array<{ __typename?: 'MFAMetod', id: string, type: string }> } };

export type SetMfaMutationVariables = Exact<{
  mfa: Scalars['Boolean']['input'];
}>;


export type SetMfaMutation = { __typename?: 'Mutation', setMFA: boolean };

export type ApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiKeysQuery = { __typename?: 'Query', apiKeys: Array<{ __typename?: 'ApiKeyResponse', id: string, name: string, createdAt: any }> };

export type ApiSecretKeyQueryVariables = Exact<{
  apiKeyId: Scalars['String']['input'];
}>;


export type ApiSecretKeyQuery = { __typename?: 'Query', apiSecretKey: string };

export type CreateApiKeyMutationVariables = Exact<{
  input: CreateApiKeyInput;
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createApiKey: { __typename?: 'ApiKeyResponse', id: string, name: string, createdAt: any } };

export type DeleteApiKeyMutationVariables = Exact<{
  apiKeyId: Scalars['String']['input'];
}>;


export type DeleteApiKeyMutation = { __typename?: 'Mutation', deleteApiKey?: boolean | null };

export type ChatThreadFragment = { __typename?: 'ChatThread', id: string, title: string, createdAt: any, updatedAt: any, numMessages: number, tableReferences: any, initialModelContext?: any | null };

export type ChatThreadQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ChatThreadQuery = { __typename?: 'Query', chatThread: { __typename?: 'ChatThread', id: string, title: string, createdAt: any, updatedAt: any, numMessages: number, tableReferences: any, initialModelContext?: any | null } };

export type ChatThreadsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChatThreadsQuery = { __typename?: 'Query', chatThreads: Array<{ __typename?: 'ChatThread', id: string, title: string, createdAt: any, updatedAt: any, numMessages: number, tableReferences: any, initialModelContext?: any | null }> };

export type ChatMessagesQueryVariables = Exact<{
  threadId: Scalars['String']['input'];
}>;


export type ChatMessagesQuery = { __typename?: 'Query', chatMessages: Array<{ __typename?: 'ChatMessage', id: string, threadId: string, content: string, role: ChatRole, createdAt: any }> };

export type NotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', id: string, accountId: string, accountName: string, type: NotificationType, source: NotificationSources, detail: any, createdAt: any, updatedAt: any, deletedAt?: any | null, entityType: NotificationEntityType, entityId: string, entityName?: string | null, message: string, notificationLevel: NotificationLevel, lastOccurence: any, isDismissable: boolean, isLock: boolean, expiration?: any | null, messageData?: any | null }> };

export type RemoveNotificationMutationVariables = Exact<{
  input: RemoveNotificationInput;
}>;


export type RemoveNotificationMutation = { __typename?: 'Mutation', removeNotification: { __typename?: 'Notification', id: string } };

export type DismissAllNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type DismissAllNotificationsMutation = { __typename?: 'Mutation', dismissAllNotifications: boolean };

export type FindAllAvailableAuditLogsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllAvailableAuditLogsQuery = { __typename?: 'Query', findAllAvailableAuditLogs: { __typename?: 'FindAllAvailableAuditLogsResponse', logs: Array<{ __typename?: 'AvailableAuditLog', date: string, count: number, type: AuditLogType }> } };

export type ListFailedSyncsBackofficeQueryVariables = Exact<{
  minFailures: Scalars['Float']['input'];
}>;


export type ListFailedSyncsBackofficeQuery = { __typename?: 'Query', listFailedSyncsBackoffice: Array<{ __typename?: 'EltSyncJobResponse', scheduledJobId?: string | null, accountId?: string | null, accountName?: string | null, syncId?: string | null, sourceIntegrationId?: string | null, destinationIntegrationId?: string | null, sourceStreamName?: string | null, nextRun?: number | null, lastRun?: number | null, lastFullSync?: string | null, lastStartedAt: string, status?: string | null, isQuarantined?: boolean | null, forceFullSync?: boolean | null, running?: boolean | null, devNotes?: string | null, devStatus?: string | null, devName?: string | null, devTimestamp?: string | null, errorsSinceLastSuccessfulRun?: number | null, config?: any | null, sourceSecretId?: string | null, targetCloudProvider?: string | null, locks?: Array<{ __typename?: 'LockResponse', id: string, target: string, reasons: Array<LockReason> }> | null }> };

export type GetEltSyncDetailsBackofficeQueryVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
}>;


export type GetEltSyncDetailsBackofficeQuery = { __typename?: 'Query', getEltSyncDetailsBackoffice?: { __typename?: 'EltSync', id: string, active: boolean, status: string, syncInterval?: string | null, sourceIntegrationId: string, destinationIntegrationId: string, sourceConnectionId: string, destinationConnectionId: string, startDate?: any | null, destinationSchemaName?: string | null, schedulerType: OrchestrationSchedulerType, sourceStreams: Array<{ __typename?: 'SourceStream', id: string, name: string, incrementalPrimaryKeyName?: Array<string> | null, incrementalPointerId?: string | null, operationMode: string, fullSyncAlways: boolean, fullSyncAtMidnight: boolean, protectedFromFullSync: boolean, dataFilters: Array<{ __typename?: 'SourceStreamDataFilter', sourceStreamObjectKey: string, transformation: string }>, job?: { __typename?: 'GetSourceStreamJobResponse', nextRun?: number | null, lastRun?: number | null, lastFullSync?: string | null, lastStartedAt?: string | null, status?: string | null, isQuarantined?: boolean | null, forceFullSync?: boolean | null, running?: boolean | null } | null, substreams: Array<{ __typename?: 'Substream', name: string, excludedColumns: Array<string>, hashedColumns: Array<string> }> }>, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection?: { __typename?: 'Connection', label: string, id: string } | null, config?: { __typename?: 'EltConfig', sourceSettings?: any | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, cronExpression: string } | null } | null };

export type EltSyncSnapshotStateBackofficeQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  syncId: Scalars['String']['input'];
}>;


export type EltSyncSnapshotStateBackofficeQuery = { __typename?: 'Query', eltSyncSnapshotStateBackoffice: { __typename?: 'EltSyncSnapshotState', syncId: string, sourceStreams: Array<{ __typename?: 'SourceStreamSnapshotStates', name: string, scheduledJobId: string, activeSync?: { __typename?: 'SourceStreamSnapshot', bytesSynced: number, errorMessage?: string | null, estimatedTotalCount?: number | null, finishedAt?: string | null, fullSyncTrigger?: FullSyncTrigger | null, isChunk?: boolean | null, operationMode?: OperationMode | null, retryAttempt?: number | null, recordsSynced?: number | null, startedAt?: string | null, status?: SyncJobStatus | null, syncId?: string | null, sourceStreamName?: string | null, scheduledJobId?: string | null, details?: string | null } | null, latestSync?: { __typename?: 'SourceStreamSnapshot', bytesSynced: number, errorMessage?: string | null, estimatedTotalCount?: number | null, finishedAt?: string | null, fullSyncTrigger?: FullSyncTrigger | null, isChunk?: boolean | null, operationMode?: OperationMode | null, retryAttempt?: number | null, recordsSynced?: number | null, startedAt?: string | null, status?: SyncJobStatus | null, syncId?: string | null, sourceStreamName?: string | null, scheduledJobId?: string | null, details?: string | null } | null }> } };

export type FindManyEltSyncHistoryBackofficeQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  syncId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
}>;


export type FindManyEltSyncHistoryBackofficeQuery = { __typename?: 'Query', findManyEltSyncHistoryBackoffice: Array<{ __typename?: 'FindSyncHistoryResponse', syncId: string, jobId?: string | null, status?: SyncJobStatus | null, startedAt: string, finishedAt?: string | null, totalRecords?: number | null, newRecords?: number | null, sizeSyncedMb?: number | null, syncedRecords?: number | null, sourceStreamName?: string | null, error?: string | null, scheduledJobId?: string | null, isChunk?: boolean | null }> };

export type GetAccountBackofficeQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type GetAccountBackofficeQuery = { __typename?: 'Query', getAccountBackoffice: { __typename?: 'Account', id: string, name?: string | null, trialEndsAt?: any | null, stripeCustomer?: { __typename?: 'Customer', id: string, companyName?: string | null, email?: string | null } | null, stripeSubscription?: { __typename?: 'StripeSubscription', stripeSubscriptionDetails: { __typename?: 'StripeSubscriptionDetails', id: string, status: StripeSubscriptionStatus, trialEndDate?: any | null, planName: PlanName } } | null } };

export type StopEltSyncBackofficeMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  eltSyncId: Scalars['String']['input'];
}>;


export type StopEltSyncBackofficeMutation = { __typename?: 'Mutation', stopEltSyncBackoffice: string };

export type StartEltSyncBackofficeMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  eltSyncId: Scalars['String']['input'];
}>;


export type StartEltSyncBackofficeMutation = { __typename?: 'Mutation', startEltSyncBackoffice: string };

export type AllNotificationsBackofficeQueryVariables = Exact<{ [key: string]: never; }>;


export type AllNotificationsBackofficeQuery = { __typename?: 'Query', allNotificationsBackoffice: Array<{ __typename?: 'Notification', id: string, accountId: string, accountName: string, type: NotificationType, source: NotificationSources, detail: any, createdAt: any, updatedAt: any, deletedAt?: any | null, entityType: NotificationEntityType, entityId: string, entityName?: string | null, message: string, notificationLevel: NotificationLevel, lastOccurence: any, isDismissable: boolean, isLock: boolean, expiration?: any | null }> };

export type RemoveNotificationBackofficeMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveNotificationBackofficeMutation = { __typename?: 'Mutation', removeNotificationBackoffice: string };

export type FreemiumAccountFragment = { __typename?: 'Account', id: string, slug: string, name?: string | null, trialEndsAt?: any | null, accountSettings: { __typename?: 'AccountSettings', id: string, deactivateELTSyncs: boolean, deactivateReverseELTSyncs: boolean } };

export type AccountsWithoutBillingBackofficeQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountsWithoutBillingBackofficeQuery = { __typename?: 'Query', getAccountsWithoutBillingBackoffice: Array<{ __typename?: 'Account', id: string, slug: string, name?: string | null, trialEndsAt?: any | null, accountSettings: { __typename?: 'AccountSettings', id: string, deactivateELTSyncs: boolean, deactivateReverseELTSyncs: boolean } }> };

export type AccountsWithSyncsBlockedBackofficeQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountsWithSyncsBlockedBackofficeQuery = { __typename?: 'Query', getAccountsWithSyncsBlockedBackoffice: Array<{ __typename?: 'Account', id: string, slug: string, name?: string | null, trialEndsAt?: any | null, accountSettings: { __typename?: 'AccountSettings', id: string, deactivateELTSyncs: boolean, deactivateReverseELTSyncs: boolean } }> };

export type AllAccountsBackofficeQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAccountsBackofficeQuery = { __typename?: 'Query', getAllAccountsBackoffice: Array<{ __typename?: 'Account', id: string, slug: string, name?: string | null, trialEndsAt?: any | null, accountSettings: { __typename?: 'AccountSettings', id: string, deactivateELTSyncs: boolean, deactivateReverseELTSyncs: boolean } }> };

export type BlockEltSyncsForAccountBackofficeMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
}>;


export type BlockEltSyncsForAccountBackofficeMutation = { __typename?: 'Mutation', blockELTSyncsForAccountBackoffice: { __typename?: 'Account', id: string, slug: string, name?: string | null, trialEndsAt?: any | null, accountSettings: { __typename?: 'AccountSettings', id: string, deactivateELTSyncs: boolean, deactivateReverseELTSyncs: boolean } } };

export type BlockReverseEltSyncsForAccountBackofficeMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
}>;


export type BlockReverseEltSyncsForAccountBackofficeMutation = { __typename?: 'Mutation', blockReverseELTSyncsForAccountBackoffice: { __typename?: 'Account', id: string, slug: string, name?: string | null, trialEndsAt?: any | null, accountSettings: { __typename?: 'AccountSettings', id: string, deactivateELTSyncs: boolean, deactivateReverseELTSyncs: boolean } } };

export type SetTrialEndDateBackofficeMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
}>;


export type SetTrialEndDateBackofficeMutation = { __typename?: 'Mutation', setTrialEndDateBackoffice: { __typename?: 'Account', id: string, slug: string, name?: string | null, trialEndsAt?: any | null, accountSettings: { __typename?: 'AccountSettings', id: string, deactivateELTSyncs: boolean, deactivateReverseELTSyncs: boolean } } };

export type GetIntegrationIdsForErdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIntegrationIdsForErdQuery = { __typename?: 'Query', getIntegrationIdsForErd: Array<string> };

export type GetErdForIntegrationQueryVariables = Exact<{
  integrationId: Scalars['String']['input'];
}>;


export type GetErdForIntegrationQuery = { __typename?: 'Query', getErdForIntegration: { __typename?: 'RawErdResponse', integrationId: string, nodes: Array<{ __typename?: 'ErdNode', id: string, type: string, parentNode?: string | null, data: { __typename?: 'NodeData', tableName: string, isSubTable?: boolean | null, childOf?: string | null, fields: Array<{ __typename?: 'ErdField', id: string, name: string, type: string, isPrimaryKey: boolean, foreignKey?: string | null }> }, position: { __typename?: 'NodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'ErdEdge', id: string, source: string, target: string, type: string }> } };

export type GetStoredErdForIntegrationQueryVariables = Exact<{
  integrationId: Scalars['String']['input'];
}>;


export type GetStoredErdForIntegrationQuery = { __typename?: 'Query', getStoredErdForIntegration?: { __typename?: 'StoredErd', integrationId: string, hideDiagram?: boolean | null, edges: Array<{ __typename?: 'ErdEdge', id: string, markerEnd?: any | null, source: string, style?: any | null, target: string, type: string }>, nodes: Array<{ __typename?: 'ErdNode', id: string, height?: number | null, parentNode?: string | null, type: string, width?: number | null, position: { __typename?: 'NodePosition', x: number, y: number }, data: { __typename?: 'NodeData', tableName: string, isSubTable?: boolean | null, childOf?: string | null, fields: Array<{ __typename?: 'ErdField', id: string, name: string, type: string, isPrimaryKey: boolean, foreignKey?: string | null }> } }> } | null };

export type SaveErdForIntegrationMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
  edges: Array<StoredErdEdgeInput> | StoredErdEdgeInput;
  nodes: Array<StoredErdNodeInput> | StoredErdNodeInput;
  hideDiagram?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SaveErdForIntegrationMutation = { __typename?: 'Mutation', saveErdForIntegration: { __typename?: 'StoredErd', integrationId: string, hideDiagram?: boolean | null, edges: Array<{ __typename?: 'ErdEdge', id: string, markerEnd?: any | null, source: string, style?: any | null, target: string, type: string }>, nodes: Array<{ __typename?: 'ErdNode', id: string, height?: number | null, parentNode?: string | null, type: string, width?: number | null, position: { __typename?: 'NodePosition', x: number, y: number }, data: { __typename?: 'NodeData', isSubTable?: boolean | null, tableName: string, fields: Array<{ __typename?: 'ErdField', id: string, isPrimaryKey: boolean, name: string, type: string }> } }> } };

export type BackofficeSyncStatsFragment = { __typename?: 'BackofficeSyncStats', numRowsSynced: number, numBillableRows: number };

export type BackofficeDailyUsageStateQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  referenceDate: Scalars['DateTime']['input'];
  historicalDataLookbackDays: Scalars['Float']['input'];
}>;


export type BackofficeDailyUsageStateQuery = { __typename?: 'Query', backofficeDailyUsageState: Array<{ __typename?: 'BackofficeWorkspaceUsageStats', date: any, numRowsSynced: number, numBillableRows: number, elt: { __typename?: 'BackofficeSyncStats', numRowsSynced: number, numBillableRows: number }, reverseElt: { __typename?: 'BackofficeSyncStats', numRowsSynced: number, numBillableRows: number } }> };

export type BackofficeUsageForecastTrainingDataQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  referenceDate: Scalars['DateTime']['input'];
  historicalDataLookbackDays: Scalars['Float']['input'];
}>;


export type BackofficeUsageForecastTrainingDataQuery = { __typename?: 'Query', backofficeUsageForecastTrainingData: Array<{ __typename?: 'HistoricalValue', date: any, numBillableRows: number }> };

export type ResetSyncBackofficeMutationVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
  sourceIntegrationId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
  numberOfErrors?: InputMaybe<Scalars['Float']['input']>;
  resetIncrementalPointer?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ResetSyncBackofficeMutation = { __typename?: 'Mutation', resetSyncBackOffice: { __typename?: 'ResetSyncResponse', job: any, reason: string, success: boolean } };

export type SetDevStatusMutationVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
  scheduledJobId: Scalars['String']['input'];
  devStatus: Scalars['String']['input'];
  devNotes: Scalars['String']['input'];
}>;


export type SetDevStatusMutation = { __typename?: 'Mutation', setDevStatus: any };

export type GetErrorLogsBackOfficeQueryVariables = Exact<{
  scheduledJobId: Scalars['String']['input'];
}>;


export type GetErrorLogsBackOfficeQuery = { __typename?: 'Query', getErrorLogsBackOffice: Array<{ __typename?: 'ErrorLogsResponse', id?: string | null, message?: string | null, log_origin?: string | null, timestamp?: string | null, error_code?: string | null, logger?: string | null }> };

export type ConnectionBaseFragment = { __typename?: 'Connection', id: string, integrationId: string, label: string, active: boolean, createdAt: any, updatedAt: any, connectedAt: any };

export type ConnectionWithSyncsFragment = { __typename?: 'Connection', eltSyncs: Array<{ __typename?: 'EltSync', id: string, createdAt: any, status: string, destinationSchemaName?: string | null, destinationConnection?: { __typename?: 'Connection', integrationId: string } | null }>, reverseEltSyncs: Array<{ __typename?: 'Sync', id: string, createdAt: any, status: string, primaryObject: string, destinationConnection: { __typename?: 'Connection', integrationId: string } }> };

export type ConnectionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ConnectionQuery = { __typename?: 'Query', connection: { __typename?: 'Connection', id: string, integrationId: string, label: string, active: boolean, createdAt: any, updatedAt: any, connectedAt: any, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, email: string } | null, eltSyncs: Array<{ __typename?: 'EltSync', id: string, createdAt: any, status: string, destinationSchemaName?: string | null, destinationConnection?: { __typename?: 'Connection', integrationId: string } | null }>, reverseEltSyncs: Array<{ __typename?: 'Sync', id: string, createdAt: any, status: string, primaryObject: string, destinationConnection: { __typename?: 'Connection', integrationId: string } }> } };

export type ConnectionWithCredentialsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ConnectionWithCredentialsQuery = { __typename?: 'Query', connection: { __typename?: 'Connection', credentials: any, id: string, integrationId: string, label: string, active: boolean, createdAt: any, updatedAt: any, connectedAt: any, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, email: string } | null, eltSyncs: Array<{ __typename?: 'EltSync', id: string, createdAt: any, status: string, destinationSchemaName?: string | null, destinationConnection?: { __typename?: 'Connection', integrationId: string } | null }>, reverseEltSyncs: Array<{ __typename?: 'Sync', id: string, createdAt: any, status: string, primaryObject: string, destinationConnection: { __typename?: 'Connection', integrationId: string } }> } };

export type ConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectionsQuery = { __typename?: 'Query', connections: Array<{ __typename?: 'Connection', id: string, integrationId: string, label: string, active: boolean, createdAt: any, updatedAt: any, connectedAt: any }> };

export type ConnectionsWithUsageSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectionsWithUsageSummaryQuery = { __typename?: 'Query', connectors: Array<{ __typename?: 'Connection', id: string, integrationId: string, label: string, active: boolean, createdAt: any, updatedAt: any, connectedAt: any, usageSummary: { __typename?: 'ConnectionUsageSummary', numEltSyncs: number, numRevEltSyncs: number, totalSyncs: number } }> };

export type EltConnectionSettingsQueryVariables = Exact<{
  input: GetSettingsInput;
}>;


export type EltConnectionSettingsQuery = { __typename?: 'Query', getEltSettings: { __typename?: 'IntegrationSettings', connectionSettings?: any | null } };

export type ActivateConnectionSettingsQueryVariables = Exact<{
  input: GetSettingsInput;
}>;


export type ActivateConnectionSettingsQuery = { __typename?: 'Query', getActivateSettings: { __typename?: 'IntegrationSettings', connectionSettings?: any | null } };

export type ObjectTypeSettingsQueryVariables = Exact<{
  objectType: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  formValues?: InputMaybe<Scalars['JSONObject']['input']>;
}>;


export type ObjectTypeSettingsQuery = { __typename?: 'Query', getObjectTypeSettings: { __typename?: 'DestinationObjectTypeSettings', settings?: any | null } };

export type RemoveConnectionMutationVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type RemoveConnectionMutation = { __typename?: 'Mutation', removeConnection: { __typename?: 'Connection', id: string } };

export type RefreshDestinationMutationVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type RefreshDestinationMutation = { __typename?: 'Mutation', refreshDestination: { __typename?: 'Connection', id: string } };

export type CreateConnectionMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
  payload: Scalars['String']['input'];
  label: Scalars['String']['input'];
}>;


export type CreateConnectionMutation = { __typename?: 'Mutation', createConnection: { __typename?: 'Connection', id: string, integrationId: string, label: string, active: boolean, createdAt: any, updatedAt: any, connectedAt: any } };

export type ConnectionBridgeBaseFragment = { __typename?: 'ConnectionBridgeResponse', id: string, integrationId: string, authorizeUrl: string, createdAt: string, expiresAt: string, label: string, connectionId?: string | null };

export type CreateConnectionBridgeMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
  connectionId?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
}>;


export type CreateConnectionBridgeMutation = { __typename?: 'Mutation', createConnectionBridge: { __typename?: 'ConnectionBridgeResponse', id: string, integrationId: string, authorizeUrl: string, createdAt: string, expiresAt: string, label: string, connectionId?: string | null } };

export type GetConnectionBridgesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConnectionBridgesQuery = { __typename?: 'Query', connectionBridges: Array<{ __typename?: 'ConnectionBridgeResponse', id: string, integrationId: string, authorizeUrl: string, createdAt: string, expiresAt: string, label: string, connectionId?: string | null }> };

export type DeleteConnectionBridgeMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteConnectionBridgeMutation = { __typename?: 'Mutation', deleteConnectionBridge: boolean };

export type GetOAuthUrlQueryVariables = Exact<{
  integrationId: Scalars['String']['input'];
  payload: Scalars['String']['input'];
  connectionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOAuthUrlQuery = { __typename?: 'Query', getOAuthURL: string };

export type UpdateConnectionMutationVariables = Exact<{
  connectionId: Scalars['String']['input'];
  payload: Scalars['String']['input'];
}>;


export type UpdateConnectionMutation = { __typename?: 'Mutation', updateConnection: { __typename?: 'Connection', id: string, label: string, integrationId: string } };

export type CreateExampleConnectionMutationVariables = Exact<{
  input: CreateExampleConnectionInput;
}>;


export type CreateExampleConnectionMutation = { __typename?: 'Mutation', createExampleConnection: { __typename?: 'Connection', id: string, label: string, integrationId: string } };

export type PreviewQueryQueryVariables = Exact<{
  sourceConnectionId: Scalars['String']['input'];
  weldSql: Scalars['String']['input'];
  dependencies: Array<QueryDependencyInput> | QueryDependencyInput;
}>;


export type PreviewQueryQuery = { __typename?: 'Query', previewQuery: { __typename?: 'PreviewQueryResponse', response: Array<any>, dwSql: string } };

export type CreateAsyncQueryPreviewMutationVariables = Exact<{
  sourceConnectionId: Scalars['ID']['input'];
  weldSql: Scalars['String']['input'];
  dependencies: Array<QueryDependencyInput> | QueryDependencyInput;
}>;


export type CreateAsyncQueryPreviewMutation = { __typename?: 'Mutation', createAsyncQueryPreview: { __typename?: 'CreateAsyncQueryPreviewResponse', queryExecutionId: string, dwSql: string } };

export type AsyncQueryPreviewResultQueryVariables = Exact<{
  sourceConnectionId: Scalars['ID']['input'];
  queryExecutionId: Scalars['ID']['input'];
}>;


export type AsyncQueryPreviewResultQuery = { __typename?: 'Query', asyncQueryPreviewResult?: { __typename?: 'AsyncQueryResultResponse', rows: Array<any>, numRowsTotal: number } | null };

export type AsyncQueryStatusQueryVariables = Exact<{
  sourceConnectionId: Scalars['ID']['input'];
  queryExecutionId: Scalars['ID']['input'];
}>;


export type AsyncQueryStatusQuery = { __typename?: 'Query', asyncQueryStatus?: { __typename?: 'AsyncQueryStatusResponse', status: QueryResultStatusEnum } | null };

export type GetAllTablesQueryVariables = Exact<{
  sourceConnectionId: Scalars['String']['input'];
}>;


export type GetAllTablesQuery = { __typename?: 'Query', getAllTables: { __typename?: 'GetAllTablesResponse', response: Array<any> } };

export type SchemasQueryVariables = Exact<{
  sourceStreamNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  sourceConnectionId: Scalars['String']['input'];
  connectionSettings: Scalars['JSONObject']['input'];
}>;


export type SchemasQuery = { __typename?: 'Query', getAllAvroSchemas: { __typename?: 'GetAllAvroSchemasResponse', schemas: Array<{ __typename?: 'SchemaDto', sourceStreamName: string, primaryKeys?: Array<string> | null, cursor?: string | null, fields: Array<{ __typename?: 'AvroSchemaFieldDto', name: string, type: Array<string>, nullable: boolean }> }> } };

export type GetRawViewsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRawViewsQuery = { __typename?: 'Query', getRawViews: Array<{ __typename?: 'RawViewReference', viewId: string, integrationId?: string | null, weldTag: string, path: Array<string>, createdAt: string, latestSyncTime: string, schema: string, sourceStream: string, syncId?: string | null, scheduledJobId?: string | null, firstSyncCompleted: boolean }> };

export type RawViewStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type RawViewStatsQuery = { __typename?: 'Query', rawViewStats: { __typename?: 'RawViewsStats', total: number, numFirstSyncCompleted: number } };

export type GetViewDetailsQueryVariables = Exact<{
  input: GetViewDetailsInput;
}>;


export type GetViewDetailsQuery = { __typename?: 'Query', getViewDetails: { __typename?: 'ViewDetails', dataSchema: Array<{ __typename?: 'DataSchema', name: string, type: string, nullable: boolean }> } };

export type GetStreamsQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
  sourceSettings: Scalars['JSONObject']['input'];
  eltSyncId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStreamsQuery = { __typename?: 'Query', getStreams: Array<{ __typename?: 'Stream', name: string, supportedModes: Array<OperationMode>, configurableIncremental: boolean, defaultConfig: any, selectable: boolean, notSelectableExplanation?: string | null, preselect: boolean, substreams: Array<{ __typename?: 'SubStream', id: string, destinationTableName: string, avroSchema: any }> }> };

export type GetStreamsAsyncQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
  sourceSettings: Scalars['JSONObject']['input'];
}>;


export type GetStreamsAsyncQuery = { __typename?: 'Query', getStreamsAsync: { __typename?: 'AsyncStreamsStatus', errorMessage?: string | null, status: AsyncJobStatusEnum, startedAt?: number | null, streams?: Array<{ __typename?: 'Stream', name: string, supportedModes: Array<OperationMode>, configurableIncremental: boolean, defaultConfig: any, selectable: boolean, notSelectableExplanation?: string | null, preselect: boolean, substreams: Array<{ __typename?: 'SubStream', id: string, destinationTableName: string, avroSchema: any }> }> | null } };

export type GetStreamsAsyncJobStatusQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type GetStreamsAsyncJobStatusQuery = { __typename?: 'Query', getStreamsAsyncJobStatus: { __typename?: 'AsyncStreamsStatus', errorMessage?: string | null, status: AsyncJobStatusEnum, startedAt?: number | null, streams?: Array<{ __typename?: 'Stream', name: string, supportedModes: Array<OperationMode>, configurableIncremental: boolean, defaultConfig: any, selectable: boolean, notSelectableExplanation?: string | null, substreams: Array<{ __typename?: 'SubStream', id: string, destinationTableName: string, avroSchema: any }> }> | null } };

export type CancelStreamsAsyncJobMutationVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type CancelStreamsAsyncJobMutation = { __typename?: 'Mutation', cancelStreamsAsyncJob: { __typename?: 'AsyncStreamsStatus', errorMessage?: string | null, status: AsyncJobStatusEnum, startedAt?: number | null, streams?: Array<{ __typename?: 'Stream', name: string, supportedModes: Array<OperationMode>, configurableIncremental: boolean, defaultConfig: any, selectable: boolean, notSelectableExplanation?: string | null, substreams: Array<{ __typename?: 'SubStream', id: string, destinationTableName: string, avroSchema: any }> }> | null } };

export type SourceStreamsWithSubStreamsQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
  eltSyncId: Scalars['String']['input'];
  sourceStreamNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SourceStreamsWithSubStreamsQuery = { __typename?: 'Query', sourceStreamsWithSubStreams: Array<{ __typename?: 'Stream', name: string, supportedModes: Array<OperationMode>, configurableIncremental: boolean, defaultConfig: any, substreams: Array<{ __typename?: 'SubStream', id: string, destinationTableName: string }> }> };

export type GetCustomFormValuesQueryVariables = Exact<{
  input: CustomFormInput;
}>;


export type GetCustomFormValuesQuery = { __typename?: 'Query', getCustomFormValues: { __typename?: 'CustomFormValues', customFormValues: any } };

export type ValidateCustomFormQueryVariables = Exact<{
  input: CustomFormValidationInput;
}>;


export type ValidateCustomFormQuery = { __typename?: 'Query', validateCustomForm: { __typename?: 'CustomFormValidationResult', customFormValidationResult: any } };

export type OnboardingConnectionPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingConnectionPreferencesQuery = { __typename?: 'Query', getOnboardingConnections: Array<{ __typename?: 'OnboardingConnection', integrationId: string }> };

export type PendingOnboardingConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PendingOnboardingConnectionsQuery = { __typename?: 'Query', getPendingOnboardingConnections: Array<{ __typename?: 'OnboardingConnection', integrationId: string }> };

export type SetOnboardingConnectionPreferencesMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  integrationIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SetOnboardingConnectionPreferencesMutation = { __typename?: 'Mutation', setOnboardingConnections: Array<{ __typename?: 'OnboardingConnection', integrationId: string }> };

export type DeleteOnboardingConnectionPreferenceMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
}>;


export type DeleteOnboardingConnectionPreferenceMutation = { __typename?: 'Mutation', deleteOnboardingConnection: boolean };

export type GenerateConnectionLabelQueryVariables = Exact<{
  baseLabel: Scalars['String']['input'];
}>;


export type GenerateConnectionLabelQuery = { __typename?: 'Query', generateConnectionLabel: string };

export type StartDatawarehouseMigrationMutationVariables = Exact<{
  createConnectionInput: CreateConnectionInput;
}>;


export type StartDatawarehouseMigrationMutation = { __typename?: 'Mutation', startDatawarehouseMigration: { __typename?: 'DatawarehouseMigration', id: string, userId: string, accountId: string, status: DwMigrationStatus, errorMessage?: string | null, createdAt: any, pendingSyncs: Array<string>, prevDWIntegrationId: string } };

export type DatawarehouseMigrationQueryVariables = Exact<{ [key: string]: never; }>;


export type DatawarehouseMigrationQuery = { __typename?: 'Query', datawarehouseMigration?: { __typename?: 'DatawarehouseMigration', id: string, userId: string, accountId: string, status: DwMigrationStatus, errorMessage?: string | null, createdAt: any, pendingSyncs: Array<string>, prevDWIntegrationId: string } | null };

export type CreateEltSyncMutationVariables = Exact<{
  sourceConnectionId: Scalars['String']['input'];
  destinationConnectionId: Scalars['String']['input'];
  syncInterval?: InputMaybe<Scalars['String']['input']>;
  sourceStreams: Array<SourceStreamInput> | SourceStreamInput;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  config?: InputMaybe<Scalars['String']['input']>;
  destinationSchemaName?: InputMaybe<Scalars['String']['input']>;
  schedulerType?: InputMaybe<OrchestrationSchedulerType>;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateEltSyncMutation = { __typename?: 'Mutation', createEltSync: { __typename?: 'EltSync', id: string, sourceConnectionId: string, destinationConnectionId: string, destinationSchemaName?: string | null } };

export type UpdateEltSyncMutationVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
  syncInterval?: InputMaybe<Scalars['String']['input']>;
  sourceStreams: Array<SourceStreamInput> | SourceStreamInput;
  config?: InputMaybe<Scalars['String']['input']>;
  schedulerType: OrchestrationSchedulerType;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateEltSyncMutation = { __typename?: 'Mutation', updateEltSync: { __typename?: 'EltSync', id: string, sourceConnectionId: string, destinationConnectionId: string } };

export type StartEltSyncMutationVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
}>;


export type StartEltSyncMutation = { __typename?: 'Mutation', startEltSync: { __typename?: 'StartEltSyncResponse', id: string, active: boolean } };

export type StopEltSyncMutationVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
}>;


export type StopEltSyncMutation = { __typename?: 'Mutation', stopEltSync: { __typename?: 'StopEltSyncResponse', id: string, active: boolean } };

export type RemoveEltSyncMutationVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
  removeDataReferences?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RemoveEltSyncMutation = { __typename?: 'Mutation', removeEltSync: { __typename?: 'RemoveEltSyncResponse', id: string } };

export type RemoveTableFromSyncMutationVariables = Exact<{
  sourceStreamName: Scalars['String']['input'];
  syncId: Scalars['String']['input'];
  viewId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveTableFromSyncMutation = { __typename?: 'Mutation', removeTableFromSync: { __typename?: 'RemoveTableResponse', sourceStreamName: string } };

export type EltSyncsQueryVariables = Exact<{ [key: string]: never; }>;


export type EltSyncsQuery = { __typename?: 'Query', eltSyncs: Array<{ __typename?: 'EltSync', id: string, active: boolean, status: string, syncInterval?: string | null, sourceIntegrationId: string, destinationIntegrationId: string, createdAt: any, destinationSchemaName?: string | null, schedulerType: OrchestrationSchedulerType, sourceConnectionId: string, sourceStreams: Array<{ __typename?: 'SourceStream', name: string }>, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection?: { __typename?: 'Connection', label: string, id: string } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, cronExpression: string } | null }> };

export type SetNextSyncToFullSyncMutationVariables = Exact<{
  sourceStreamId: Scalars['String']['input'];
  forceFullSync: Scalars['Boolean']['input'];
}>;


export type SetNextSyncToFullSyncMutation = { __typename?: 'Mutation', setNextSyncToFullSync: { __typename?: 'SourceStream', job?: { __typename?: 'GetSourceStreamJobResponse', forceFullSync?: boolean | null } | null } };

export type CheckOnDemandSyncEligibilityQueryVariables = Exact<{
  input: RunJobNowInput;
}>;


export type CheckOnDemandSyncEligibilityQuery = { __typename?: 'Query', checkOnDemandSyncEligibility: { __typename?: 'OnDemandSyncEligibilityResponse', possible: boolean, reason?: string | null } };

export type RunJobNowMutationVariables = Exact<{
  input: RunJobNowInput;
}>;


export type RunJobNowMutation = { __typename?: 'Mutation', runJobNow?: boolean | null };

export type EltSyncJobsQueryVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
}>;


export type EltSyncJobsQuery = { __typename?: 'Query', eltSync: { __typename?: 'EltSync', sourceStreams: Array<{ __typename?: 'SourceStream', job?: { __typename?: 'GetSourceStreamJobResponse', nextRun?: number | null, lastRun?: number | null, lastFullSync?: string | null, lastStartedAt?: string | null, status?: string | null, isQuarantined?: boolean | null, forceFullSync?: boolean | null, running?: boolean | null } | null }> } };

export type EltSyncQueryVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
}>;


export type EltSyncQuery = { __typename?: 'Query', eltSync: { __typename?: 'EltSync', id: string, active: boolean, status: string, syncInterval?: string | null, sourceIntegrationId: string, destinationIntegrationId: string, sourceConnectionId: string, destinationConnectionId: string, startDate?: any | null, destinationSchemaName?: string | null, schedulerType: OrchestrationSchedulerType, sourceStreams: Array<{ __typename?: 'SourceStream', id: string, name: string, incrementalPrimaryKeyName?: Array<string> | null, incrementalPointerId?: string | null, operationMode: string, fullSyncAlways: boolean, fullSyncAtMidnight: boolean, protectedFromFullSync: boolean, dataFilters: Array<{ __typename?: 'SourceStreamDataFilter', sourceStreamObjectKey: string, transformation: string }>, job?: { __typename?: 'GetSourceStreamJobResponse', nextRun?: number | null, lastRun?: number | null, lastFullSync?: string | null, lastStartedAt?: string | null, status?: string | null, isQuarantined?: boolean | null, forceFullSync?: boolean | null, running?: boolean | null } | null, substreams: Array<{ __typename?: 'Substream', name: string, excludedColumns: Array<string>, hashedColumns: Array<string> }> }>, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection?: { __typename?: 'Connection', label: string, id: string } | null, config?: { __typename?: 'EltConfig', sourceSettings?: any | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, cronExpression: string } | null } };

export type GetErrorLogsQueryVariables = Exact<{
  sourceStreamName: Scalars['String']['input'];
  eltSyncId: Scalars['String']['input'];
}>;


export type GetErrorLogsQuery = { __typename?: 'Query', getErrorLogs: Array<{ __typename?: 'ErrorLogsResponse', id?: string | null, message?: string | null, timestamp?: string | null, error_code?: string | null }> };

export type EltJobsCompletionStatsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type EltJobsCompletionStatsQuery = { __typename?: 'Query', eltJobsCompletionStats: { __typename?: 'SyncJobsCompletionMetricResponse', stats?: { __typename?: 'SyncJobsCompletionMetric', total: number, successCount: number, successPercent: number, failureCount: number, failurePercent: number } | null } };

export type UpdateSourceStreamMutationVariables = Exact<{
  sourceStreamId: Scalars['String']['input'];
  input: UpdateSourceStreamInput;
}>;


export type UpdateSourceStreamMutation = { __typename?: 'Mutation', updateSourceStream: { __typename?: 'SourceStream', id: string, name: string, protectedFromFullSync: boolean } };

export type EltSyncHistoryStatsResponseFragment = { __typename?: 'EltSyncHistoryStatsResponse', limit?: number | null, stats: Array<{ __typename?: 'EltSyncHistoryStat', startedAt?: any | null, finishedAt?: any | null, duration?: number | null, status?: SyncJobStatus | null, sourceStreamName?: string | null, rowsSynced: number, rowsSyncedMb: number, operationMode?: OperationMode | null, fullSyncTrigger: FullSyncTrigger }> };

export type EltSyncStatsRecentQueryVariables = Exact<{
  syncId: Scalars['String']['input'];
  from: Scalars['DateTime']['input'];
  sourceStreamName?: InputMaybe<Scalars['String']['input']>;
}>;


export type EltSyncStatsRecentQuery = { __typename?: 'Query', eltSyncStatsRecent: { __typename?: 'EltSyncHistoryStatsResponse', limit?: number | null, stats: Array<{ __typename?: 'EltSyncHistoryStat', startedAt?: any | null, finishedAt?: any | null, duration?: number | null, status?: SyncJobStatus | null, sourceStreamName?: string | null, rowsSynced: number, rowsSyncedMb: number, operationMode?: OperationMode | null, fullSyncTrigger: FullSyncTrigger }> } };

export type EltSyncStatsHistoricQueryVariables = Exact<{
  syncId: Scalars['String']['input'];
  from: Scalars['DateTime']['input'];
  sourceStreamName?: InputMaybe<Scalars['String']['input']>;
}>;


export type EltSyncStatsHistoricQuery = { __typename?: 'Query', eltSyncStatsHistoric: { __typename?: 'EltSyncHistoryStatsResponse', limit?: number | null, stats: Array<{ __typename?: 'EltSyncHistoryStat', startedAt?: any | null, finishedAt?: any | null, duration?: number | null, status?: SyncJobStatus | null, sourceStreamName?: string | null, rowsSynced: number, rowsSyncedMb: number, operationMode?: OperationMode | null, fullSyncTrigger: FullSyncTrigger }> } };

export type RecreateViewMutationVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
}>;


export type RecreateViewMutation = { __typename?: 'Mutation', recreateDestinationView: { __typename?: 'RecreateViewResponse', success: boolean, error?: string | null } };

export type GetWebhookDataQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type GetWebhookDataQuery = { __typename?: 'Query', getWebhookData: { __typename?: 'WebhookDataResponse', data: any } };

export type CreateWebhookMutationVariables = Exact<{
  data: CreateWebhookInput;
}>;


export type CreateWebhookMutation = { __typename?: 'Mutation', createWebhook: { __typename?: 'WebhookResponse', webhookId: string, name: string, connectionId: string, orchestrationWorkflowId?: string | null, type: ExternalSystem, createdAt: any, updatedAt: any, dependencies: Array<{ __typename?: 'WebhookDependencyResponse', name: string, id: string, itemId: string, type: string }> } };

export type DeleteWebhookMutationVariables = Exact<{
  webhookId: Scalars['String']['input'];
}>;


export type DeleteWebhookMutation = { __typename?: 'Mutation', deleteWebhook: boolean };

export type ListWebhooksQueryVariables = Exact<{
  orchestrationWorkflowId: Scalars['String']['input'];
}>;


export type ListWebhooksQuery = { __typename?: 'Query', listWebhoooks: Array<{ __typename?: 'WebhookResponse', orchestrationWorkflowId?: string | null, webhookId: string, name: string, connectionId: string, type: ExternalSystem, createdAt: any, updatedAt: any, dependencies: Array<{ __typename?: 'WebhookDependencyResponse', name: string, id: string, itemId: string, type: string }> }> };

export type RequestBetaConnectorAccessMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
}>;


export type RequestBetaConnectorAccessMutation = { __typename?: 'Mutation', requestBetaConnectorAccess: boolean };

export type RequestConnectorMutationVariables = Exact<{
  integrationName: Scalars['String']['input'];
  integrationTypes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RequestConnectorMutation = { __typename?: 'Mutation', requestConnector: boolean };

export type RequestDestinationMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
}>;


export type RequestDestinationMutation = { __typename?: 'Mutation', requestDestination: boolean };

export type CountryFragment = { __typename?: 'Country', code: string, name: string, currency: string, emoji: string, dial_code: string };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', code: string, name: string, currency: string, emoji: string, dial_code: string }> };

export type ResolveCountryFromTimeZoneQueryVariables = Exact<{
  timeZone: Scalars['String']['input'];
}>;


export type ResolveCountryFromTimeZoneQuery = { __typename?: 'Query', resolveCountryFromTimeZone: { __typename?: 'ResolveCountryResponse', country?: { __typename?: 'Country', code: string, name: string, currency: string, emoji: string, dial_code: string } | null } };

export type CountriesAndCurrentCountryQueryVariables = Exact<{
  timeZone: Scalars['String']['input'];
}>;


export type CountriesAndCurrentCountryQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', code: string, name: string, currency: string, emoji: string, dial_code: string }>, resolveCountryFromTimeZone: { __typename?: 'ResolveCountryResponse', country?: { __typename?: 'Country', code: string, name: string, currency: string, emoji: string, dial_code: string } | null } };

export type IntegrationConfigurationOptionsFragment = { __typename?: 'IntegrationConfiguration', hideSelectAllTables?: boolean | null, supportsStartDate?: boolean | null, usesAsyncStreams?: boolean | null, usesLazySchemas?: boolean | null };

export type IntegrationConfigurationFragment = { __typename?: 'IntegrationConfiguration', id: string, name: string, form: any, forms: Array<any>, hideSelectAllTables?: boolean | null, supportsStartDate?: boolean | null, usesAsyncStreams?: boolean | null, usesLazySchemas?: boolean | null };

export type IntegrationConfigurationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type IntegrationConfigurationQuery = { __typename?: 'Query', integrationConfiguration: { __typename?: 'IntegrationConfiguration', id: string, name: string, form: any, forms: Array<any>, hideSelectAllTables?: boolean | null, supportsStartDate?: boolean | null, usesAsyncStreams?: boolean | null, usesLazySchemas?: boolean | null } };

export type GetSetupGuideUrlQueryVariables = Exact<{
  integrationId: Scalars['String']['input'];
  isDatawarehouse: Scalars['Boolean']['input'];
}>;


export type GetSetupGuideUrlQuery = { __typename?: 'Query', getSetupGuideUrl?: string | null };

export type DataConnectorMetadataFragment = { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string> };

export type AvailableIntegrationFragment = { __typename?: 'AvailableIntegration', abilities: Array<IntegrationAbility>, baseId: string, categories: Array<string>, id: string, isUtilityConnector: boolean, name: string, requiresAdmin?: boolean | null, meetsPlanRequirement: boolean, minRequiredPlan?: PlanName | null, aliasMetadata?: { __typename?: 'AliasMetadata', id: string, name: string } | null, config?: { __typename?: 'IntegrationConfiguration', hideSelectAllTables?: boolean | null, supportsStartDate?: boolean | null, usesAsyncStreams?: boolean | null, usesLazySchemas?: boolean | null } | null, logo: { __typename?: 'IntegrationLogoVariants', default?: string | null, dark?: string | null }, eltSource?: { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string> } | null, activateDestination?: { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string> } | null, dataWarehouse?: { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string> } | null };

export type AvailableIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableIntegrationsQuery = { __typename?: 'Query', availableIntegrations: Array<{ __typename?: 'AvailableIntegration', abilities: Array<IntegrationAbility>, baseId: string, categories: Array<string>, id: string, isUtilityConnector: boolean, name: string, requiresAdmin?: boolean | null, meetsPlanRequirement: boolean, minRequiredPlan?: PlanName | null, aliasMetadata?: { __typename?: 'AliasMetadata', id: string, name: string } | null, config?: { __typename?: 'IntegrationConfiguration', hideSelectAllTables?: boolean | null, supportsStartDate?: boolean | null, usesAsyncStreams?: boolean | null, usesLazySchemas?: boolean | null } | null, logo: { __typename?: 'IntegrationLogoVariants', default?: string | null, dark?: string | null }, eltSource?: { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string> } | null, activateDestination?: { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string> } | null, dataWarehouse?: { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string> } | null }> };

export type DestinationIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type DestinationIntegrationsQuery = { __typename?: 'Query', destinationIntegrations: Array<{ __typename?: 'AvailableIntegration', abilities: Array<IntegrationAbility>, baseId: string, categories: Array<string>, id: string, isUtilityConnector: boolean, name: string, requiresAdmin?: boolean | null, meetsPlanRequirement: boolean, minRequiredPlan?: PlanName | null, aliasMetadata?: { __typename?: 'AliasMetadata', id: string, name: string } | null, config?: { __typename?: 'IntegrationConfiguration', hideSelectAllTables?: boolean | null, supportsStartDate?: boolean | null, usesAsyncStreams?: boolean | null, usesLazySchemas?: boolean | null } | null, logo: { __typename?: 'IntegrationLogoVariants', default?: string | null, dark?: string | null }, eltSource?: { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string> } | null, activateDestination?: { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string> } | null, dataWarehouse?: { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string> } | null }> };

export type CreateModelTestMutationVariables = Exact<{
  createModelTestInput: CreateModelTestInput;
}>;


export type CreateModelTestMutation = { __typename?: 'Mutation', createModelTest: { __typename?: 'ModelTest', id: string } };

export type UpdateModelTestMutationVariables = Exact<{
  updateModelTestInput: UpdateModelTestInput;
}>;


export type UpdateModelTestMutation = { __typename?: 'Mutation', updateModelTest: { __typename?: 'ModelTest', id: string } };

export type RemoveModelTestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveModelTestMutation = { __typename?: 'Mutation', removeModelTest: { __typename?: 'ModelTest', id: string } };

export type ModelTestsByModelQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type ModelTestsByModelQuery = { __typename?: 'Query', model: { __typename?: 'Model', id: string, modelTests: Array<{ __typename?: 'ModelTest', id: string, column: string, type: TestType }> } };

export type StartTestQueryVariables = Exact<{
  modelTestId: Scalars['ID']['input'];
}>;


export type StartTestQuery = { __typename?: 'Query', startTest: { __typename?: 'ModelTestResult', modelTestId: string, status: TestStatus, queryExecutionId?: string | null, modelTestWeldSql?: string | null, failedRows?: Array<any> | null, error?: string | null } };

export type GetTestResultQueryVariables = Exact<{
  modelTestId: Scalars['ID']['input'];
  queryExecutionId: Scalars['String']['input'];
  sourceConnectionId: Scalars['String']['input'];
}>;


export type GetTestResultQuery = { __typename?: 'Query', getTestResult: { __typename?: 'ModelTestResult', modelTestId: string, status: TestStatus, queryExecutionId?: string | null, failedRows?: Array<any> | null, error?: string | null } };

export type ModelBaseFragment = { __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType };

export type ModelViewReferenceFragmentFragment = { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string };

export type MaterializedTableReferenceFragmentFragment = { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null };

export type PublishedQueryBaseFragmentFragment = { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null };

export type PublishedQueryWithSqlFragmentFragment = { __typename?: 'SqlQuery', weldSql: string, id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null };

export type ModelPublishedFragmentFragment = { __typename?: 'Model', dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null };

export type ModelListItemFragment = { __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null };

export type CreateDraftModelMutationVariables = Exact<{
  name: Scalars['String']['input'];
  sourceConnectionId: Scalars['String']['input'];
  weldSql: Scalars['String']['input'];
  dashboardId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateDraftModelMutation = { __typename?: 'Mutation', createDraftModel: { __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null } };

export type CreateModelFromTemplateMutationVariables = Exact<{
  input: CreateFromTemplateInput;
}>;


export type CreateModelFromTemplateMutation = { __typename?: 'Mutation', createModelFromTemplate: { __typename?: 'TemplatePublished', modelId: string, weldTag: string } };

export type PublishModelAsyncMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  query: QueryInput;
  materializationType: MaterializationType;
  materializationSchedule?: InputMaybe<Scalars['String']['input']>;
  modelFolderId: Scalars['String']['input'];
  orchestrationScheduler?: InputMaybe<OrchestrationSchedulerType>;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  isUnsavedModel: Scalars['Boolean']['input'];
  sourceConnectionId: Scalars['String']['input'];
}>;


export type PublishModelAsyncMutation = { __typename?: 'Mutation', publishModelAsync: string };

export type UpdatePublishedModelQueryAsyncMutationVariables = Exact<{
  id: Scalars['String']['input'];
  query: QueryInput;
}>;


export type UpdatePublishedModelQueryAsyncMutation = { __typename?: 'Mutation', updatePublishedModelQueryAsync: string };

export type UpdatePublishedModelMaterializationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  materializationType: MaterializationType;
  materializationSchedule?: InputMaybe<Scalars['String']['input']>;
  orchestrationScheduler?: InputMaybe<OrchestrationSchedulerType>;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdatePublishedModelMaterializationMutation = { __typename?: 'Mutation', updatePublishedModelMaterialization: { __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null } };

export type UpdateDraftModelNameMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateDraftModelNameMutation = { __typename?: 'Mutation', updateDraftModelName: { __typename?: 'Model', id: string, name: string } };

export type UpdateUnpublishedModelQueryMutationVariables = Exact<{
  id: Scalars['String']['input'];
  query: QueryInput;
}>;


export type UpdateUnpublishedModelQueryMutation = { __typename?: 'Mutation', updateUnpublishedModelSqlQuery: { __typename?: 'SqlQuery', id: string } };

export type UpdateModelDocumentationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  documentation: Scalars['String']['input'];
}>;


export type UpdateModelDocumentationMutation = { __typename?: 'Mutation', updateModelDocumentation: { __typename?: 'Model', id: string, documentation?: string | null } };

export type MoveModelMutationVariables = Exact<{
  id: Scalars['String']['input'];
  modelFolderId: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type MoveModelMutation = { __typename?: 'Mutation', moveModel: { __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null } };

export type RemoveModelMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type RemoveModelMutation = { __typename?: 'Mutation', removeModel: { __typename?: 'Model', id: string } };

export type RemoveDashboardModelsMutationVariables = Exact<{
  dashboardId: Scalars['String']['input'];
}>;


export type RemoveDashboardModelsMutation = { __typename?: 'Mutation', removeDashboardModels: Array<{ __typename?: 'Model', id: string }> };

export type RematerializeNowMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type RematerializeNowMutation = { __typename?: 'Mutation', rematerializeNow: { __typename?: 'Model', id: string, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null } };

export type UpdateModelEmojiMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
  emoji?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateModelEmojiMutation = { __typename?: 'Mutation', updateModelEmoji: { __typename?: 'Model', id: string, emoji?: string | null } };

export type UpdateFolderEmojiMutationVariables = Exact<{
  folderId: Scalars['String']['input'];
  emoji?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateFolderEmojiMutation = { __typename?: 'Mutation', updateFolderEmoji: boolean };

export type ModelQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type ModelQuery = { __typename?: 'Query', model: { __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null } };

export type ModelsByIdsQueryVariables = Exact<{
  modelIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ModelsByIdsQuery = { __typename?: 'Query', modelsByIds: Array<{ __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null }> };

export type PublishedModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type PublishedModelsQuery = { __typename?: 'Query', publishedModels: Array<{ __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null }> };

export type SavedDraftModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type SavedDraftModelsQuery = { __typename?: 'Query', savedDrafts: Array<{ __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType }> };

export type MostRecentPublishedModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type MostRecentPublishedModelsQuery = { __typename?: 'Query', mostRecentPublishedModels: Array<{ __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null }> };

export type ModelUsageSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type ModelUsageSummaryQuery = { __typename?: 'Query', modelUsageSummary: { __typename?: 'ModelUsageSummaryDto', publishedModels: number, draftModels: number } };

export type ModelSearchResultFragment = { __typename?: 'Model', id: string, name: string, emoji?: string | null, publishedQueryId?: string | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null };

export type SearchModelsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  publishedOnly: Scalars['Boolean']['input'];
}>;


export type SearchModelsQuery = { __typename?: 'Query', searchModels: Array<{ __typename?: 'Model', id: string, name: string, emoji?: string | null, publishedQueryId?: string | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null }> };

export type ListDeletedModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListDeletedModelsQuery = { __typename?: 'Query', deletedModels: Array<{ __typename?: 'Model', id: string, name: string, integrationId: string, createdAt: any, userId?: string | null, emoji?: string | null }> };

export type HasDeletedModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type HasDeletedModelsQuery = { __typename?: 'Query', hasDeletedModels: { __typename?: 'HasDeletedModelsResponse', value: boolean } };

export type RestoreDeletedModelMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type RestoreDeletedModelMutation = { __typename?: 'Mutation', restoreDeletedModel: { __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null } };

export type UpdateModelTableReferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type UpdateModelTableReferencesQuery = { __typename?: 'Query', publishedModels: Array<{ __typename?: 'Model', dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null }> };

export type GetLocalMaterializationJobQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type GetLocalMaterializationJobQuery = { __typename?: 'Query', model: { __typename?: 'Model', id: string, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', modelId: string, queryId: string, status: string, lastRun?: number | null, nextRun: number, startedAt?: string | null, cronExpression: string, latestErrorMessage?: string | null } | null } };

export type GetMaterializationTableQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type GetMaterializationTableQuery = { __typename?: 'Query', model: { __typename?: 'Model', id: string, dwTable?: { __typename?: 'MaterializedTableReference', accountId: string, modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null } };

export type SqlQueryQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type SqlQueryQuery = { __typename?: 'Query', model: { __typename?: 'Model', id: string, publishedQuery?: { __typename?: 'SqlQuery', weldSql: string, id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null } };

export type ModelDocumentationQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type ModelDocumentationQuery = { __typename?: 'Query', model: { __typename?: 'Model', documentation?: string | null } };

export type FindQueryHistoryQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type FindQueryHistoryQuery = { __typename?: 'Query', model: { __typename?: 'Model', id: string, sqlQueries: Array<{ __typename?: 'SqlQuery', id: string, data: string, weldSql: string, createdAt: any, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, email: string } | null }> } };

export type GetDwDirectoryQueryVariables = Exact<{
  input: GetDwDirectoryInput;
}>;


export type GetDwDirectoryQuery = { __typename?: 'Query', getDWDirectory: { __typename?: 'Directory', typename: string, children: Array<string>, hasNext: boolean } };

export type GetDwDirectoryItemsQueryVariables = Exact<{
  input: GetDwDirectoryItemsInput;
}>;


export type GetDwDirectoryItemsQuery = { __typename?: 'Query', getDWDirectoryItems: Array<{ __typename?: 'DwDirectoryItem', path: Array<string> }> };

export type ImportDwDirectoryMutationVariables = Exact<{
  input: ImportDwDirectoryInput;
}>;


export type ImportDwDirectoryMutation = { __typename?: 'Mutation', importDWDirectory: Array<{ __typename?: 'DwDirectoryItem', path: Array<string>, error?: string | null }> };

export type ListModelFoldersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListModelFoldersQuery = { __typename?: 'Query', listModelFolders: Array<{ __typename?: 'ModelFolder', id: string, name: string, emoji?: string | null, type?: ModelType | null, parentId?: string | null, DWName: string }> };

export type VerifyUnpublishedChangesQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type VerifyUnpublishedChangesQuery = { __typename?: 'Query', verifyUnpublishedChanges: { __typename?: 'VerifyUnpublishedChangesResponse', hasUnpublishedChanges: boolean } };

export type CreateModelFolderMutationVariables = Exact<{
  input: CreateFolderInput;
}>;


export type CreateModelFolderMutation = { __typename?: 'Mutation', createModelFolder: { __typename?: 'ModelFolder', name: string, type?: ModelType | null, DWName: string, id: string } };

export type InitiateModelFoldersMutationVariables = Exact<{
  input: Array<CreateFolderInput> | CreateFolderInput;
}>;


export type InitiateModelFoldersMutation = { __typename?: 'Mutation', initiateModelFolders: Array<{ __typename?: 'ModelFolder', name: string, type?: ModelType | null, DWName: string, id: string }> };

export type DeleteModelFolderMutationVariables = Exact<{
  folderId: Scalars['String']['input'];
}>;


export type DeleteModelFolderMutation = { __typename?: 'Mutation', deleteModelFolder: { __typename?: 'ModelFolder', name: string, type?: ModelType | null } };

export type DeleteFolderWithContentMutationVariables = Exact<{
  folderId: Scalars['String']['input'];
}>;


export type DeleteFolderWithContentMutation = { __typename?: 'Mutation', deleteFolderWithContent: string };

export type UnpublishModelMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type UnpublishModelMutation = { __typename?: 'Mutation', unpublishModel: { __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null } };

export type DeleteRawViewMutationVariables = Exact<{
  viewId: Scalars['String']['input'];
}>;


export type DeleteRawViewMutation = { __typename?: 'Mutation', deleteRawView?: boolean | null };

export type FailedTablesQueryVariables = Exact<{ [key: string]: never; }>;


export type FailedTablesQuery = { __typename?: 'Query', failedTables: Array<{ __typename?: 'MaterializedTableReference', latestRunErrorMessage?: string | null, modelId: string, weldTag: string, latestSyncTime?: string | null }> };

export type QueryModelQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type QueryModelQuery = { __typename?: 'Query', queryModel: { __typename?: 'QueryModelResponse', id: string, response: Array<any>, dwSql: string } };

export type ObjectTypeFragment = { __typename?: 'ObjectType', id: string, objectName: string, associations: Array<string>, supportedDestinationMapping: Array<string> };

export type ListObjectTypesQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type ListObjectTypesQuery = { __typename?: 'Query', objectTypes: Array<{ __typename?: 'ObjectType', id: string, objectName: string, associations: Array<string>, supportedDestinationMapping: Array<string> }> };

export type IncidentUpdateFragment = { __typename?: 'IncidentUpdate', body: string, createdAt: any, displayAt: any, id: string, incidentId: string, status: string, updatedAt: string };

export type IncidentFragment = { __typename?: 'Incident', createdAt: any, id: string, impact: string, name: string, resolvedAt?: any | null, shortlink: string, status: string, updatedAt: any, scheduledFor: any, scheduledUntil: any, incidentUpdates: Array<{ __typename?: 'IncidentUpdate', body: string, createdAt: any, displayAt: any, id: string, incidentId: string, status: string, updatedAt: string }> };

export type UnresolvedIncidentsQueryVariables = Exact<{ [key: string]: never; }>;


export type UnresolvedIncidentsQuery = { __typename?: 'Query', unresolvedIncidents: Array<{ __typename?: 'Incident', createdAt: any, id: string, impact: string, name: string, resolvedAt?: any | null, shortlink: string, status: string, updatedAt: any, scheduledFor: any, scheduledUntil: any, incidentUpdates: Array<{ __typename?: 'IncidentUpdate', body: string, createdAt: any, displayAt: any, id: string, incidentId: string, status: string, updatedAt: string }> }> };

export type ScheduledIncidentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ScheduledIncidentsQuery = { __typename?: 'Query', scheduledIncidents: Array<{ __typename?: 'Incident', createdAt: any, id: string, impact: string, name: string, resolvedAt?: any | null, shortlink: string, status: string, updatedAt: any, scheduledFor: any, scheduledUntil: any, incidentUpdates: Array<{ __typename?: 'IncidentUpdate', body: string, createdAt: any, displayAt: any, id: string, incidentId: string, status: string, updatedAt: string }> }> };

export type OperationModeOptionFragment = { __typename?: 'FindAvailableOperationsResponse', id: string, operationType: OperationTypes, operationMode: OperationModes, primaryKeyRequired: boolean, integrationId: string };

export type FindAvailableOperationsQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
}>;


export type FindAvailableOperationsQuery = { __typename?: 'Query', findAllAvailableOperations: Array<{ __typename?: 'FindAvailableOperationsResponse', id: string, operationType: OperationTypes, operationMode: OperationModes, primaryKeyRequired: boolean, integrationId: string }> };

export type CreateWorkflowMutationVariables = Exact<{
  cronExpression: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateWorkflowMutation = { __typename?: 'Mutation', createWorkflow: { __typename?: 'OrchestrationWorkflow', id: string, nextRun?: { __typename?: 'OrchestrationWorkflowRun', id: string } | null } };

export type EditWorkflowMutationVariables = Exact<{
  cronExpression: Scalars['String']['input'];
  workflowId: Scalars['ID']['input'];
}>;


export type EditWorkflowMutation = { __typename?: 'Mutation', editWorkflow: { __typename?: 'OrchestrationWorkflow', nextRun?: { __typename?: 'OrchestrationWorkflowRun', id: string } | null } };

export type DeleteWorkflowMutationVariables = Exact<{
  workflowId: Scalars['ID']['input'];
  cronSchedule: Scalars['String']['input'];
}>;


export type DeleteWorkflowMutation = { __typename?: 'Mutation', deleteWorkflow: string };

export type OrchestrationWorkflowRunFragment = { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus };

export type ModelTestRunFragment = { __typename?: 'ModelTestRun', workflowRunId: string, modelTestId: string, result?: { __typename?: 'ModelTestRunResult', rows?: Array<any> | null, status: ModelTestStatus, numRowsTotal?: number | null, error?: string | null } | null };

export type OrchestrationJobFragment = { __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string } | { __typename?: 'ModelViewReference', modelId: string } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null };

export type OrchestrationWorkflowHistoryQueryVariables = Exact<{
  workflowId: Scalars['ID']['input'];
}>;


export type OrchestrationWorkflowHistoryQuery = { __typename?: 'Query', orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, accountId: string, cronExpression: string, runs: Array<{ __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus }> } | null };

export type ListOrchestrationWorkflowsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOrchestrationWorkflowsQuery = { __typename?: 'Query', orchestrationWorkflows: Array<{ __typename?: 'OrchestrationWorkflow', id: string, name: string, cronExpression: string, currentRun?: { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus, jobs: Array<{ __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string } | { __typename?: 'ModelViewReference', modelId: string } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null }> } | null, nextRun?: { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus, jobs: Array<{ __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string } | { __typename?: 'ModelViewReference', modelId: string } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null }> } | null }> };

export type OrchestrationWorkflowQueryVariables = Exact<{
  workflowId: Scalars['ID']['input'];
}>;


export type OrchestrationWorkflowQuery = { __typename?: 'Query', orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, name: string, cronExpression: string, currentRun?: { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus, jobs: Array<{ __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string, modelTestRuns: Array<{ __typename?: 'ModelTestRun', workflowRunId: string, modelTestId: string, result?: { __typename?: 'ModelTestRunResult', rows?: Array<any> | null, status: ModelTestStatus, numRowsTotal?: number | null, error?: string | null } | null }> } | { __typename?: 'ModelViewReference', modelId: string, modelTestRuns: Array<{ __typename?: 'ModelTestRun', workflowRunId: string, modelTestId: string, result?: { __typename?: 'ModelTestRunResult', rows?: Array<any> | null, status: ModelTestStatus, numRowsTotal?: number | null, error?: string | null } | null }> } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null }> } | null, nextRun?: { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus, jobs: Array<{ __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string } | { __typename?: 'ModelViewReference', modelId: string } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null }> } | null } | null };

export type OrchestrationWorkflowRunQueryVariables = Exact<{
  runId: Scalars['ID']['input'];
}>;


export type OrchestrationWorkflowRunQuery = { __typename?: 'Query', orchestrationWorkflowRun: { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus, jobs: Array<{ __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string, modelTestRuns: Array<{ __typename?: 'ModelTestRun', workflowRunId: string, modelTestId: string, result?: { __typename?: 'ModelTestRunResult', rows?: Array<any> | null, status: ModelTestStatus, numRowsTotal?: number | null, error?: string | null } | null }> } | { __typename?: 'ModelViewReference', modelId: string, modelTestRuns: Array<{ __typename?: 'ModelTestRun', workflowRunId: string, modelTestId: string, result?: { __typename?: 'ModelTestRunResult', rows?: Array<any> | null, status: ModelTestStatus, numRowsTotal?: number | null, error?: string | null } | null }> } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null }> } };

export type StartWorkflowNowMutationVariables = Exact<{
  workflowId: Scalars['ID']['input'];
}>;


export type StartWorkflowNowMutation = { __typename?: 'Mutation', runOrchestrationWorkflowNow: { __typename?: 'OrchestrationWorkflow', nextRun?: { __typename?: 'OrchestrationWorkflowRun', id: string } | null } };

export type CancelCurrentWorkflowRunMutationVariables = Exact<{
  workflowId: Scalars['ID']['input'];
}>;


export type CancelCurrentWorkflowRunMutation = { __typename?: 'Mutation', cancelCurrentWorkflowRun: { __typename?: 'OrchestrationWorkflow', nextRun?: { __typename?: 'OrchestrationWorkflowRun', id: string } | null } };

export type SourcePropertyFragment = { __typename?: 'DataSchema', name: string, type: string, nullable: boolean };

export type SourcePropertiesQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type SourcePropertiesQuery = { __typename?: 'Query', sourceProperties: { __typename?: 'ViewDetails', dataSchema: Array<{ __typename?: 'DataSchema', name: string, type: string, nullable: boolean }> } };

export type DestinationPropertyFragment = { __typename?: 'Property', id: string, propertyId: string, propertyName: string, propertyType: string, readonly: boolean, isRequired: boolean, isPrimaryKey: boolean, automapMatchAny: boolean };

export type DestinationPropertiesQueryVariables = Exact<{
  destinationConnectionId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  operationMode: Scalars['String']['input'];
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DestinationPropertiesQuery = { __typename?: 'Query', destinationProperties: Array<{ __typename?: 'Property', id: string, propertyId: string, propertyName: string, propertyType: string, readonly: boolean, isRequired: boolean, isPrimaryKey: boolean, automapMatchAny: boolean }> };

export type SaveSignupQuestionnaireResultMutationVariables = Exact<{
  input: SaveSignupQuestionnaireResultInput;
}>;


export type SaveSignupQuestionnaireResultMutation = { __typename?: 'Mutation', saveSignupQuestionnaireResult: boolean };

export type GetSignupQuestionnaireResultQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSignupQuestionnaireResultQuery = { __typename?: 'Query', getSignupQuestionnaireResult: { __typename?: 'GetSignupQuestionnaireResponse', result?: { __typename?: 'SignupQuestionnaireResult', userId: string, result: any, timestamp: number } | null } };

export type StripePaymentMethodFragment = { __typename?: 'PaymentMethod', card: { __typename?: 'Card', last4: string, brand: CardBrand, expirationMonth: number, expirationYear: number } };

export type StripeCustomerFragment = { __typename?: 'Customer', id: string, companyName?: string | null, email?: string | null, currency?: string | null, taxId?: { __typename?: 'TaxId', type: string, country: string, value: string } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, state?: string | null } | null, defaultPaymentMethod?: { __typename?: 'PaymentMethod', card: { __typename?: 'Card', last4: string, brand: CardBrand, expirationMonth: number, expirationYear: number } } | null };

export type PriceFragment = { __typename?: 'Price', id: string, currency: string, price: number, billingScheme: BillingScheme, tiersMode?: TiersMode | null, lookupKey?: string | null, recurring?: { __typename?: 'Recurring', interval: RecurrenceInterval, intervalCount: number, usageType: RecurrenceUsageType } | null, tiers?: Array<{ __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null }> | null, currencyOptions: Array<{ __typename?: 'CurrencyOption', currency: string, price: number }> };

export type ProductFragment = { __typename?: 'Product', id: string, name: string, description?: string | null, type: WeldProductType, addOnType?: WeldAddOnType | null, active: boolean, price: { __typename?: 'Price', id: string, currency: string, price: number, billingScheme: BillingScheme, tiersMode?: TiersMode | null, lookupKey?: string | null, recurring?: { __typename?: 'Recurring', interval: RecurrenceInterval, intervalCount: number, usageType: RecurrenceUsageType } | null, tiers?: Array<{ __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null }> | null, currencyOptions: Array<{ __typename?: 'CurrencyOption', currency: string, price: number }> }, features: { __typename?: 'StripePlanFeatures', limitRows?: number | null, limitUsers?: number | null, limitConnectors?: number | null, minSyncIntervalInMinutes?: number | null } };

export type StripeSubscriptionItemFragment = { __typename?: 'StripeSubscriptionItem', quantity: number, price: { __typename?: 'StripeSubscriptionItemPrice', id: string, currency: string, price: number, billingScheme: BillingScheme, lookupKey?: string | null, product: { __typename?: 'BaseProduct', id: string, name: string, description?: string | null, image?: string | null, type: WeldProductType, addOnType?: WeldAddOnType | null, active: boolean, features: { __typename?: 'StripePlanFeatures', limitRows?: number | null, limitUsers?: number | null, limitConnectors?: number | null, minSyncIntervalInMinutes?: number | null } }, recurring?: { __typename?: 'Recurring', interval: RecurrenceInterval, intervalCount: number, usageType: RecurrenceUsageType } | null, tiers?: Array<{ __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null }> | null, currencyOptions: Array<{ __typename?: 'CurrencyOption', currency: string, price: number }> }, tier?: { __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null } | null };

export type StripePlanFeaturesFragment = { __typename?: 'StripePlanFeatures', limitRows?: number | null, limitUsers?: number | null, limitConnectors?: number | null, minSyncIntervalInMinutes?: number | null };

export type StripeSubscriptionQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type StripeSubscriptionQuery = { __typename?: 'Query', accountBySlug: { __typename?: 'Account', id: string, slug: string, stripeCustomer?: { __typename?: 'Customer', id: string, companyName?: string | null, email?: string | null, currency?: string | null, taxId?: { __typename?: 'TaxId', type: string, country: string, value: string } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, state?: string | null } | null, defaultPaymentMethod?: { __typename?: 'PaymentMethod', card: { __typename?: 'Card', last4: string, brand: CardBrand, expirationMonth: number, expirationYear: number } } | null } | null, stripeSubscription?: { __typename?: 'StripeSubscription', stripeSubscriptionDetails: { __typename?: 'StripeSubscriptionDetails', id: string, status: StripeSubscriptionStatus, createdDate: any, trialEndDate?: any | null, cancelDate?: any | null, currentPeriodStartDate: any, currentPeriodEndDate: any, planName: PlanName, items: Array<{ __typename?: 'StripeSubscriptionItem', quantity: number, price: { __typename?: 'StripeSubscriptionItemPrice', id: string, currency: string, price: number, billingScheme: BillingScheme, lookupKey?: string | null, product: { __typename?: 'BaseProduct', id: string, name: string, description?: string | null, image?: string | null, type: WeldProductType, addOnType?: WeldAddOnType | null, active: boolean, features: { __typename?: 'StripePlanFeatures', limitRows?: number | null, limitUsers?: number | null, limitConnectors?: number | null, minSyncIntervalInMinutes?: number | null } }, recurring?: { __typename?: 'Recurring', interval: RecurrenceInterval, intervalCount: number, usageType: RecurrenceUsageType } | null, tiers?: Array<{ __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null }> | null, currencyOptions: Array<{ __typename?: 'CurrencyOption', currency: string, price: number }> }, tier?: { __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null } | null }> } } | null } };

export type StripeCustomerQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type StripeCustomerQuery = { __typename?: 'Query', accountBySlug: { __typename?: 'Account', stripeCustomer?: { __typename?: 'Customer', id: string, companyName?: string | null, email?: string | null, currency?: string | null, taxId?: { __typename?: 'TaxId', type: string, country: string, value: string } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, state?: string | null } | null, defaultPaymentMethod?: { __typename?: 'PaymentMethod', card: { __typename?: 'Card', last4: string, brand: CardBrand, expirationMonth: number, expirationYear: number } } | null } | null } };

export type CreateOrUpdateCustomerMutationVariables = Exact<{
  input: CreateOrUpdateCustomerInput;
}>;


export type CreateOrUpdateCustomerMutation = { __typename?: 'Mutation', createOrUpdateCustomer: { __typename?: 'Customer', id: string, companyName?: string | null, email?: string | null, currency?: string | null, taxId?: { __typename?: 'TaxId', type: string, country: string, value: string } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, state?: string | null } | null, defaultPaymentMethod?: { __typename?: 'PaymentMethod', card: { __typename?: 'Card', last4: string, brand: CardBrand, expirationMonth: number, expirationYear: number } } | null } };

export type CreateOrUpdateWeldSubscriptionMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  numConnectors: Scalars['Int']['input'];
  numUsers: Scalars['Int']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOrUpdateWeldSubscriptionMutation = { __typename?: 'Mutation', createOrUpdateWeldSubscription: { __typename?: 'CreateSubscriptionResponse', id: string } };

export type CancelWeldSubscriptionMutationVariables = Exact<{
  input: CancelSubscriptionInput;
}>;


export type CancelWeldSubscriptionMutation = { __typename?: 'Mutation', cancelWeldSubscription: { __typename?: 'CancelSubscriptionResponse', id: string } };

export type RevertWeldSubscriptionCancellationMutationVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
}>;


export type RevertWeldSubscriptionCancellationMutation = { __typename?: 'Mutation', revertSubscriptionCancelation: { __typename?: 'CancelSubscriptionResponse', id: string } };

export type UpdateSubscriptionAddOnsMutationVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
  input: UpdateSubscriptionAddOnsInput;
}>;


export type UpdateSubscriptionAddOnsMutation = { __typename?: 'Mutation', updateSubscriptionAddOns: { __typename?: 'UpdateSubscriptionResponse', id: string } };

export type UpdatePaymentMethodMutationVariables = Exact<{
  input: CreatePaymentMethodCheckoutSessionInput;
}>;


export type UpdatePaymentMethodMutation = { __typename?: 'Mutation', createPaymentMethodCheckoutSession: { __typename?: 'CheckoutSession', id: string, url: string, expiresAt: any } };

export type UpdateBillingDetailsMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  billingDetails: BillingDetailsInput;
}>;


export type UpdateBillingDetailsMutation = { __typename?: 'Mutation', updateBillingDetails: { __typename?: 'Customer', id: string, email?: string | null } };

export type StripePlanProductQueryVariables = Exact<{
  planName: Scalars['String']['input'];
}>;


export type StripePlanProductQuery = { __typename?: 'Query', getPlanProduct?: { __typename?: 'Product', id: string, name: string, description?: string | null, type: WeldProductType, addOnType?: WeldAddOnType | null, active: boolean, price: { __typename?: 'Price', id: string, currency: string, price: number, billingScheme: BillingScheme, tiersMode?: TiersMode | null, lookupKey?: string | null, recurring?: { __typename?: 'Recurring', interval: RecurrenceInterval, intervalCount: number, usageType: RecurrenceUsageType } | null, tiers?: Array<{ __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null }> | null, currencyOptions: Array<{ __typename?: 'CurrencyOption', currency: string, price: number }> }, features: { __typename?: 'StripePlanFeatures', limitRows?: number | null, limitUsers?: number | null, limitConnectors?: number | null, minSyncIntervalInMinutes?: number | null } } | null };

export type AvailableAddOnProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableAddOnProductsQuery = { __typename?: 'Query', getAvailableAddOnProducts: Array<{ __typename?: 'Product', id: string, name: string, description?: string | null, type: WeldProductType, addOnType?: WeldAddOnType | null, active: boolean, price: { __typename?: 'Price', id: string, currency: string, price: number, billingScheme: BillingScheme, tiersMode?: TiersMode | null, lookupKey?: string | null, recurring?: { __typename?: 'Recurring', interval: RecurrenceInterval, intervalCount: number, usageType: RecurrenceUsageType } | null, tiers?: Array<{ __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null }> | null, currencyOptions: Array<{ __typename?: 'CurrencyOption', currency: string, price: number }> }, features: { __typename?: 'StripePlanFeatures', limitRows?: number | null, limitUsers?: number | null, limitConnectors?: number | null, minSyncIntervalInMinutes?: number | null } }> };

export type AddOnProductsByIdsQueryVariables = Exact<{
  productIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddOnProductsByIdsQuery = { __typename?: 'Query', getAddOnProductsByIds: Array<{ __typename?: 'Product', id: string, name: string, description?: string | null, type: WeldProductType, addOnType?: WeldAddOnType | null, active: boolean, price: { __typename?: 'Price', id: string, currency: string, price: number, billingScheme: BillingScheme, tiersMode?: TiersMode | null, lookupKey?: string | null, recurring?: { __typename?: 'Recurring', interval: RecurrenceInterval, intervalCount: number, usageType: RecurrenceUsageType } | null, tiers?: Array<{ __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null }> | null, currencyOptions: Array<{ __typename?: 'CurrencyOption', currency: string, price: number }> }, features: { __typename?: 'StripePlanFeatures', limitRows?: number | null, limitUsers?: number | null, limitConnectors?: number | null, minSyncIntervalInMinutes?: number | null } }> };

export type ProductPriceQueryVariables = Exact<{
  priceId: Scalars['String']['input'];
  currency: Scalars['String']['input'];
}>;


export type ProductPriceQuery = { __typename?: 'Query', getProductPrice: { __typename?: 'Price', id: string, currency: string, price: number, billingScheme: BillingScheme, tiersMode?: TiersMode | null, lookupKey?: string | null, currencyOptions: Array<{ __typename?: 'CurrencyOption', currency: string, price: number, tiers?: Array<{ __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null }> | null }>, recurring?: { __typename?: 'Recurring', interval: RecurrenceInterval, intervalCount: number, usageType: RecurrenceUsageType } | null, tiers?: Array<{ __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null }> | null } };

export type ProductPriceByLookupKeyQueryVariables = Exact<{
  lookupKey: Scalars['String']['input'];
  currency: Scalars['String']['input'];
}>;


export type ProductPriceByLookupKeyQuery = { __typename?: 'Query', getProductPriceByLookupKey: { __typename?: 'Price', id: string, currency: string, price: number, billingScheme: BillingScheme, tiersMode?: TiersMode | null, lookupKey?: string | null, currencyOptions: Array<{ __typename?: 'CurrencyOption', currency: string, price: number, tiers?: Array<{ __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null }> | null }>, recurring?: { __typename?: 'Recurring', interval: RecurrenceInterval, intervalCount: number, usageType: RecurrenceUsageType } | null, tiers?: Array<{ __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null }> | null } };

export type StripeInvoiceFragment = { __typename?: 'Invoice', id: string, chargeStatus?: StripeChargeStatus | null, chargeFailureMessage?: string | null, currency: string, dueDate: any, hostedInvoiceUrl?: string | null, periodStart: any, status?: InvoiceStatus | null, total: number };

export type InvoicesQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type InvoicesQuery = { __typename?: 'Query', invoices: Array<{ __typename?: 'Invoice', id: string, chargeStatus?: StripeChargeStatus | null, chargeFailureMessage?: string | null, currency: string, dueDate: any, hostedInvoiceUrl?: string | null, periodStart: any, status?: InvoiceStatus | null, total: number }> };

export type OverdueInvoicesQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type OverdueInvoicesQuery = { __typename?: 'Query', overdueInvoices: Array<{ __typename?: 'Invoice', id: string, dueDate: any, hostedInvoiceUrl?: string | null }> };

export type UpcomingInvoiceFragment = { __typename?: 'UpcomingInvoice', total: number, subTotal: number, currency: string, createdDate: any, periodStart: any, periodEnd: any, trialEnd?: any | null, subscriptionStatus?: StripeSubscriptionStatus | null, taxes: Array<{ __typename?: 'InvoiceTaxes', amount: number, percentage: number, displayName: string }>, breakdown?: Array<{ __typename?: 'InvoiceBreakdownItem', amount: number, quantity?: number | null, label: string, description?: string | null }> | null, discounts: Array<{ __typename?: 'DiscountItem', amount: number, name: string }> };

export type CheckoutPreviewQueryVariables = Exact<{
  input: InvoicePreviewInput;
}>;


export type CheckoutPreviewQuery = { __typename?: 'Query', getCheckoutPreview: { __typename?: 'UpcomingInvoice', total: number, subTotal: number, currency: string, createdDate: any, periodStart: any, periodEnd: any, trialEnd?: any | null, subscriptionStatus?: StripeSubscriptionStatus | null, taxes: Array<{ __typename?: 'InvoiceTaxes', amount: number, percentage: number, displayName: string }>, breakdown?: Array<{ __typename?: 'InvoiceBreakdownItem', amount: number, quantity?: number | null, label: string, description?: string | null }> | null, discounts: Array<{ __typename?: 'DiscountItem', amount: number, name: string }> } };

export type StaticCheckoutPreviewQueryVariables = Exact<{
  input: StaticInvoicePreviewInput;
}>;


export type StaticCheckoutPreviewQuery = { __typename?: 'Query', getStaticPreview: { __typename?: 'UpcomingInvoice', total: number, subTotal: number, currency: string, createdDate: any, periodStart: any, periodEnd: any, trialEnd?: any | null, subscriptionStatus?: StripeSubscriptionStatus | null, taxes: Array<{ __typename?: 'InvoiceTaxes', amount: number, percentage: number, displayName: string }>, breakdown?: Array<{ __typename?: 'InvoiceBreakdownItem', amount: number, quantity?: number | null, label: string, description?: string | null }> | null, discounts: Array<{ __typename?: 'DiscountItem', amount: number, name: string }> } };

export type StaticCheckoutPreviewByLookupKeyQueryVariables = Exact<{
  input: StaticInvoicePreviewByLookupKeyInput;
}>;


export type StaticCheckoutPreviewByLookupKeyQuery = { __typename?: 'Query', getStaticPreviewByLookupKey: { __typename?: 'UpcomingInvoice', total: number, subTotal: number, currency: string, createdDate: any, periodStart: any, periodEnd: any, trialEnd?: any | null, subscriptionStatus?: StripeSubscriptionStatus | null, taxes: Array<{ __typename?: 'InvoiceTaxes', amount: number, percentage: number, displayName: string }>, breakdown?: Array<{ __typename?: 'InvoiceBreakdownItem', amount: number, quantity?: number | null, label: string, description?: string | null }> | null, discounts: Array<{ __typename?: 'DiscountItem', amount: number, name: string }> } };

export type UpcomingInvoiceQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
}>;


export type UpcomingInvoiceQuery = { __typename?: 'Query', upcomingInvoice: { __typename?: 'UpcomingInvoice', total: number, subTotal: number, currency: string, createdDate: any, periodStart: any, periodEnd: any, trialEnd?: any | null, subscriptionStatus?: StripeSubscriptionStatus | null, taxes: Array<{ __typename?: 'InvoiceTaxes', amount: number, percentage: number, displayName: string }>, breakdown?: Array<{ __typename?: 'InvoiceBreakdownItem', amount: number, quantity?: number | null, label: string, description?: string | null }> | null, discounts: Array<{ __typename?: 'DiscountItem', amount: number, name: string }> } };

export type TaxIdsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type TaxIdsDataQuery = { __typename?: 'Query', taxIdsData: Array<{ __typename?: 'TaxIdData', country: string, countryCode: string, enum: string, shortName: string, description: string, example: string }> };

export type CreateFuturePaymentsSetupIntentMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type CreateFuturePaymentsSetupIntentMutation = { __typename?: 'Mutation', createFuturePaymentsSetupIntent: { __typename?: 'CreateSetupIntentResponse', clientSecret: string } };

export type SubmitProductNpsMutationVariables = Exact<{
  input: SubmitSurveyInput;
}>;


export type SubmitProductNpsMutation = { __typename?: 'Mutation', submitProductNPS: { __typename?: 'SurveyResponse', id: string, surveyId: string, score?: number | null } };

export type DismissProductNpsMutationVariables = Exact<{ [key: string]: never; }>;


export type DismissProductNpsMutation = { __typename?: 'Mutation', dismissProductNPS: { __typename?: 'SurveyResponse', id: string, surveyId: string, score?: number | null } };

export type GetPromptableProductNpsSurveyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPromptableProductNpsSurveyQuery = { __typename?: 'Query', getPromptableProductNPSSurvey: { __typename?: 'PromptableSurveyResponse', survey?: { __typename?: 'Survey', id: string, name: string, question: string } | null } };

export type FindSyncHistoryResponseFragment = { __typename?: 'FindSyncHistoryResponse', syncId: string, jobId?: string | null, status?: SyncJobStatus | null, startedAt: string, finishedAt?: string | null, totalRecords?: number | null, newRecords?: number | null, sizeSyncedMb?: number | null, syncedRecords?: number | null, failedRecords?: number | null, sourceStreamName?: string | null, error?: string | null, scheduledJobId?: string | null, isChunk?: boolean | null, fullSyncTrigger?: FullSyncTrigger | null, operationMode?: OperationMode | null, details?: string | null };

export type SourceStreamSnapshotFragment = { __typename?: 'SourceStreamSnapshot', bytesSynced: number, errorMessage?: string | null, estimatedTotalCount?: number | null, finishedAt?: string | null, fullSyncTrigger?: FullSyncTrigger | null, isChunk?: boolean | null, operationMode?: OperationMode | null, retryAttempt?: number | null, recordsSynced?: number | null, startedAt?: string | null, status?: SyncJobStatus | null, syncId?: string | null, sourceStreamName?: string | null, scheduledJobId?: string | null, details?: string | null };

export type SourceStreamSnapshotStatesFragment = { __typename?: 'SourceStreamSnapshotStates', name: string, scheduledJobId: string, activeSync?: { __typename?: 'SourceStreamSnapshot', bytesSynced: number, errorMessage?: string | null, estimatedTotalCount?: number | null, finishedAt?: string | null, fullSyncTrigger?: FullSyncTrigger | null, isChunk?: boolean | null, operationMode?: OperationMode | null, retryAttempt?: number | null, recordsSynced?: number | null, startedAt?: string | null, status?: SyncJobStatus | null, syncId?: string | null, sourceStreamName?: string | null, scheduledJobId?: string | null, details?: string | null } | null, latestSync?: { __typename?: 'SourceStreamSnapshot', bytesSynced: number, errorMessage?: string | null, estimatedTotalCount?: number | null, finishedAt?: string | null, fullSyncTrigger?: FullSyncTrigger | null, isChunk?: boolean | null, operationMode?: OperationMode | null, retryAttempt?: number | null, recordsSynced?: number | null, startedAt?: string | null, status?: SyncJobStatus | null, syncId?: string | null, sourceStreamName?: string | null, scheduledJobId?: string | null, details?: string | null } | null };

export type FindSyncHistoryQueryVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type FindSyncHistoryQuery = { __typename?: 'Query', findReverseEltSyncHistory: Array<{ __typename?: 'FindSyncHistoryResponse', syncId: string, jobId?: string | null, status?: SyncJobStatus | null, startedAt: string, finishedAt?: string | null, totalRecords?: number | null, newRecords?: number | null, sizeSyncedMb?: number | null, syncedRecords?: number | null, failedRecords?: number | null, sourceStreamName?: string | null, error?: string | null, scheduledJobId?: string | null, isChunk?: boolean | null, fullSyncTrigger?: FullSyncTrigger | null, operationMode?: OperationMode | null, details?: string | null }> };

export type EltSyncSnapshotStateQueryVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type EltSyncSnapshotStateQuery = { __typename?: 'Query', eltSyncSnapshotState: { __typename?: 'EltSyncSnapshotState', syncId: string, sourceStreams: Array<{ __typename?: 'SourceStreamSnapshotStates', name: string, scheduledJobId: string, activeSync?: { __typename?: 'SourceStreamSnapshot', bytesSynced: number, errorMessage?: string | null, estimatedTotalCount?: number | null, finishedAt?: string | null, fullSyncTrigger?: FullSyncTrigger | null, isChunk?: boolean | null, operationMode?: OperationMode | null, retryAttempt?: number | null, recordsSynced?: number | null, startedAt?: string | null, status?: SyncJobStatus | null, syncId?: string | null, sourceStreamName?: string | null, scheduledJobId?: string | null, details?: string | null } | null, latestSync?: { __typename?: 'SourceStreamSnapshot', bytesSynced: number, errorMessage?: string | null, estimatedTotalCount?: number | null, finishedAt?: string | null, fullSyncTrigger?: FullSyncTrigger | null, isChunk?: boolean | null, operationMode?: OperationMode | null, retryAttempt?: number | null, recordsSynced?: number | null, startedAt?: string | null, status?: SyncJobStatus | null, syncId?: string | null, sourceStreamName?: string | null, scheduledJobId?: string | null, details?: string | null } | null }> } };

export type FindManyEltSyncHistoryQueryVariables = Exact<{
  syncId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
  excludeEmpty?: Scalars['Boolean']['input'];
}>;


export type FindManyEltSyncHistoryQuery = { __typename?: 'Query', findManyEltSyncHistory: Array<{ __typename?: 'FindSyncHistoryResponse', syncId: string, jobId?: string | null, status?: SyncJobStatus | null, startedAt: string, finishedAt?: string | null, totalRecords?: number | null, newRecords?: number | null, sizeSyncedMb?: number | null, syncedRecords?: number | null, failedRecords?: number | null, sourceStreamName?: string | null, error?: string | null, scheduledJobId?: string | null, isChunk?: boolean | null, fullSyncTrigger?: FullSyncTrigger | null, operationMode?: OperationMode | null, details?: string | null }> };

export type GetJobLogsQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetJobLogsQuery = { __typename?: 'Query', getJobLogs: Array<{ __typename?: 'GetJobLogsResponse', status: JobLoggingMessageStatus, timestamp: string, message: string }> };

export type ActiveInitialSyncsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveInitialSyncsQuery = { __typename?: 'Query', activeInitialSyncs: Array<{ __typename?: 'EltSync', id: string }> };

export type InitialSyncsStatusQueryVariables = Exact<{
  syncIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InitialSyncsStatusQuery = { __typename?: 'Query', initialSyncsStatus: Array<{ __typename?: 'InitialSyncStatusResponse', syncId: string, integrationId: string, status: InitialSyncStatus, startedAt: any, finishedAt?: any | null, duration?: number | null, isChunkedSync: boolean, tableStats: { __typename?: 'InitialSyncTableStats', running: number, completed: number, failed: number, total: number, recordsSynced: number, bytesSynced: number } }> };

export type RevEtlJobStatusFragment = { __typename?: 'ReverseEtlJobResponse', nextRun?: number | null, lastRun?: number | null, status?: string | null, running?: boolean | null, startedAt?: string | null, isQuarantined?: boolean | null };

export type SyncListItemFragment = { __typename?: 'Sync', id: string, status: string, active: boolean, sourceIntegrationId: string, destinationIntegrationId: string, sourceConnectionId: string, primaryObject: string, createdAt: any, syncInterval?: string | null, errorCount: number, config?: { __typename?: 'Config', destinationSettings?: any | null } | null, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection: { __typename?: 'Connection', label: string, id: string }, model?: { __typename?: 'Model', id: string, name: string, createdAt: any, materializationType: MaterializationType, emoji?: string | null, dashboardId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string } | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, cronExpression: string } | null, job?: { __typename?: 'ReverseEtlJobResponse', nextRun?: number | null, lastRun?: number | null, status?: string | null, running?: boolean | null, startedAt?: string | null, isQuarantined?: boolean | null } | null };

export type ReverseEtlSyncFragment = { __typename?: 'Sync', id: string, status: string, active: boolean, primaryObject: string, syncInterval?: string | null, sourceConnectionId: string, destinationConnectionId: string, sourceIntegrationId: string, destinationIntegrationId: string, schedulerType: OrchestrationSchedulerType, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection: { __typename?: 'Connection', label: string, id: string }, operations: Array<{ __typename?: 'Operation', availableOperationId: string, operationMode: OperationModes, operationType: OperationTypes, objectType: string, primaryKeyRequired: boolean, primaryKeyMapping?: { __typename?: 'Mapping', id: string, sourcePropertyId: string, sourcePropertyName: string, sourcePropertyType: string, destinationPropertyId: string, destinationPropertyName: string, destinationPropertyType: string, readonly: boolean, primaryKey: boolean } | null }>, mappings: Array<{ __typename?: 'Mapping', id: string, sourcePropertyId: string, sourcePropertyName: string, sourcePropertyType: string, destinationPropertyId: string, destinationPropertyName: string, destinationPropertyType: string, readonly: boolean, primaryKey: boolean }>, model?: { __typename?: 'Model', id: string, name: string } | null, config?: { __typename?: 'Config', destinationSettings?: any | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null, job?: { __typename?: 'ReverseEtlJobResponse', nextRun?: number | null, lastRun?: number | null, status?: string | null, running?: boolean | null, startedAt?: string | null, isQuarantined?: boolean | null } | null };

export type CreateSyncMutationVariables = Exact<{
  sourceConnectionId: Scalars['String']['input'];
  destinationConnectionId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  operations: Array<CreateOperationInput> | CreateOperationInput;
  primaryObject: Scalars['String']['input'];
  syncInterval?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['String']['input']>;
  schedulerType: OrchestrationSchedulerType;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateSyncMutation = { __typename?: 'Mutation', createSync: { __typename?: 'Sync', id: string, status: string, active: boolean, sourceIntegrationId: string, destinationIntegrationId: string, sourceConnectionId: string, primaryObject: string, createdAt: any, syncInterval?: string | null, errorCount: number, config?: { __typename?: 'Config', destinationSettings?: any | null } | null, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection: { __typename?: 'Connection', label: string, id: string }, model?: { __typename?: 'Model', id: string, name: string, createdAt: any, materializationType: MaterializationType, emoji?: string | null, dashboardId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string } | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, cronExpression: string } | null, job?: { __typename?: 'ReverseEtlJobResponse', nextRun?: number | null, lastRun?: number | null, status?: string | null, running?: boolean | null, startedAt?: string | null, isQuarantined?: boolean | null } | null } };

export type UpdateSyncMutationVariables = Exact<{
  syncId: Scalars['String']['input'];
  operations: Array<CreateOperationInput> | CreateOperationInput;
  syncInterval?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['String']['input']>;
  schedulerType: OrchestrationSchedulerType;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateSyncMutation = { __typename?: 'Mutation', updateSync: { __typename?: 'Sync', id: string, sourceConnectionId: string, destinationConnectionId: string } };

export type StartSyncMutationVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type StartSyncMutation = { __typename?: 'Mutation', startSync: { __typename?: 'Sync', id: string } };

export type StopSyncMutationVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type StopSyncMutation = { __typename?: 'Mutation', stopSync: { __typename?: 'Sync', id: string } };

export type CheckOnDemandReverseEtlSyncEligibilityQueryVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type CheckOnDemandReverseEtlSyncEligibilityQuery = { __typename?: 'Query', checkOnDemandReverseEtlSyncEligibility: { __typename?: 'OnDemandReverseETLSyncEligibilityResponse', possible: boolean, reason?: string | null } };

export type RunRevEtlSyncNowMutationVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type RunRevEtlSyncNowMutation = { __typename?: 'Mutation', runSyncNow?: boolean | null };

export type RemoveSyncMutationVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type RemoveSyncMutation = { __typename?: 'Mutation', removeSync: { __typename?: 'Sync', id: string } };

export type ListSyncsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListSyncsQuery = { __typename?: 'Query', syncs: Array<{ __typename?: 'Sync', id: string, status: string, active: boolean, sourceIntegrationId: string, destinationIntegrationId: string, sourceConnectionId: string, primaryObject: string, createdAt: any, syncInterval?: string | null, errorCount: number, config?: { __typename?: 'Config', destinationSettings?: any | null } | null, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection: { __typename?: 'Connection', label: string, id: string }, model?: { __typename?: 'Model', id: string, name: string, createdAt: any, materializationType: MaterializationType, emoji?: string | null, dashboardId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string } | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, cronExpression: string } | null, job?: { __typename?: 'ReverseEtlJobResponse', nextRun?: number | null, lastRun?: number | null, status?: string | null, running?: boolean | null, startedAt?: string | null, isQuarantined?: boolean | null } | null }> };

export type FindOneSyncQueryVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type FindOneSyncQuery = { __typename?: 'Query', findOneSync: { __typename?: 'Sync', id: string, status: string, active: boolean, primaryObject: string, syncInterval?: string | null, sourceConnectionId: string, destinationConnectionId: string, sourceIntegrationId: string, destinationIntegrationId: string, schedulerType: OrchestrationSchedulerType, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection: { __typename?: 'Connection', label: string, id: string }, operations: Array<{ __typename?: 'Operation', availableOperationId: string, operationMode: OperationModes, operationType: OperationTypes, objectType: string, primaryKeyRequired: boolean, primaryKeyMapping?: { __typename?: 'Mapping', id: string, sourcePropertyId: string, sourcePropertyName: string, sourcePropertyType: string, destinationPropertyId: string, destinationPropertyName: string, destinationPropertyType: string, readonly: boolean, primaryKey: boolean } | null }>, mappings: Array<{ __typename?: 'Mapping', id: string, sourcePropertyId: string, sourcePropertyName: string, sourcePropertyType: string, destinationPropertyId: string, destinationPropertyName: string, destinationPropertyType: string, readonly: boolean, primaryKey: boolean }>, model?: { __typename?: 'Model', id: string, name: string } | null, config?: { __typename?: 'Config', destinationSettings?: any | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null, job?: { __typename?: 'ReverseEtlJobResponse', nextRun?: number | null, lastRun?: number | null, status?: string | null, running?: boolean | null, startedAt?: string | null, isQuarantined?: boolean | null } | null } };

export type GetSyncErrorsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSyncErrorsQuery = { __typename?: 'Query', getErrors: Array<{ __typename?: 'ActivateError', objectId: string, scheduledJobId: string, syncId: string, error: string }> };

export type ResetErrorsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  objectIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ResetErrorsMutation = { __typename?: 'Mutation', resetErrors: boolean };

export type ResetAllErrorsMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ResetAllErrorsMutation = { __typename?: 'Mutation', resetAllErrors: boolean };

export type ReverseEtlJobsCompletionStatsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ReverseEtlJobsCompletionStatsQuery = { __typename?: 'Query', reverseEtlJobsCompletionStats: { __typename?: 'SyncJobsCompletionMetricResponse', stats?: { __typename?: 'SyncJobsCompletionMetric', total: number, successCount: number, successPercent: number, failureCount: number, failurePercent: number } | null } };

export type ReverseEtlJobStatusQueryVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type ReverseEtlJobStatusQuery = { __typename?: 'Query', findOneSync: { __typename?: 'Sync', job?: { __typename?: 'ReverseEtlJobResponse', nextRun?: number | null, lastRun?: number | null, status?: string | null, running?: boolean | null, startedAt?: string | null, isQuarantined?: boolean | null } | null } };

export type CreateTemplateMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  template: TemplatesEnum;
}>;


export type CreateTemplateMutation = { __typename?: 'Mutation', createTemplate: { __typename?: 'Template', id: string, name: TemplatesEnum, createdAt: any, updatedAt: any } };

export type CreateEltSyncFromTemplateMutationVariables = Exact<{
  input: EltFromTemplateInput;
}>;


export type CreateEltSyncFromTemplateMutation = { __typename?: 'Mutation', createEltSyncFromTemplate: { __typename?: 'EltSync', id: string, sourceConnectionId: string, destinationConnectionId: string } };

export type GetTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTemplatesQuery = { __typename?: 'Query', getTemplates: Array<{ __typename?: 'Template', id: string, name: TemplatesEnum, createdAt: any, updatedAt: any, templateEltSync: Array<{ __typename?: 'TemplateEltSync', sourceIntegrationId: string, eltSyncId: string }> }> };

export type ListTemplateConfigurationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListTemplateConfigurationsQuery = { __typename?: 'Query', listTemplateConfigurations: Array<{ __typename?: 'TemplateConfig', useCase: TemplatesEnum, integrations: Array<{ __typename?: 'IntegrationTemplate', sourceIntegationId: string, required: boolean, config: { __typename?: 'EltPartialConfig', destinationSchemaName?: string | null, sourceStreams: Array<{ __typename?: 'TemplateSourceStream', name: string, mode: string, substreams: Array<{ __typename?: 'TemplateSubstream', name: string }> }> }, models: Array<{ __typename?: 'TemplateModel', templateItemId: string, name: string, description: string }> }>, metrics: Array<{ __typename?: 'TemplateMetric', name: string, folder: string, description: string, aiInsights: Array<string>, columns?: Array<{ __typename?: 'MetricColumn', columnName: string, columnType: MetricColumnType, description: string }> | null, config: { __typename?: 'MetricConfig', templateItemId: string } }> }> };

export type AttachEltSyncToTemplateMutationVariables = Exact<{
  input: AttachEltTemplateInput;
}>;


export type AttachEltSyncToTemplateMutation = { __typename?: 'Mutation', attachEltSyncToTemplate: { __typename?: 'EltSync', id: string, sourceConnectionId: string, destinationConnectionId: string } };

export type SyncStatsFragment = { __typename?: 'SyncStats', numRowsSynced: number, numBillableRows: number };

export type StatsPeriodFragment = { __typename?: 'StatsPeriod', start: any, end: any };

export type WorkspaceSyncStatsFragment = { __typename?: 'WorkspaceSyncStats', date: any, numRowsSynced: number, numBillableRows: number, elt: { __typename?: 'SyncStats', numRowsSynced: number, numBillableRows: number }, reverseElt: { __typename?: 'SyncStats', numRowsSynced: number, numBillableRows: number } };

export type IntegrationSyncStatsFragment = { __typename?: 'IntegrationSyncStats', integrationId: string, numRowsSynced: number, numBillableRows: number, elt: { __typename?: 'SyncStats', numRowsSynced: number, numBillableRows: number }, reverseElt: { __typename?: 'SyncStats', numRowsSynced: number, numBillableRows: number } };

export type SourceStreamSyncStatsFragment = { __typename?: 'SourceStreamSyncStats', integrationId: string, sourceStreamName: string, numRowsSynced: number, numBillableRows: number };

export type WorkspaceSyncStatsQueryVariables = Exact<{
  fromMonth: Scalars['DateTime']['input'];
  toMonth?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type WorkspaceSyncStatsQuery = { __typename?: 'Query', workspaceSyncStats: { __typename?: 'WorkspaceSyncStatsResponse', period: { __typename?: 'StatsPeriod', start: any, end: any }, data: Array<{ __typename?: 'WorkspaceSyncStats', date: any, numRowsSynced: number, numBillableRows: number, elt: { __typename?: 'SyncStats', numRowsSynced: number, numBillableRows: number }, reverseElt: { __typename?: 'SyncStats', numRowsSynced: number, numBillableRows: number } }> } };

export type WorkspaceSyncStatsByIntegrationQueryVariables = Exact<{
  month: Scalars['DateTime']['input'];
}>;


export type WorkspaceSyncStatsByIntegrationQuery = { __typename?: 'Query', workspaceSyncStatsByIntegration: { __typename?: 'IntegrationSyncStatsResponse', period: { __typename?: 'StatsPeriod', start: any, end: any }, data: Array<{ __typename?: 'IntegrationSyncStats', integrationId: string, numRowsSynced: number, numBillableRows: number, elt: { __typename?: 'SyncStats', numRowsSynced: number, numBillableRows: number }, reverseElt: { __typename?: 'SyncStats', numRowsSynced: number, numBillableRows: number } }> } };

export type WorkspaceSyncStatsBySourceStreamQueryVariables = Exact<{
  month: Scalars['DateTime']['input'];
}>;


export type WorkspaceSyncStatsBySourceStreamQuery = { __typename?: 'Query', workspaceSyncStatsBySourceStream: { __typename?: 'SourceStreamSyncStatsResponse', period: { __typename?: 'StatsPeriod', start: any, end: any }, data: Array<{ __typename?: 'SourceStreamSyncStats', integrationId: string, sourceStreamName: string, numRowsSynced: number, numBillableRows: number }> } };

export type WorkspaceStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspaceStatsQuery = { __typename?: 'Query', workspaceStats: { __typename?: 'WorkspaceStats', numConnections: number, numUsers: number } };

export type DailyUsageStatsForMonthQueryVariables = Exact<{
  referenceDate: Scalars['DateTime']['input'];
}>;


export type DailyUsageStatsForMonthQuery = { __typename?: 'Query', dailyUsageStatsForMonth: { __typename?: 'WorkspaceSyncStatsResponse', period: { __typename?: 'StatsPeriod', start: any, end: any }, data: Array<{ __typename?: 'WorkspaceSyncStats', date: any, numRowsSynced: number, numBillableRows: number, elt: { __typename?: 'SyncStats', numRowsSynced: number, numBillableRows: number }, reverseElt: { __typename?: 'SyncStats', numRowsSynced: number, numBillableRows: number } }> } };

export type UsageStatsLast30DaysQueryVariables = Exact<{ [key: string]: never; }>;


export type UsageStatsLast30DaysQuery = { __typename?: 'Query', usageStatsLast30Days: { __typename?: 'WorkspaceSyncStatsLast30DaysResponse', period: { __typename?: 'StatsPeriod', start: any, end: any }, data: { __typename?: 'WorkspaceSyncStatsLast30Days', total: number, elt: number, eltPercentage: number, reverseElt: number, reverseEltPercentage: number } } };

export type CurrentMonthUsageForecastQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentMonthUsageForecastQuery = { __typename?: 'Query', currentMonthUsageForecast: { __typename?: 'UsageForecastResponse', data?: Array<{ __typename?: 'ForecastedDataPoint', date: any, value: number }> | null } };

export type BigQueryUsageStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type BigQueryUsageStatsQuery = { __typename?: 'Query', bigQueryUsageStats: { __typename?: 'BigQueryStats', data: Array<{ __typename?: 'BQUsage', datasetId: string, tableId: string, path: string, totalBytesProcessed: number, totalBytesBilled: number, bqBilledUsd: number, metabaseUsage?: { __typename?: 'QueryUsage', bytesProcessed: number, bytesBilled: number, bqBilledUsd: number } | null, queryUsage?: { __typename?: 'QueryUsage', bytesProcessed: number, bytesBilled: number, bqBilledUsd: number } | null }> } };

export type FeatureLimitFragment = { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null };

export type FeatureSetFragment = { __typename?: 'FeatureSet', aiAssistantHistoryEnabled: boolean, auditLogsEnabled: boolean, columnHashingEnabled: boolean, customConnectorEnabled: boolean, externalAuthorizationEnabled: boolean, lineageEnabled: boolean, minSyncIntervalInMinutes: number, modelTestingEnabled: boolean, onDemandSyncsEnabled: boolean, orchestrationEnabled: boolean, limitConnectors: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null }, limitRows: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null }, limitUsers: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null }, limitWorkspaces: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null } };

export type ConfigurableLimitsFragment = { __typename?: 'ConfigurableLimits', maxConnectors?: number | null, maxUsers?: number | null };

export type PriceLookupKeyMapFragment = { __typename?: 'PriceLookupKeyMap', monthly: string, yearly: string };

export type WeldPlanFragment = { __typename?: 'WeldPlan', billingPeriod?: RecurrenceInterval | null, isLegacyPlan?: boolean | null, isConsumptionPlan?: boolean | null, isEnterprisePlan?: boolean | null, name: PlanName, configurableLimits?: { __typename?: 'ConfigurableLimits', maxConnectors?: number | null, maxUsers?: number | null } | null, features: { __typename?: 'FeatureSet', aiAssistantHistoryEnabled: boolean, auditLogsEnabled: boolean, columnHashingEnabled: boolean, customConnectorEnabled: boolean, externalAuthorizationEnabled: boolean, lineageEnabled: boolean, minSyncIntervalInMinutes: number, modelTestingEnabled: boolean, onDemandSyncsEnabled: boolean, orchestrationEnabled: boolean, limitConnectors: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null }, limitRows: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null }, limitUsers: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null }, limitWorkspaces: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null } }, priceLookupKeys?: { __typename?: 'PriceLookupKeyMap', monthly: string, yearly: string } | null, userPriceLookupKeys?: { __typename?: 'PriceLookupKeyMap', monthly: string, yearly: string } | null };

export type AllWeldPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type AllWeldPlansQuery = { __typename?: 'Query', allWeldPlans: Array<{ __typename?: 'WeldPlan', billingPeriod?: RecurrenceInterval | null, isLegacyPlan?: boolean | null, isConsumptionPlan?: boolean | null, isEnterprisePlan?: boolean | null, name: PlanName, configurableLimits?: { __typename?: 'ConfigurableLimits', maxConnectors?: number | null, maxUsers?: number | null } | null, features: { __typename?: 'FeatureSet', aiAssistantHistoryEnabled: boolean, auditLogsEnabled: boolean, columnHashingEnabled: boolean, customConnectorEnabled: boolean, externalAuthorizationEnabled: boolean, lineageEnabled: boolean, minSyncIntervalInMinutes: number, modelTestingEnabled: boolean, onDemandSyncsEnabled: boolean, orchestrationEnabled: boolean, limitConnectors: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null }, limitRows: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null }, limitUsers: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null }, limitWorkspaces: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null } }, priceLookupKeys?: { __typename?: 'PriceLookupKeyMap', monthly: string, yearly: string } | null, userPriceLookupKeys?: { __typename?: 'PriceLookupKeyMap', monthly: string, yearly: string } | null }> };

export type WeldPlanQueryVariables = Exact<{
  planName: Scalars['String']['input'];
}>;


export type WeldPlanQuery = { __typename?: 'Query', weldPlan: { __typename?: 'WeldPlan', billingPeriod?: RecurrenceInterval | null, isLegacyPlan?: boolean | null, isConsumptionPlan?: boolean | null, isEnterprisePlan?: boolean | null, name: PlanName, configurableLimits?: { __typename?: 'ConfigurableLimits', maxConnectors?: number | null, maxUsers?: number | null } | null, features: { __typename?: 'FeatureSet', aiAssistantHistoryEnabled: boolean, auditLogsEnabled: boolean, columnHashingEnabled: boolean, customConnectorEnabled: boolean, externalAuthorizationEnabled: boolean, lineageEnabled: boolean, minSyncIntervalInMinutes: number, modelTestingEnabled: boolean, onDemandSyncsEnabled: boolean, orchestrationEnabled: boolean, limitConnectors: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null }, limitRows: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null }, limitUsers: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null }, limitWorkspaces: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null } }, priceLookupKeys?: { __typename?: 'PriceLookupKeyMap', monthly: string, yearly: string } | null, userPriceLookupKeys?: { __typename?: 'PriceLookupKeyMap', monthly: string, yearly: string } | null } };

export type CurrentWeldPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentWeldPlanQuery = { __typename?: 'Query', currentPlan: { __typename?: 'WeldPlan', billingPeriod?: RecurrenceInterval | null, isLegacyPlan?: boolean | null, isConsumptionPlan?: boolean | null, isEnterprisePlan?: boolean | null, name: PlanName, configurableLimits?: { __typename?: 'ConfigurableLimits', maxConnectors?: number | null, maxUsers?: number | null } | null, features: { __typename?: 'FeatureSet', aiAssistantHistoryEnabled: boolean, auditLogsEnabled: boolean, columnHashingEnabled: boolean, customConnectorEnabled: boolean, externalAuthorizationEnabled: boolean, lineageEnabled: boolean, minSyncIntervalInMinutes: number, modelTestingEnabled: boolean, onDemandSyncsEnabled: boolean, orchestrationEnabled: boolean, limitConnectors: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null }, limitRows: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null }, limitUsers: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null }, limitWorkspaces: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null } }, priceLookupKeys?: { __typename?: 'PriceLookupKeyMap', monthly: string, yearly: string } | null, userPriceLookupKeys?: { __typename?: 'PriceLookupKeyMap', monthly: string, yearly: string } | null } };

export type CurrentSubscriptionStateQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentSubscriptionStateQuery = { __typename?: 'Query', currentSubscriptionState: { __typename?: 'SubscriptionState', status: SubscriptionStatus, customerId?: string | null, subscriptionId?: string | null } };

export type PlanLimitsStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type PlanLimitsStatusQuery = { __typename?: 'Query', getPlanLimitsStatus: { __typename?: 'PlanLimitsStatus', isConnectionsLimitReached: boolean, isUsersLimitReached: boolean } };

export type ValidateConnectionAdditionQueryVariables = Exact<{
  integrationId: Scalars['String']['input'];
}>;


export type ValidateConnectionAdditionQuery = { __typename?: 'Query', validateConnectionAddition: { __typename?: 'ValidationResult', valid: boolean, errors: Array<{ __typename?: 'ValidationErrorItem', errorCode?: ValidationErrorCode | null, reason?: string | null }> } };

export type ConnectorPlanViolationFragment = { __typename?: 'ConnectorPlanViolation', id: string, name: string, minRequiredPlan: PlanName };

export type ValidateCurrentConnectionUsageAgainstPlanQueryVariables = Exact<{
  planName: PlanName;
}>;


export type ValidateCurrentConnectionUsageAgainstPlanQuery = { __typename?: 'Query', validateCurrentConnectionUsageAgainstPlan: { __typename?: 'ConnectorPlanValidationResult', valid: boolean, connectionCount: number, maxConnections: number, isConnectorLimitExceeded: boolean, violations: Array<{ __typename?: 'ConnectorPlanViolation', id: string, name: string, minRequiredPlan: PlanName }>, dataWarehouseViolation?: { __typename?: 'ConnectorPlanViolation', id: string, name: string, minRequiredPlan: PlanName } | null } };

export type BestFitPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type BestFitPlanQuery = { __typename?: 'Query', bestFitPlan: { __typename?: 'BestFitPlan', integrationIds: Array<string>, plan: { __typename?: 'WeldPlan', billingPeriod?: RecurrenceInterval | null, isLegacyPlan?: boolean | null, isConsumptionPlan?: boolean | null, isEnterprisePlan?: boolean | null, name: PlanName, configurableLimits?: { __typename?: 'ConfigurableLimits', maxConnectors?: number | null, maxUsers?: number | null } | null, features: { __typename?: 'FeatureSet', aiAssistantHistoryEnabled: boolean, auditLogsEnabled: boolean, columnHashingEnabled: boolean, customConnectorEnabled: boolean, externalAuthorizationEnabled: boolean, lineageEnabled: boolean, minSyncIntervalInMinutes: number, modelTestingEnabled: boolean, onDemandSyncsEnabled: boolean, orchestrationEnabled: boolean, limitConnectors: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null }, limitRows: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null }, limitUsers: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null }, limitWorkspaces: { __typename?: 'FeatureLimit', value: number, isSoftLimit?: boolean | null } }, priceLookupKeys?: { __typename?: 'PriceLookupKeyMap', monthly: string, yearly: string } | null, userPriceLookupKeys?: { __typename?: 'PriceLookupKeyMap', monthly: string, yearly: string } | null }, workspaceStats: { __typename?: 'WorkspaceStats', numConnections: number, numUsers: number } } };

export const AccountFragmentDoc = gql`
    fragment Account on Account {
  id
  dataWarehouseConnectionId
  name
  slug
  notificationEmails
  createdAt
  dataWarehouse {
    connectionId
    title
    subTitle
    supportsAsyncQuery
    supportsMaterializedTable
    integrationId
  }
  trialEndsAt
  accountSettings {
    id
    deactivateELTSyncs
    deactivateReverseELTSyncs
    maxBillableRows
  }
  slackNotificationInfo {
    id
    connectionId
    channelId
    channelName
  }
}
    `;
export const ChatThreadFragmentDoc = gql`
    fragment ChatThread on ChatThread {
  id
  title
  createdAt
  updatedAt
  numMessages
  tableReferences
  initialModelContext
}
    `;
export const FreemiumAccountFragmentDoc = gql`
    fragment FreemiumAccount on Account {
  id
  slug
  name
  trialEndsAt
  accountSettings {
    id
    deactivateELTSyncs
    deactivateReverseELTSyncs
  }
}
    `;
export const BackofficeSyncStatsFragmentDoc = gql`
    fragment BackofficeSyncStats on BackofficeSyncStats {
  numRowsSynced
  numBillableRows
}
    `;
export const ConnectionBaseFragmentDoc = gql`
    fragment ConnectionBase on Connection {
  id
  integrationId
  label
  active
  createdAt
  updatedAt
  connectedAt
}
    `;
export const ConnectionWithSyncsFragmentDoc = gql`
    fragment ConnectionWithSyncs on Connection {
  eltSyncs {
    id
    createdAt
    status
    destinationSchemaName
    destinationConnection {
      integrationId
    }
  }
  reverseEltSyncs {
    id
    createdAt
    status
    primaryObject
    destinationConnection {
      integrationId
    }
  }
}
    `;
export const ConnectionBridgeBaseFragmentDoc = gql`
    fragment ConnectionBridgeBase on ConnectionBridgeResponse {
  id
  integrationId
  authorizeUrl
  createdAt
  expiresAt
  label
  connectionId
}
    `;
export const EltSyncHistoryStatsResponseFragmentDoc = gql`
    fragment EltSyncHistoryStatsResponse on EltSyncHistoryStatsResponse {
  stats {
    startedAt
    finishedAt
    duration
    status
    sourceStreamName
    rowsSynced
    rowsSyncedMb
    operationMode
    fullSyncTrigger
  }
  limit
}
    `;
export const CountryFragmentDoc = gql`
    fragment Country on Country {
  code
  name
  currency
  emoji
  dial_code
}
    `;
export const IntegrationConfigurationOptionsFragmentDoc = gql`
    fragment IntegrationConfigurationOptions on IntegrationConfiguration {
  hideSelectAllTables
  supportsStartDate
  usesAsyncStreams
  usesLazySchemas
}
    `;
export const IntegrationConfigurationFragmentDoc = gql`
    fragment IntegrationConfiguration on IntegrationConfiguration {
  ...IntegrationConfigurationOptions
  id
  name
  form
  forms
}
    ${IntegrationConfigurationOptionsFragmentDoc}`;
export const DataConnectorMetadataFragmentDoc = gql`
    fragment DataConnectorMetadata on DataConnectorMetadata {
  minRequiredPlan
  status
  tags
}
    `;
export const AvailableIntegrationFragmentDoc = gql`
    fragment AvailableIntegration on AvailableIntegration {
  abilities
  aliasMetadata {
    id
    name
  }
  baseId
  categories
  config {
    ...IntegrationConfigurationOptions
  }
  id
  isUtilityConnector
  logo {
    default
    dark
  }
  name
  requiresAdmin
  meetsPlanRequirement
  minRequiredPlan
  eltSource {
    ...DataConnectorMetadata
  }
  activateDestination {
    ...DataConnectorMetadata
  }
  dataWarehouse {
    ...DataConnectorMetadata
  }
}
    ${IntegrationConfigurationOptionsFragmentDoc}
${DataConnectorMetadataFragmentDoc}`;
export const PublishedQueryBaseFragmentFragmentDoc = gql`
    fragment PublishedQueryBaseFragment on SqlQuery {
  id
  createdAt
  dependencies {
    dwItemId
    type
    weldTag
  }
  userId
}
    `;
export const PublishedQueryWithSqlFragmentFragmentDoc = gql`
    fragment PublishedQueryWithSQLFragment on SqlQuery {
  ...PublishedQueryBaseFragment
  weldSql
}
    ${PublishedQueryBaseFragmentFragmentDoc}`;
export const ModelBaseFragmentDoc = gql`
    fragment ModelBase on Model {
  id
  name
  createdAt
  emoji
  type
  materializationType
}
    `;
export const ModelViewReferenceFragmentFragmentDoc = gql`
    fragment ModelViewReferenceFragment on ModelViewReference {
  modelId
  queryId
  type
  path
  weldTag
  dwSqlReference
  createdAt
  latestSyncTime
}
    `;
export const MaterializedTableReferenceFragmentFragmentDoc = gql`
    fragment MaterializedTableReferenceFragment on MaterializedTableReference {
  modelId
  queryId
  type
  path
  weldTag
  dwSqlReference
  createdAt
  latestSyncTime
  status
  latestRunErrorMessage
}
    `;
export const ModelPublishedFragmentFragmentDoc = gql`
    fragment ModelPublishedFragment on Model {
  folder {
    id
    name
    parentId
  }
  folderPath {
    id
    name
  }
  publishedQuery {
    ...PublishedQueryBaseFragment
  }
  dwSync {
    ...ModelViewReferenceFragment
  }
  dwTable {
    ...MaterializedTableReferenceFragment
  }
  localMaterializationJob {
    queryId
    status
    lastRun
    nextRun
    cronExpression
    latestErrorMessage
  }
  orchestrationWorkflow {
    id
  }
  dashboardId
  orchestrationScheduler
  materializationSchedule
  templateId
  templateItemId
}
    ${PublishedQueryBaseFragmentFragmentDoc}
${ModelViewReferenceFragmentFragmentDoc}
${MaterializedTableReferenceFragmentFragmentDoc}`;
export const ModelListItemFragmentDoc = gql`
    fragment ModelListItem on Model {
  ...ModelBase
  ...ModelPublishedFragment
}
    ${ModelBaseFragmentDoc}
${ModelPublishedFragmentFragmentDoc}`;
export const ModelSearchResultFragmentDoc = gql`
    fragment ModelSearchResult on Model {
  id
  name
  emoji
  folderPath {
    id
    name
  }
  publishedQueryId
}
    `;
export const ObjectTypeFragmentDoc = gql`
    fragment ObjectType on ObjectType {
  id
  objectName
  associations
  supportedDestinationMapping
}
    `;
export const IncidentUpdateFragmentDoc = gql`
    fragment IncidentUpdate on IncidentUpdate {
  body
  createdAt
  displayAt
  id
  incidentId
  status
  updatedAt
}
    `;
export const IncidentFragmentDoc = gql`
    fragment Incident on Incident {
  createdAt
  id
  impact
  incidentUpdates {
    ...IncidentUpdate
  }
  name
  resolvedAt
  shortlink
  status
  updatedAt
  scheduledFor
  scheduledUntil
}
    ${IncidentUpdateFragmentDoc}`;
export const OperationModeOptionFragmentDoc = gql`
    fragment OperationModeOption on FindAvailableOperationsResponse {
  id
  operationType
  operationMode
  primaryKeyRequired
  integrationId
}
    `;
export const OrchestrationWorkflowRunFragmentDoc = gql`
    fragment OrchestrationWorkflowRun on OrchestrationWorkflowRun {
  id
  dueAt
  startedAt
  finishedAt
  status
}
    `;
export const ModelTestRunFragmentDoc = gql`
    fragment ModelTestRun on ModelTestRun {
  workflowRunId
  modelTestId
  result {
    rows
    status
    numRowsTotal
    error
  }
}
    `;
export const OrchestrationJobFragmentDoc = gql`
    fragment OrchestrationJob on WorkflowJob {
  itemId
  target {
    ... on MaterializedTableReference {
      modelId
    }
    ... on ModelViewReference {
      modelId
    }
    ... on RawViewReference {
      viewId
    }
    ... on SourceStream {
      id
      name
      eltSync {
        id
      }
    }
    ... on Sync {
      id
    }
    ... on Webhook {
      id
    }
  }
  order
  errorMessage
  status
  incomingDependencies
  outgoingDependencies
}
    `;
export const SourcePropertyFragmentDoc = gql`
    fragment SourceProperty on DataSchema {
  name
  type
  nullable
}
    `;
export const DestinationPropertyFragmentDoc = gql`
    fragment DestinationProperty on Property {
  id
  propertyId
  propertyName
  propertyType
  readonly
  isRequired
  isPrimaryKey
  automapMatchAny
}
    `;
export const StripePaymentMethodFragmentDoc = gql`
    fragment StripePaymentMethod on PaymentMethod {
  card {
    last4
    brand
    expirationMonth
    expirationYear
  }
}
    `;
export const StripeCustomerFragmentDoc = gql`
    fragment StripeCustomer on Customer {
  id
  companyName
  email
  currency
  taxId {
    type
    country
    value
  }
  address {
    line1
    line2
    postalCode
    city
    country
    state
  }
  defaultPaymentMethod {
    ...StripePaymentMethod
  }
}
    ${StripePaymentMethodFragmentDoc}`;
export const PriceFragmentDoc = gql`
    fragment Price on Price {
  id
  currency
  price
  recurring {
    interval
    intervalCount
    usageType
  }
  billingScheme
  tiers {
    price
    upTo
    unitAmount
  }
  tiersMode
  currencyOptions {
    currency
    price
  }
  lookupKey
}
    `;
export const StripePlanFeaturesFragmentDoc = gql`
    fragment StripePlanFeatures on StripePlanFeatures {
  limitRows
  limitUsers
  limitConnectors
  minSyncIntervalInMinutes
}
    `;
export const ProductFragmentDoc = gql`
    fragment Product on Product {
  id
  name
  description
  price {
    ...Price
  }
  type
  addOnType
  features {
    ...StripePlanFeatures
  }
  active
}
    ${PriceFragmentDoc}
${StripePlanFeaturesFragmentDoc}`;
export const StripeSubscriptionItemFragmentDoc = gql`
    fragment StripeSubscriptionItem on StripeSubscriptionItem {
  price {
    id
    product {
      id
      name
      description
      image
      type
      addOnType
      features {
        ...StripePlanFeatures
      }
      active
    }
    currency
    price
    recurring {
      interval
      intervalCount
      usageType
    }
    billingScheme
    tiers {
      price
      upTo
      unitAmount
    }
    currencyOptions {
      currency
      price
    }
    lookupKey
  }
  quantity
  tier {
    price
    upTo
    unitAmount
  }
}
    ${StripePlanFeaturesFragmentDoc}`;
export const StripeInvoiceFragmentDoc = gql`
    fragment StripeInvoice on Invoice {
  id
  chargeStatus
  chargeFailureMessage
  currency
  dueDate
  hostedInvoiceUrl
  periodStart
  status
  total
}
    `;
export const UpcomingInvoiceFragmentDoc = gql`
    fragment UpcomingInvoice on UpcomingInvoice {
  total
  subTotal
  taxes {
    amount
    percentage
    displayName
  }
  currency
  createdDate
  periodStart
  periodEnd
  trialEnd
  subscriptionStatus
  breakdown {
    amount
    quantity
    label
    description
  }
  discounts {
    amount
    name
  }
}
    `;
export const FindSyncHistoryResponseFragmentDoc = gql`
    fragment FindSyncHistoryResponse on FindSyncHistoryResponse {
  syncId
  jobId
  status
  startedAt
  finishedAt
  totalRecords
  newRecords
  sizeSyncedMb
  syncedRecords
  failedRecords
  sourceStreamName
  error
  scheduledJobId
  isChunk
  fullSyncTrigger
  operationMode
  details
}
    `;
export const SourceStreamSnapshotFragmentDoc = gql`
    fragment SourceStreamSnapshot on SourceStreamSnapshot {
  bytesSynced
  errorMessage
  estimatedTotalCount
  finishedAt
  fullSyncTrigger
  isChunk
  operationMode
  retryAttempt
  recordsSynced
  startedAt
  status
  syncId
  sourceStreamName
  scheduledJobId
  details
}
    `;
export const SourceStreamSnapshotStatesFragmentDoc = gql`
    fragment SourceStreamSnapshotStates on SourceStreamSnapshotStates {
  name
  scheduledJobId
  activeSync {
    ...SourceStreamSnapshot
  }
  latestSync {
    ...SourceStreamSnapshot
  }
}
    ${SourceStreamSnapshotFragmentDoc}`;
export const RevEtlJobStatusFragmentDoc = gql`
    fragment RevEtlJobStatus on ReverseEtlJobResponse {
  nextRun
  lastRun
  status
  running
  startedAt
  isQuarantined
}
    `;
export const SyncListItemFragmentDoc = gql`
    fragment SyncListItem on Sync {
  id
  status
  active
  sourceIntegrationId
  destinationIntegrationId
  sourceConnectionId
  primaryObject
  createdAt
  syncInterval
  config {
    destinationSettings
  }
  sourceConnection {
    label
    id
  }
  destinationConnection {
    label
    id
  }
  model {
    id
    name
    createdAt
    materializationType
    emoji
    dashboardId
    folder {
      id
      name
    }
  }
  orchestrationWorkflow {
    id
    cronExpression
  }
  job {
    ...RevEtlJobStatus
  }
  errorCount
}
    ${RevEtlJobStatusFragmentDoc}`;
export const ReverseEtlSyncFragmentDoc = gql`
    fragment ReverseETLSync on Sync {
  id
  status
  active
  primaryObject
  syncInterval
  sourceConnectionId
  destinationConnectionId
  sourceConnection {
    label
    id
  }
  destinationConnection {
    label
    id
  }
  operations {
    availableOperationId
    operationMode
    operationType
    objectType
    primaryKeyRequired
    primaryKeyMapping {
      id
      sourcePropertyId
      sourcePropertyName
      sourcePropertyType
      destinationPropertyId
      destinationPropertyName
      destinationPropertyType
      readonly
      primaryKey
    }
  }
  mappings {
    id
    sourcePropertyId
    sourcePropertyName
    sourcePropertyType
    destinationPropertyId
    destinationPropertyName
    destinationPropertyType
    readonly
    primaryKey
  }
  sourceIntegrationId
  destinationIntegrationId
  model {
    id
    name
  }
  config {
    destinationSettings
  }
  schedulerType
  orchestrationWorkflow {
    id
  }
  job {
    ...RevEtlJobStatus
  }
}
    ${RevEtlJobStatusFragmentDoc}`;
export const StatsPeriodFragmentDoc = gql`
    fragment StatsPeriod on StatsPeriod {
  start
  end
}
    `;
export const SyncStatsFragmentDoc = gql`
    fragment SyncStats on SyncStats {
  numRowsSynced
  numBillableRows
}
    `;
export const WorkspaceSyncStatsFragmentDoc = gql`
    fragment WorkspaceSyncStats on WorkspaceSyncStats {
  date
  numRowsSynced
  numBillableRows
  elt {
    ...SyncStats
  }
  reverseElt {
    ...SyncStats
  }
}
    ${SyncStatsFragmentDoc}`;
export const IntegrationSyncStatsFragmentDoc = gql`
    fragment IntegrationSyncStats on IntegrationSyncStats {
  integrationId
  numRowsSynced
  numBillableRows
  elt {
    ...SyncStats
  }
  reverseElt {
    ...SyncStats
  }
}
    ${SyncStatsFragmentDoc}`;
export const SourceStreamSyncStatsFragmentDoc = gql`
    fragment SourceStreamSyncStats on SourceStreamSyncStats {
  integrationId
  sourceStreamName
  numRowsSynced
  numBillableRows
}
    `;
export const ConfigurableLimitsFragmentDoc = gql`
    fragment ConfigurableLimits on ConfigurableLimits {
  maxConnectors
  maxUsers
}
    `;
export const FeatureLimitFragmentDoc = gql`
    fragment FeatureLimit on FeatureLimit {
  value
  isSoftLimit
}
    `;
export const FeatureSetFragmentDoc = gql`
    fragment FeatureSet on FeatureSet {
  aiAssistantHistoryEnabled
  auditLogsEnabled
  columnHashingEnabled
  customConnectorEnabled
  externalAuthorizationEnabled
  limitConnectors {
    ...FeatureLimit
  }
  limitRows {
    ...FeatureLimit
  }
  limitUsers {
    ...FeatureLimit
  }
  limitWorkspaces {
    ...FeatureLimit
  }
  lineageEnabled
  minSyncIntervalInMinutes
  modelTestingEnabled
  onDemandSyncsEnabled
  orchestrationEnabled
}
    ${FeatureLimitFragmentDoc}`;
export const PriceLookupKeyMapFragmentDoc = gql`
    fragment PriceLookupKeyMap on PriceLookupKeyMap {
  monthly
  yearly
}
    `;
export const WeldPlanFragmentDoc = gql`
    fragment WeldPlan on WeldPlan {
  billingPeriod
  configurableLimits {
    ...ConfigurableLimits
  }
  features {
    ...FeatureSet
  }
  isLegacyPlan
  isConsumptionPlan
  isEnterprisePlan
  name
  priceLookupKeys {
    ...PriceLookupKeyMap
  }
  userPriceLookupKeys {
    ...PriceLookupKeyMap
  }
}
    ${ConfigurableLimitsFragmentDoc}
${FeatureSetFragmentDoc}
${PriceLookupKeyMapFragmentDoc}`;
export const ConnectorPlanViolationFragmentDoc = gql`
    fragment ConnectorPlanViolation on ConnectorPlanViolation {
  id
  name
  minRequiredPlan
}
    `;
export const UpdateDataWarehouseConnectionIdHackDocument = gql`
    mutation UpdateDataWarehouseConnectionIdHack($dataWarehouseConnectionId: String!) {
  updateDataWarehouseConnectionIdHack(
    dataWarehouseConnectionId: $dataWarehouseConnectionId
  ) {
    id
  }
}
    `;
export type UpdateDataWarehouseConnectionIdHackMutationFn = Apollo.MutationFunction<UpdateDataWarehouseConnectionIdHackMutation, UpdateDataWarehouseConnectionIdHackMutationVariables>;

/**
 * __useUpdateDataWarehouseConnectionIdHackMutation__
 *
 * To run a mutation, you first call `useUpdateDataWarehouseConnectionIdHackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDataWarehouseConnectionIdHackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDataWarehouseConnectionIdHackMutation, { data, loading, error }] = useUpdateDataWarehouseConnectionIdHackMutation({
 *   variables: {
 *      dataWarehouseConnectionId: // value for 'dataWarehouseConnectionId'
 *   },
 * });
 */
export function useUpdateDataWarehouseConnectionIdHackMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDataWarehouseConnectionIdHackMutation, UpdateDataWarehouseConnectionIdHackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDataWarehouseConnectionIdHackMutation, UpdateDataWarehouseConnectionIdHackMutationVariables>(UpdateDataWarehouseConnectionIdHackDocument, options);
      }
export type UpdateDataWarehouseConnectionIdHackMutationHookResult = ReturnType<typeof useUpdateDataWarehouseConnectionIdHackMutation>;
export type UpdateDataWarehouseConnectionIdHackMutationResult = Apollo.MutationResult<UpdateDataWarehouseConnectionIdHackMutation>;
export type UpdateDataWarehouseConnectionIdHackMutationOptions = Apollo.BaseMutationOptions<UpdateDataWarehouseConnectionIdHackMutation, UpdateDataWarehouseConnectionIdHackMutationVariables>;
export const CurrentUserWithAccountsDocument = gql`
    query CurrentUserWithAccounts {
  current {
    id
    firstName
    lastName
    email
    weldSuperAdmin
    accounts {
      ...Account
    }
  }
}
    ${AccountFragmentDoc}`;

/**
 * __useCurrentUserWithAccountsQuery__
 *
 * To run a query within a React component, call `useCurrentUserWithAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserWithAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserWithAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserWithAccountsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserWithAccountsQuery, CurrentUserWithAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserWithAccountsQuery, CurrentUserWithAccountsQueryVariables>(CurrentUserWithAccountsDocument, options);
      }
export function useCurrentUserWithAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserWithAccountsQuery, CurrentUserWithAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserWithAccountsQuery, CurrentUserWithAccountsQueryVariables>(CurrentUserWithAccountsDocument, options);
        }
export function useCurrentUserWithAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserWithAccountsQuery, CurrentUserWithAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserWithAccountsQuery, CurrentUserWithAccountsQueryVariables>(CurrentUserWithAccountsDocument, options);
        }
export type CurrentUserWithAccountsQueryHookResult = ReturnType<typeof useCurrentUserWithAccountsQuery>;
export type CurrentUserWithAccountsLazyQueryHookResult = ReturnType<typeof useCurrentUserWithAccountsLazyQuery>;
export type CurrentUserWithAccountsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserWithAccountsSuspenseQuery>;
export type CurrentUserWithAccountsQueryResult = Apollo.QueryResult<CurrentUserWithAccountsQuery, CurrentUserWithAccountsQueryVariables>;
export const CurrentUserRoleDocument = gql`
    query CurrentUserRole {
  current {
    id
    role
  }
}
    `;

/**
 * __useCurrentUserRoleQuery__
 *
 * To run a query within a React component, call `useCurrentUserRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserRoleQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserRoleQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserRoleQuery, CurrentUserRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserRoleQuery, CurrentUserRoleQueryVariables>(CurrentUserRoleDocument, options);
      }
export function useCurrentUserRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserRoleQuery, CurrentUserRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserRoleQuery, CurrentUserRoleQueryVariables>(CurrentUserRoleDocument, options);
        }
export function useCurrentUserRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserRoleQuery, CurrentUserRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserRoleQuery, CurrentUserRoleQueryVariables>(CurrentUserRoleDocument, options);
        }
export type CurrentUserRoleQueryHookResult = ReturnType<typeof useCurrentUserRoleQuery>;
export type CurrentUserRoleLazyQueryHookResult = ReturnType<typeof useCurrentUserRoleLazyQuery>;
export type CurrentUserRoleSuspenseQueryHookResult = ReturnType<typeof useCurrentUserRoleSuspenseQuery>;
export type CurrentUserRoleQueryResult = Apollo.QueryResult<CurrentUserRoleQuery, CurrentUserRoleQueryVariables>;
export const GetCurrentUserPermissionsDocument = gql`
    query GetCurrentUserPermissions {
  current {
    id
    permissions
  }
}
    `;

/**
 * __useGetCurrentUserPermissionsQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserPermissionsQuery, GetCurrentUserPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserPermissionsQuery, GetCurrentUserPermissionsQueryVariables>(GetCurrentUserPermissionsDocument, options);
      }
export function useGetCurrentUserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserPermissionsQuery, GetCurrentUserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserPermissionsQuery, GetCurrentUserPermissionsQueryVariables>(GetCurrentUserPermissionsDocument, options);
        }
export function useGetCurrentUserPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserPermissionsQuery, GetCurrentUserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserPermissionsQuery, GetCurrentUserPermissionsQueryVariables>(GetCurrentUserPermissionsDocument, options);
        }
export type GetCurrentUserPermissionsQueryHookResult = ReturnType<typeof useGetCurrentUserPermissionsQuery>;
export type GetCurrentUserPermissionsLazyQueryHookResult = ReturnType<typeof useGetCurrentUserPermissionsLazyQuery>;
export type GetCurrentUserPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserPermissionsSuspenseQuery>;
export type GetCurrentUserPermissionsQueryResult = Apollo.QueryResult<GetCurrentUserPermissionsQuery, GetCurrentUserPermissionsQueryVariables>;
export const UserSignupInfoDocument = gql`
    query UserSignupInfo($userId: String!) {
  user(userId: $userId) {
    id
    userSignupInfo {
      jobTitle
      companyName
    }
  }
}
    `;

/**
 * __useUserSignupInfoQuery__
 *
 * To run a query within a React component, call `useUserSignupInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSignupInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSignupInfoQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserSignupInfoQuery(baseOptions: Apollo.QueryHookOptions<UserSignupInfoQuery, UserSignupInfoQueryVariables> & ({ variables: UserSignupInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSignupInfoQuery, UserSignupInfoQueryVariables>(UserSignupInfoDocument, options);
      }
export function useUserSignupInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSignupInfoQuery, UserSignupInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSignupInfoQuery, UserSignupInfoQueryVariables>(UserSignupInfoDocument, options);
        }
export function useUserSignupInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserSignupInfoQuery, UserSignupInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserSignupInfoQuery, UserSignupInfoQueryVariables>(UserSignupInfoDocument, options);
        }
export type UserSignupInfoQueryHookResult = ReturnType<typeof useUserSignupInfoQuery>;
export type UserSignupInfoLazyQueryHookResult = ReturnType<typeof useUserSignupInfoLazyQuery>;
export type UserSignupInfoSuspenseQueryHookResult = ReturnType<typeof useUserSignupInfoSuspenseQuery>;
export type UserSignupInfoQueryResult = Apollo.QueryResult<UserSignupInfoQuery, UserSignupInfoQueryVariables>;
export const FirebaseTokenDocument = gql`
    query FirebaseToken {
  firebaseToken
}
    `;

/**
 * __useFirebaseTokenQuery__
 *
 * To run a query within a React component, call `useFirebaseTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirebaseTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirebaseTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useFirebaseTokenQuery(baseOptions?: Apollo.QueryHookOptions<FirebaseTokenQuery, FirebaseTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FirebaseTokenQuery, FirebaseTokenQueryVariables>(FirebaseTokenDocument, options);
      }
export function useFirebaseTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FirebaseTokenQuery, FirebaseTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FirebaseTokenQuery, FirebaseTokenQueryVariables>(FirebaseTokenDocument, options);
        }
export function useFirebaseTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FirebaseTokenQuery, FirebaseTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FirebaseTokenQuery, FirebaseTokenQueryVariables>(FirebaseTokenDocument, options);
        }
export type FirebaseTokenQueryHookResult = ReturnType<typeof useFirebaseTokenQuery>;
export type FirebaseTokenLazyQueryHookResult = ReturnType<typeof useFirebaseTokenLazyQuery>;
export type FirebaseTokenSuspenseQueryHookResult = ReturnType<typeof useFirebaseTokenSuspenseQuery>;
export type FirebaseTokenQueryResult = Apollo.QueryResult<FirebaseTokenQuery, FirebaseTokenQueryVariables>;
export const UserDocument = gql`
    query User($userId: String!) {
  user(userId: $userId) {
    id
    email
    firstName
    lastName
    updatedAt
    createdAt
    role
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables> & ({ variables: UserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UsersDocument = gql`
    query Users {
  users {
    id
    email
    firstName
    lastName
    updatedAt
    createdAt
    role
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export function useUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const RemoveUserDocument = gql`
    mutation RemoveUser($userId: String!) {
  deleteUser(id: $userId) {
    id
  }
}
    `;
export type RemoveUserMutationFn = Apollo.MutationFunction<RemoveUserMutation, RemoveUserMutationVariables>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMutation, RemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserMutation, RemoveUserMutationVariables>(RemoveUserDocument, options);
      }
export type RemoveUserMutationHookResult = ReturnType<typeof useRemoveUserMutation>;
export type RemoveUserMutationResult = Apollo.MutationResult<RemoveUserMutation>;
export type RemoveUserMutationOptions = Apollo.BaseMutationOptions<RemoveUserMutation, RemoveUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserAccountRoleDocument = gql`
    mutation UpdateUserAccountRole($userId: String!, $role: Role!) {
  updateUserAccountRole(userId: $userId, role: $role) {
    id
    role
    firstName
    lastName
  }
}
    `;
export type UpdateUserAccountRoleMutationFn = Apollo.MutationFunction<UpdateUserAccountRoleMutation, UpdateUserAccountRoleMutationVariables>;

/**
 * __useUpdateUserAccountRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserAccountRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAccountRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAccountRoleMutation, { data, loading, error }] = useUpdateUserAccountRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateUserAccountRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAccountRoleMutation, UpdateUserAccountRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAccountRoleMutation, UpdateUserAccountRoleMutationVariables>(UpdateUserAccountRoleDocument, options);
      }
export type UpdateUserAccountRoleMutationHookResult = ReturnType<typeof useUpdateUserAccountRoleMutation>;
export type UpdateUserAccountRoleMutationResult = Apollo.MutationResult<UpdateUserAccountRoleMutation>;
export type UpdateUserAccountRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserAccountRoleMutation, UpdateUserAccountRoleMutationVariables>;
export const UpsertUserSignupInfoDocument = gql`
    mutation UpsertUserSignupInfo($input: UpsertUserSignupInfoInput!) {
  upsertUserSignupInfo(input: $input) {
    id
    companyName
  }
}
    `;
export type UpsertUserSignupInfoMutationFn = Apollo.MutationFunction<UpsertUserSignupInfoMutation, UpsertUserSignupInfoMutationVariables>;

/**
 * __useUpsertUserSignupInfoMutation__
 *
 * To run a mutation, you first call `useUpsertUserSignupInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserSignupInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserSignupInfoMutation, { data, loading, error }] = useUpsertUserSignupInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertUserSignupInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserSignupInfoMutation, UpsertUserSignupInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserSignupInfoMutation, UpsertUserSignupInfoMutationVariables>(UpsertUserSignupInfoDocument, options);
      }
export type UpsertUserSignupInfoMutationHookResult = ReturnType<typeof useUpsertUserSignupInfoMutation>;
export type UpsertUserSignupInfoMutationResult = Apollo.MutationResult<UpsertUserSignupInfoMutation>;
export type UpsertUserSignupInfoMutationOptions = Apollo.BaseMutationOptions<UpsertUserSignupInfoMutation, UpsertUserSignupInfoMutationVariables>;
export const GetSlugAvailabilityDocument = gql`
    query GetSlugAvailability($slug: String!) {
  slugAvailability(slug: $slug) {
    isAvailable
  }
}
    `;

/**
 * __useGetSlugAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetSlugAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlugAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlugAvailabilityQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetSlugAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<GetSlugAvailabilityQuery, GetSlugAvailabilityQueryVariables> & ({ variables: GetSlugAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSlugAvailabilityQuery, GetSlugAvailabilityQueryVariables>(GetSlugAvailabilityDocument, options);
      }
export function useGetSlugAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSlugAvailabilityQuery, GetSlugAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSlugAvailabilityQuery, GetSlugAvailabilityQueryVariables>(GetSlugAvailabilityDocument, options);
        }
export function useGetSlugAvailabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSlugAvailabilityQuery, GetSlugAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSlugAvailabilityQuery, GetSlugAvailabilityQueryVariables>(GetSlugAvailabilityDocument, options);
        }
export type GetSlugAvailabilityQueryHookResult = ReturnType<typeof useGetSlugAvailabilityQuery>;
export type GetSlugAvailabilityLazyQueryHookResult = ReturnType<typeof useGetSlugAvailabilityLazyQuery>;
export type GetSlugAvailabilitySuspenseQueryHookResult = ReturnType<typeof useGetSlugAvailabilitySuspenseQuery>;
export type GetSlugAvailabilityQueryResult = Apollo.QueryResult<GetSlugAvailabilityQuery, GetSlugAvailabilityQueryVariables>;
export const GetAccountIdDocument = gql`
    query GetAccountId($slug: String!) {
  accountBySlug(slug: $slug) {
    id
  }
}
    `;

/**
 * __useGetAccountIdQuery__
 *
 * To run a query within a React component, call `useGetAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountIdQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetAccountIdQuery(baseOptions: Apollo.QueryHookOptions<GetAccountIdQuery, GetAccountIdQueryVariables> & ({ variables: GetAccountIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountIdQuery, GetAccountIdQueryVariables>(GetAccountIdDocument, options);
      }
export function useGetAccountIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountIdQuery, GetAccountIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountIdQuery, GetAccountIdQueryVariables>(GetAccountIdDocument, options);
        }
export function useGetAccountIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountIdQuery, GetAccountIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountIdQuery, GetAccountIdQueryVariables>(GetAccountIdDocument, options);
        }
export type GetAccountIdQueryHookResult = ReturnType<typeof useGetAccountIdQuery>;
export type GetAccountIdLazyQueryHookResult = ReturnType<typeof useGetAccountIdLazyQuery>;
export type GetAccountIdSuspenseQueryHookResult = ReturnType<typeof useGetAccountIdSuspenseQuery>;
export type GetAccountIdQueryResult = Apollo.QueryResult<GetAccountIdQuery, GetAccountIdQueryVariables>;
export const GetAccountSlugDocument = gql`
    query GetAccountSlug($id: String!) {
  accountById(id: $id) {
    slug
  }
}
    `;

/**
 * __useGetAccountSlugQuery__
 *
 * To run a query within a React component, call `useGetAccountSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountSlugQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountSlugQuery(baseOptions: Apollo.QueryHookOptions<GetAccountSlugQuery, GetAccountSlugQueryVariables> & ({ variables: GetAccountSlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountSlugQuery, GetAccountSlugQueryVariables>(GetAccountSlugDocument, options);
      }
export function useGetAccountSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountSlugQuery, GetAccountSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountSlugQuery, GetAccountSlugQueryVariables>(GetAccountSlugDocument, options);
        }
export function useGetAccountSlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountSlugQuery, GetAccountSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountSlugQuery, GetAccountSlugQueryVariables>(GetAccountSlugDocument, options);
        }
export type GetAccountSlugQueryHookResult = ReturnType<typeof useGetAccountSlugQuery>;
export type GetAccountSlugLazyQueryHookResult = ReturnType<typeof useGetAccountSlugLazyQuery>;
export type GetAccountSlugSuspenseQueryHookResult = ReturnType<typeof useGetAccountSlugSuspenseQuery>;
export type GetAccountSlugQueryResult = Apollo.QueryResult<GetAccountSlugQuery, GetAccountSlugQueryVariables>;
export const InvitationsDocument = gql`
    query Invitations($getUsed: Boolean) {
  invitations(getUsed: $getUsed) {
    id
    email
    firstName
    lastName
    used
    expiresAt
    updatedAt
    createdAt
    role
  }
}
    `;

/**
 * __useInvitationsQuery__
 *
 * To run a query within a React component, call `useInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsQuery({
 *   variables: {
 *      getUsed: // value for 'getUsed'
 *   },
 * });
 */
export function useInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<InvitationsQuery, InvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitationsQuery, InvitationsQueryVariables>(InvitationsDocument, options);
      }
export function useInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitationsQuery, InvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitationsQuery, InvitationsQueryVariables>(InvitationsDocument, options);
        }
export function useInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvitationsQuery, InvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitationsQuery, InvitationsQueryVariables>(InvitationsDocument, options);
        }
export type InvitationsQueryHookResult = ReturnType<typeof useInvitationsQuery>;
export type InvitationsLazyQueryHookResult = ReturnType<typeof useInvitationsLazyQuery>;
export type InvitationsSuspenseQueryHookResult = ReturnType<typeof useInvitationsSuspenseQuery>;
export type InvitationsQueryResult = Apollo.QueryResult<InvitationsQuery, InvitationsQueryVariables>;
export const OpenInvitationsDocument = gql`
    query OpenInvitations {
  openInvitations {
    id
    email
    firstName
    lastName
    used
    expiresAt
    updatedAt
    createdAt
    role
    account {
      id
      name
    }
  }
}
    `;

/**
 * __useOpenInvitationsQuery__
 *
 * To run a query within a React component, call `useOpenInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenInvitationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOpenInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<OpenInvitationsQuery, OpenInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenInvitationsQuery, OpenInvitationsQueryVariables>(OpenInvitationsDocument, options);
      }
export function useOpenInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenInvitationsQuery, OpenInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenInvitationsQuery, OpenInvitationsQueryVariables>(OpenInvitationsDocument, options);
        }
export function useOpenInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OpenInvitationsQuery, OpenInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpenInvitationsQuery, OpenInvitationsQueryVariables>(OpenInvitationsDocument, options);
        }
export type OpenInvitationsQueryHookResult = ReturnType<typeof useOpenInvitationsQuery>;
export type OpenInvitationsLazyQueryHookResult = ReturnType<typeof useOpenInvitationsLazyQuery>;
export type OpenInvitationsSuspenseQueryHookResult = ReturnType<typeof useOpenInvitationsSuspenseQuery>;
export type OpenInvitationsQueryResult = Apollo.QueryResult<OpenInvitationsQuery, OpenInvitationsQueryVariables>;
export const SendInvitationDocument = gql`
    mutation SendInvitation($email: String!, $firstName: String, $lastName: String, $role: Role!) {
  sendInvitation(
    input: {email: $email, firstName: $firstName, lastName: $lastName, role: $role}
  ) {
    id
  }
}
    `;
export type SendInvitationMutationFn = Apollo.MutationFunction<SendInvitationMutation, SendInvitationMutationVariables>;

/**
 * __useSendInvitationMutation__
 *
 * To run a mutation, you first call `useSendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitationMutation, { data, loading, error }] = useSendInvitationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useSendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<SendInvitationMutation, SendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInvitationMutation, SendInvitationMutationVariables>(SendInvitationDocument, options);
      }
export type SendInvitationMutationHookResult = ReturnType<typeof useSendInvitationMutation>;
export type SendInvitationMutationResult = Apollo.MutationResult<SendInvitationMutation>;
export type SendInvitationMutationOptions = Apollo.BaseMutationOptions<SendInvitationMutation, SendInvitationMutationVariables>;
export const ResendOwnInvitationDocument = gql`
    mutation ResendOwnInvitation($accountId: String!) {
  resendOwnInvitation(accountId: $accountId) {
    id
  }
}
    `;
export type ResendOwnInvitationMutationFn = Apollo.MutationFunction<ResendOwnInvitationMutation, ResendOwnInvitationMutationVariables>;

/**
 * __useResendOwnInvitationMutation__
 *
 * To run a mutation, you first call `useResendOwnInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendOwnInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendOwnInvitationMutation, { data, loading, error }] = useResendOwnInvitationMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useResendOwnInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendOwnInvitationMutation, ResendOwnInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendOwnInvitationMutation, ResendOwnInvitationMutationVariables>(ResendOwnInvitationDocument, options);
      }
export type ResendOwnInvitationMutationHookResult = ReturnType<typeof useResendOwnInvitationMutation>;
export type ResendOwnInvitationMutationResult = Apollo.MutationResult<ResendOwnInvitationMutation>;
export type ResendOwnInvitationMutationOptions = Apollo.BaseMutationOptions<ResendOwnInvitationMutation, ResendOwnInvitationMutationVariables>;
export const AcceptInvitationDocument = gql`
    mutation AcceptInvitation($invitationId: String!) {
  useInvitation(invitationId: $invitationId) {
    accountId
  }
}
    `;
export type AcceptInvitationMutationFn = Apollo.MutationFunction<AcceptInvitationMutation, AcceptInvitationMutationVariables>;

/**
 * __useAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInvitationMutation, { data, loading, error }] = useAcceptInvitationMutation({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useAcceptInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInvitationMutation, AcceptInvitationMutationVariables>(AcceptInvitationDocument, options);
      }
export type AcceptInvitationMutationHookResult = ReturnType<typeof useAcceptInvitationMutation>;
export type AcceptInvitationMutationResult = Apollo.MutationResult<AcceptInvitationMutation>;
export type AcceptInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>;
export const DeclineOwnInvitationDocument = gql`
    mutation DeclineOwnInvitation($accountId: String!) {
  declineOwnInvitation(accountId: $accountId) {
    id
  }
}
    `;
export type DeclineOwnInvitationMutationFn = Apollo.MutationFunction<DeclineOwnInvitationMutation, DeclineOwnInvitationMutationVariables>;

/**
 * __useDeclineOwnInvitationMutation__
 *
 * To run a mutation, you first call `useDeclineOwnInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineOwnInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineOwnInvitationMutation, { data, loading, error }] = useDeclineOwnInvitationMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeclineOwnInvitationMutation(baseOptions?: Apollo.MutationHookOptions<DeclineOwnInvitationMutation, DeclineOwnInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineOwnInvitationMutation, DeclineOwnInvitationMutationVariables>(DeclineOwnInvitationDocument, options);
      }
export type DeclineOwnInvitationMutationHookResult = ReturnType<typeof useDeclineOwnInvitationMutation>;
export type DeclineOwnInvitationMutationResult = Apollo.MutationResult<DeclineOwnInvitationMutation>;
export type DeclineOwnInvitationMutationOptions = Apollo.BaseMutationOptions<DeclineOwnInvitationMutation, DeclineOwnInvitationMutationVariables>;
export const RemoveInvitationDocument = gql`
    mutation RemoveInvitation($invitationId: String!) {
  deleteInvitation(id: $invitationId) {
    id
  }
}
    `;
export type RemoveInvitationMutationFn = Apollo.MutationFunction<RemoveInvitationMutation, RemoveInvitationMutationVariables>;

/**
 * __useRemoveInvitationMutation__
 *
 * To run a mutation, you first call `useRemoveInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInvitationMutation, { data, loading, error }] = useRemoveInvitationMutation({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useRemoveInvitationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInvitationMutation, RemoveInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInvitationMutation, RemoveInvitationMutationVariables>(RemoveInvitationDocument, options);
      }
export type RemoveInvitationMutationHookResult = ReturnType<typeof useRemoveInvitationMutation>;
export type RemoveInvitationMutationResult = Apollo.MutationResult<RemoveInvitationMutation>;
export type RemoveInvitationMutationOptions = Apollo.BaseMutationOptions<RemoveInvitationMutation, RemoveInvitationMutationVariables>;
export const CreateAccountDocument = gql`
    mutation CreateAccount($name: String!, $isTest: Boolean) {
  createAccount(input: {name: $name, isTest: $isTest}) {
    id
    slug
    name
  }
}
    `;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      name: // value for 'name'
 *      isTest: // value for 'isTest'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, options);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const SetDatawarehouseDocument = gql`
    mutation SetDatawarehouse($createConnectionInput: CreateConnectionInput!) {
  setDatawarehouse(createConnectionInput: $createConnectionInput)
}
    `;
export type SetDatawarehouseMutationFn = Apollo.MutationFunction<SetDatawarehouseMutation, SetDatawarehouseMutationVariables>;

/**
 * __useSetDatawarehouseMutation__
 *
 * To run a mutation, you first call `useSetDatawarehouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDatawarehouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDatawarehouseMutation, { data, loading, error }] = useSetDatawarehouseMutation({
 *   variables: {
 *      createConnectionInput: // value for 'createConnectionInput'
 *   },
 * });
 */
export function useSetDatawarehouseMutation(baseOptions?: Apollo.MutationHookOptions<SetDatawarehouseMutation, SetDatawarehouseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDatawarehouseMutation, SetDatawarehouseMutationVariables>(SetDatawarehouseDocument, options);
      }
export type SetDatawarehouseMutationHookResult = ReturnType<typeof useSetDatawarehouseMutation>;
export type SetDatawarehouseMutationResult = Apollo.MutationResult<SetDatawarehouseMutation>;
export type SetDatawarehouseMutationOptions = Apollo.BaseMutationOptions<SetDatawarehouseMutation, SetDatawarehouseMutationVariables>;
export const GetDatawarehouseSetupStatusDocument = gql`
    query GetDatawarehouseSetupStatus {
  getDatawarehouseSetupStatus {
    status
    error
  }
}
    `;

/**
 * __useGetDatawarehouseSetupStatusQuery__
 *
 * To run a query within a React component, call `useGetDatawarehouseSetupStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatawarehouseSetupStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatawarehouseSetupStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDatawarehouseSetupStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetDatawarehouseSetupStatusQuery, GetDatawarehouseSetupStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatawarehouseSetupStatusQuery, GetDatawarehouseSetupStatusQueryVariables>(GetDatawarehouseSetupStatusDocument, options);
      }
export function useGetDatawarehouseSetupStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatawarehouseSetupStatusQuery, GetDatawarehouseSetupStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatawarehouseSetupStatusQuery, GetDatawarehouseSetupStatusQueryVariables>(GetDatawarehouseSetupStatusDocument, options);
        }
export function useGetDatawarehouseSetupStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatawarehouseSetupStatusQuery, GetDatawarehouseSetupStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatawarehouseSetupStatusQuery, GetDatawarehouseSetupStatusQueryVariables>(GetDatawarehouseSetupStatusDocument, options);
        }
export type GetDatawarehouseSetupStatusQueryHookResult = ReturnType<typeof useGetDatawarehouseSetupStatusQuery>;
export type GetDatawarehouseSetupStatusLazyQueryHookResult = ReturnType<typeof useGetDatawarehouseSetupStatusLazyQuery>;
export type GetDatawarehouseSetupStatusSuspenseQueryHookResult = ReturnType<typeof useGetDatawarehouseSetupStatusSuspenseQuery>;
export type GetDatawarehouseSetupStatusQueryResult = Apollo.QueryResult<GetDatawarehouseSetupStatusQuery, GetDatawarehouseSetupStatusQueryVariables>;
export const DeleteAccountDocument = gql`
    mutation DeleteAccount($input: DeleteAccountInput!) {
  deleteAccount(input: $input) {
    id
  }
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const CreateWorkspaceWithManagedDatawarehouseDocument = gql`
    mutation CreateWorkspaceWithManagedDatawarehouse($workspaceName: String!, $dataWarehouseLocation: String!, $isTest: Boolean) {
  createWorkspaceWithManagedDatawarehouse(
    input: {workspaceName: $workspaceName, dataWarehouseLocation: $dataWarehouseLocation, isTest: $isTest}
  ) {
    id
    slug
    name
  }
}
    `;
export type CreateWorkspaceWithManagedDatawarehouseMutationFn = Apollo.MutationFunction<CreateWorkspaceWithManagedDatawarehouseMutation, CreateWorkspaceWithManagedDatawarehouseMutationVariables>;

/**
 * __useCreateWorkspaceWithManagedDatawarehouseMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceWithManagedDatawarehouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceWithManagedDatawarehouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceWithManagedDatawarehouseMutation, { data, loading, error }] = useCreateWorkspaceWithManagedDatawarehouseMutation({
 *   variables: {
 *      workspaceName: // value for 'workspaceName'
 *      dataWarehouseLocation: // value for 'dataWarehouseLocation'
 *      isTest: // value for 'isTest'
 *   },
 * });
 */
export function useCreateWorkspaceWithManagedDatawarehouseMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkspaceWithManagedDatawarehouseMutation, CreateWorkspaceWithManagedDatawarehouseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkspaceWithManagedDatawarehouseMutation, CreateWorkspaceWithManagedDatawarehouseMutationVariables>(CreateWorkspaceWithManagedDatawarehouseDocument, options);
      }
export type CreateWorkspaceWithManagedDatawarehouseMutationHookResult = ReturnType<typeof useCreateWorkspaceWithManagedDatawarehouseMutation>;
export type CreateWorkspaceWithManagedDatawarehouseMutationResult = Apollo.MutationResult<CreateWorkspaceWithManagedDatawarehouseMutation>;
export type CreateWorkspaceWithManagedDatawarehouseMutationOptions = Apollo.BaseMutationOptions<CreateWorkspaceWithManagedDatawarehouseMutation, CreateWorkspaceWithManagedDatawarehouseMutationVariables>;
export const StartSelfOnboardingProcessDocument = gql`
    mutation StartSelfOnboardingProcess($location: String!) {
  startSelfOnboardingProcess(location: $location)
}
    `;
export type StartSelfOnboardingProcessMutationFn = Apollo.MutationFunction<StartSelfOnboardingProcessMutation, StartSelfOnboardingProcessMutationVariables>;

/**
 * __useStartSelfOnboardingProcessMutation__
 *
 * To run a mutation, you first call `useStartSelfOnboardingProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSelfOnboardingProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSelfOnboardingProcessMutation, { data, loading, error }] = useStartSelfOnboardingProcessMutation({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useStartSelfOnboardingProcessMutation(baseOptions?: Apollo.MutationHookOptions<StartSelfOnboardingProcessMutation, StartSelfOnboardingProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartSelfOnboardingProcessMutation, StartSelfOnboardingProcessMutationVariables>(StartSelfOnboardingProcessDocument, options);
      }
export type StartSelfOnboardingProcessMutationHookResult = ReturnType<typeof useStartSelfOnboardingProcessMutation>;
export type StartSelfOnboardingProcessMutationResult = Apollo.MutationResult<StartSelfOnboardingProcessMutation>;
export type StartSelfOnboardingProcessMutationOptions = Apollo.BaseMutationOptions<StartSelfOnboardingProcessMutation, StartSelfOnboardingProcessMutationVariables>;
export const GetSelfOnboardingProcessStatusDocument = gql`
    query GetSelfOnboardingProcessStatus {
  getSelfOnboardingProcessStatus {
    status
    error
  }
}
    `;

/**
 * __useGetSelfOnboardingProcessStatusQuery__
 *
 * To run a query within a React component, call `useGetSelfOnboardingProcessStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelfOnboardingProcessStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelfOnboardingProcessStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSelfOnboardingProcessStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetSelfOnboardingProcessStatusQuery, GetSelfOnboardingProcessStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelfOnboardingProcessStatusQuery, GetSelfOnboardingProcessStatusQueryVariables>(GetSelfOnboardingProcessStatusDocument, options);
      }
export function useGetSelfOnboardingProcessStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelfOnboardingProcessStatusQuery, GetSelfOnboardingProcessStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelfOnboardingProcessStatusQuery, GetSelfOnboardingProcessStatusQueryVariables>(GetSelfOnboardingProcessStatusDocument, options);
        }
export function useGetSelfOnboardingProcessStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSelfOnboardingProcessStatusQuery, GetSelfOnboardingProcessStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSelfOnboardingProcessStatusQuery, GetSelfOnboardingProcessStatusQueryVariables>(GetSelfOnboardingProcessStatusDocument, options);
        }
export type GetSelfOnboardingProcessStatusQueryHookResult = ReturnType<typeof useGetSelfOnboardingProcessStatusQuery>;
export type GetSelfOnboardingProcessStatusLazyQueryHookResult = ReturnType<typeof useGetSelfOnboardingProcessStatusLazyQuery>;
export type GetSelfOnboardingProcessStatusSuspenseQueryHookResult = ReturnType<typeof useGetSelfOnboardingProcessStatusSuspenseQuery>;
export type GetSelfOnboardingProcessStatusQueryResult = Apollo.QueryResult<GetSelfOnboardingProcessStatusQuery, GetSelfOnboardingProcessStatusQueryVariables>;
export const AddNotificationEmailDocument = gql`
    mutation AddNotificationEmail($notificationEmail: String!) {
  addNotificationEmail(input: {notificationEmail: $notificationEmail}) {
    id
  }
}
    `;
export type AddNotificationEmailMutationFn = Apollo.MutationFunction<AddNotificationEmailMutation, AddNotificationEmailMutationVariables>;

/**
 * __useAddNotificationEmailMutation__
 *
 * To run a mutation, you first call `useAddNotificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNotificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNotificationEmailMutation, { data, loading, error }] = useAddNotificationEmailMutation({
 *   variables: {
 *      notificationEmail: // value for 'notificationEmail'
 *   },
 * });
 */
export function useAddNotificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<AddNotificationEmailMutation, AddNotificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNotificationEmailMutation, AddNotificationEmailMutationVariables>(AddNotificationEmailDocument, options);
      }
export type AddNotificationEmailMutationHookResult = ReturnType<typeof useAddNotificationEmailMutation>;
export type AddNotificationEmailMutationResult = Apollo.MutationResult<AddNotificationEmailMutation>;
export type AddNotificationEmailMutationOptions = Apollo.BaseMutationOptions<AddNotificationEmailMutation, AddNotificationEmailMutationVariables>;
export const RemoveNotificationEmailDocument = gql`
    mutation RemoveNotificationEmail($notificationEmail: String!) {
  removeNotificationEmail(input: {notificationEmail: $notificationEmail}) {
    id
  }
}
    `;
export type RemoveNotificationEmailMutationFn = Apollo.MutationFunction<RemoveNotificationEmailMutation, RemoveNotificationEmailMutationVariables>;

/**
 * __useRemoveNotificationEmailMutation__
 *
 * To run a mutation, you first call `useRemoveNotificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNotificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNotificationEmailMutation, { data, loading, error }] = useRemoveNotificationEmailMutation({
 *   variables: {
 *      notificationEmail: // value for 'notificationEmail'
 *   },
 * });
 */
export function useRemoveNotificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<RemoveNotificationEmailMutation, RemoveNotificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveNotificationEmailMutation, RemoveNotificationEmailMutationVariables>(RemoveNotificationEmailDocument, options);
      }
export type RemoveNotificationEmailMutationHookResult = ReturnType<typeof useRemoveNotificationEmailMutation>;
export type RemoveNotificationEmailMutationResult = Apollo.MutationResult<RemoveNotificationEmailMutation>;
export type RemoveNotificationEmailMutationOptions = Apollo.BaseMutationOptions<RemoveNotificationEmailMutation, RemoveNotificationEmailMutationVariables>;
export const SessionStartedDocument = gql`
    mutation SessionStarted {
  sessionStarted
}
    `;
export type SessionStartedMutationFn = Apollo.MutationFunction<SessionStartedMutation, SessionStartedMutationVariables>;

/**
 * __useSessionStartedMutation__
 *
 * To run a mutation, you first call `useSessionStartedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionStartedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionStartedMutation, { data, loading, error }] = useSessionStartedMutation({
 *   variables: {
 *   },
 * });
 */
export function useSessionStartedMutation(baseOptions?: Apollo.MutationHookOptions<SessionStartedMutation, SessionStartedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionStartedMutation, SessionStartedMutationVariables>(SessionStartedDocument, options);
      }
export type SessionStartedMutationHookResult = ReturnType<typeof useSessionStartedMutation>;
export type SessionStartedMutationResult = Apollo.MutationResult<SessionStartedMutation>;
export type SessionStartedMutationOptions = Apollo.BaseMutationOptions<SessionStartedMutation, SessionStartedMutationVariables>;
export const SeedDataWarehouseDocument = gql`
    mutation SeedDataWarehouse {
  seedDataWarehouse {
    models {
      id
      name
    }
  }
}
    `;
export type SeedDataWarehouseMutationFn = Apollo.MutationFunction<SeedDataWarehouseMutation, SeedDataWarehouseMutationVariables>;

/**
 * __useSeedDataWarehouseMutation__
 *
 * To run a mutation, you first call `useSeedDataWarehouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeedDataWarehouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seedDataWarehouseMutation, { data, loading, error }] = useSeedDataWarehouseMutation({
 *   variables: {
 *   },
 * });
 */
export function useSeedDataWarehouseMutation(baseOptions?: Apollo.MutationHookOptions<SeedDataWarehouseMutation, SeedDataWarehouseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SeedDataWarehouseMutation, SeedDataWarehouseMutationVariables>(SeedDataWarehouseDocument, options);
      }
export type SeedDataWarehouseMutationHookResult = ReturnType<typeof useSeedDataWarehouseMutation>;
export type SeedDataWarehouseMutationResult = Apollo.MutationResult<SeedDataWarehouseMutation>;
export type SeedDataWarehouseMutationOptions = Apollo.BaseMutationOptions<SeedDataWarehouseMutation, SeedDataWarehouseMutationVariables>;
export const GetSlackChannelsDocument = gql`
    query GetSlackChannels($connectionId: String!) {
  getSlackChannels(connectionId: $connectionId) {
    id
    name
  }
}
    `;

/**
 * __useGetSlackChannelsQuery__
 *
 * To run a query within a React component, call `useGetSlackChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlackChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlackChannelsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useGetSlackChannelsQuery(baseOptions: Apollo.QueryHookOptions<GetSlackChannelsQuery, GetSlackChannelsQueryVariables> & ({ variables: GetSlackChannelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSlackChannelsQuery, GetSlackChannelsQueryVariables>(GetSlackChannelsDocument, options);
      }
export function useGetSlackChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSlackChannelsQuery, GetSlackChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSlackChannelsQuery, GetSlackChannelsQueryVariables>(GetSlackChannelsDocument, options);
        }
export function useGetSlackChannelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSlackChannelsQuery, GetSlackChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSlackChannelsQuery, GetSlackChannelsQueryVariables>(GetSlackChannelsDocument, options);
        }
export type GetSlackChannelsQueryHookResult = ReturnType<typeof useGetSlackChannelsQuery>;
export type GetSlackChannelsLazyQueryHookResult = ReturnType<typeof useGetSlackChannelsLazyQuery>;
export type GetSlackChannelsSuspenseQueryHookResult = ReturnType<typeof useGetSlackChannelsSuspenseQuery>;
export type GetSlackChannelsQueryResult = Apollo.QueryResult<GetSlackChannelsQuery, GetSlackChannelsQueryVariables>;
export const SetupSlackNotificationsDocument = gql`
    mutation SetupSlackNotifications($connectionId: String!, $channelId: String!, $channelName: String!) {
  setupSlackNotifications(
    input: {connectionId: $connectionId, channelId: $channelId, channelName: $channelName}
  ) {
    id
    slackNotificationInfo {
      id
      connectionId
      channelId
      channelName
    }
  }
}
    `;
export type SetupSlackNotificationsMutationFn = Apollo.MutationFunction<SetupSlackNotificationsMutation, SetupSlackNotificationsMutationVariables>;

/**
 * __useSetupSlackNotificationsMutation__
 *
 * To run a mutation, you first call `useSetupSlackNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupSlackNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupSlackNotificationsMutation, { data, loading, error }] = useSetupSlackNotificationsMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      channelId: // value for 'channelId'
 *      channelName: // value for 'channelName'
 *   },
 * });
 */
export function useSetupSlackNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<SetupSlackNotificationsMutation, SetupSlackNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupSlackNotificationsMutation, SetupSlackNotificationsMutationVariables>(SetupSlackNotificationsDocument, options);
      }
export type SetupSlackNotificationsMutationHookResult = ReturnType<typeof useSetupSlackNotificationsMutation>;
export type SetupSlackNotificationsMutationResult = Apollo.MutationResult<SetupSlackNotificationsMutation>;
export type SetupSlackNotificationsMutationOptions = Apollo.BaseMutationOptions<SetupSlackNotificationsMutation, SetupSlackNotificationsMutationVariables>;
export const DisconnectSlackNotificationsDocument = gql`
    mutation DisconnectSlackNotifications {
  disconnectSlackNotifications {
    id
  }
}
    `;
export type DisconnectSlackNotificationsMutationFn = Apollo.MutationFunction<DisconnectSlackNotificationsMutation, DisconnectSlackNotificationsMutationVariables>;

/**
 * __useDisconnectSlackNotificationsMutation__
 *
 * To run a mutation, you first call `useDisconnectSlackNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectSlackNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectSlackNotificationsMutation, { data, loading, error }] = useDisconnectSlackNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisconnectSlackNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectSlackNotificationsMutation, DisconnectSlackNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectSlackNotificationsMutation, DisconnectSlackNotificationsMutationVariables>(DisconnectSlackNotificationsDocument, options);
      }
export type DisconnectSlackNotificationsMutationHookResult = ReturnType<typeof useDisconnectSlackNotificationsMutation>;
export type DisconnectSlackNotificationsMutationResult = Apollo.MutationResult<DisconnectSlackNotificationsMutation>;
export type DisconnectSlackNotificationsMutationOptions = Apollo.BaseMutationOptions<DisconnectSlackNotificationsMutation, DisconnectSlackNotificationsMutationVariables>;
export const SetMaxBillableRowsDocument = gql`
    mutation SetMaxBillableRows($maxRows: Int) {
  setMaxBillableRows(maxRows: $maxRows) {
    id
    accountSettings {
      id
      maxBillableRows
    }
  }
}
    `;
export type SetMaxBillableRowsMutationFn = Apollo.MutationFunction<SetMaxBillableRowsMutation, SetMaxBillableRowsMutationVariables>;

/**
 * __useSetMaxBillableRowsMutation__
 *
 * To run a mutation, you first call `useSetMaxBillableRowsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMaxBillableRowsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMaxBillableRowsMutation, { data, loading, error }] = useSetMaxBillableRowsMutation({
 *   variables: {
 *      maxRows: // value for 'maxRows'
 *   },
 * });
 */
export function useSetMaxBillableRowsMutation(baseOptions?: Apollo.MutationHookOptions<SetMaxBillableRowsMutation, SetMaxBillableRowsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMaxBillableRowsMutation, SetMaxBillableRowsMutationVariables>(SetMaxBillableRowsDocument, options);
      }
export type SetMaxBillableRowsMutationHookResult = ReturnType<typeof useSetMaxBillableRowsMutation>;
export type SetMaxBillableRowsMutationResult = Apollo.MutationResult<SetMaxBillableRowsMutation>;
export type SetMaxBillableRowsMutationOptions = Apollo.BaseMutationOptions<SetMaxBillableRowsMutation, SetMaxBillableRowsMutationVariables>;
export const GetMfaDocument = gql`
    query GetMfa {
  getMFA {
    hasMFA
    mfaMethods {
      id
      type
    }
  }
}
    `;

/**
 * __useGetMfaQuery__
 *
 * To run a query within a React component, call `useGetMfaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMfaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMfaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMfaQuery(baseOptions?: Apollo.QueryHookOptions<GetMfaQuery, GetMfaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMfaQuery, GetMfaQueryVariables>(GetMfaDocument, options);
      }
export function useGetMfaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMfaQuery, GetMfaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMfaQuery, GetMfaQueryVariables>(GetMfaDocument, options);
        }
export function useGetMfaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMfaQuery, GetMfaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMfaQuery, GetMfaQueryVariables>(GetMfaDocument, options);
        }
export type GetMfaQueryHookResult = ReturnType<typeof useGetMfaQuery>;
export type GetMfaLazyQueryHookResult = ReturnType<typeof useGetMfaLazyQuery>;
export type GetMfaSuspenseQueryHookResult = ReturnType<typeof useGetMfaSuspenseQuery>;
export type GetMfaQueryResult = Apollo.QueryResult<GetMfaQuery, GetMfaQueryVariables>;
export const SetMfaDocument = gql`
    mutation setMFA($mfa: Boolean!) {
  setMFA(use_mfa: $mfa)
}
    `;
export type SetMfaMutationFn = Apollo.MutationFunction<SetMfaMutation, SetMfaMutationVariables>;

/**
 * __useSetMfaMutation__
 *
 * To run a mutation, you first call `useSetMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMfaMutation, { data, loading, error }] = useSetMfaMutation({
 *   variables: {
 *      mfa: // value for 'mfa'
 *   },
 * });
 */
export function useSetMfaMutation(baseOptions?: Apollo.MutationHookOptions<SetMfaMutation, SetMfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMfaMutation, SetMfaMutationVariables>(SetMfaDocument, options);
      }
export type SetMfaMutationHookResult = ReturnType<typeof useSetMfaMutation>;
export type SetMfaMutationResult = Apollo.MutationResult<SetMfaMutation>;
export type SetMfaMutationOptions = Apollo.BaseMutationOptions<SetMfaMutation, SetMfaMutationVariables>;
export const ApiKeysDocument = gql`
    query ApiKeys {
  apiKeys {
    id
    name
    createdAt
  }
}
    `;

/**
 * __useApiKeysQuery__
 *
 * To run a query within a React component, call `useApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
      }
export function useApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
        }
export function useApiKeysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
        }
export type ApiKeysQueryHookResult = ReturnType<typeof useApiKeysQuery>;
export type ApiKeysLazyQueryHookResult = ReturnType<typeof useApiKeysLazyQuery>;
export type ApiKeysSuspenseQueryHookResult = ReturnType<typeof useApiKeysSuspenseQuery>;
export type ApiKeysQueryResult = Apollo.QueryResult<ApiKeysQuery, ApiKeysQueryVariables>;
export const ApiSecretKeyDocument = gql`
    query ApiSecretKey($apiKeyId: String!) {
  apiSecretKey(apiKeyId: $apiKeyId)
}
    `;

/**
 * __useApiSecretKeyQuery__
 *
 * To run a query within a React component, call `useApiSecretKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiSecretKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiSecretKeyQuery({
 *   variables: {
 *      apiKeyId: // value for 'apiKeyId'
 *   },
 * });
 */
export function useApiSecretKeyQuery(baseOptions: Apollo.QueryHookOptions<ApiSecretKeyQuery, ApiSecretKeyQueryVariables> & ({ variables: ApiSecretKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiSecretKeyQuery, ApiSecretKeyQueryVariables>(ApiSecretKeyDocument, options);
      }
export function useApiSecretKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiSecretKeyQuery, ApiSecretKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiSecretKeyQuery, ApiSecretKeyQueryVariables>(ApiSecretKeyDocument, options);
        }
export function useApiSecretKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApiSecretKeyQuery, ApiSecretKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiSecretKeyQuery, ApiSecretKeyQueryVariables>(ApiSecretKeyDocument, options);
        }
export type ApiSecretKeyQueryHookResult = ReturnType<typeof useApiSecretKeyQuery>;
export type ApiSecretKeyLazyQueryHookResult = ReturnType<typeof useApiSecretKeyLazyQuery>;
export type ApiSecretKeySuspenseQueryHookResult = ReturnType<typeof useApiSecretKeySuspenseQuery>;
export type ApiSecretKeyQueryResult = Apollo.QueryResult<ApiSecretKeyQuery, ApiSecretKeyQueryVariables>;
export const CreateApiKeyDocument = gql`
    mutation CreateApiKey($input: CreateApiKeyInput!) {
  createApiKey(input: $input) {
    id
    name
    createdAt
  }
}
    `;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<CreateApiKeyMutation, CreateApiKeyMutationVariables>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export type CreateApiKeyMutationResult = Apollo.MutationResult<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const DeleteApiKeyDocument = gql`
    mutation DeleteApiKey($apiKeyId: String!) {
  deleteApiKey(apiKeyId: $apiKeyId)
}
    `;
export type DeleteApiKeyMutationFn = Apollo.MutationFunction<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;

/**
 * __useDeleteApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiKeyMutation, { data, loading, error }] = useDeleteApiKeyMutation({
 *   variables: {
 *      apiKeyId: // value for 'apiKeyId'
 *   },
 * });
 */
export function useDeleteApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>(DeleteApiKeyDocument, options);
      }
export type DeleteApiKeyMutationHookResult = ReturnType<typeof useDeleteApiKeyMutation>;
export type DeleteApiKeyMutationResult = Apollo.MutationResult<DeleteApiKeyMutation>;
export type DeleteApiKeyMutationOptions = Apollo.BaseMutationOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;
export const ChatThreadDocument = gql`
    query ChatThread($id: String!) {
  chatThread(id: $id) {
    ...ChatThread
  }
}
    ${ChatThreadFragmentDoc}`;

/**
 * __useChatThreadQuery__
 *
 * To run a query within a React component, call `useChatThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatThreadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChatThreadQuery(baseOptions: Apollo.QueryHookOptions<ChatThreadQuery, ChatThreadQueryVariables> & ({ variables: ChatThreadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatThreadQuery, ChatThreadQueryVariables>(ChatThreadDocument, options);
      }
export function useChatThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatThreadQuery, ChatThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatThreadQuery, ChatThreadQueryVariables>(ChatThreadDocument, options);
        }
export function useChatThreadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatThreadQuery, ChatThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatThreadQuery, ChatThreadQueryVariables>(ChatThreadDocument, options);
        }
export type ChatThreadQueryHookResult = ReturnType<typeof useChatThreadQuery>;
export type ChatThreadLazyQueryHookResult = ReturnType<typeof useChatThreadLazyQuery>;
export type ChatThreadSuspenseQueryHookResult = ReturnType<typeof useChatThreadSuspenseQuery>;
export type ChatThreadQueryResult = Apollo.QueryResult<ChatThreadQuery, ChatThreadQueryVariables>;
export const ChatThreadsDocument = gql`
    query ChatThreads($offset: Int, $limit: Int) {
  chatThreads(offset: $offset, limit: $limit) {
    ...ChatThread
  }
}
    ${ChatThreadFragmentDoc}`;

/**
 * __useChatThreadsQuery__
 *
 * To run a query within a React component, call `useChatThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatThreadsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useChatThreadsQuery(baseOptions?: Apollo.QueryHookOptions<ChatThreadsQuery, ChatThreadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatThreadsQuery, ChatThreadsQueryVariables>(ChatThreadsDocument, options);
      }
export function useChatThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatThreadsQuery, ChatThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatThreadsQuery, ChatThreadsQueryVariables>(ChatThreadsDocument, options);
        }
export function useChatThreadsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatThreadsQuery, ChatThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatThreadsQuery, ChatThreadsQueryVariables>(ChatThreadsDocument, options);
        }
export type ChatThreadsQueryHookResult = ReturnType<typeof useChatThreadsQuery>;
export type ChatThreadsLazyQueryHookResult = ReturnType<typeof useChatThreadsLazyQuery>;
export type ChatThreadsSuspenseQueryHookResult = ReturnType<typeof useChatThreadsSuspenseQuery>;
export type ChatThreadsQueryResult = Apollo.QueryResult<ChatThreadsQuery, ChatThreadsQueryVariables>;
export const ChatMessagesDocument = gql`
    query ChatMessages($threadId: String!) {
  chatMessages(threadId: $threadId) {
    id
    threadId
    content
    role
    createdAt
  }
}
    `;

/**
 * __useChatMessagesQuery__
 *
 * To run a query within a React component, call `useChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatMessagesQuery({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useChatMessagesQuery(baseOptions: Apollo.QueryHookOptions<ChatMessagesQuery, ChatMessagesQueryVariables> & ({ variables: ChatMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatMessagesQuery, ChatMessagesQueryVariables>(ChatMessagesDocument, options);
      }
export function useChatMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatMessagesQuery, ChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatMessagesQuery, ChatMessagesQueryVariables>(ChatMessagesDocument, options);
        }
export function useChatMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatMessagesQuery, ChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatMessagesQuery, ChatMessagesQueryVariables>(ChatMessagesDocument, options);
        }
export type ChatMessagesQueryHookResult = ReturnType<typeof useChatMessagesQuery>;
export type ChatMessagesLazyQueryHookResult = ReturnType<typeof useChatMessagesLazyQuery>;
export type ChatMessagesSuspenseQueryHookResult = ReturnType<typeof useChatMessagesSuspenseQuery>;
export type ChatMessagesQueryResult = Apollo.QueryResult<ChatMessagesQuery, ChatMessagesQueryVariables>;
export const NotificationsDocument = gql`
    query Notifications {
  notifications {
    id
    accountId
    accountName
    type
    source
    detail
    createdAt
    updatedAt
    deletedAt
    entityType
    entityId
    entityName
    message
    notificationLevel
    lastOccurence
    isDismissable
    isLock
    expiration
    messageData
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export function useNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsSuspenseQueryHookResult = ReturnType<typeof useNotificationsSuspenseQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const RemoveNotificationDocument = gql`
    mutation RemoveNotification($input: RemoveNotificationInput!) {
  removeNotification(input: $input) {
    id
  }
}
    `;
export type RemoveNotificationMutationFn = Apollo.MutationFunction<RemoveNotificationMutation, RemoveNotificationMutationVariables>;

/**
 * __useRemoveNotificationMutation__
 *
 * To run a mutation, you first call `useRemoveNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNotificationMutation, { data, loading, error }] = useRemoveNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveNotificationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveNotificationMutation, RemoveNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveNotificationMutation, RemoveNotificationMutationVariables>(RemoveNotificationDocument, options);
      }
export type RemoveNotificationMutationHookResult = ReturnType<typeof useRemoveNotificationMutation>;
export type RemoveNotificationMutationResult = Apollo.MutationResult<RemoveNotificationMutation>;
export type RemoveNotificationMutationOptions = Apollo.BaseMutationOptions<RemoveNotificationMutation, RemoveNotificationMutationVariables>;
export const DismissAllNotificationsDocument = gql`
    mutation DismissAllNotifications {
  dismissAllNotifications
}
    `;
export type DismissAllNotificationsMutationFn = Apollo.MutationFunction<DismissAllNotificationsMutation, DismissAllNotificationsMutationVariables>;

/**
 * __useDismissAllNotificationsMutation__
 *
 * To run a mutation, you first call `useDismissAllNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissAllNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissAllNotificationsMutation, { data, loading, error }] = useDismissAllNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDismissAllNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<DismissAllNotificationsMutation, DismissAllNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissAllNotificationsMutation, DismissAllNotificationsMutationVariables>(DismissAllNotificationsDocument, options);
      }
export type DismissAllNotificationsMutationHookResult = ReturnType<typeof useDismissAllNotificationsMutation>;
export type DismissAllNotificationsMutationResult = Apollo.MutationResult<DismissAllNotificationsMutation>;
export type DismissAllNotificationsMutationOptions = Apollo.BaseMutationOptions<DismissAllNotificationsMutation, DismissAllNotificationsMutationVariables>;
export const FindAllAvailableAuditLogsDocument = gql`
    query FindAllAvailableAuditLogs {
  findAllAvailableAuditLogs {
    logs {
      date
      count
      type
    }
  }
}
    `;

/**
 * __useFindAllAvailableAuditLogsQuery__
 *
 * To run a query within a React component, call `useFindAllAvailableAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllAvailableAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllAvailableAuditLogsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllAvailableAuditLogsQuery(baseOptions?: Apollo.QueryHookOptions<FindAllAvailableAuditLogsQuery, FindAllAvailableAuditLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllAvailableAuditLogsQuery, FindAllAvailableAuditLogsQueryVariables>(FindAllAvailableAuditLogsDocument, options);
      }
export function useFindAllAvailableAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllAvailableAuditLogsQuery, FindAllAvailableAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllAvailableAuditLogsQuery, FindAllAvailableAuditLogsQueryVariables>(FindAllAvailableAuditLogsDocument, options);
        }
export function useFindAllAvailableAuditLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllAvailableAuditLogsQuery, FindAllAvailableAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllAvailableAuditLogsQuery, FindAllAvailableAuditLogsQueryVariables>(FindAllAvailableAuditLogsDocument, options);
        }
export type FindAllAvailableAuditLogsQueryHookResult = ReturnType<typeof useFindAllAvailableAuditLogsQuery>;
export type FindAllAvailableAuditLogsLazyQueryHookResult = ReturnType<typeof useFindAllAvailableAuditLogsLazyQuery>;
export type FindAllAvailableAuditLogsSuspenseQueryHookResult = ReturnType<typeof useFindAllAvailableAuditLogsSuspenseQuery>;
export type FindAllAvailableAuditLogsQueryResult = Apollo.QueryResult<FindAllAvailableAuditLogsQuery, FindAllAvailableAuditLogsQueryVariables>;
export const ListFailedSyncsBackofficeDocument = gql`
    query ListFailedSyncsBackoffice($minFailures: Float!) {
  listFailedSyncsBackoffice(minFailures: $minFailures) {
    scheduledJobId
    accountId
    accountName
    syncId
    sourceIntegrationId
    destinationIntegrationId
    sourceStreamName
    nextRun
    lastRun
    lastFullSync
    lastStartedAt
    status
    isQuarantined
    forceFullSync
    running
    devNotes
    devStatus
    devName
    devTimestamp
    errorsSinceLastSuccessfulRun
    config
    sourceSecretId
    targetCloudProvider
    locks {
      id
      target
      reasons
    }
  }
}
    `;

/**
 * __useListFailedSyncsBackofficeQuery__
 *
 * To run a query within a React component, call `useListFailedSyncsBackofficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFailedSyncsBackofficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFailedSyncsBackofficeQuery({
 *   variables: {
 *      minFailures: // value for 'minFailures'
 *   },
 * });
 */
export function useListFailedSyncsBackofficeQuery(baseOptions: Apollo.QueryHookOptions<ListFailedSyncsBackofficeQuery, ListFailedSyncsBackofficeQueryVariables> & ({ variables: ListFailedSyncsBackofficeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFailedSyncsBackofficeQuery, ListFailedSyncsBackofficeQueryVariables>(ListFailedSyncsBackofficeDocument, options);
      }
export function useListFailedSyncsBackofficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFailedSyncsBackofficeQuery, ListFailedSyncsBackofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFailedSyncsBackofficeQuery, ListFailedSyncsBackofficeQueryVariables>(ListFailedSyncsBackofficeDocument, options);
        }
export function useListFailedSyncsBackofficeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListFailedSyncsBackofficeQuery, ListFailedSyncsBackofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListFailedSyncsBackofficeQuery, ListFailedSyncsBackofficeQueryVariables>(ListFailedSyncsBackofficeDocument, options);
        }
export type ListFailedSyncsBackofficeQueryHookResult = ReturnType<typeof useListFailedSyncsBackofficeQuery>;
export type ListFailedSyncsBackofficeLazyQueryHookResult = ReturnType<typeof useListFailedSyncsBackofficeLazyQuery>;
export type ListFailedSyncsBackofficeSuspenseQueryHookResult = ReturnType<typeof useListFailedSyncsBackofficeSuspenseQuery>;
export type ListFailedSyncsBackofficeQueryResult = Apollo.QueryResult<ListFailedSyncsBackofficeQuery, ListFailedSyncsBackofficeQueryVariables>;
export const GetEltSyncDetailsBackofficeDocument = gql`
    query GetEltSyncDetailsBackoffice($eltSyncId: String!) {
  getEltSyncDetailsBackoffice(eltSyncId: $eltSyncId) {
    id
    active
    status
    syncInterval
    sourceIntegrationId
    destinationIntegrationId
    sourceConnectionId
    destinationConnectionId
    sourceStreams {
      id
      name
      incrementalPrimaryKeyName
      incrementalPointerId
      operationMode
      fullSyncAlways
      fullSyncAtMidnight
      protectedFromFullSync
      dataFilters {
        sourceStreamObjectKey
        transformation
      }
      job {
        nextRun
        lastRun
        lastFullSync
        lastStartedAt
        status
        isQuarantined
        forceFullSync
        running
      }
      substreams {
        name
        excludedColumns
        hashedColumns
      }
    }
    startDate
    sourceConnection {
      label
      id
    }
    destinationConnection {
      label
      id
    }
    config {
      sourceSettings
    }
    destinationSchemaName
    schedulerType
    orchestrationWorkflow {
      id
      cronExpression
    }
  }
}
    `;

/**
 * __useGetEltSyncDetailsBackofficeQuery__
 *
 * To run a query within a React component, call `useGetEltSyncDetailsBackofficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEltSyncDetailsBackofficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEltSyncDetailsBackofficeQuery({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *   },
 * });
 */
export function useGetEltSyncDetailsBackofficeQuery(baseOptions: Apollo.QueryHookOptions<GetEltSyncDetailsBackofficeQuery, GetEltSyncDetailsBackofficeQueryVariables> & ({ variables: GetEltSyncDetailsBackofficeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEltSyncDetailsBackofficeQuery, GetEltSyncDetailsBackofficeQueryVariables>(GetEltSyncDetailsBackofficeDocument, options);
      }
export function useGetEltSyncDetailsBackofficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEltSyncDetailsBackofficeQuery, GetEltSyncDetailsBackofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEltSyncDetailsBackofficeQuery, GetEltSyncDetailsBackofficeQueryVariables>(GetEltSyncDetailsBackofficeDocument, options);
        }
export function useGetEltSyncDetailsBackofficeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEltSyncDetailsBackofficeQuery, GetEltSyncDetailsBackofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEltSyncDetailsBackofficeQuery, GetEltSyncDetailsBackofficeQueryVariables>(GetEltSyncDetailsBackofficeDocument, options);
        }
export type GetEltSyncDetailsBackofficeQueryHookResult = ReturnType<typeof useGetEltSyncDetailsBackofficeQuery>;
export type GetEltSyncDetailsBackofficeLazyQueryHookResult = ReturnType<typeof useGetEltSyncDetailsBackofficeLazyQuery>;
export type GetEltSyncDetailsBackofficeSuspenseQueryHookResult = ReturnType<typeof useGetEltSyncDetailsBackofficeSuspenseQuery>;
export type GetEltSyncDetailsBackofficeQueryResult = Apollo.QueryResult<GetEltSyncDetailsBackofficeQuery, GetEltSyncDetailsBackofficeQueryVariables>;
export const EltSyncSnapshotStateBackofficeDocument = gql`
    query EltSyncSnapshotStateBackoffice($accountId: String!, $syncId: String!) {
  eltSyncSnapshotStateBackoffice(accountId: $accountId, syncId: $syncId) {
    syncId
    sourceStreams {
      ...SourceStreamSnapshotStates
    }
  }
}
    ${SourceStreamSnapshotStatesFragmentDoc}`;

/**
 * __useEltSyncSnapshotStateBackofficeQuery__
 *
 * To run a query within a React component, call `useEltSyncSnapshotStateBackofficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltSyncSnapshotStateBackofficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltSyncSnapshotStateBackofficeQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useEltSyncSnapshotStateBackofficeQuery(baseOptions: Apollo.QueryHookOptions<EltSyncSnapshotStateBackofficeQuery, EltSyncSnapshotStateBackofficeQueryVariables> & ({ variables: EltSyncSnapshotStateBackofficeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltSyncSnapshotStateBackofficeQuery, EltSyncSnapshotStateBackofficeQueryVariables>(EltSyncSnapshotStateBackofficeDocument, options);
      }
export function useEltSyncSnapshotStateBackofficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltSyncSnapshotStateBackofficeQuery, EltSyncSnapshotStateBackofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltSyncSnapshotStateBackofficeQuery, EltSyncSnapshotStateBackofficeQueryVariables>(EltSyncSnapshotStateBackofficeDocument, options);
        }
export function useEltSyncSnapshotStateBackofficeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltSyncSnapshotStateBackofficeQuery, EltSyncSnapshotStateBackofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltSyncSnapshotStateBackofficeQuery, EltSyncSnapshotStateBackofficeQueryVariables>(EltSyncSnapshotStateBackofficeDocument, options);
        }
export type EltSyncSnapshotStateBackofficeQueryHookResult = ReturnType<typeof useEltSyncSnapshotStateBackofficeQuery>;
export type EltSyncSnapshotStateBackofficeLazyQueryHookResult = ReturnType<typeof useEltSyncSnapshotStateBackofficeLazyQuery>;
export type EltSyncSnapshotStateBackofficeSuspenseQueryHookResult = ReturnType<typeof useEltSyncSnapshotStateBackofficeSuspenseQuery>;
export type EltSyncSnapshotStateBackofficeQueryResult = Apollo.QueryResult<EltSyncSnapshotStateBackofficeQuery, EltSyncSnapshotStateBackofficeQueryVariables>;
export const FindManyEltSyncHistoryBackofficeDocument = gql`
    query FindManyEltSyncHistoryBackoffice($accountId: String!, $syncId: String!, $sourceStreamName: String!) {
  findManyEltSyncHistoryBackoffice(
    accountId: $accountId
    syncId: $syncId
    sourceStreamName: $sourceStreamName
  ) {
    syncId
    jobId
    status
    startedAt
    finishedAt
    totalRecords
    newRecords
    sizeSyncedMb
    syncedRecords
    sourceStreamName
    error
    scheduledJobId
    isChunk
  }
}
    `;

/**
 * __useFindManyEltSyncHistoryBackofficeQuery__
 *
 * To run a query within a React component, call `useFindManyEltSyncHistoryBackofficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyEltSyncHistoryBackofficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyEltSyncHistoryBackofficeQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      syncId: // value for 'syncId'
 *      sourceStreamName: // value for 'sourceStreamName'
 *   },
 * });
 */
export function useFindManyEltSyncHistoryBackofficeQuery(baseOptions: Apollo.QueryHookOptions<FindManyEltSyncHistoryBackofficeQuery, FindManyEltSyncHistoryBackofficeQueryVariables> & ({ variables: FindManyEltSyncHistoryBackofficeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyEltSyncHistoryBackofficeQuery, FindManyEltSyncHistoryBackofficeQueryVariables>(FindManyEltSyncHistoryBackofficeDocument, options);
      }
export function useFindManyEltSyncHistoryBackofficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyEltSyncHistoryBackofficeQuery, FindManyEltSyncHistoryBackofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyEltSyncHistoryBackofficeQuery, FindManyEltSyncHistoryBackofficeQueryVariables>(FindManyEltSyncHistoryBackofficeDocument, options);
        }
export function useFindManyEltSyncHistoryBackofficeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindManyEltSyncHistoryBackofficeQuery, FindManyEltSyncHistoryBackofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindManyEltSyncHistoryBackofficeQuery, FindManyEltSyncHistoryBackofficeQueryVariables>(FindManyEltSyncHistoryBackofficeDocument, options);
        }
export type FindManyEltSyncHistoryBackofficeQueryHookResult = ReturnType<typeof useFindManyEltSyncHistoryBackofficeQuery>;
export type FindManyEltSyncHistoryBackofficeLazyQueryHookResult = ReturnType<typeof useFindManyEltSyncHistoryBackofficeLazyQuery>;
export type FindManyEltSyncHistoryBackofficeSuspenseQueryHookResult = ReturnType<typeof useFindManyEltSyncHistoryBackofficeSuspenseQuery>;
export type FindManyEltSyncHistoryBackofficeQueryResult = Apollo.QueryResult<FindManyEltSyncHistoryBackofficeQuery, FindManyEltSyncHistoryBackofficeQueryVariables>;
export const GetAccountBackofficeDocument = gql`
    query GetAccountBackoffice($accountId: String!) {
  getAccountBackoffice(accountId: $accountId) {
    id
    name
    trialEndsAt
    stripeCustomer {
      id
      companyName
      email
    }
    stripeSubscription {
      stripeSubscriptionDetails {
        id
        status
        trialEndDate
        planName
      }
    }
  }
}
    `;

/**
 * __useGetAccountBackofficeQuery__
 *
 * To run a query within a React component, call `useGetAccountBackofficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountBackofficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountBackofficeQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAccountBackofficeQuery(baseOptions: Apollo.QueryHookOptions<GetAccountBackofficeQuery, GetAccountBackofficeQueryVariables> & ({ variables: GetAccountBackofficeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountBackofficeQuery, GetAccountBackofficeQueryVariables>(GetAccountBackofficeDocument, options);
      }
export function useGetAccountBackofficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountBackofficeQuery, GetAccountBackofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountBackofficeQuery, GetAccountBackofficeQueryVariables>(GetAccountBackofficeDocument, options);
        }
export function useGetAccountBackofficeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountBackofficeQuery, GetAccountBackofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountBackofficeQuery, GetAccountBackofficeQueryVariables>(GetAccountBackofficeDocument, options);
        }
export type GetAccountBackofficeQueryHookResult = ReturnType<typeof useGetAccountBackofficeQuery>;
export type GetAccountBackofficeLazyQueryHookResult = ReturnType<typeof useGetAccountBackofficeLazyQuery>;
export type GetAccountBackofficeSuspenseQueryHookResult = ReturnType<typeof useGetAccountBackofficeSuspenseQuery>;
export type GetAccountBackofficeQueryResult = Apollo.QueryResult<GetAccountBackofficeQuery, GetAccountBackofficeQueryVariables>;
export const StopEltSyncBackofficeDocument = gql`
    mutation StopEltSyncBackoffice($accountId: String!, $eltSyncId: String!) {
  stopEltSyncBackoffice(accountId: $accountId, eltSyncId: $eltSyncId)
}
    `;
export type StopEltSyncBackofficeMutationFn = Apollo.MutationFunction<StopEltSyncBackofficeMutation, StopEltSyncBackofficeMutationVariables>;

/**
 * __useStopEltSyncBackofficeMutation__
 *
 * To run a mutation, you first call `useStopEltSyncBackofficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopEltSyncBackofficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopEltSyncBackofficeMutation, { data, loading, error }] = useStopEltSyncBackofficeMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      eltSyncId: // value for 'eltSyncId'
 *   },
 * });
 */
export function useStopEltSyncBackofficeMutation(baseOptions?: Apollo.MutationHookOptions<StopEltSyncBackofficeMutation, StopEltSyncBackofficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopEltSyncBackofficeMutation, StopEltSyncBackofficeMutationVariables>(StopEltSyncBackofficeDocument, options);
      }
export type StopEltSyncBackofficeMutationHookResult = ReturnType<typeof useStopEltSyncBackofficeMutation>;
export type StopEltSyncBackofficeMutationResult = Apollo.MutationResult<StopEltSyncBackofficeMutation>;
export type StopEltSyncBackofficeMutationOptions = Apollo.BaseMutationOptions<StopEltSyncBackofficeMutation, StopEltSyncBackofficeMutationVariables>;
export const StartEltSyncBackofficeDocument = gql`
    mutation StartEltSyncBackoffice($accountId: String!, $eltSyncId: String!) {
  startEltSyncBackoffice(accountId: $accountId, eltSyncId: $eltSyncId)
}
    `;
export type StartEltSyncBackofficeMutationFn = Apollo.MutationFunction<StartEltSyncBackofficeMutation, StartEltSyncBackofficeMutationVariables>;

/**
 * __useStartEltSyncBackofficeMutation__
 *
 * To run a mutation, you first call `useStartEltSyncBackofficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartEltSyncBackofficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startEltSyncBackofficeMutation, { data, loading, error }] = useStartEltSyncBackofficeMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      eltSyncId: // value for 'eltSyncId'
 *   },
 * });
 */
export function useStartEltSyncBackofficeMutation(baseOptions?: Apollo.MutationHookOptions<StartEltSyncBackofficeMutation, StartEltSyncBackofficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartEltSyncBackofficeMutation, StartEltSyncBackofficeMutationVariables>(StartEltSyncBackofficeDocument, options);
      }
export type StartEltSyncBackofficeMutationHookResult = ReturnType<typeof useStartEltSyncBackofficeMutation>;
export type StartEltSyncBackofficeMutationResult = Apollo.MutationResult<StartEltSyncBackofficeMutation>;
export type StartEltSyncBackofficeMutationOptions = Apollo.BaseMutationOptions<StartEltSyncBackofficeMutation, StartEltSyncBackofficeMutationVariables>;
export const AllNotificationsBackofficeDocument = gql`
    query AllNotificationsBackoffice {
  allNotificationsBackoffice {
    id
    accountId
    accountName
    type
    source
    detail
    createdAt
    updatedAt
    deletedAt
    entityType
    entityId
    entityName
    message
    notificationLevel
    lastOccurence
    isDismissable
    isLock
    expiration
  }
}
    `;

/**
 * __useAllNotificationsBackofficeQuery__
 *
 * To run a query within a React component, call `useAllNotificationsBackofficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllNotificationsBackofficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllNotificationsBackofficeQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllNotificationsBackofficeQuery(baseOptions?: Apollo.QueryHookOptions<AllNotificationsBackofficeQuery, AllNotificationsBackofficeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllNotificationsBackofficeQuery, AllNotificationsBackofficeQueryVariables>(AllNotificationsBackofficeDocument, options);
      }
export function useAllNotificationsBackofficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllNotificationsBackofficeQuery, AllNotificationsBackofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllNotificationsBackofficeQuery, AllNotificationsBackofficeQueryVariables>(AllNotificationsBackofficeDocument, options);
        }
export function useAllNotificationsBackofficeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllNotificationsBackofficeQuery, AllNotificationsBackofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllNotificationsBackofficeQuery, AllNotificationsBackofficeQueryVariables>(AllNotificationsBackofficeDocument, options);
        }
export type AllNotificationsBackofficeQueryHookResult = ReturnType<typeof useAllNotificationsBackofficeQuery>;
export type AllNotificationsBackofficeLazyQueryHookResult = ReturnType<typeof useAllNotificationsBackofficeLazyQuery>;
export type AllNotificationsBackofficeSuspenseQueryHookResult = ReturnType<typeof useAllNotificationsBackofficeSuspenseQuery>;
export type AllNotificationsBackofficeQueryResult = Apollo.QueryResult<AllNotificationsBackofficeQuery, AllNotificationsBackofficeQueryVariables>;
export const RemoveNotificationBackofficeDocument = gql`
    mutation RemoveNotificationBackoffice($id: String!) {
  removeNotificationBackoffice(id: $id)
}
    `;
export type RemoveNotificationBackofficeMutationFn = Apollo.MutationFunction<RemoveNotificationBackofficeMutation, RemoveNotificationBackofficeMutationVariables>;

/**
 * __useRemoveNotificationBackofficeMutation__
 *
 * To run a mutation, you first call `useRemoveNotificationBackofficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNotificationBackofficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNotificationBackofficeMutation, { data, loading, error }] = useRemoveNotificationBackofficeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveNotificationBackofficeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveNotificationBackofficeMutation, RemoveNotificationBackofficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveNotificationBackofficeMutation, RemoveNotificationBackofficeMutationVariables>(RemoveNotificationBackofficeDocument, options);
      }
export type RemoveNotificationBackofficeMutationHookResult = ReturnType<typeof useRemoveNotificationBackofficeMutation>;
export type RemoveNotificationBackofficeMutationResult = Apollo.MutationResult<RemoveNotificationBackofficeMutation>;
export type RemoveNotificationBackofficeMutationOptions = Apollo.BaseMutationOptions<RemoveNotificationBackofficeMutation, RemoveNotificationBackofficeMutationVariables>;
export const AccountsWithoutBillingBackofficeDocument = gql`
    query AccountsWithoutBillingBackoffice {
  getAccountsWithoutBillingBackoffice {
    ...FreemiumAccount
  }
}
    ${FreemiumAccountFragmentDoc}`;

/**
 * __useAccountsWithoutBillingBackofficeQuery__
 *
 * To run a query within a React component, call `useAccountsWithoutBillingBackofficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsWithoutBillingBackofficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsWithoutBillingBackofficeQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountsWithoutBillingBackofficeQuery(baseOptions?: Apollo.QueryHookOptions<AccountsWithoutBillingBackofficeQuery, AccountsWithoutBillingBackofficeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountsWithoutBillingBackofficeQuery, AccountsWithoutBillingBackofficeQueryVariables>(AccountsWithoutBillingBackofficeDocument, options);
      }
export function useAccountsWithoutBillingBackofficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountsWithoutBillingBackofficeQuery, AccountsWithoutBillingBackofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountsWithoutBillingBackofficeQuery, AccountsWithoutBillingBackofficeQueryVariables>(AccountsWithoutBillingBackofficeDocument, options);
        }
export function useAccountsWithoutBillingBackofficeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountsWithoutBillingBackofficeQuery, AccountsWithoutBillingBackofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountsWithoutBillingBackofficeQuery, AccountsWithoutBillingBackofficeQueryVariables>(AccountsWithoutBillingBackofficeDocument, options);
        }
export type AccountsWithoutBillingBackofficeQueryHookResult = ReturnType<typeof useAccountsWithoutBillingBackofficeQuery>;
export type AccountsWithoutBillingBackofficeLazyQueryHookResult = ReturnType<typeof useAccountsWithoutBillingBackofficeLazyQuery>;
export type AccountsWithoutBillingBackofficeSuspenseQueryHookResult = ReturnType<typeof useAccountsWithoutBillingBackofficeSuspenseQuery>;
export type AccountsWithoutBillingBackofficeQueryResult = Apollo.QueryResult<AccountsWithoutBillingBackofficeQuery, AccountsWithoutBillingBackofficeQueryVariables>;
export const AccountsWithSyncsBlockedBackofficeDocument = gql`
    query AccountsWithSyncsBlockedBackoffice {
  getAccountsWithSyncsBlockedBackoffice {
    ...FreemiumAccount
  }
}
    ${FreemiumAccountFragmentDoc}`;

/**
 * __useAccountsWithSyncsBlockedBackofficeQuery__
 *
 * To run a query within a React component, call `useAccountsWithSyncsBlockedBackofficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsWithSyncsBlockedBackofficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsWithSyncsBlockedBackofficeQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountsWithSyncsBlockedBackofficeQuery(baseOptions?: Apollo.QueryHookOptions<AccountsWithSyncsBlockedBackofficeQuery, AccountsWithSyncsBlockedBackofficeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountsWithSyncsBlockedBackofficeQuery, AccountsWithSyncsBlockedBackofficeQueryVariables>(AccountsWithSyncsBlockedBackofficeDocument, options);
      }
export function useAccountsWithSyncsBlockedBackofficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountsWithSyncsBlockedBackofficeQuery, AccountsWithSyncsBlockedBackofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountsWithSyncsBlockedBackofficeQuery, AccountsWithSyncsBlockedBackofficeQueryVariables>(AccountsWithSyncsBlockedBackofficeDocument, options);
        }
export function useAccountsWithSyncsBlockedBackofficeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountsWithSyncsBlockedBackofficeQuery, AccountsWithSyncsBlockedBackofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountsWithSyncsBlockedBackofficeQuery, AccountsWithSyncsBlockedBackofficeQueryVariables>(AccountsWithSyncsBlockedBackofficeDocument, options);
        }
export type AccountsWithSyncsBlockedBackofficeQueryHookResult = ReturnType<typeof useAccountsWithSyncsBlockedBackofficeQuery>;
export type AccountsWithSyncsBlockedBackofficeLazyQueryHookResult = ReturnType<typeof useAccountsWithSyncsBlockedBackofficeLazyQuery>;
export type AccountsWithSyncsBlockedBackofficeSuspenseQueryHookResult = ReturnType<typeof useAccountsWithSyncsBlockedBackofficeSuspenseQuery>;
export type AccountsWithSyncsBlockedBackofficeQueryResult = Apollo.QueryResult<AccountsWithSyncsBlockedBackofficeQuery, AccountsWithSyncsBlockedBackofficeQueryVariables>;
export const AllAccountsBackofficeDocument = gql`
    query AllAccountsBackoffice {
  getAllAccountsBackoffice {
    ...FreemiumAccount
  }
}
    ${FreemiumAccountFragmentDoc}`;

/**
 * __useAllAccountsBackofficeQuery__
 *
 * To run a query within a React component, call `useAllAccountsBackofficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAccountsBackofficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAccountsBackofficeQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAccountsBackofficeQuery(baseOptions?: Apollo.QueryHookOptions<AllAccountsBackofficeQuery, AllAccountsBackofficeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAccountsBackofficeQuery, AllAccountsBackofficeQueryVariables>(AllAccountsBackofficeDocument, options);
      }
export function useAllAccountsBackofficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAccountsBackofficeQuery, AllAccountsBackofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAccountsBackofficeQuery, AllAccountsBackofficeQueryVariables>(AllAccountsBackofficeDocument, options);
        }
export function useAllAccountsBackofficeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllAccountsBackofficeQuery, AllAccountsBackofficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllAccountsBackofficeQuery, AllAccountsBackofficeQueryVariables>(AllAccountsBackofficeDocument, options);
        }
export type AllAccountsBackofficeQueryHookResult = ReturnType<typeof useAllAccountsBackofficeQuery>;
export type AllAccountsBackofficeLazyQueryHookResult = ReturnType<typeof useAllAccountsBackofficeLazyQuery>;
export type AllAccountsBackofficeSuspenseQueryHookResult = ReturnType<typeof useAllAccountsBackofficeSuspenseQuery>;
export type AllAccountsBackofficeQueryResult = Apollo.QueryResult<AllAccountsBackofficeQuery, AllAccountsBackofficeQueryVariables>;
export const BlockEltSyncsForAccountBackofficeDocument = gql`
    mutation BlockELTSyncsForAccountBackoffice($accountId: String!, $value: Boolean!) {
  blockELTSyncsForAccountBackoffice(accountId: $accountId, value: $value) {
    ...FreemiumAccount
  }
}
    ${FreemiumAccountFragmentDoc}`;
export type BlockEltSyncsForAccountBackofficeMutationFn = Apollo.MutationFunction<BlockEltSyncsForAccountBackofficeMutation, BlockEltSyncsForAccountBackofficeMutationVariables>;

/**
 * __useBlockEltSyncsForAccountBackofficeMutation__
 *
 * To run a mutation, you first call `useBlockEltSyncsForAccountBackofficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockEltSyncsForAccountBackofficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockEltSyncsForAccountBackofficeMutation, { data, loading, error }] = useBlockEltSyncsForAccountBackofficeMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useBlockEltSyncsForAccountBackofficeMutation(baseOptions?: Apollo.MutationHookOptions<BlockEltSyncsForAccountBackofficeMutation, BlockEltSyncsForAccountBackofficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockEltSyncsForAccountBackofficeMutation, BlockEltSyncsForAccountBackofficeMutationVariables>(BlockEltSyncsForAccountBackofficeDocument, options);
      }
export type BlockEltSyncsForAccountBackofficeMutationHookResult = ReturnType<typeof useBlockEltSyncsForAccountBackofficeMutation>;
export type BlockEltSyncsForAccountBackofficeMutationResult = Apollo.MutationResult<BlockEltSyncsForAccountBackofficeMutation>;
export type BlockEltSyncsForAccountBackofficeMutationOptions = Apollo.BaseMutationOptions<BlockEltSyncsForAccountBackofficeMutation, BlockEltSyncsForAccountBackofficeMutationVariables>;
export const BlockReverseEltSyncsForAccountBackofficeDocument = gql`
    mutation BlockReverseELTSyncsForAccountBackoffice($accountId: String!, $value: Boolean!) {
  blockReverseELTSyncsForAccountBackoffice(accountId: $accountId, value: $value) {
    ...FreemiumAccount
  }
}
    ${FreemiumAccountFragmentDoc}`;
export type BlockReverseEltSyncsForAccountBackofficeMutationFn = Apollo.MutationFunction<BlockReverseEltSyncsForAccountBackofficeMutation, BlockReverseEltSyncsForAccountBackofficeMutationVariables>;

/**
 * __useBlockReverseEltSyncsForAccountBackofficeMutation__
 *
 * To run a mutation, you first call `useBlockReverseEltSyncsForAccountBackofficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockReverseEltSyncsForAccountBackofficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockReverseEltSyncsForAccountBackofficeMutation, { data, loading, error }] = useBlockReverseEltSyncsForAccountBackofficeMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useBlockReverseEltSyncsForAccountBackofficeMutation(baseOptions?: Apollo.MutationHookOptions<BlockReverseEltSyncsForAccountBackofficeMutation, BlockReverseEltSyncsForAccountBackofficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockReverseEltSyncsForAccountBackofficeMutation, BlockReverseEltSyncsForAccountBackofficeMutationVariables>(BlockReverseEltSyncsForAccountBackofficeDocument, options);
      }
export type BlockReverseEltSyncsForAccountBackofficeMutationHookResult = ReturnType<typeof useBlockReverseEltSyncsForAccountBackofficeMutation>;
export type BlockReverseEltSyncsForAccountBackofficeMutationResult = Apollo.MutationResult<BlockReverseEltSyncsForAccountBackofficeMutation>;
export type BlockReverseEltSyncsForAccountBackofficeMutationOptions = Apollo.BaseMutationOptions<BlockReverseEltSyncsForAccountBackofficeMutation, BlockReverseEltSyncsForAccountBackofficeMutationVariables>;
export const SetTrialEndDateBackofficeDocument = gql`
    mutation SetTrialEndDateBackoffice($accountId: String!, $date: DateTime!) {
  setTrialEndDateBackoffice(accountId: $accountId, date: $date) {
    ...FreemiumAccount
  }
}
    ${FreemiumAccountFragmentDoc}`;
export type SetTrialEndDateBackofficeMutationFn = Apollo.MutationFunction<SetTrialEndDateBackofficeMutation, SetTrialEndDateBackofficeMutationVariables>;

/**
 * __useSetTrialEndDateBackofficeMutation__
 *
 * To run a mutation, you first call `useSetTrialEndDateBackofficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTrialEndDateBackofficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTrialEndDateBackofficeMutation, { data, loading, error }] = useSetTrialEndDateBackofficeMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useSetTrialEndDateBackofficeMutation(baseOptions?: Apollo.MutationHookOptions<SetTrialEndDateBackofficeMutation, SetTrialEndDateBackofficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTrialEndDateBackofficeMutation, SetTrialEndDateBackofficeMutationVariables>(SetTrialEndDateBackofficeDocument, options);
      }
export type SetTrialEndDateBackofficeMutationHookResult = ReturnType<typeof useSetTrialEndDateBackofficeMutation>;
export type SetTrialEndDateBackofficeMutationResult = Apollo.MutationResult<SetTrialEndDateBackofficeMutation>;
export type SetTrialEndDateBackofficeMutationOptions = Apollo.BaseMutationOptions<SetTrialEndDateBackofficeMutation, SetTrialEndDateBackofficeMutationVariables>;
export const GetIntegrationIdsForErdDocument = gql`
    query GetIntegrationIdsForErd {
  getIntegrationIdsForErd
}
    `;

/**
 * __useGetIntegrationIdsForErdQuery__
 *
 * To run a query within a React component, call `useGetIntegrationIdsForErdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationIdsForErdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationIdsForErdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntegrationIdsForErdQuery(baseOptions?: Apollo.QueryHookOptions<GetIntegrationIdsForErdQuery, GetIntegrationIdsForErdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationIdsForErdQuery, GetIntegrationIdsForErdQueryVariables>(GetIntegrationIdsForErdDocument, options);
      }
export function useGetIntegrationIdsForErdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationIdsForErdQuery, GetIntegrationIdsForErdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationIdsForErdQuery, GetIntegrationIdsForErdQueryVariables>(GetIntegrationIdsForErdDocument, options);
        }
export function useGetIntegrationIdsForErdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntegrationIdsForErdQuery, GetIntegrationIdsForErdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationIdsForErdQuery, GetIntegrationIdsForErdQueryVariables>(GetIntegrationIdsForErdDocument, options);
        }
export type GetIntegrationIdsForErdQueryHookResult = ReturnType<typeof useGetIntegrationIdsForErdQuery>;
export type GetIntegrationIdsForErdLazyQueryHookResult = ReturnType<typeof useGetIntegrationIdsForErdLazyQuery>;
export type GetIntegrationIdsForErdSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationIdsForErdSuspenseQuery>;
export type GetIntegrationIdsForErdQueryResult = Apollo.QueryResult<GetIntegrationIdsForErdQuery, GetIntegrationIdsForErdQueryVariables>;
export const GetErdForIntegrationDocument = gql`
    query GetErdForIntegration($integrationId: String!) {
  getErdForIntegration(integrationId: $integrationId) {
    integrationId
    nodes {
      id
      type
      data {
        fields {
          id
          name
          type
          isPrimaryKey
          foreignKey
        }
        tableName
        isSubTable
        childOf
      }
      position {
        x
        y
      }
      parentNode
    }
    edges {
      id
      source
      target
      type
    }
  }
}
    `;

/**
 * __useGetErdForIntegrationQuery__
 *
 * To run a query within a React component, call `useGetErdForIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErdForIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErdForIntegrationQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useGetErdForIntegrationQuery(baseOptions: Apollo.QueryHookOptions<GetErdForIntegrationQuery, GetErdForIntegrationQueryVariables> & ({ variables: GetErdForIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetErdForIntegrationQuery, GetErdForIntegrationQueryVariables>(GetErdForIntegrationDocument, options);
      }
export function useGetErdForIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetErdForIntegrationQuery, GetErdForIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetErdForIntegrationQuery, GetErdForIntegrationQueryVariables>(GetErdForIntegrationDocument, options);
        }
export function useGetErdForIntegrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetErdForIntegrationQuery, GetErdForIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetErdForIntegrationQuery, GetErdForIntegrationQueryVariables>(GetErdForIntegrationDocument, options);
        }
export type GetErdForIntegrationQueryHookResult = ReturnType<typeof useGetErdForIntegrationQuery>;
export type GetErdForIntegrationLazyQueryHookResult = ReturnType<typeof useGetErdForIntegrationLazyQuery>;
export type GetErdForIntegrationSuspenseQueryHookResult = ReturnType<typeof useGetErdForIntegrationSuspenseQuery>;
export type GetErdForIntegrationQueryResult = Apollo.QueryResult<GetErdForIntegrationQuery, GetErdForIntegrationQueryVariables>;
export const GetStoredErdForIntegrationDocument = gql`
    query GetStoredErdForIntegration($integrationId: String!) {
  getStoredErdForIntegration(integrationId: $integrationId) {
    integrationId
    hideDiagram
    edges {
      id
      markerEnd
      source
      style
      target
      type
    }
    nodes {
      id
      height
      parentNode
      position {
        x
        y
      }
      type
      width
      data {
        tableName
        fields {
          id
          name
          type
          isPrimaryKey
          foreignKey
        }
        isSubTable
        childOf
      }
    }
  }
}
    `;

/**
 * __useGetStoredErdForIntegrationQuery__
 *
 * To run a query within a React component, call `useGetStoredErdForIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoredErdForIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoredErdForIntegrationQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useGetStoredErdForIntegrationQuery(baseOptions: Apollo.QueryHookOptions<GetStoredErdForIntegrationQuery, GetStoredErdForIntegrationQueryVariables> & ({ variables: GetStoredErdForIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoredErdForIntegrationQuery, GetStoredErdForIntegrationQueryVariables>(GetStoredErdForIntegrationDocument, options);
      }
export function useGetStoredErdForIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoredErdForIntegrationQuery, GetStoredErdForIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoredErdForIntegrationQuery, GetStoredErdForIntegrationQueryVariables>(GetStoredErdForIntegrationDocument, options);
        }
export function useGetStoredErdForIntegrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStoredErdForIntegrationQuery, GetStoredErdForIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoredErdForIntegrationQuery, GetStoredErdForIntegrationQueryVariables>(GetStoredErdForIntegrationDocument, options);
        }
export type GetStoredErdForIntegrationQueryHookResult = ReturnType<typeof useGetStoredErdForIntegrationQuery>;
export type GetStoredErdForIntegrationLazyQueryHookResult = ReturnType<typeof useGetStoredErdForIntegrationLazyQuery>;
export type GetStoredErdForIntegrationSuspenseQueryHookResult = ReturnType<typeof useGetStoredErdForIntegrationSuspenseQuery>;
export type GetStoredErdForIntegrationQueryResult = Apollo.QueryResult<GetStoredErdForIntegrationQuery, GetStoredErdForIntegrationQueryVariables>;
export const SaveErdForIntegrationDocument = gql`
    mutation SaveErdForIntegration($integrationId: String!, $edges: [StoredErdEdgeInput!]!, $nodes: [StoredErdNodeInput!]!, $hideDiagram: Boolean) {
  saveErdForIntegration(
    input: {integrationId: $integrationId, nodes: $nodes, edges: $edges, hideDiagram: $hideDiagram}
  ) {
    integrationId
    hideDiagram
    edges {
      id
      markerEnd
      source
      style
      target
      type
    }
    nodes {
      id
      height
      parentNode
      position {
        x
        y
      }
      type
      width
      data {
        fields {
          id
          isPrimaryKey
          name
          type
        }
        isSubTable
        tableName
      }
    }
  }
}
    `;
export type SaveErdForIntegrationMutationFn = Apollo.MutationFunction<SaveErdForIntegrationMutation, SaveErdForIntegrationMutationVariables>;

/**
 * __useSaveErdForIntegrationMutation__
 *
 * To run a mutation, you first call `useSaveErdForIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveErdForIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveErdForIntegrationMutation, { data, loading, error }] = useSaveErdForIntegrationMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      edges: // value for 'edges'
 *      nodes: // value for 'nodes'
 *      hideDiagram: // value for 'hideDiagram'
 *   },
 * });
 */
export function useSaveErdForIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<SaveErdForIntegrationMutation, SaveErdForIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveErdForIntegrationMutation, SaveErdForIntegrationMutationVariables>(SaveErdForIntegrationDocument, options);
      }
export type SaveErdForIntegrationMutationHookResult = ReturnType<typeof useSaveErdForIntegrationMutation>;
export type SaveErdForIntegrationMutationResult = Apollo.MutationResult<SaveErdForIntegrationMutation>;
export type SaveErdForIntegrationMutationOptions = Apollo.BaseMutationOptions<SaveErdForIntegrationMutation, SaveErdForIntegrationMutationVariables>;
export const BackofficeDailyUsageStateDocument = gql`
    query BackofficeDailyUsageState($accountId: String!, $referenceDate: DateTime!, $historicalDataLookbackDays: Float!) {
  backofficeDailyUsageState(
    accountId: $accountId
    referenceDate: $referenceDate
    historicalDataLookbackDays: $historicalDataLookbackDays
  ) {
    date
    numRowsSynced
    numBillableRows
    elt {
      ...BackofficeSyncStats
    }
    reverseElt {
      ...BackofficeSyncStats
    }
  }
}
    ${BackofficeSyncStatsFragmentDoc}`;

/**
 * __useBackofficeDailyUsageStateQuery__
 *
 * To run a query within a React component, call `useBackofficeDailyUsageStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackofficeDailyUsageStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackofficeDailyUsageStateQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      referenceDate: // value for 'referenceDate'
 *      historicalDataLookbackDays: // value for 'historicalDataLookbackDays'
 *   },
 * });
 */
export function useBackofficeDailyUsageStateQuery(baseOptions: Apollo.QueryHookOptions<BackofficeDailyUsageStateQuery, BackofficeDailyUsageStateQueryVariables> & ({ variables: BackofficeDailyUsageStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BackofficeDailyUsageStateQuery, BackofficeDailyUsageStateQueryVariables>(BackofficeDailyUsageStateDocument, options);
      }
export function useBackofficeDailyUsageStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BackofficeDailyUsageStateQuery, BackofficeDailyUsageStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BackofficeDailyUsageStateQuery, BackofficeDailyUsageStateQueryVariables>(BackofficeDailyUsageStateDocument, options);
        }
export function useBackofficeDailyUsageStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BackofficeDailyUsageStateQuery, BackofficeDailyUsageStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BackofficeDailyUsageStateQuery, BackofficeDailyUsageStateQueryVariables>(BackofficeDailyUsageStateDocument, options);
        }
export type BackofficeDailyUsageStateQueryHookResult = ReturnType<typeof useBackofficeDailyUsageStateQuery>;
export type BackofficeDailyUsageStateLazyQueryHookResult = ReturnType<typeof useBackofficeDailyUsageStateLazyQuery>;
export type BackofficeDailyUsageStateSuspenseQueryHookResult = ReturnType<typeof useBackofficeDailyUsageStateSuspenseQuery>;
export type BackofficeDailyUsageStateQueryResult = Apollo.QueryResult<BackofficeDailyUsageStateQuery, BackofficeDailyUsageStateQueryVariables>;
export const BackofficeUsageForecastTrainingDataDocument = gql`
    query BackofficeUsageForecastTrainingData($accountId: String!, $referenceDate: DateTime!, $historicalDataLookbackDays: Float!) {
  backofficeUsageForecastTrainingData(
    accountId: $accountId
    referenceDate: $referenceDate
    historicalDataLookbackDays: $historicalDataLookbackDays
  ) {
    date
    numBillableRows
  }
}
    `;

/**
 * __useBackofficeUsageForecastTrainingDataQuery__
 *
 * To run a query within a React component, call `useBackofficeUsageForecastTrainingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackofficeUsageForecastTrainingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackofficeUsageForecastTrainingDataQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      referenceDate: // value for 'referenceDate'
 *      historicalDataLookbackDays: // value for 'historicalDataLookbackDays'
 *   },
 * });
 */
export function useBackofficeUsageForecastTrainingDataQuery(baseOptions: Apollo.QueryHookOptions<BackofficeUsageForecastTrainingDataQuery, BackofficeUsageForecastTrainingDataQueryVariables> & ({ variables: BackofficeUsageForecastTrainingDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BackofficeUsageForecastTrainingDataQuery, BackofficeUsageForecastTrainingDataQueryVariables>(BackofficeUsageForecastTrainingDataDocument, options);
      }
export function useBackofficeUsageForecastTrainingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BackofficeUsageForecastTrainingDataQuery, BackofficeUsageForecastTrainingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BackofficeUsageForecastTrainingDataQuery, BackofficeUsageForecastTrainingDataQueryVariables>(BackofficeUsageForecastTrainingDataDocument, options);
        }
export function useBackofficeUsageForecastTrainingDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BackofficeUsageForecastTrainingDataQuery, BackofficeUsageForecastTrainingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BackofficeUsageForecastTrainingDataQuery, BackofficeUsageForecastTrainingDataQueryVariables>(BackofficeUsageForecastTrainingDataDocument, options);
        }
export type BackofficeUsageForecastTrainingDataQueryHookResult = ReturnType<typeof useBackofficeUsageForecastTrainingDataQuery>;
export type BackofficeUsageForecastTrainingDataLazyQueryHookResult = ReturnType<typeof useBackofficeUsageForecastTrainingDataLazyQuery>;
export type BackofficeUsageForecastTrainingDataSuspenseQueryHookResult = ReturnType<typeof useBackofficeUsageForecastTrainingDataSuspenseQuery>;
export type BackofficeUsageForecastTrainingDataQueryResult = Apollo.QueryResult<BackofficeUsageForecastTrainingDataQuery, BackofficeUsageForecastTrainingDataQueryVariables>;
export const ResetSyncBackofficeDocument = gql`
    mutation ResetSyncBackoffice($eltSyncId: String!, $sourceIntegrationId: String!, $sourceStreamName: String!, $numberOfErrors: Float, $resetIncrementalPointer: Boolean) {
  resetSyncBackOffice(
    input: {eltSyncId: $eltSyncId, sourceIntegrationId: $sourceIntegrationId, sourceStreamName: $sourceStreamName, numberOfErrors: $numberOfErrors, resetIncrementalPointer: $resetIncrementalPointer}
  ) {
    job
    reason
    success
  }
}
    `;
export type ResetSyncBackofficeMutationFn = Apollo.MutationFunction<ResetSyncBackofficeMutation, ResetSyncBackofficeMutationVariables>;

/**
 * __useResetSyncBackofficeMutation__
 *
 * To run a mutation, you first call `useResetSyncBackofficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetSyncBackofficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetSyncBackofficeMutation, { data, loading, error }] = useResetSyncBackofficeMutation({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *      sourceIntegrationId: // value for 'sourceIntegrationId'
 *      sourceStreamName: // value for 'sourceStreamName'
 *      numberOfErrors: // value for 'numberOfErrors'
 *      resetIncrementalPointer: // value for 'resetIncrementalPointer'
 *   },
 * });
 */
export function useResetSyncBackofficeMutation(baseOptions?: Apollo.MutationHookOptions<ResetSyncBackofficeMutation, ResetSyncBackofficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetSyncBackofficeMutation, ResetSyncBackofficeMutationVariables>(ResetSyncBackofficeDocument, options);
      }
export type ResetSyncBackofficeMutationHookResult = ReturnType<typeof useResetSyncBackofficeMutation>;
export type ResetSyncBackofficeMutationResult = Apollo.MutationResult<ResetSyncBackofficeMutation>;
export type ResetSyncBackofficeMutationOptions = Apollo.BaseMutationOptions<ResetSyncBackofficeMutation, ResetSyncBackofficeMutationVariables>;
export const SetDevStatusDocument = gql`
    mutation SetDevStatus($eltSyncId: String!, $scheduledJobId: String!, $devStatus: String!, $devNotes: String!) {
  setDevStatus(
    input: {eltSyncId: $eltSyncId, scheduledJobId: $scheduledJobId, devStatus: $devStatus, devNotes: $devNotes}
  )
}
    `;
export type SetDevStatusMutationFn = Apollo.MutationFunction<SetDevStatusMutation, SetDevStatusMutationVariables>;

/**
 * __useSetDevStatusMutation__
 *
 * To run a mutation, you first call `useSetDevStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDevStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDevStatusMutation, { data, loading, error }] = useSetDevStatusMutation({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *      scheduledJobId: // value for 'scheduledJobId'
 *      devStatus: // value for 'devStatus'
 *      devNotes: // value for 'devNotes'
 *   },
 * });
 */
export function useSetDevStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetDevStatusMutation, SetDevStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDevStatusMutation, SetDevStatusMutationVariables>(SetDevStatusDocument, options);
      }
export type SetDevStatusMutationHookResult = ReturnType<typeof useSetDevStatusMutation>;
export type SetDevStatusMutationResult = Apollo.MutationResult<SetDevStatusMutation>;
export type SetDevStatusMutationOptions = Apollo.BaseMutationOptions<SetDevStatusMutation, SetDevStatusMutationVariables>;
export const GetErrorLogsBackOfficeDocument = gql`
    query GetErrorLogsBackOffice($scheduledJobId: String!) {
  getErrorLogsBackOffice(scheduledJobId: $scheduledJobId) {
    id
    message
    log_origin
    timestamp
    error_code
    logger
  }
}
    `;

/**
 * __useGetErrorLogsBackOfficeQuery__
 *
 * To run a query within a React component, call `useGetErrorLogsBackOfficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorLogsBackOfficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorLogsBackOfficeQuery({
 *   variables: {
 *      scheduledJobId: // value for 'scheduledJobId'
 *   },
 * });
 */
export function useGetErrorLogsBackOfficeQuery(baseOptions: Apollo.QueryHookOptions<GetErrorLogsBackOfficeQuery, GetErrorLogsBackOfficeQueryVariables> & ({ variables: GetErrorLogsBackOfficeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetErrorLogsBackOfficeQuery, GetErrorLogsBackOfficeQueryVariables>(GetErrorLogsBackOfficeDocument, options);
      }
export function useGetErrorLogsBackOfficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetErrorLogsBackOfficeQuery, GetErrorLogsBackOfficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetErrorLogsBackOfficeQuery, GetErrorLogsBackOfficeQueryVariables>(GetErrorLogsBackOfficeDocument, options);
        }
export function useGetErrorLogsBackOfficeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetErrorLogsBackOfficeQuery, GetErrorLogsBackOfficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetErrorLogsBackOfficeQuery, GetErrorLogsBackOfficeQueryVariables>(GetErrorLogsBackOfficeDocument, options);
        }
export type GetErrorLogsBackOfficeQueryHookResult = ReturnType<typeof useGetErrorLogsBackOfficeQuery>;
export type GetErrorLogsBackOfficeLazyQueryHookResult = ReturnType<typeof useGetErrorLogsBackOfficeLazyQuery>;
export type GetErrorLogsBackOfficeSuspenseQueryHookResult = ReturnType<typeof useGetErrorLogsBackOfficeSuspenseQuery>;
export type GetErrorLogsBackOfficeQueryResult = Apollo.QueryResult<GetErrorLogsBackOfficeQuery, GetErrorLogsBackOfficeQueryVariables>;
export const ConnectionDocument = gql`
    query Connection($id: String!) {
  connection(id: $id) {
    ...ConnectionBase
    ...ConnectionWithSyncs
    user {
      firstName
      lastName
      email
    }
  }
}
    ${ConnectionBaseFragmentDoc}
${ConnectionWithSyncsFragmentDoc}`;

/**
 * __useConnectionQuery__
 *
 * To run a query within a React component, call `useConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConnectionQuery(baseOptions: Apollo.QueryHookOptions<ConnectionQuery, ConnectionQueryVariables> & ({ variables: ConnectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectionQuery, ConnectionQueryVariables>(ConnectionDocument, options);
      }
export function useConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectionQuery, ConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectionQuery, ConnectionQueryVariables>(ConnectionDocument, options);
        }
export function useConnectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectionQuery, ConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectionQuery, ConnectionQueryVariables>(ConnectionDocument, options);
        }
export type ConnectionQueryHookResult = ReturnType<typeof useConnectionQuery>;
export type ConnectionLazyQueryHookResult = ReturnType<typeof useConnectionLazyQuery>;
export type ConnectionSuspenseQueryHookResult = ReturnType<typeof useConnectionSuspenseQuery>;
export type ConnectionQueryResult = Apollo.QueryResult<ConnectionQuery, ConnectionQueryVariables>;
export const ConnectionWithCredentialsDocument = gql`
    query ConnectionWithCredentials($id: String!) {
  connection(id: $id) {
    ...ConnectionBase
    ...ConnectionWithSyncs
    user {
      firstName
      lastName
      email
    }
    credentials
  }
}
    ${ConnectionBaseFragmentDoc}
${ConnectionWithSyncsFragmentDoc}`;

/**
 * __useConnectionWithCredentialsQuery__
 *
 * To run a query within a React component, call `useConnectionWithCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionWithCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionWithCredentialsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConnectionWithCredentialsQuery(baseOptions: Apollo.QueryHookOptions<ConnectionWithCredentialsQuery, ConnectionWithCredentialsQueryVariables> & ({ variables: ConnectionWithCredentialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectionWithCredentialsQuery, ConnectionWithCredentialsQueryVariables>(ConnectionWithCredentialsDocument, options);
      }
export function useConnectionWithCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectionWithCredentialsQuery, ConnectionWithCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectionWithCredentialsQuery, ConnectionWithCredentialsQueryVariables>(ConnectionWithCredentialsDocument, options);
        }
export function useConnectionWithCredentialsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectionWithCredentialsQuery, ConnectionWithCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectionWithCredentialsQuery, ConnectionWithCredentialsQueryVariables>(ConnectionWithCredentialsDocument, options);
        }
export type ConnectionWithCredentialsQueryHookResult = ReturnType<typeof useConnectionWithCredentialsQuery>;
export type ConnectionWithCredentialsLazyQueryHookResult = ReturnType<typeof useConnectionWithCredentialsLazyQuery>;
export type ConnectionWithCredentialsSuspenseQueryHookResult = ReturnType<typeof useConnectionWithCredentialsSuspenseQuery>;
export type ConnectionWithCredentialsQueryResult = Apollo.QueryResult<ConnectionWithCredentialsQuery, ConnectionWithCredentialsQueryVariables>;
export const ConnectionsDocument = gql`
    query Connections {
  connections {
    ...ConnectionBase
  }
}
    ${ConnectionBaseFragmentDoc}`;

/**
 * __useConnectionsQuery__
 *
 * To run a query within a React component, call `useConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<ConnectionsQuery, ConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectionsQuery, ConnectionsQueryVariables>(ConnectionsDocument, options);
      }
export function useConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectionsQuery, ConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectionsQuery, ConnectionsQueryVariables>(ConnectionsDocument, options);
        }
export function useConnectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectionsQuery, ConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectionsQuery, ConnectionsQueryVariables>(ConnectionsDocument, options);
        }
export type ConnectionsQueryHookResult = ReturnType<typeof useConnectionsQuery>;
export type ConnectionsLazyQueryHookResult = ReturnType<typeof useConnectionsLazyQuery>;
export type ConnectionsSuspenseQueryHookResult = ReturnType<typeof useConnectionsSuspenseQuery>;
export type ConnectionsQueryResult = Apollo.QueryResult<ConnectionsQuery, ConnectionsQueryVariables>;
export const ConnectionsWithUsageSummaryDocument = gql`
    query ConnectionsWithUsageSummary {
  connectors {
    ...ConnectionBase
    usageSummary {
      numEltSyncs
      numRevEltSyncs
      totalSyncs
    }
  }
}
    ${ConnectionBaseFragmentDoc}`;

/**
 * __useConnectionsWithUsageSummaryQuery__
 *
 * To run a query within a React component, call `useConnectionsWithUsageSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionsWithUsageSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionsWithUsageSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useConnectionsWithUsageSummaryQuery(baseOptions?: Apollo.QueryHookOptions<ConnectionsWithUsageSummaryQuery, ConnectionsWithUsageSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectionsWithUsageSummaryQuery, ConnectionsWithUsageSummaryQueryVariables>(ConnectionsWithUsageSummaryDocument, options);
      }
export function useConnectionsWithUsageSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectionsWithUsageSummaryQuery, ConnectionsWithUsageSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectionsWithUsageSummaryQuery, ConnectionsWithUsageSummaryQueryVariables>(ConnectionsWithUsageSummaryDocument, options);
        }
export function useConnectionsWithUsageSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectionsWithUsageSummaryQuery, ConnectionsWithUsageSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectionsWithUsageSummaryQuery, ConnectionsWithUsageSummaryQueryVariables>(ConnectionsWithUsageSummaryDocument, options);
        }
export type ConnectionsWithUsageSummaryQueryHookResult = ReturnType<typeof useConnectionsWithUsageSummaryQuery>;
export type ConnectionsWithUsageSummaryLazyQueryHookResult = ReturnType<typeof useConnectionsWithUsageSummaryLazyQuery>;
export type ConnectionsWithUsageSummarySuspenseQueryHookResult = ReturnType<typeof useConnectionsWithUsageSummarySuspenseQuery>;
export type ConnectionsWithUsageSummaryQueryResult = Apollo.QueryResult<ConnectionsWithUsageSummaryQuery, ConnectionsWithUsageSummaryQueryVariables>;
export const EltConnectionSettingsDocument = gql`
    query EltConnectionSettings($input: GetSettingsInput!) {
  getEltSettings(input: $input) {
    connectionSettings
  }
}
    `;

/**
 * __useEltConnectionSettingsQuery__
 *
 * To run a query within a React component, call `useEltConnectionSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltConnectionSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltConnectionSettingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEltConnectionSettingsQuery(baseOptions: Apollo.QueryHookOptions<EltConnectionSettingsQuery, EltConnectionSettingsQueryVariables> & ({ variables: EltConnectionSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltConnectionSettingsQuery, EltConnectionSettingsQueryVariables>(EltConnectionSettingsDocument, options);
      }
export function useEltConnectionSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltConnectionSettingsQuery, EltConnectionSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltConnectionSettingsQuery, EltConnectionSettingsQueryVariables>(EltConnectionSettingsDocument, options);
        }
export function useEltConnectionSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltConnectionSettingsQuery, EltConnectionSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltConnectionSettingsQuery, EltConnectionSettingsQueryVariables>(EltConnectionSettingsDocument, options);
        }
export type EltConnectionSettingsQueryHookResult = ReturnType<typeof useEltConnectionSettingsQuery>;
export type EltConnectionSettingsLazyQueryHookResult = ReturnType<typeof useEltConnectionSettingsLazyQuery>;
export type EltConnectionSettingsSuspenseQueryHookResult = ReturnType<typeof useEltConnectionSettingsSuspenseQuery>;
export type EltConnectionSettingsQueryResult = Apollo.QueryResult<EltConnectionSettingsQuery, EltConnectionSettingsQueryVariables>;
export const ActivateConnectionSettingsDocument = gql`
    query activateConnectionSettings($input: GetSettingsInput!) {
  getActivateSettings(input: $input) {
    connectionSettings
  }
}
    `;

/**
 * __useActivateConnectionSettingsQuery__
 *
 * To run a query within a React component, call `useActivateConnectionSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivateConnectionSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivateConnectionSettingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateConnectionSettingsQuery(baseOptions: Apollo.QueryHookOptions<ActivateConnectionSettingsQuery, ActivateConnectionSettingsQueryVariables> & ({ variables: ActivateConnectionSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivateConnectionSettingsQuery, ActivateConnectionSettingsQueryVariables>(ActivateConnectionSettingsDocument, options);
      }
export function useActivateConnectionSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivateConnectionSettingsQuery, ActivateConnectionSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivateConnectionSettingsQuery, ActivateConnectionSettingsQueryVariables>(ActivateConnectionSettingsDocument, options);
        }
export function useActivateConnectionSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActivateConnectionSettingsQuery, ActivateConnectionSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivateConnectionSettingsQuery, ActivateConnectionSettingsQueryVariables>(ActivateConnectionSettingsDocument, options);
        }
export type ActivateConnectionSettingsQueryHookResult = ReturnType<typeof useActivateConnectionSettingsQuery>;
export type ActivateConnectionSettingsLazyQueryHookResult = ReturnType<typeof useActivateConnectionSettingsLazyQuery>;
export type ActivateConnectionSettingsSuspenseQueryHookResult = ReturnType<typeof useActivateConnectionSettingsSuspenseQuery>;
export type ActivateConnectionSettingsQueryResult = Apollo.QueryResult<ActivateConnectionSettingsQuery, ActivateConnectionSettingsQueryVariables>;
export const ObjectTypeSettingsDocument = gql`
    query ObjectTypeSettings($objectType: String!, $connectionId: String!, $formValues: JSONObject) {
  getObjectTypeSettings(
    objectType: $objectType
    connectionId: $connectionId
    formValues: $formValues
  ) {
    settings
  }
}
    `;

/**
 * __useObjectTypeSettingsQuery__
 *
 * To run a query within a React component, call `useObjectTypeSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useObjectTypeSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObjectTypeSettingsQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      connectionId: // value for 'connectionId'
 *      formValues: // value for 'formValues'
 *   },
 * });
 */
export function useObjectTypeSettingsQuery(baseOptions: Apollo.QueryHookOptions<ObjectTypeSettingsQuery, ObjectTypeSettingsQueryVariables> & ({ variables: ObjectTypeSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ObjectTypeSettingsQuery, ObjectTypeSettingsQueryVariables>(ObjectTypeSettingsDocument, options);
      }
export function useObjectTypeSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ObjectTypeSettingsQuery, ObjectTypeSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ObjectTypeSettingsQuery, ObjectTypeSettingsQueryVariables>(ObjectTypeSettingsDocument, options);
        }
export function useObjectTypeSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ObjectTypeSettingsQuery, ObjectTypeSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ObjectTypeSettingsQuery, ObjectTypeSettingsQueryVariables>(ObjectTypeSettingsDocument, options);
        }
export type ObjectTypeSettingsQueryHookResult = ReturnType<typeof useObjectTypeSettingsQuery>;
export type ObjectTypeSettingsLazyQueryHookResult = ReturnType<typeof useObjectTypeSettingsLazyQuery>;
export type ObjectTypeSettingsSuspenseQueryHookResult = ReturnType<typeof useObjectTypeSettingsSuspenseQuery>;
export type ObjectTypeSettingsQueryResult = Apollo.QueryResult<ObjectTypeSettingsQuery, ObjectTypeSettingsQueryVariables>;
export const RemoveConnectionDocument = gql`
    mutation RemoveConnection($connectionId: String!) {
  removeConnection(id: $connectionId) {
    id
  }
}
    `;
export type RemoveConnectionMutationFn = Apollo.MutationFunction<RemoveConnectionMutation, RemoveConnectionMutationVariables>;

/**
 * __useRemoveConnectionMutation__
 *
 * To run a mutation, you first call `useRemoveConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeConnectionMutation, { data, loading, error }] = useRemoveConnectionMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useRemoveConnectionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveConnectionMutation, RemoveConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveConnectionMutation, RemoveConnectionMutationVariables>(RemoveConnectionDocument, options);
      }
export type RemoveConnectionMutationHookResult = ReturnType<typeof useRemoveConnectionMutation>;
export type RemoveConnectionMutationResult = Apollo.MutationResult<RemoveConnectionMutation>;
export type RemoveConnectionMutationOptions = Apollo.BaseMutationOptions<RemoveConnectionMutation, RemoveConnectionMutationVariables>;
export const RefreshDestinationDocument = gql`
    mutation RefreshDestination($connectionId: String!) {
  refreshDestination(id: $connectionId) {
    id
  }
}
    `;
export type RefreshDestinationMutationFn = Apollo.MutationFunction<RefreshDestinationMutation, RefreshDestinationMutationVariables>;

/**
 * __useRefreshDestinationMutation__
 *
 * To run a mutation, you first call `useRefreshDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshDestinationMutation, { data, loading, error }] = useRefreshDestinationMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useRefreshDestinationMutation(baseOptions?: Apollo.MutationHookOptions<RefreshDestinationMutation, RefreshDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshDestinationMutation, RefreshDestinationMutationVariables>(RefreshDestinationDocument, options);
      }
export type RefreshDestinationMutationHookResult = ReturnType<typeof useRefreshDestinationMutation>;
export type RefreshDestinationMutationResult = Apollo.MutationResult<RefreshDestinationMutation>;
export type RefreshDestinationMutationOptions = Apollo.BaseMutationOptions<RefreshDestinationMutation, RefreshDestinationMutationVariables>;
export const CreateConnectionDocument = gql`
    mutation CreateConnection($integrationId: String!, $payload: String!, $label: String!) {
  createConnection(
    input: {integrationId: $integrationId, payload: $payload, label: $label}
  ) {
    ...ConnectionBase
  }
}
    ${ConnectionBaseFragmentDoc}`;
export type CreateConnectionMutationFn = Apollo.MutationFunction<CreateConnectionMutation, CreateConnectionMutationVariables>;

/**
 * __useCreateConnectionMutation__
 *
 * To run a mutation, you first call `useCreateConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConnectionMutation, { data, loading, error }] = useCreateConnectionMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      payload: // value for 'payload'
 *      label: // value for 'label'
 *   },
 * });
 */
export function useCreateConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateConnectionMutation, CreateConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConnectionMutation, CreateConnectionMutationVariables>(CreateConnectionDocument, options);
      }
export type CreateConnectionMutationHookResult = ReturnType<typeof useCreateConnectionMutation>;
export type CreateConnectionMutationResult = Apollo.MutationResult<CreateConnectionMutation>;
export type CreateConnectionMutationOptions = Apollo.BaseMutationOptions<CreateConnectionMutation, CreateConnectionMutationVariables>;
export const CreateConnectionBridgeDocument = gql`
    mutation CreateConnectionBridge($integrationId: String!, $connectionId: String, $label: String!) {
  createConnectionBridge(
    input: {connectionId: $connectionId, integrationId: $integrationId, label: $label}
  ) {
    ...ConnectionBridgeBase
  }
}
    ${ConnectionBridgeBaseFragmentDoc}`;
export type CreateConnectionBridgeMutationFn = Apollo.MutationFunction<CreateConnectionBridgeMutation, CreateConnectionBridgeMutationVariables>;

/**
 * __useCreateConnectionBridgeMutation__
 *
 * To run a mutation, you first call `useCreateConnectionBridgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConnectionBridgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConnectionBridgeMutation, { data, loading, error }] = useCreateConnectionBridgeMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      connectionId: // value for 'connectionId'
 *      label: // value for 'label'
 *   },
 * });
 */
export function useCreateConnectionBridgeMutation(baseOptions?: Apollo.MutationHookOptions<CreateConnectionBridgeMutation, CreateConnectionBridgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConnectionBridgeMutation, CreateConnectionBridgeMutationVariables>(CreateConnectionBridgeDocument, options);
      }
export type CreateConnectionBridgeMutationHookResult = ReturnType<typeof useCreateConnectionBridgeMutation>;
export type CreateConnectionBridgeMutationResult = Apollo.MutationResult<CreateConnectionBridgeMutation>;
export type CreateConnectionBridgeMutationOptions = Apollo.BaseMutationOptions<CreateConnectionBridgeMutation, CreateConnectionBridgeMutationVariables>;
export const GetConnectionBridgesDocument = gql`
    query GetConnectionBridges {
  connectionBridges {
    ...ConnectionBridgeBase
  }
}
    ${ConnectionBridgeBaseFragmentDoc}`;

/**
 * __useGetConnectionBridgesQuery__
 *
 * To run a query within a React component, call `useGetConnectionBridgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectionBridgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectionBridgesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConnectionBridgesQuery(baseOptions?: Apollo.QueryHookOptions<GetConnectionBridgesQuery, GetConnectionBridgesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectionBridgesQuery, GetConnectionBridgesQueryVariables>(GetConnectionBridgesDocument, options);
      }
export function useGetConnectionBridgesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectionBridgesQuery, GetConnectionBridgesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectionBridgesQuery, GetConnectionBridgesQueryVariables>(GetConnectionBridgesDocument, options);
        }
export function useGetConnectionBridgesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConnectionBridgesQuery, GetConnectionBridgesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConnectionBridgesQuery, GetConnectionBridgesQueryVariables>(GetConnectionBridgesDocument, options);
        }
export type GetConnectionBridgesQueryHookResult = ReturnType<typeof useGetConnectionBridgesQuery>;
export type GetConnectionBridgesLazyQueryHookResult = ReturnType<typeof useGetConnectionBridgesLazyQuery>;
export type GetConnectionBridgesSuspenseQueryHookResult = ReturnType<typeof useGetConnectionBridgesSuspenseQuery>;
export type GetConnectionBridgesQueryResult = Apollo.QueryResult<GetConnectionBridgesQuery, GetConnectionBridgesQueryVariables>;
export const DeleteConnectionBridgeDocument = gql`
    mutation DeleteConnectionBridge($id: String!) {
  deleteConnectionBridge(id: $id)
}
    `;
export type DeleteConnectionBridgeMutationFn = Apollo.MutationFunction<DeleteConnectionBridgeMutation, DeleteConnectionBridgeMutationVariables>;

/**
 * __useDeleteConnectionBridgeMutation__
 *
 * To run a mutation, you first call `useDeleteConnectionBridgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConnectionBridgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConnectionBridgeMutation, { data, loading, error }] = useDeleteConnectionBridgeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteConnectionBridgeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConnectionBridgeMutation, DeleteConnectionBridgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConnectionBridgeMutation, DeleteConnectionBridgeMutationVariables>(DeleteConnectionBridgeDocument, options);
      }
export type DeleteConnectionBridgeMutationHookResult = ReturnType<typeof useDeleteConnectionBridgeMutation>;
export type DeleteConnectionBridgeMutationResult = Apollo.MutationResult<DeleteConnectionBridgeMutation>;
export type DeleteConnectionBridgeMutationOptions = Apollo.BaseMutationOptions<DeleteConnectionBridgeMutation, DeleteConnectionBridgeMutationVariables>;
export const GetOAuthUrlDocument = gql`
    query GetOAuthURL($integrationId: String!, $payload: String!, $connectionId: String) {
  getOAuthURL(
    input: {connectionId: $connectionId, integrationId: $integrationId, payload: $payload}
  )
}
    `;

/**
 * __useGetOAuthUrlQuery__
 *
 * To run a query within a React component, call `useGetOAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOAuthUrlQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      payload: // value for 'payload'
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useGetOAuthUrlQuery(baseOptions: Apollo.QueryHookOptions<GetOAuthUrlQuery, GetOAuthUrlQueryVariables> & ({ variables: GetOAuthUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOAuthUrlQuery, GetOAuthUrlQueryVariables>(GetOAuthUrlDocument, options);
      }
export function useGetOAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOAuthUrlQuery, GetOAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOAuthUrlQuery, GetOAuthUrlQueryVariables>(GetOAuthUrlDocument, options);
        }
export function useGetOAuthUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOAuthUrlQuery, GetOAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOAuthUrlQuery, GetOAuthUrlQueryVariables>(GetOAuthUrlDocument, options);
        }
export type GetOAuthUrlQueryHookResult = ReturnType<typeof useGetOAuthUrlQuery>;
export type GetOAuthUrlLazyQueryHookResult = ReturnType<typeof useGetOAuthUrlLazyQuery>;
export type GetOAuthUrlSuspenseQueryHookResult = ReturnType<typeof useGetOAuthUrlSuspenseQuery>;
export type GetOAuthUrlQueryResult = Apollo.QueryResult<GetOAuthUrlQuery, GetOAuthUrlQueryVariables>;
export const UpdateConnectionDocument = gql`
    mutation UpdateConnection($connectionId: String!, $payload: String!) {
  updateConnection(input: {connectionId: $connectionId, payload: $payload}) {
    id
    label
    integrationId
  }
}
    `;
export type UpdateConnectionMutationFn = Apollo.MutationFunction<UpdateConnectionMutation, UpdateConnectionMutationVariables>;

/**
 * __useUpdateConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConnectionMutation, { data, loading, error }] = useUpdateConnectionMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConnectionMutation, UpdateConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConnectionMutation, UpdateConnectionMutationVariables>(UpdateConnectionDocument, options);
      }
export type UpdateConnectionMutationHookResult = ReturnType<typeof useUpdateConnectionMutation>;
export type UpdateConnectionMutationResult = Apollo.MutationResult<UpdateConnectionMutation>;
export type UpdateConnectionMutationOptions = Apollo.BaseMutationOptions<UpdateConnectionMutation, UpdateConnectionMutationVariables>;
export const CreateExampleConnectionDocument = gql`
    mutation CreateExampleConnection($input: CreateExampleConnectionInput!) {
  createExampleConnection(input: $input) {
    id
    label
    integrationId
  }
}
    `;
export type CreateExampleConnectionMutationFn = Apollo.MutationFunction<CreateExampleConnectionMutation, CreateExampleConnectionMutationVariables>;

/**
 * __useCreateExampleConnectionMutation__
 *
 * To run a mutation, you first call `useCreateExampleConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExampleConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExampleConnectionMutation, { data, loading, error }] = useCreateExampleConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExampleConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateExampleConnectionMutation, CreateExampleConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExampleConnectionMutation, CreateExampleConnectionMutationVariables>(CreateExampleConnectionDocument, options);
      }
export type CreateExampleConnectionMutationHookResult = ReturnType<typeof useCreateExampleConnectionMutation>;
export type CreateExampleConnectionMutationResult = Apollo.MutationResult<CreateExampleConnectionMutation>;
export type CreateExampleConnectionMutationOptions = Apollo.BaseMutationOptions<CreateExampleConnectionMutation, CreateExampleConnectionMutationVariables>;
export const PreviewQueryDocument = gql`
    query PreviewQuery($sourceConnectionId: String!, $weldSql: String!, $dependencies: [QueryDependencyInput!]!) {
  previewQuery(
    input: {sourceConnectionId: $sourceConnectionId, weldSql: $weldSql, dependencies: $dependencies}
  ) {
    response
    dwSql
  }
}
    `;

/**
 * __usePreviewQueryQuery__
 *
 * To run a query within a React component, call `usePreviewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewQueryQuery({
 *   variables: {
 *      sourceConnectionId: // value for 'sourceConnectionId'
 *      weldSql: // value for 'weldSql'
 *      dependencies: // value for 'dependencies'
 *   },
 * });
 */
export function usePreviewQueryQuery(baseOptions: Apollo.QueryHookOptions<PreviewQueryQuery, PreviewQueryQueryVariables> & ({ variables: PreviewQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewQueryQuery, PreviewQueryQueryVariables>(PreviewQueryDocument, options);
      }
export function usePreviewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewQueryQuery, PreviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewQueryQuery, PreviewQueryQueryVariables>(PreviewQueryDocument, options);
        }
export function usePreviewQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreviewQueryQuery, PreviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewQueryQuery, PreviewQueryQueryVariables>(PreviewQueryDocument, options);
        }
export type PreviewQueryQueryHookResult = ReturnType<typeof usePreviewQueryQuery>;
export type PreviewQueryLazyQueryHookResult = ReturnType<typeof usePreviewQueryLazyQuery>;
export type PreviewQuerySuspenseQueryHookResult = ReturnType<typeof usePreviewQuerySuspenseQuery>;
export type PreviewQueryQueryResult = Apollo.QueryResult<PreviewQueryQuery, PreviewQueryQueryVariables>;
export const CreateAsyncQueryPreviewDocument = gql`
    mutation CreateAsyncQueryPreview($sourceConnectionId: ID!, $weldSql: String!, $dependencies: [QueryDependencyInput!]!) {
  createAsyncQueryPreview(
    sourceConnectionId: $sourceConnectionId
    weldSql: $weldSql
    dependencies: $dependencies
  ) {
    queryExecutionId
    dwSql
  }
}
    `;
export type CreateAsyncQueryPreviewMutationFn = Apollo.MutationFunction<CreateAsyncQueryPreviewMutation, CreateAsyncQueryPreviewMutationVariables>;

/**
 * __useCreateAsyncQueryPreviewMutation__
 *
 * To run a mutation, you first call `useCreateAsyncQueryPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAsyncQueryPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAsyncQueryPreviewMutation, { data, loading, error }] = useCreateAsyncQueryPreviewMutation({
 *   variables: {
 *      sourceConnectionId: // value for 'sourceConnectionId'
 *      weldSql: // value for 'weldSql'
 *      dependencies: // value for 'dependencies'
 *   },
 * });
 */
export function useCreateAsyncQueryPreviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateAsyncQueryPreviewMutation, CreateAsyncQueryPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAsyncQueryPreviewMutation, CreateAsyncQueryPreviewMutationVariables>(CreateAsyncQueryPreviewDocument, options);
      }
export type CreateAsyncQueryPreviewMutationHookResult = ReturnType<typeof useCreateAsyncQueryPreviewMutation>;
export type CreateAsyncQueryPreviewMutationResult = Apollo.MutationResult<CreateAsyncQueryPreviewMutation>;
export type CreateAsyncQueryPreviewMutationOptions = Apollo.BaseMutationOptions<CreateAsyncQueryPreviewMutation, CreateAsyncQueryPreviewMutationVariables>;
export const AsyncQueryPreviewResultDocument = gql`
    query AsyncQueryPreviewResult($sourceConnectionId: ID!, $queryExecutionId: ID!) {
  asyncQueryPreviewResult(
    sourceConnectionId: $sourceConnectionId
    queryExecutionId: $queryExecutionId
  ) {
    rows
    numRowsTotal
  }
}
    `;

/**
 * __useAsyncQueryPreviewResultQuery__
 *
 * To run a query within a React component, call `useAsyncQueryPreviewResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsyncQueryPreviewResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsyncQueryPreviewResultQuery({
 *   variables: {
 *      sourceConnectionId: // value for 'sourceConnectionId'
 *      queryExecutionId: // value for 'queryExecutionId'
 *   },
 * });
 */
export function useAsyncQueryPreviewResultQuery(baseOptions: Apollo.QueryHookOptions<AsyncQueryPreviewResultQuery, AsyncQueryPreviewResultQueryVariables> & ({ variables: AsyncQueryPreviewResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsyncQueryPreviewResultQuery, AsyncQueryPreviewResultQueryVariables>(AsyncQueryPreviewResultDocument, options);
      }
export function useAsyncQueryPreviewResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsyncQueryPreviewResultQuery, AsyncQueryPreviewResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsyncQueryPreviewResultQuery, AsyncQueryPreviewResultQueryVariables>(AsyncQueryPreviewResultDocument, options);
        }
export function useAsyncQueryPreviewResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AsyncQueryPreviewResultQuery, AsyncQueryPreviewResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AsyncQueryPreviewResultQuery, AsyncQueryPreviewResultQueryVariables>(AsyncQueryPreviewResultDocument, options);
        }
export type AsyncQueryPreviewResultQueryHookResult = ReturnType<typeof useAsyncQueryPreviewResultQuery>;
export type AsyncQueryPreviewResultLazyQueryHookResult = ReturnType<typeof useAsyncQueryPreviewResultLazyQuery>;
export type AsyncQueryPreviewResultSuspenseQueryHookResult = ReturnType<typeof useAsyncQueryPreviewResultSuspenseQuery>;
export type AsyncQueryPreviewResultQueryResult = Apollo.QueryResult<AsyncQueryPreviewResultQuery, AsyncQueryPreviewResultQueryVariables>;
export const AsyncQueryStatusDocument = gql`
    query AsyncQueryStatus($sourceConnectionId: ID!, $queryExecutionId: ID!) {
  asyncQueryStatus(
    sourceConnectionId: $sourceConnectionId
    queryExecutionId: $queryExecutionId
  ) {
    status
  }
}
    `;

/**
 * __useAsyncQueryStatusQuery__
 *
 * To run a query within a React component, call `useAsyncQueryStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsyncQueryStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsyncQueryStatusQuery({
 *   variables: {
 *      sourceConnectionId: // value for 'sourceConnectionId'
 *      queryExecutionId: // value for 'queryExecutionId'
 *   },
 * });
 */
export function useAsyncQueryStatusQuery(baseOptions: Apollo.QueryHookOptions<AsyncQueryStatusQuery, AsyncQueryStatusQueryVariables> & ({ variables: AsyncQueryStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsyncQueryStatusQuery, AsyncQueryStatusQueryVariables>(AsyncQueryStatusDocument, options);
      }
export function useAsyncQueryStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsyncQueryStatusQuery, AsyncQueryStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsyncQueryStatusQuery, AsyncQueryStatusQueryVariables>(AsyncQueryStatusDocument, options);
        }
export function useAsyncQueryStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AsyncQueryStatusQuery, AsyncQueryStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AsyncQueryStatusQuery, AsyncQueryStatusQueryVariables>(AsyncQueryStatusDocument, options);
        }
export type AsyncQueryStatusQueryHookResult = ReturnType<typeof useAsyncQueryStatusQuery>;
export type AsyncQueryStatusLazyQueryHookResult = ReturnType<typeof useAsyncQueryStatusLazyQuery>;
export type AsyncQueryStatusSuspenseQueryHookResult = ReturnType<typeof useAsyncQueryStatusSuspenseQuery>;
export type AsyncQueryStatusQueryResult = Apollo.QueryResult<AsyncQueryStatusQuery, AsyncQueryStatusQueryVariables>;
export const GetAllTablesDocument = gql`
    query GetAllTables($sourceConnectionId: String!) {
  getAllTables(input: $sourceConnectionId) {
    response
  }
}
    `;

/**
 * __useGetAllTablesQuery__
 *
 * To run a query within a React component, call `useGetAllTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTablesQuery({
 *   variables: {
 *      sourceConnectionId: // value for 'sourceConnectionId'
 *   },
 * });
 */
export function useGetAllTablesQuery(baseOptions: Apollo.QueryHookOptions<GetAllTablesQuery, GetAllTablesQueryVariables> & ({ variables: GetAllTablesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTablesQuery, GetAllTablesQueryVariables>(GetAllTablesDocument, options);
      }
export function useGetAllTablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTablesQuery, GetAllTablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTablesQuery, GetAllTablesQueryVariables>(GetAllTablesDocument, options);
        }
export function useGetAllTablesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllTablesQuery, GetAllTablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTablesQuery, GetAllTablesQueryVariables>(GetAllTablesDocument, options);
        }
export type GetAllTablesQueryHookResult = ReturnType<typeof useGetAllTablesQuery>;
export type GetAllTablesLazyQueryHookResult = ReturnType<typeof useGetAllTablesLazyQuery>;
export type GetAllTablesSuspenseQueryHookResult = ReturnType<typeof useGetAllTablesSuspenseQuery>;
export type GetAllTablesQueryResult = Apollo.QueryResult<GetAllTablesQuery, GetAllTablesQueryVariables>;
export const SchemasDocument = gql`
    query Schemas($sourceStreamNames: [String!]!, $sourceConnectionId: String!, $connectionSettings: JSONObject!) {
  getAllAvroSchemas(
    sourceStreamNames: $sourceStreamNames
    sourceConnectionId: $sourceConnectionId
    connectionSettings: $connectionSettings
  ) {
    schemas {
      sourceStreamName
      primaryKeys
      cursor
      fields {
        name
        type
        nullable
      }
    }
  }
}
    `;

/**
 * __useSchemasQuery__
 *
 * To run a query within a React component, call `useSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemasQuery({
 *   variables: {
 *      sourceStreamNames: // value for 'sourceStreamNames'
 *      sourceConnectionId: // value for 'sourceConnectionId'
 *      connectionSettings: // value for 'connectionSettings'
 *   },
 * });
 */
export function useSchemasQuery(baseOptions: Apollo.QueryHookOptions<SchemasQuery, SchemasQueryVariables> & ({ variables: SchemasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemasQuery, SchemasQueryVariables>(SchemasDocument, options);
      }
export function useSchemasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemasQuery, SchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemasQuery, SchemasQueryVariables>(SchemasDocument, options);
        }
export function useSchemasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchemasQuery, SchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchemasQuery, SchemasQueryVariables>(SchemasDocument, options);
        }
export type SchemasQueryHookResult = ReturnType<typeof useSchemasQuery>;
export type SchemasLazyQueryHookResult = ReturnType<typeof useSchemasLazyQuery>;
export type SchemasSuspenseQueryHookResult = ReturnType<typeof useSchemasSuspenseQuery>;
export type SchemasQueryResult = Apollo.QueryResult<SchemasQuery, SchemasQueryVariables>;
export const GetRawViewsDocument = gql`
    query GetRawViews {
  getRawViews {
    viewId
    integrationId
    weldTag
    path
    createdAt
    latestSyncTime
    schema
    sourceStream
    syncId
    scheduledJobId
    firstSyncCompleted
  }
}
    `;

/**
 * __useGetRawViewsQuery__
 *
 * To run a query within a React component, call `useGetRawViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRawViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRawViewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRawViewsQuery(baseOptions?: Apollo.QueryHookOptions<GetRawViewsQuery, GetRawViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRawViewsQuery, GetRawViewsQueryVariables>(GetRawViewsDocument, options);
      }
export function useGetRawViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRawViewsQuery, GetRawViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRawViewsQuery, GetRawViewsQueryVariables>(GetRawViewsDocument, options);
        }
export function useGetRawViewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRawViewsQuery, GetRawViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRawViewsQuery, GetRawViewsQueryVariables>(GetRawViewsDocument, options);
        }
export type GetRawViewsQueryHookResult = ReturnType<typeof useGetRawViewsQuery>;
export type GetRawViewsLazyQueryHookResult = ReturnType<typeof useGetRawViewsLazyQuery>;
export type GetRawViewsSuspenseQueryHookResult = ReturnType<typeof useGetRawViewsSuspenseQuery>;
export type GetRawViewsQueryResult = Apollo.QueryResult<GetRawViewsQuery, GetRawViewsQueryVariables>;
export const RawViewStatsDocument = gql`
    query RawViewStats {
  rawViewStats {
    total
    numFirstSyncCompleted
  }
}
    `;

/**
 * __useRawViewStatsQuery__
 *
 * To run a query within a React component, call `useRawViewStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRawViewStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRawViewStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRawViewStatsQuery(baseOptions?: Apollo.QueryHookOptions<RawViewStatsQuery, RawViewStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RawViewStatsQuery, RawViewStatsQueryVariables>(RawViewStatsDocument, options);
      }
export function useRawViewStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RawViewStatsQuery, RawViewStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RawViewStatsQuery, RawViewStatsQueryVariables>(RawViewStatsDocument, options);
        }
export function useRawViewStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RawViewStatsQuery, RawViewStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RawViewStatsQuery, RawViewStatsQueryVariables>(RawViewStatsDocument, options);
        }
export type RawViewStatsQueryHookResult = ReturnType<typeof useRawViewStatsQuery>;
export type RawViewStatsLazyQueryHookResult = ReturnType<typeof useRawViewStatsLazyQuery>;
export type RawViewStatsSuspenseQueryHookResult = ReturnType<typeof useRawViewStatsSuspenseQuery>;
export type RawViewStatsQueryResult = Apollo.QueryResult<RawViewStatsQuery, RawViewStatsQueryVariables>;
export const GetViewDetailsDocument = gql`
    query GetViewDetails($input: GetViewDetailsInput!) {
  getViewDetails(input: $input) {
    dataSchema {
      name
      type
      nullable
    }
  }
}
    `;

/**
 * __useGetViewDetailsQuery__
 *
 * To run a query within a React component, call `useGetViewDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewDetailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetViewDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetViewDetailsQuery, GetViewDetailsQueryVariables> & ({ variables: GetViewDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetViewDetailsQuery, GetViewDetailsQueryVariables>(GetViewDetailsDocument, options);
      }
export function useGetViewDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewDetailsQuery, GetViewDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetViewDetailsQuery, GetViewDetailsQueryVariables>(GetViewDetailsDocument, options);
        }
export function useGetViewDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetViewDetailsQuery, GetViewDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetViewDetailsQuery, GetViewDetailsQueryVariables>(GetViewDetailsDocument, options);
        }
export type GetViewDetailsQueryHookResult = ReturnType<typeof useGetViewDetailsQuery>;
export type GetViewDetailsLazyQueryHookResult = ReturnType<typeof useGetViewDetailsLazyQuery>;
export type GetViewDetailsSuspenseQueryHookResult = ReturnType<typeof useGetViewDetailsSuspenseQuery>;
export type GetViewDetailsQueryResult = Apollo.QueryResult<GetViewDetailsQuery, GetViewDetailsQueryVariables>;
export const GetStreamsDocument = gql`
    query GetStreams($connectionId: String!, $sourceSettings: JSONObject!, $eltSyncId: String) {
  getStreams(
    connectionId: $connectionId
    sourceSettings: $sourceSettings
    eltSyncId: $eltSyncId
  ) {
    name
    supportedModes
    configurableIncremental
    defaultConfig
    selectable
    notSelectableExplanation
    preselect
    substreams {
      id
      destinationTableName
      avroSchema
    }
  }
}
    `;

/**
 * __useGetStreamsQuery__
 *
 * To run a query within a React component, call `useGetStreamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStreamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStreamsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      sourceSettings: // value for 'sourceSettings'
 *      eltSyncId: // value for 'eltSyncId'
 *   },
 * });
 */
export function useGetStreamsQuery(baseOptions: Apollo.QueryHookOptions<GetStreamsQuery, GetStreamsQueryVariables> & ({ variables: GetStreamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStreamsQuery, GetStreamsQueryVariables>(GetStreamsDocument, options);
      }
export function useGetStreamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStreamsQuery, GetStreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStreamsQuery, GetStreamsQueryVariables>(GetStreamsDocument, options);
        }
export function useGetStreamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStreamsQuery, GetStreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStreamsQuery, GetStreamsQueryVariables>(GetStreamsDocument, options);
        }
export type GetStreamsQueryHookResult = ReturnType<typeof useGetStreamsQuery>;
export type GetStreamsLazyQueryHookResult = ReturnType<typeof useGetStreamsLazyQuery>;
export type GetStreamsSuspenseQueryHookResult = ReturnType<typeof useGetStreamsSuspenseQuery>;
export type GetStreamsQueryResult = Apollo.QueryResult<GetStreamsQuery, GetStreamsQueryVariables>;
export const GetStreamsAsyncDocument = gql`
    query GetStreamsAsync($connectionId: String!, $sourceSettings: JSONObject!) {
  getStreamsAsync(connectionId: $connectionId, sourceSettings: $sourceSettings) {
    errorMessage
    status
    startedAt
    streams {
      name
      supportedModes
      configurableIncremental
      defaultConfig
      selectable
      notSelectableExplanation
      preselect
      substreams {
        id
        destinationTableName
        avroSchema
      }
    }
  }
}
    `;

/**
 * __useGetStreamsAsyncQuery__
 *
 * To run a query within a React component, call `useGetStreamsAsyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStreamsAsyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStreamsAsyncQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      sourceSettings: // value for 'sourceSettings'
 *   },
 * });
 */
export function useGetStreamsAsyncQuery(baseOptions: Apollo.QueryHookOptions<GetStreamsAsyncQuery, GetStreamsAsyncQueryVariables> & ({ variables: GetStreamsAsyncQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStreamsAsyncQuery, GetStreamsAsyncQueryVariables>(GetStreamsAsyncDocument, options);
      }
export function useGetStreamsAsyncLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStreamsAsyncQuery, GetStreamsAsyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStreamsAsyncQuery, GetStreamsAsyncQueryVariables>(GetStreamsAsyncDocument, options);
        }
export function useGetStreamsAsyncSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStreamsAsyncQuery, GetStreamsAsyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStreamsAsyncQuery, GetStreamsAsyncQueryVariables>(GetStreamsAsyncDocument, options);
        }
export type GetStreamsAsyncQueryHookResult = ReturnType<typeof useGetStreamsAsyncQuery>;
export type GetStreamsAsyncLazyQueryHookResult = ReturnType<typeof useGetStreamsAsyncLazyQuery>;
export type GetStreamsAsyncSuspenseQueryHookResult = ReturnType<typeof useGetStreamsAsyncSuspenseQuery>;
export type GetStreamsAsyncQueryResult = Apollo.QueryResult<GetStreamsAsyncQuery, GetStreamsAsyncQueryVariables>;
export const GetStreamsAsyncJobStatusDocument = gql`
    query GetStreamsAsyncJobStatus($connectionId: String!) {
  getStreamsAsyncJobStatus(connectionId: $connectionId) {
    errorMessage
    status
    startedAt
    streams {
      name
      supportedModes
      configurableIncremental
      defaultConfig
      selectable
      notSelectableExplanation
      substreams {
        id
        destinationTableName
        avroSchema
      }
    }
  }
}
    `;

/**
 * __useGetStreamsAsyncJobStatusQuery__
 *
 * To run a query within a React component, call `useGetStreamsAsyncJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStreamsAsyncJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStreamsAsyncJobStatusQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useGetStreamsAsyncJobStatusQuery(baseOptions: Apollo.QueryHookOptions<GetStreamsAsyncJobStatusQuery, GetStreamsAsyncJobStatusQueryVariables> & ({ variables: GetStreamsAsyncJobStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStreamsAsyncJobStatusQuery, GetStreamsAsyncJobStatusQueryVariables>(GetStreamsAsyncJobStatusDocument, options);
      }
export function useGetStreamsAsyncJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStreamsAsyncJobStatusQuery, GetStreamsAsyncJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStreamsAsyncJobStatusQuery, GetStreamsAsyncJobStatusQueryVariables>(GetStreamsAsyncJobStatusDocument, options);
        }
export function useGetStreamsAsyncJobStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStreamsAsyncJobStatusQuery, GetStreamsAsyncJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStreamsAsyncJobStatusQuery, GetStreamsAsyncJobStatusQueryVariables>(GetStreamsAsyncJobStatusDocument, options);
        }
export type GetStreamsAsyncJobStatusQueryHookResult = ReturnType<typeof useGetStreamsAsyncJobStatusQuery>;
export type GetStreamsAsyncJobStatusLazyQueryHookResult = ReturnType<typeof useGetStreamsAsyncJobStatusLazyQuery>;
export type GetStreamsAsyncJobStatusSuspenseQueryHookResult = ReturnType<typeof useGetStreamsAsyncJobStatusSuspenseQuery>;
export type GetStreamsAsyncJobStatusQueryResult = Apollo.QueryResult<GetStreamsAsyncJobStatusQuery, GetStreamsAsyncJobStatusQueryVariables>;
export const CancelStreamsAsyncJobDocument = gql`
    mutation CancelStreamsAsyncJob($connectionId: String!) {
  cancelStreamsAsyncJob(connectionId: $connectionId) {
    errorMessage
    status
    startedAt
    streams {
      name
      supportedModes
      configurableIncremental
      defaultConfig
      selectable
      notSelectableExplanation
      substreams {
        id
        destinationTableName
        avroSchema
      }
    }
  }
}
    `;
export type CancelStreamsAsyncJobMutationFn = Apollo.MutationFunction<CancelStreamsAsyncJobMutation, CancelStreamsAsyncJobMutationVariables>;

/**
 * __useCancelStreamsAsyncJobMutation__
 *
 * To run a mutation, you first call `useCancelStreamsAsyncJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelStreamsAsyncJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelStreamsAsyncJobMutation, { data, loading, error }] = useCancelStreamsAsyncJobMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useCancelStreamsAsyncJobMutation(baseOptions?: Apollo.MutationHookOptions<CancelStreamsAsyncJobMutation, CancelStreamsAsyncJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelStreamsAsyncJobMutation, CancelStreamsAsyncJobMutationVariables>(CancelStreamsAsyncJobDocument, options);
      }
export type CancelStreamsAsyncJobMutationHookResult = ReturnType<typeof useCancelStreamsAsyncJobMutation>;
export type CancelStreamsAsyncJobMutationResult = Apollo.MutationResult<CancelStreamsAsyncJobMutation>;
export type CancelStreamsAsyncJobMutationOptions = Apollo.BaseMutationOptions<CancelStreamsAsyncJobMutation, CancelStreamsAsyncJobMutationVariables>;
export const SourceStreamsWithSubStreamsDocument = gql`
    query SourceStreamsWithSubStreams($connectionId: String!, $eltSyncId: String!, $sourceStreamNames: [String!]!) {
  sourceStreamsWithSubStreams(
    connectionId: $connectionId
    eltSyncId: $eltSyncId
    sourceStreamNames: $sourceStreamNames
  ) {
    name
    supportedModes
    configurableIncremental
    defaultConfig
    substreams {
      id
      destinationTableName
    }
  }
}
    `;

/**
 * __useSourceStreamsWithSubStreamsQuery__
 *
 * To run a query within a React component, call `useSourceStreamsWithSubStreamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceStreamsWithSubStreamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceStreamsWithSubStreamsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      eltSyncId: // value for 'eltSyncId'
 *      sourceStreamNames: // value for 'sourceStreamNames'
 *   },
 * });
 */
export function useSourceStreamsWithSubStreamsQuery(baseOptions: Apollo.QueryHookOptions<SourceStreamsWithSubStreamsQuery, SourceStreamsWithSubStreamsQueryVariables> & ({ variables: SourceStreamsWithSubStreamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourceStreamsWithSubStreamsQuery, SourceStreamsWithSubStreamsQueryVariables>(SourceStreamsWithSubStreamsDocument, options);
      }
export function useSourceStreamsWithSubStreamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourceStreamsWithSubStreamsQuery, SourceStreamsWithSubStreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourceStreamsWithSubStreamsQuery, SourceStreamsWithSubStreamsQueryVariables>(SourceStreamsWithSubStreamsDocument, options);
        }
export function useSourceStreamsWithSubStreamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SourceStreamsWithSubStreamsQuery, SourceStreamsWithSubStreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SourceStreamsWithSubStreamsQuery, SourceStreamsWithSubStreamsQueryVariables>(SourceStreamsWithSubStreamsDocument, options);
        }
export type SourceStreamsWithSubStreamsQueryHookResult = ReturnType<typeof useSourceStreamsWithSubStreamsQuery>;
export type SourceStreamsWithSubStreamsLazyQueryHookResult = ReturnType<typeof useSourceStreamsWithSubStreamsLazyQuery>;
export type SourceStreamsWithSubStreamsSuspenseQueryHookResult = ReturnType<typeof useSourceStreamsWithSubStreamsSuspenseQuery>;
export type SourceStreamsWithSubStreamsQueryResult = Apollo.QueryResult<SourceStreamsWithSubStreamsQuery, SourceStreamsWithSubStreamsQueryVariables>;
export const GetCustomFormValuesDocument = gql`
    query GetCustomFormValues($input: CustomFormInput!) {
  getCustomFormValues(input: $input) {
    customFormValues
  }
}
    `;

/**
 * __useGetCustomFormValuesQuery__
 *
 * To run a query within a React component, call `useGetCustomFormValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomFormValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomFormValuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCustomFormValuesQuery(baseOptions: Apollo.QueryHookOptions<GetCustomFormValuesQuery, GetCustomFormValuesQueryVariables> & ({ variables: GetCustomFormValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomFormValuesQuery, GetCustomFormValuesQueryVariables>(GetCustomFormValuesDocument, options);
      }
export function useGetCustomFormValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomFormValuesQuery, GetCustomFormValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomFormValuesQuery, GetCustomFormValuesQueryVariables>(GetCustomFormValuesDocument, options);
        }
export function useGetCustomFormValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomFormValuesQuery, GetCustomFormValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomFormValuesQuery, GetCustomFormValuesQueryVariables>(GetCustomFormValuesDocument, options);
        }
export type GetCustomFormValuesQueryHookResult = ReturnType<typeof useGetCustomFormValuesQuery>;
export type GetCustomFormValuesLazyQueryHookResult = ReturnType<typeof useGetCustomFormValuesLazyQuery>;
export type GetCustomFormValuesSuspenseQueryHookResult = ReturnType<typeof useGetCustomFormValuesSuspenseQuery>;
export type GetCustomFormValuesQueryResult = Apollo.QueryResult<GetCustomFormValuesQuery, GetCustomFormValuesQueryVariables>;
export const ValidateCustomFormDocument = gql`
    query ValidateCustomForm($input: CustomFormValidationInput!) {
  validateCustomForm(input: $input) {
    customFormValidationResult
  }
}
    `;

/**
 * __useValidateCustomFormQuery__
 *
 * To run a query within a React component, call `useValidateCustomFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCustomFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCustomFormQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateCustomFormQuery(baseOptions: Apollo.QueryHookOptions<ValidateCustomFormQuery, ValidateCustomFormQueryVariables> & ({ variables: ValidateCustomFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateCustomFormQuery, ValidateCustomFormQueryVariables>(ValidateCustomFormDocument, options);
      }
export function useValidateCustomFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateCustomFormQuery, ValidateCustomFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateCustomFormQuery, ValidateCustomFormQueryVariables>(ValidateCustomFormDocument, options);
        }
export function useValidateCustomFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateCustomFormQuery, ValidateCustomFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateCustomFormQuery, ValidateCustomFormQueryVariables>(ValidateCustomFormDocument, options);
        }
export type ValidateCustomFormQueryHookResult = ReturnType<typeof useValidateCustomFormQuery>;
export type ValidateCustomFormLazyQueryHookResult = ReturnType<typeof useValidateCustomFormLazyQuery>;
export type ValidateCustomFormSuspenseQueryHookResult = ReturnType<typeof useValidateCustomFormSuspenseQuery>;
export type ValidateCustomFormQueryResult = Apollo.QueryResult<ValidateCustomFormQuery, ValidateCustomFormQueryVariables>;
export const OnboardingConnectionPreferencesDocument = gql`
    query OnboardingConnectionPreferences {
  getOnboardingConnections {
    integrationId
  }
}
    `;

/**
 * __useOnboardingConnectionPreferencesQuery__
 *
 * To run a query within a React component, call `useOnboardingConnectionPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingConnectionPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingConnectionPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingConnectionPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingConnectionPreferencesQuery, OnboardingConnectionPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingConnectionPreferencesQuery, OnboardingConnectionPreferencesQueryVariables>(OnboardingConnectionPreferencesDocument, options);
      }
export function useOnboardingConnectionPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingConnectionPreferencesQuery, OnboardingConnectionPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingConnectionPreferencesQuery, OnboardingConnectionPreferencesQueryVariables>(OnboardingConnectionPreferencesDocument, options);
        }
export function useOnboardingConnectionPreferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnboardingConnectionPreferencesQuery, OnboardingConnectionPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingConnectionPreferencesQuery, OnboardingConnectionPreferencesQueryVariables>(OnboardingConnectionPreferencesDocument, options);
        }
export type OnboardingConnectionPreferencesQueryHookResult = ReturnType<typeof useOnboardingConnectionPreferencesQuery>;
export type OnboardingConnectionPreferencesLazyQueryHookResult = ReturnType<typeof useOnboardingConnectionPreferencesLazyQuery>;
export type OnboardingConnectionPreferencesSuspenseQueryHookResult = ReturnType<typeof useOnboardingConnectionPreferencesSuspenseQuery>;
export type OnboardingConnectionPreferencesQueryResult = Apollo.QueryResult<OnboardingConnectionPreferencesQuery, OnboardingConnectionPreferencesQueryVariables>;
export const PendingOnboardingConnectionsDocument = gql`
    query PendingOnboardingConnections {
  getPendingOnboardingConnections {
    integrationId
  }
}
    `;

/**
 * __usePendingOnboardingConnectionsQuery__
 *
 * To run a query within a React component, call `usePendingOnboardingConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingOnboardingConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingOnboardingConnectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePendingOnboardingConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<PendingOnboardingConnectionsQuery, PendingOnboardingConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingOnboardingConnectionsQuery, PendingOnboardingConnectionsQueryVariables>(PendingOnboardingConnectionsDocument, options);
      }
export function usePendingOnboardingConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingOnboardingConnectionsQuery, PendingOnboardingConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingOnboardingConnectionsQuery, PendingOnboardingConnectionsQueryVariables>(PendingOnboardingConnectionsDocument, options);
        }
export function usePendingOnboardingConnectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PendingOnboardingConnectionsQuery, PendingOnboardingConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PendingOnboardingConnectionsQuery, PendingOnboardingConnectionsQueryVariables>(PendingOnboardingConnectionsDocument, options);
        }
export type PendingOnboardingConnectionsQueryHookResult = ReturnType<typeof usePendingOnboardingConnectionsQuery>;
export type PendingOnboardingConnectionsLazyQueryHookResult = ReturnType<typeof usePendingOnboardingConnectionsLazyQuery>;
export type PendingOnboardingConnectionsSuspenseQueryHookResult = ReturnType<typeof usePendingOnboardingConnectionsSuspenseQuery>;
export type PendingOnboardingConnectionsQueryResult = Apollo.QueryResult<PendingOnboardingConnectionsQuery, PendingOnboardingConnectionsQueryVariables>;
export const SetOnboardingConnectionPreferencesDocument = gql`
    mutation SetOnboardingConnectionPreferences($accountId: String!, $integrationIds: [String!]!) {
  setOnboardingConnections(accountId: $accountId, integrationIds: $integrationIds) {
    integrationId
  }
}
    `;
export type SetOnboardingConnectionPreferencesMutationFn = Apollo.MutationFunction<SetOnboardingConnectionPreferencesMutation, SetOnboardingConnectionPreferencesMutationVariables>;

/**
 * __useSetOnboardingConnectionPreferencesMutation__
 *
 * To run a mutation, you first call `useSetOnboardingConnectionPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOnboardingConnectionPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOnboardingConnectionPreferencesMutation, { data, loading, error }] = useSetOnboardingConnectionPreferencesMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      integrationIds: // value for 'integrationIds'
 *   },
 * });
 */
export function useSetOnboardingConnectionPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<SetOnboardingConnectionPreferencesMutation, SetOnboardingConnectionPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOnboardingConnectionPreferencesMutation, SetOnboardingConnectionPreferencesMutationVariables>(SetOnboardingConnectionPreferencesDocument, options);
      }
export type SetOnboardingConnectionPreferencesMutationHookResult = ReturnType<typeof useSetOnboardingConnectionPreferencesMutation>;
export type SetOnboardingConnectionPreferencesMutationResult = Apollo.MutationResult<SetOnboardingConnectionPreferencesMutation>;
export type SetOnboardingConnectionPreferencesMutationOptions = Apollo.BaseMutationOptions<SetOnboardingConnectionPreferencesMutation, SetOnboardingConnectionPreferencesMutationVariables>;
export const DeleteOnboardingConnectionPreferenceDocument = gql`
    mutation DeleteOnboardingConnectionPreference($integrationId: String!) {
  deleteOnboardingConnection(integrationId: $integrationId)
}
    `;
export type DeleteOnboardingConnectionPreferenceMutationFn = Apollo.MutationFunction<DeleteOnboardingConnectionPreferenceMutation, DeleteOnboardingConnectionPreferenceMutationVariables>;

/**
 * __useDeleteOnboardingConnectionPreferenceMutation__
 *
 * To run a mutation, you first call `useDeleteOnboardingConnectionPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOnboardingConnectionPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOnboardingConnectionPreferenceMutation, { data, loading, error }] = useDeleteOnboardingConnectionPreferenceMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useDeleteOnboardingConnectionPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOnboardingConnectionPreferenceMutation, DeleteOnboardingConnectionPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOnboardingConnectionPreferenceMutation, DeleteOnboardingConnectionPreferenceMutationVariables>(DeleteOnboardingConnectionPreferenceDocument, options);
      }
export type DeleteOnboardingConnectionPreferenceMutationHookResult = ReturnType<typeof useDeleteOnboardingConnectionPreferenceMutation>;
export type DeleteOnboardingConnectionPreferenceMutationResult = Apollo.MutationResult<DeleteOnboardingConnectionPreferenceMutation>;
export type DeleteOnboardingConnectionPreferenceMutationOptions = Apollo.BaseMutationOptions<DeleteOnboardingConnectionPreferenceMutation, DeleteOnboardingConnectionPreferenceMutationVariables>;
export const GenerateConnectionLabelDocument = gql`
    query GenerateConnectionLabel($baseLabel: String!) {
  generateConnectionLabel(baseLabel: $baseLabel)
}
    `;

/**
 * __useGenerateConnectionLabelQuery__
 *
 * To run a query within a React component, call `useGenerateConnectionLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateConnectionLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateConnectionLabelQuery({
 *   variables: {
 *      baseLabel: // value for 'baseLabel'
 *   },
 * });
 */
export function useGenerateConnectionLabelQuery(baseOptions: Apollo.QueryHookOptions<GenerateConnectionLabelQuery, GenerateConnectionLabelQueryVariables> & ({ variables: GenerateConnectionLabelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateConnectionLabelQuery, GenerateConnectionLabelQueryVariables>(GenerateConnectionLabelDocument, options);
      }
export function useGenerateConnectionLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateConnectionLabelQuery, GenerateConnectionLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateConnectionLabelQuery, GenerateConnectionLabelQueryVariables>(GenerateConnectionLabelDocument, options);
        }
export function useGenerateConnectionLabelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GenerateConnectionLabelQuery, GenerateConnectionLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateConnectionLabelQuery, GenerateConnectionLabelQueryVariables>(GenerateConnectionLabelDocument, options);
        }
export type GenerateConnectionLabelQueryHookResult = ReturnType<typeof useGenerateConnectionLabelQuery>;
export type GenerateConnectionLabelLazyQueryHookResult = ReturnType<typeof useGenerateConnectionLabelLazyQuery>;
export type GenerateConnectionLabelSuspenseQueryHookResult = ReturnType<typeof useGenerateConnectionLabelSuspenseQuery>;
export type GenerateConnectionLabelQueryResult = Apollo.QueryResult<GenerateConnectionLabelQuery, GenerateConnectionLabelQueryVariables>;
export const StartDatawarehouseMigrationDocument = gql`
    mutation StartDatawarehouseMigration($createConnectionInput: CreateConnectionInput!) {
  startDatawarehouseMigration(createConnectionInput: $createConnectionInput) {
    id
    userId
    accountId
    status
    errorMessage
    createdAt
    pendingSyncs
    prevDWIntegrationId
  }
}
    `;
export type StartDatawarehouseMigrationMutationFn = Apollo.MutationFunction<StartDatawarehouseMigrationMutation, StartDatawarehouseMigrationMutationVariables>;

/**
 * __useStartDatawarehouseMigrationMutation__
 *
 * To run a mutation, you first call `useStartDatawarehouseMigrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartDatawarehouseMigrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startDatawarehouseMigrationMutation, { data, loading, error }] = useStartDatawarehouseMigrationMutation({
 *   variables: {
 *      createConnectionInput: // value for 'createConnectionInput'
 *   },
 * });
 */
export function useStartDatawarehouseMigrationMutation(baseOptions?: Apollo.MutationHookOptions<StartDatawarehouseMigrationMutation, StartDatawarehouseMigrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartDatawarehouseMigrationMutation, StartDatawarehouseMigrationMutationVariables>(StartDatawarehouseMigrationDocument, options);
      }
export type StartDatawarehouseMigrationMutationHookResult = ReturnType<typeof useStartDatawarehouseMigrationMutation>;
export type StartDatawarehouseMigrationMutationResult = Apollo.MutationResult<StartDatawarehouseMigrationMutation>;
export type StartDatawarehouseMigrationMutationOptions = Apollo.BaseMutationOptions<StartDatawarehouseMigrationMutation, StartDatawarehouseMigrationMutationVariables>;
export const DatawarehouseMigrationDocument = gql`
    query DatawarehouseMigration {
  datawarehouseMigration {
    id
    userId
    accountId
    status
    errorMessage
    createdAt
    pendingSyncs
    prevDWIntegrationId
  }
}
    `;

/**
 * __useDatawarehouseMigrationQuery__
 *
 * To run a query within a React component, call `useDatawarehouseMigrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatawarehouseMigrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatawarehouseMigrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useDatawarehouseMigrationQuery(baseOptions?: Apollo.QueryHookOptions<DatawarehouseMigrationQuery, DatawarehouseMigrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatawarehouseMigrationQuery, DatawarehouseMigrationQueryVariables>(DatawarehouseMigrationDocument, options);
      }
export function useDatawarehouseMigrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatawarehouseMigrationQuery, DatawarehouseMigrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatawarehouseMigrationQuery, DatawarehouseMigrationQueryVariables>(DatawarehouseMigrationDocument, options);
        }
export function useDatawarehouseMigrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DatawarehouseMigrationQuery, DatawarehouseMigrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DatawarehouseMigrationQuery, DatawarehouseMigrationQueryVariables>(DatawarehouseMigrationDocument, options);
        }
export type DatawarehouseMigrationQueryHookResult = ReturnType<typeof useDatawarehouseMigrationQuery>;
export type DatawarehouseMigrationLazyQueryHookResult = ReturnType<typeof useDatawarehouseMigrationLazyQuery>;
export type DatawarehouseMigrationSuspenseQueryHookResult = ReturnType<typeof useDatawarehouseMigrationSuspenseQuery>;
export type DatawarehouseMigrationQueryResult = Apollo.QueryResult<DatawarehouseMigrationQuery, DatawarehouseMigrationQueryVariables>;
export const CreateEltSyncDocument = gql`
    mutation CreateEltSync($sourceConnectionId: String!, $destinationConnectionId: String!, $syncInterval: String, $sourceStreams: [SourceStreamInput!]!, $startDate: DateTime, $config: String, $destinationSchemaName: String, $schedulerType: OrchestrationSchedulerType, $orchestrationWorkflowId: ID) {
  createEltSync(
    input: {sourceConnectionId: $sourceConnectionId, destinationConnectionId: $destinationConnectionId, sourceStreams: $sourceStreams, startDate: $startDate, config: $config, destinationSchemaName: $destinationSchemaName, schedulerType: $schedulerType, syncInterval: $syncInterval, orchestrationWorkflowId: $orchestrationWorkflowId}
  ) {
    id
    sourceConnectionId
    destinationConnectionId
    destinationSchemaName
  }
}
    `;
export type CreateEltSyncMutationFn = Apollo.MutationFunction<CreateEltSyncMutation, CreateEltSyncMutationVariables>;

/**
 * __useCreateEltSyncMutation__
 *
 * To run a mutation, you first call `useCreateEltSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEltSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEltSyncMutation, { data, loading, error }] = useCreateEltSyncMutation({
 *   variables: {
 *      sourceConnectionId: // value for 'sourceConnectionId'
 *      destinationConnectionId: // value for 'destinationConnectionId'
 *      syncInterval: // value for 'syncInterval'
 *      sourceStreams: // value for 'sourceStreams'
 *      startDate: // value for 'startDate'
 *      config: // value for 'config'
 *      destinationSchemaName: // value for 'destinationSchemaName'
 *      schedulerType: // value for 'schedulerType'
 *      orchestrationWorkflowId: // value for 'orchestrationWorkflowId'
 *   },
 * });
 */
export function useCreateEltSyncMutation(baseOptions?: Apollo.MutationHookOptions<CreateEltSyncMutation, CreateEltSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEltSyncMutation, CreateEltSyncMutationVariables>(CreateEltSyncDocument, options);
      }
export type CreateEltSyncMutationHookResult = ReturnType<typeof useCreateEltSyncMutation>;
export type CreateEltSyncMutationResult = Apollo.MutationResult<CreateEltSyncMutation>;
export type CreateEltSyncMutationOptions = Apollo.BaseMutationOptions<CreateEltSyncMutation, CreateEltSyncMutationVariables>;
export const UpdateEltSyncDocument = gql`
    mutation UpdateEltSync($eltSyncId: String!, $syncInterval: String, $sourceStreams: [SourceStreamInput!]!, $config: String, $schedulerType: OrchestrationSchedulerType!, $orchestrationWorkflowId: ID) {
  updateEltSync(
    input: {eltSyncId: $eltSyncId, syncInterval: $syncInterval, sourceStreams: $sourceStreams, config: $config, schedulerType: $schedulerType, orchestrationWorkflowId: $orchestrationWorkflowId}
  ) {
    id
    sourceConnectionId
    destinationConnectionId
  }
}
    `;
export type UpdateEltSyncMutationFn = Apollo.MutationFunction<UpdateEltSyncMutation, UpdateEltSyncMutationVariables>;

/**
 * __useUpdateEltSyncMutation__
 *
 * To run a mutation, you first call `useUpdateEltSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEltSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEltSyncMutation, { data, loading, error }] = useUpdateEltSyncMutation({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *      syncInterval: // value for 'syncInterval'
 *      sourceStreams: // value for 'sourceStreams'
 *      config: // value for 'config'
 *      schedulerType: // value for 'schedulerType'
 *      orchestrationWorkflowId: // value for 'orchestrationWorkflowId'
 *   },
 * });
 */
export function useUpdateEltSyncMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEltSyncMutation, UpdateEltSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEltSyncMutation, UpdateEltSyncMutationVariables>(UpdateEltSyncDocument, options);
      }
export type UpdateEltSyncMutationHookResult = ReturnType<typeof useUpdateEltSyncMutation>;
export type UpdateEltSyncMutationResult = Apollo.MutationResult<UpdateEltSyncMutation>;
export type UpdateEltSyncMutationOptions = Apollo.BaseMutationOptions<UpdateEltSyncMutation, UpdateEltSyncMutationVariables>;
export const StartEltSyncDocument = gql`
    mutation StartEltSync($eltSyncId: String!) {
  startEltSync(input: {eltSyncId: $eltSyncId}) {
    id
    active
  }
}
    `;
export type StartEltSyncMutationFn = Apollo.MutationFunction<StartEltSyncMutation, StartEltSyncMutationVariables>;

/**
 * __useStartEltSyncMutation__
 *
 * To run a mutation, you first call `useStartEltSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartEltSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startEltSyncMutation, { data, loading, error }] = useStartEltSyncMutation({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *   },
 * });
 */
export function useStartEltSyncMutation(baseOptions?: Apollo.MutationHookOptions<StartEltSyncMutation, StartEltSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartEltSyncMutation, StartEltSyncMutationVariables>(StartEltSyncDocument, options);
      }
export type StartEltSyncMutationHookResult = ReturnType<typeof useStartEltSyncMutation>;
export type StartEltSyncMutationResult = Apollo.MutationResult<StartEltSyncMutation>;
export type StartEltSyncMutationOptions = Apollo.BaseMutationOptions<StartEltSyncMutation, StartEltSyncMutationVariables>;
export const StopEltSyncDocument = gql`
    mutation StopEltSync($eltSyncId: String!) {
  stopEltSync(input: {eltSyncId: $eltSyncId}) {
    id
    active
  }
}
    `;
export type StopEltSyncMutationFn = Apollo.MutationFunction<StopEltSyncMutation, StopEltSyncMutationVariables>;

/**
 * __useStopEltSyncMutation__
 *
 * To run a mutation, you first call `useStopEltSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopEltSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopEltSyncMutation, { data, loading, error }] = useStopEltSyncMutation({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *   },
 * });
 */
export function useStopEltSyncMutation(baseOptions?: Apollo.MutationHookOptions<StopEltSyncMutation, StopEltSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopEltSyncMutation, StopEltSyncMutationVariables>(StopEltSyncDocument, options);
      }
export type StopEltSyncMutationHookResult = ReturnType<typeof useStopEltSyncMutation>;
export type StopEltSyncMutationResult = Apollo.MutationResult<StopEltSyncMutation>;
export type StopEltSyncMutationOptions = Apollo.BaseMutationOptions<StopEltSyncMutation, StopEltSyncMutationVariables>;
export const RemoveEltSyncDocument = gql`
    mutation RemoveEltSync($eltSyncId: String!, $removeDataReferences: Boolean) {
  removeEltSync(
    input: {eltSyncId: $eltSyncId, removeDataReferences: $removeDataReferences}
  ) {
    id
  }
}
    `;
export type RemoveEltSyncMutationFn = Apollo.MutationFunction<RemoveEltSyncMutation, RemoveEltSyncMutationVariables>;

/**
 * __useRemoveEltSyncMutation__
 *
 * To run a mutation, you first call `useRemoveEltSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEltSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEltSyncMutation, { data, loading, error }] = useRemoveEltSyncMutation({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *      removeDataReferences: // value for 'removeDataReferences'
 *   },
 * });
 */
export function useRemoveEltSyncMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEltSyncMutation, RemoveEltSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEltSyncMutation, RemoveEltSyncMutationVariables>(RemoveEltSyncDocument, options);
      }
export type RemoveEltSyncMutationHookResult = ReturnType<typeof useRemoveEltSyncMutation>;
export type RemoveEltSyncMutationResult = Apollo.MutationResult<RemoveEltSyncMutation>;
export type RemoveEltSyncMutationOptions = Apollo.BaseMutationOptions<RemoveEltSyncMutation, RemoveEltSyncMutationVariables>;
export const RemoveTableFromSyncDocument = gql`
    mutation RemoveTableFromSync($sourceStreamName: String!, $syncId: String!, $viewId: String) {
  removeTableFromSync(
    input: {sourceStreamName: $sourceStreamName, syncId: $syncId, viewId: $viewId}
  ) {
    sourceStreamName
  }
}
    `;
export type RemoveTableFromSyncMutationFn = Apollo.MutationFunction<RemoveTableFromSyncMutation, RemoveTableFromSyncMutationVariables>;

/**
 * __useRemoveTableFromSyncMutation__
 *
 * To run a mutation, you first call `useRemoveTableFromSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTableFromSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTableFromSyncMutation, { data, loading, error }] = useRemoveTableFromSyncMutation({
 *   variables: {
 *      sourceStreamName: // value for 'sourceStreamName'
 *      syncId: // value for 'syncId'
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useRemoveTableFromSyncMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTableFromSyncMutation, RemoveTableFromSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTableFromSyncMutation, RemoveTableFromSyncMutationVariables>(RemoveTableFromSyncDocument, options);
      }
export type RemoveTableFromSyncMutationHookResult = ReturnType<typeof useRemoveTableFromSyncMutation>;
export type RemoveTableFromSyncMutationResult = Apollo.MutationResult<RemoveTableFromSyncMutation>;
export type RemoveTableFromSyncMutationOptions = Apollo.BaseMutationOptions<RemoveTableFromSyncMutation, RemoveTableFromSyncMutationVariables>;
export const EltSyncsDocument = gql`
    query EltSyncs {
  eltSyncs {
    id
    active
    status
    syncInterval
    sourceIntegrationId
    destinationIntegrationId
    createdAt
    destinationSchemaName
    schedulerType
    sourceConnectionId
    sourceStreams {
      name
    }
    sourceConnection {
      label
      id
    }
    destinationConnection {
      label
      id
    }
    schedulerType
    orchestrationWorkflow {
      id
      cronExpression
    }
  }
}
    `;

/**
 * __useEltSyncsQuery__
 *
 * To run a query within a React component, call `useEltSyncsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltSyncsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltSyncsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEltSyncsQuery(baseOptions?: Apollo.QueryHookOptions<EltSyncsQuery, EltSyncsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltSyncsQuery, EltSyncsQueryVariables>(EltSyncsDocument, options);
      }
export function useEltSyncsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltSyncsQuery, EltSyncsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltSyncsQuery, EltSyncsQueryVariables>(EltSyncsDocument, options);
        }
export function useEltSyncsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltSyncsQuery, EltSyncsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltSyncsQuery, EltSyncsQueryVariables>(EltSyncsDocument, options);
        }
export type EltSyncsQueryHookResult = ReturnType<typeof useEltSyncsQuery>;
export type EltSyncsLazyQueryHookResult = ReturnType<typeof useEltSyncsLazyQuery>;
export type EltSyncsSuspenseQueryHookResult = ReturnType<typeof useEltSyncsSuspenseQuery>;
export type EltSyncsQueryResult = Apollo.QueryResult<EltSyncsQuery, EltSyncsQueryVariables>;
export const SetNextSyncToFullSyncDocument = gql`
    mutation SetNextSyncToFullSync($sourceStreamId: String!, $forceFullSync: Boolean!) {
  setNextSyncToFullSync(
    sourceStreamId: $sourceStreamId
    forceFullSync: $forceFullSync
  ) {
    job {
      forceFullSync
    }
  }
}
    `;
export type SetNextSyncToFullSyncMutationFn = Apollo.MutationFunction<SetNextSyncToFullSyncMutation, SetNextSyncToFullSyncMutationVariables>;

/**
 * __useSetNextSyncToFullSyncMutation__
 *
 * To run a mutation, you first call `useSetNextSyncToFullSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNextSyncToFullSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNextSyncToFullSyncMutation, { data, loading, error }] = useSetNextSyncToFullSyncMutation({
 *   variables: {
 *      sourceStreamId: // value for 'sourceStreamId'
 *      forceFullSync: // value for 'forceFullSync'
 *   },
 * });
 */
export function useSetNextSyncToFullSyncMutation(baseOptions?: Apollo.MutationHookOptions<SetNextSyncToFullSyncMutation, SetNextSyncToFullSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNextSyncToFullSyncMutation, SetNextSyncToFullSyncMutationVariables>(SetNextSyncToFullSyncDocument, options);
      }
export type SetNextSyncToFullSyncMutationHookResult = ReturnType<typeof useSetNextSyncToFullSyncMutation>;
export type SetNextSyncToFullSyncMutationResult = Apollo.MutationResult<SetNextSyncToFullSyncMutation>;
export type SetNextSyncToFullSyncMutationOptions = Apollo.BaseMutationOptions<SetNextSyncToFullSyncMutation, SetNextSyncToFullSyncMutationVariables>;
export const CheckOnDemandSyncEligibilityDocument = gql`
    query CheckOnDemandSyncEligibility($input: RunJobNowInput!) {
  checkOnDemandSyncEligibility(input: $input) {
    possible
    reason
  }
}
    `;

/**
 * __useCheckOnDemandSyncEligibilityQuery__
 *
 * To run a query within a React component, call `useCheckOnDemandSyncEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckOnDemandSyncEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckOnDemandSyncEligibilityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckOnDemandSyncEligibilityQuery(baseOptions: Apollo.QueryHookOptions<CheckOnDemandSyncEligibilityQuery, CheckOnDemandSyncEligibilityQueryVariables> & ({ variables: CheckOnDemandSyncEligibilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckOnDemandSyncEligibilityQuery, CheckOnDemandSyncEligibilityQueryVariables>(CheckOnDemandSyncEligibilityDocument, options);
      }
export function useCheckOnDemandSyncEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckOnDemandSyncEligibilityQuery, CheckOnDemandSyncEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckOnDemandSyncEligibilityQuery, CheckOnDemandSyncEligibilityQueryVariables>(CheckOnDemandSyncEligibilityDocument, options);
        }
export function useCheckOnDemandSyncEligibilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckOnDemandSyncEligibilityQuery, CheckOnDemandSyncEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckOnDemandSyncEligibilityQuery, CheckOnDemandSyncEligibilityQueryVariables>(CheckOnDemandSyncEligibilityDocument, options);
        }
export type CheckOnDemandSyncEligibilityQueryHookResult = ReturnType<typeof useCheckOnDemandSyncEligibilityQuery>;
export type CheckOnDemandSyncEligibilityLazyQueryHookResult = ReturnType<typeof useCheckOnDemandSyncEligibilityLazyQuery>;
export type CheckOnDemandSyncEligibilitySuspenseQueryHookResult = ReturnType<typeof useCheckOnDemandSyncEligibilitySuspenseQuery>;
export type CheckOnDemandSyncEligibilityQueryResult = Apollo.QueryResult<CheckOnDemandSyncEligibilityQuery, CheckOnDemandSyncEligibilityQueryVariables>;
export const RunJobNowDocument = gql`
    mutation RunJobNow($input: RunJobNowInput!) {
  runJobNow(input: $input)
}
    `;
export type RunJobNowMutationFn = Apollo.MutationFunction<RunJobNowMutation, RunJobNowMutationVariables>;

/**
 * __useRunJobNowMutation__
 *
 * To run a mutation, you first call `useRunJobNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunJobNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runJobNowMutation, { data, loading, error }] = useRunJobNowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunJobNowMutation(baseOptions?: Apollo.MutationHookOptions<RunJobNowMutation, RunJobNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunJobNowMutation, RunJobNowMutationVariables>(RunJobNowDocument, options);
      }
export type RunJobNowMutationHookResult = ReturnType<typeof useRunJobNowMutation>;
export type RunJobNowMutationResult = Apollo.MutationResult<RunJobNowMutation>;
export type RunJobNowMutationOptions = Apollo.BaseMutationOptions<RunJobNowMutation, RunJobNowMutationVariables>;
export const EltSyncJobsDocument = gql`
    query EltSyncJobs($eltSyncId: String!) {
  eltSync(id: $eltSyncId) {
    sourceStreams {
      job {
        nextRun
        lastRun
        lastFullSync
        lastStartedAt
        status
        isQuarantined
        forceFullSync
        running
      }
    }
  }
}
    `;

/**
 * __useEltSyncJobsQuery__
 *
 * To run a query within a React component, call `useEltSyncJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltSyncJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltSyncJobsQuery({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *   },
 * });
 */
export function useEltSyncJobsQuery(baseOptions: Apollo.QueryHookOptions<EltSyncJobsQuery, EltSyncJobsQueryVariables> & ({ variables: EltSyncJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltSyncJobsQuery, EltSyncJobsQueryVariables>(EltSyncJobsDocument, options);
      }
export function useEltSyncJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltSyncJobsQuery, EltSyncJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltSyncJobsQuery, EltSyncJobsQueryVariables>(EltSyncJobsDocument, options);
        }
export function useEltSyncJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltSyncJobsQuery, EltSyncJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltSyncJobsQuery, EltSyncJobsQueryVariables>(EltSyncJobsDocument, options);
        }
export type EltSyncJobsQueryHookResult = ReturnType<typeof useEltSyncJobsQuery>;
export type EltSyncJobsLazyQueryHookResult = ReturnType<typeof useEltSyncJobsLazyQuery>;
export type EltSyncJobsSuspenseQueryHookResult = ReturnType<typeof useEltSyncJobsSuspenseQuery>;
export type EltSyncJobsQueryResult = Apollo.QueryResult<EltSyncJobsQuery, EltSyncJobsQueryVariables>;
export const EltSyncDocument = gql`
    query EltSync($eltSyncId: String!) {
  eltSync(id: $eltSyncId) {
    id
    active
    status
    syncInterval
    sourceIntegrationId
    destinationIntegrationId
    sourceConnectionId
    destinationConnectionId
    sourceStreams {
      id
      name
      incrementalPrimaryKeyName
      incrementalPointerId
      operationMode
      fullSyncAlways
      fullSyncAtMidnight
      protectedFromFullSync
      dataFilters {
        sourceStreamObjectKey
        transformation
      }
      job {
        nextRun
        lastRun
        lastFullSync
        lastStartedAt
        status
        isQuarantined
        forceFullSync
        running
      }
      substreams {
        name
        excludedColumns
        hashedColumns
      }
    }
    startDate
    sourceConnection {
      label
      id
    }
    destinationConnection {
      label
      id
    }
    config {
      sourceSettings
    }
    destinationSchemaName
    schedulerType
    orchestrationWorkflow {
      id
      cronExpression
    }
  }
}
    `;

/**
 * __useEltSyncQuery__
 *
 * To run a query within a React component, call `useEltSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltSyncQuery({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *   },
 * });
 */
export function useEltSyncQuery(baseOptions: Apollo.QueryHookOptions<EltSyncQuery, EltSyncQueryVariables> & ({ variables: EltSyncQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltSyncQuery, EltSyncQueryVariables>(EltSyncDocument, options);
      }
export function useEltSyncLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltSyncQuery, EltSyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltSyncQuery, EltSyncQueryVariables>(EltSyncDocument, options);
        }
export function useEltSyncSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltSyncQuery, EltSyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltSyncQuery, EltSyncQueryVariables>(EltSyncDocument, options);
        }
export type EltSyncQueryHookResult = ReturnType<typeof useEltSyncQuery>;
export type EltSyncLazyQueryHookResult = ReturnType<typeof useEltSyncLazyQuery>;
export type EltSyncSuspenseQueryHookResult = ReturnType<typeof useEltSyncSuspenseQuery>;
export type EltSyncQueryResult = Apollo.QueryResult<EltSyncQuery, EltSyncQueryVariables>;
export const GetErrorLogsDocument = gql`
    query GetErrorLogs($sourceStreamName: String!, $eltSyncId: String!) {
  getErrorLogs(sourceStreamName: $sourceStreamName, eltSyncId: $eltSyncId) {
    id
    message
    timestamp
    error_code
  }
}
    `;

/**
 * __useGetErrorLogsQuery__
 *
 * To run a query within a React component, call `useGetErrorLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorLogsQuery({
 *   variables: {
 *      sourceStreamName: // value for 'sourceStreamName'
 *      eltSyncId: // value for 'eltSyncId'
 *   },
 * });
 */
export function useGetErrorLogsQuery(baseOptions: Apollo.QueryHookOptions<GetErrorLogsQuery, GetErrorLogsQueryVariables> & ({ variables: GetErrorLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetErrorLogsQuery, GetErrorLogsQueryVariables>(GetErrorLogsDocument, options);
      }
export function useGetErrorLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetErrorLogsQuery, GetErrorLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetErrorLogsQuery, GetErrorLogsQueryVariables>(GetErrorLogsDocument, options);
        }
export function useGetErrorLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetErrorLogsQuery, GetErrorLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetErrorLogsQuery, GetErrorLogsQueryVariables>(GetErrorLogsDocument, options);
        }
export type GetErrorLogsQueryHookResult = ReturnType<typeof useGetErrorLogsQuery>;
export type GetErrorLogsLazyQueryHookResult = ReturnType<typeof useGetErrorLogsLazyQuery>;
export type GetErrorLogsSuspenseQueryHookResult = ReturnType<typeof useGetErrorLogsSuspenseQuery>;
export type GetErrorLogsQueryResult = Apollo.QueryResult<GetErrorLogsQuery, GetErrorLogsQueryVariables>;
export const EltJobsCompletionStatsDocument = gql`
    query EltJobsCompletionStats($from: DateTime, $to: DateTime) {
  eltJobsCompletionStats(from: $from, to: $to) {
    stats {
      total
      successCount
      successPercent
      failureCount
      failurePercent
    }
  }
}
    `;

/**
 * __useEltJobsCompletionStatsQuery__
 *
 * To run a query within a React component, call `useEltJobsCompletionStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltJobsCompletionStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltJobsCompletionStatsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useEltJobsCompletionStatsQuery(baseOptions?: Apollo.QueryHookOptions<EltJobsCompletionStatsQuery, EltJobsCompletionStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltJobsCompletionStatsQuery, EltJobsCompletionStatsQueryVariables>(EltJobsCompletionStatsDocument, options);
      }
export function useEltJobsCompletionStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltJobsCompletionStatsQuery, EltJobsCompletionStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltJobsCompletionStatsQuery, EltJobsCompletionStatsQueryVariables>(EltJobsCompletionStatsDocument, options);
        }
export function useEltJobsCompletionStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltJobsCompletionStatsQuery, EltJobsCompletionStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltJobsCompletionStatsQuery, EltJobsCompletionStatsQueryVariables>(EltJobsCompletionStatsDocument, options);
        }
export type EltJobsCompletionStatsQueryHookResult = ReturnType<typeof useEltJobsCompletionStatsQuery>;
export type EltJobsCompletionStatsLazyQueryHookResult = ReturnType<typeof useEltJobsCompletionStatsLazyQuery>;
export type EltJobsCompletionStatsSuspenseQueryHookResult = ReturnType<typeof useEltJobsCompletionStatsSuspenseQuery>;
export type EltJobsCompletionStatsQueryResult = Apollo.QueryResult<EltJobsCompletionStatsQuery, EltJobsCompletionStatsQueryVariables>;
export const UpdateSourceStreamDocument = gql`
    mutation UpdateSourceStream($sourceStreamId: String!, $input: UpdateSourceStreamInput!) {
  updateSourceStream(sourceStreamId: $sourceStreamId, input: $input) {
    id
    name
    protectedFromFullSync
  }
}
    `;
export type UpdateSourceStreamMutationFn = Apollo.MutationFunction<UpdateSourceStreamMutation, UpdateSourceStreamMutationVariables>;

/**
 * __useUpdateSourceStreamMutation__
 *
 * To run a mutation, you first call `useUpdateSourceStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSourceStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSourceStreamMutation, { data, loading, error }] = useUpdateSourceStreamMutation({
 *   variables: {
 *      sourceStreamId: // value for 'sourceStreamId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSourceStreamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSourceStreamMutation, UpdateSourceStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSourceStreamMutation, UpdateSourceStreamMutationVariables>(UpdateSourceStreamDocument, options);
      }
export type UpdateSourceStreamMutationHookResult = ReturnType<typeof useUpdateSourceStreamMutation>;
export type UpdateSourceStreamMutationResult = Apollo.MutationResult<UpdateSourceStreamMutation>;
export type UpdateSourceStreamMutationOptions = Apollo.BaseMutationOptions<UpdateSourceStreamMutation, UpdateSourceStreamMutationVariables>;
export const EltSyncStatsRecentDocument = gql`
    query EltSyncStatsRecent($syncId: String!, $from: DateTime!, $sourceStreamName: String) {
  eltSyncStatsRecent(
    syncId: $syncId
    from: $from
    sourceStreamName: $sourceStreamName
  ) {
    ...EltSyncHistoryStatsResponse
  }
}
    ${EltSyncHistoryStatsResponseFragmentDoc}`;

/**
 * __useEltSyncStatsRecentQuery__
 *
 * To run a query within a React component, call `useEltSyncStatsRecentQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltSyncStatsRecentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltSyncStatsRecentQuery({
 *   variables: {
 *      syncId: // value for 'syncId'
 *      from: // value for 'from'
 *      sourceStreamName: // value for 'sourceStreamName'
 *   },
 * });
 */
export function useEltSyncStatsRecentQuery(baseOptions: Apollo.QueryHookOptions<EltSyncStatsRecentQuery, EltSyncStatsRecentQueryVariables> & ({ variables: EltSyncStatsRecentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltSyncStatsRecentQuery, EltSyncStatsRecentQueryVariables>(EltSyncStatsRecentDocument, options);
      }
export function useEltSyncStatsRecentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltSyncStatsRecentQuery, EltSyncStatsRecentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltSyncStatsRecentQuery, EltSyncStatsRecentQueryVariables>(EltSyncStatsRecentDocument, options);
        }
export function useEltSyncStatsRecentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltSyncStatsRecentQuery, EltSyncStatsRecentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltSyncStatsRecentQuery, EltSyncStatsRecentQueryVariables>(EltSyncStatsRecentDocument, options);
        }
export type EltSyncStatsRecentQueryHookResult = ReturnType<typeof useEltSyncStatsRecentQuery>;
export type EltSyncStatsRecentLazyQueryHookResult = ReturnType<typeof useEltSyncStatsRecentLazyQuery>;
export type EltSyncStatsRecentSuspenseQueryHookResult = ReturnType<typeof useEltSyncStatsRecentSuspenseQuery>;
export type EltSyncStatsRecentQueryResult = Apollo.QueryResult<EltSyncStatsRecentQuery, EltSyncStatsRecentQueryVariables>;
export const EltSyncStatsHistoricDocument = gql`
    query EltSyncStatsHistoric($syncId: String!, $from: DateTime!, $sourceStreamName: String) {
  eltSyncStatsHistoric(
    syncId: $syncId
    from: $from
    sourceStreamName: $sourceStreamName
  ) {
    ...EltSyncHistoryStatsResponse
  }
}
    ${EltSyncHistoryStatsResponseFragmentDoc}`;

/**
 * __useEltSyncStatsHistoricQuery__
 *
 * To run a query within a React component, call `useEltSyncStatsHistoricQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltSyncStatsHistoricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltSyncStatsHistoricQuery({
 *   variables: {
 *      syncId: // value for 'syncId'
 *      from: // value for 'from'
 *      sourceStreamName: // value for 'sourceStreamName'
 *   },
 * });
 */
export function useEltSyncStatsHistoricQuery(baseOptions: Apollo.QueryHookOptions<EltSyncStatsHistoricQuery, EltSyncStatsHistoricQueryVariables> & ({ variables: EltSyncStatsHistoricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltSyncStatsHistoricQuery, EltSyncStatsHistoricQueryVariables>(EltSyncStatsHistoricDocument, options);
      }
export function useEltSyncStatsHistoricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltSyncStatsHistoricQuery, EltSyncStatsHistoricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltSyncStatsHistoricQuery, EltSyncStatsHistoricQueryVariables>(EltSyncStatsHistoricDocument, options);
        }
export function useEltSyncStatsHistoricSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltSyncStatsHistoricQuery, EltSyncStatsHistoricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltSyncStatsHistoricQuery, EltSyncStatsHistoricQueryVariables>(EltSyncStatsHistoricDocument, options);
        }
export type EltSyncStatsHistoricQueryHookResult = ReturnType<typeof useEltSyncStatsHistoricQuery>;
export type EltSyncStatsHistoricLazyQueryHookResult = ReturnType<typeof useEltSyncStatsHistoricLazyQuery>;
export type EltSyncStatsHistoricSuspenseQueryHookResult = ReturnType<typeof useEltSyncStatsHistoricSuspenseQuery>;
export type EltSyncStatsHistoricQueryResult = Apollo.QueryResult<EltSyncStatsHistoricQuery, EltSyncStatsHistoricQueryVariables>;
export const RecreateViewDocument = gql`
    mutation recreateView($eltSyncId: String!, $sourceStreamName: String!) {
  recreateDestinationView(
    eltSyncId: $eltSyncId
    sourceStreamName: $sourceStreamName
  ) {
    success
    error
  }
}
    `;
export type RecreateViewMutationFn = Apollo.MutationFunction<RecreateViewMutation, RecreateViewMutationVariables>;

/**
 * __useRecreateViewMutation__
 *
 * To run a mutation, you first call `useRecreateViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecreateViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recreateViewMutation, { data, loading, error }] = useRecreateViewMutation({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *      sourceStreamName: // value for 'sourceStreamName'
 *   },
 * });
 */
export function useRecreateViewMutation(baseOptions?: Apollo.MutationHookOptions<RecreateViewMutation, RecreateViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecreateViewMutation, RecreateViewMutationVariables>(RecreateViewDocument, options);
      }
export type RecreateViewMutationHookResult = ReturnType<typeof useRecreateViewMutation>;
export type RecreateViewMutationResult = Apollo.MutationResult<RecreateViewMutation>;
export type RecreateViewMutationOptions = Apollo.BaseMutationOptions<RecreateViewMutation, RecreateViewMutationVariables>;
export const GetWebhookDataDocument = gql`
    query getWebhookData($type: String!) {
  getWebhookData(type: $type) {
    data
  }
}
    `;

/**
 * __useGetWebhookDataQuery__
 *
 * To run a query within a React component, call `useGetWebhookDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebhookDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebhookDataQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetWebhookDataQuery(baseOptions: Apollo.QueryHookOptions<GetWebhookDataQuery, GetWebhookDataQueryVariables> & ({ variables: GetWebhookDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebhookDataQuery, GetWebhookDataQueryVariables>(GetWebhookDataDocument, options);
      }
export function useGetWebhookDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebhookDataQuery, GetWebhookDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebhookDataQuery, GetWebhookDataQueryVariables>(GetWebhookDataDocument, options);
        }
export function useGetWebhookDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebhookDataQuery, GetWebhookDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebhookDataQuery, GetWebhookDataQueryVariables>(GetWebhookDataDocument, options);
        }
export type GetWebhookDataQueryHookResult = ReturnType<typeof useGetWebhookDataQuery>;
export type GetWebhookDataLazyQueryHookResult = ReturnType<typeof useGetWebhookDataLazyQuery>;
export type GetWebhookDataSuspenseQueryHookResult = ReturnType<typeof useGetWebhookDataSuspenseQuery>;
export type GetWebhookDataQueryResult = Apollo.QueryResult<GetWebhookDataQuery, GetWebhookDataQueryVariables>;
export const CreateWebhookDocument = gql`
    mutation createWebhook($data: CreateWebhookInput!) {
  createWebhook(data: $data) {
    webhookId
    name
    connectionId
    orchestrationWorkflowId
    type
    dependencies {
      name
      id
      itemId
      type
    }
    createdAt
    updatedAt
  }
}
    `;
export type CreateWebhookMutationFn = Apollo.MutationFunction<CreateWebhookMutation, CreateWebhookMutationVariables>;

/**
 * __useCreateWebhookMutation__
 *
 * To run a mutation, you first call `useCreateWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebhookMutation, { data, loading, error }] = useCreateWebhookMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateWebhookMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebhookMutation, CreateWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebhookMutation, CreateWebhookMutationVariables>(CreateWebhookDocument, options);
      }
export type CreateWebhookMutationHookResult = ReturnType<typeof useCreateWebhookMutation>;
export type CreateWebhookMutationResult = Apollo.MutationResult<CreateWebhookMutation>;
export type CreateWebhookMutationOptions = Apollo.BaseMutationOptions<CreateWebhookMutation, CreateWebhookMutationVariables>;
export const DeleteWebhookDocument = gql`
    mutation deleteWebhook($webhookId: String!) {
  deleteWebhook(id: $webhookId)
}
    `;
export type DeleteWebhookMutationFn = Apollo.MutationFunction<DeleteWebhookMutation, DeleteWebhookMutationVariables>;

/**
 * __useDeleteWebhookMutation__
 *
 * To run a mutation, you first call `useDeleteWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWebhookMutation, { data, loading, error }] = useDeleteWebhookMutation({
 *   variables: {
 *      webhookId: // value for 'webhookId'
 *   },
 * });
 */
export function useDeleteWebhookMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWebhookMutation, DeleteWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWebhookMutation, DeleteWebhookMutationVariables>(DeleteWebhookDocument, options);
      }
export type DeleteWebhookMutationHookResult = ReturnType<typeof useDeleteWebhookMutation>;
export type DeleteWebhookMutationResult = Apollo.MutationResult<DeleteWebhookMutation>;
export type DeleteWebhookMutationOptions = Apollo.BaseMutationOptions<DeleteWebhookMutation, DeleteWebhookMutationVariables>;
export const ListWebhooksDocument = gql`
    query listWebhooks($orchestrationWorkflowId: String!) {
  listWebhoooks(orchestrationWorkflowId: $orchestrationWorkflowId) {
    orchestrationWorkflowId
    webhookId
    name
    connectionId
    type
    dependencies {
      name
      id
      itemId
      type
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useListWebhooksQuery__
 *
 * To run a query within a React component, call `useListWebhooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWebhooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWebhooksQuery({
 *   variables: {
 *      orchestrationWorkflowId: // value for 'orchestrationWorkflowId'
 *   },
 * });
 */
export function useListWebhooksQuery(baseOptions: Apollo.QueryHookOptions<ListWebhooksQuery, ListWebhooksQueryVariables> & ({ variables: ListWebhooksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWebhooksQuery, ListWebhooksQueryVariables>(ListWebhooksDocument, options);
      }
export function useListWebhooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWebhooksQuery, ListWebhooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWebhooksQuery, ListWebhooksQueryVariables>(ListWebhooksDocument, options);
        }
export function useListWebhooksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListWebhooksQuery, ListWebhooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWebhooksQuery, ListWebhooksQueryVariables>(ListWebhooksDocument, options);
        }
export type ListWebhooksQueryHookResult = ReturnType<typeof useListWebhooksQuery>;
export type ListWebhooksLazyQueryHookResult = ReturnType<typeof useListWebhooksLazyQuery>;
export type ListWebhooksSuspenseQueryHookResult = ReturnType<typeof useListWebhooksSuspenseQuery>;
export type ListWebhooksQueryResult = Apollo.QueryResult<ListWebhooksQuery, ListWebhooksQueryVariables>;
export const RequestBetaConnectorAccessDocument = gql`
    mutation RequestBetaConnectorAccess($integrationId: String!) {
  requestBetaConnectorAccess(integrationId: $integrationId)
}
    `;
export type RequestBetaConnectorAccessMutationFn = Apollo.MutationFunction<RequestBetaConnectorAccessMutation, RequestBetaConnectorAccessMutationVariables>;

/**
 * __useRequestBetaConnectorAccessMutation__
 *
 * To run a mutation, you first call `useRequestBetaConnectorAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestBetaConnectorAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestBetaConnectorAccessMutation, { data, loading, error }] = useRequestBetaConnectorAccessMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useRequestBetaConnectorAccessMutation(baseOptions?: Apollo.MutationHookOptions<RequestBetaConnectorAccessMutation, RequestBetaConnectorAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestBetaConnectorAccessMutation, RequestBetaConnectorAccessMutationVariables>(RequestBetaConnectorAccessDocument, options);
      }
export type RequestBetaConnectorAccessMutationHookResult = ReturnType<typeof useRequestBetaConnectorAccessMutation>;
export type RequestBetaConnectorAccessMutationResult = Apollo.MutationResult<RequestBetaConnectorAccessMutation>;
export type RequestBetaConnectorAccessMutationOptions = Apollo.BaseMutationOptions<RequestBetaConnectorAccessMutation, RequestBetaConnectorAccessMutationVariables>;
export const RequestConnectorDocument = gql`
    mutation RequestConnector($integrationName: String!, $integrationTypes: [String!]!) {
  requestConnector(
    integrationName: $integrationName
    integrationTypes: $integrationTypes
  )
}
    `;
export type RequestConnectorMutationFn = Apollo.MutationFunction<RequestConnectorMutation, RequestConnectorMutationVariables>;

/**
 * __useRequestConnectorMutation__
 *
 * To run a mutation, you first call `useRequestConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestConnectorMutation, { data, loading, error }] = useRequestConnectorMutation({
 *   variables: {
 *      integrationName: // value for 'integrationName'
 *      integrationTypes: // value for 'integrationTypes'
 *   },
 * });
 */
export function useRequestConnectorMutation(baseOptions?: Apollo.MutationHookOptions<RequestConnectorMutation, RequestConnectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestConnectorMutation, RequestConnectorMutationVariables>(RequestConnectorDocument, options);
      }
export type RequestConnectorMutationHookResult = ReturnType<typeof useRequestConnectorMutation>;
export type RequestConnectorMutationResult = Apollo.MutationResult<RequestConnectorMutation>;
export type RequestConnectorMutationOptions = Apollo.BaseMutationOptions<RequestConnectorMutation, RequestConnectorMutationVariables>;
export const RequestDestinationDocument = gql`
    mutation RequestDestination($integrationId: String!) {
  requestDestination(integrationId: $integrationId)
}
    `;
export type RequestDestinationMutationFn = Apollo.MutationFunction<RequestDestinationMutation, RequestDestinationMutationVariables>;

/**
 * __useRequestDestinationMutation__
 *
 * To run a mutation, you first call `useRequestDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDestinationMutation, { data, loading, error }] = useRequestDestinationMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useRequestDestinationMutation(baseOptions?: Apollo.MutationHookOptions<RequestDestinationMutation, RequestDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestDestinationMutation, RequestDestinationMutationVariables>(RequestDestinationDocument, options);
      }
export type RequestDestinationMutationHookResult = ReturnType<typeof useRequestDestinationMutation>;
export type RequestDestinationMutationResult = Apollo.MutationResult<RequestDestinationMutation>;
export type RequestDestinationMutationOptions = Apollo.BaseMutationOptions<RequestDestinationMutation, RequestDestinationMutationVariables>;
export const CountriesDocument = gql`
    query Countries {
  countries {
    ...Country
  }
}
    ${CountryFragmentDoc}`;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export function useCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesSuspenseQueryHookResult = ReturnType<typeof useCountriesSuspenseQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const ResolveCountryFromTimeZoneDocument = gql`
    query ResolveCountryFromTimeZone($timeZone: String!) {
  resolveCountryFromTimeZone(timeZone: $timeZone) {
    country {
      ...Country
    }
  }
}
    ${CountryFragmentDoc}`;

/**
 * __useResolveCountryFromTimeZoneQuery__
 *
 * To run a query within a React component, call `useResolveCountryFromTimeZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveCountryFromTimeZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveCountryFromTimeZoneQuery({
 *   variables: {
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useResolveCountryFromTimeZoneQuery(baseOptions: Apollo.QueryHookOptions<ResolveCountryFromTimeZoneQuery, ResolveCountryFromTimeZoneQueryVariables> & ({ variables: ResolveCountryFromTimeZoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResolveCountryFromTimeZoneQuery, ResolveCountryFromTimeZoneQueryVariables>(ResolveCountryFromTimeZoneDocument, options);
      }
export function useResolveCountryFromTimeZoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResolveCountryFromTimeZoneQuery, ResolveCountryFromTimeZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResolveCountryFromTimeZoneQuery, ResolveCountryFromTimeZoneQueryVariables>(ResolveCountryFromTimeZoneDocument, options);
        }
export function useResolveCountryFromTimeZoneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ResolveCountryFromTimeZoneQuery, ResolveCountryFromTimeZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResolveCountryFromTimeZoneQuery, ResolveCountryFromTimeZoneQueryVariables>(ResolveCountryFromTimeZoneDocument, options);
        }
export type ResolveCountryFromTimeZoneQueryHookResult = ReturnType<typeof useResolveCountryFromTimeZoneQuery>;
export type ResolveCountryFromTimeZoneLazyQueryHookResult = ReturnType<typeof useResolveCountryFromTimeZoneLazyQuery>;
export type ResolveCountryFromTimeZoneSuspenseQueryHookResult = ReturnType<typeof useResolveCountryFromTimeZoneSuspenseQuery>;
export type ResolveCountryFromTimeZoneQueryResult = Apollo.QueryResult<ResolveCountryFromTimeZoneQuery, ResolveCountryFromTimeZoneQueryVariables>;
export const CountriesAndCurrentCountryDocument = gql`
    query CountriesAndCurrentCountry($timeZone: String!) {
  countries {
    ...Country
  }
  resolveCountryFromTimeZone(timeZone: $timeZone) {
    country {
      ...Country
    }
  }
}
    ${CountryFragmentDoc}`;

/**
 * __useCountriesAndCurrentCountryQuery__
 *
 * To run a query within a React component, call `useCountriesAndCurrentCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesAndCurrentCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesAndCurrentCountryQuery({
 *   variables: {
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useCountriesAndCurrentCountryQuery(baseOptions: Apollo.QueryHookOptions<CountriesAndCurrentCountryQuery, CountriesAndCurrentCountryQueryVariables> & ({ variables: CountriesAndCurrentCountryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesAndCurrentCountryQuery, CountriesAndCurrentCountryQueryVariables>(CountriesAndCurrentCountryDocument, options);
      }
export function useCountriesAndCurrentCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesAndCurrentCountryQuery, CountriesAndCurrentCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesAndCurrentCountryQuery, CountriesAndCurrentCountryQueryVariables>(CountriesAndCurrentCountryDocument, options);
        }
export function useCountriesAndCurrentCountrySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountriesAndCurrentCountryQuery, CountriesAndCurrentCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountriesAndCurrentCountryQuery, CountriesAndCurrentCountryQueryVariables>(CountriesAndCurrentCountryDocument, options);
        }
export type CountriesAndCurrentCountryQueryHookResult = ReturnType<typeof useCountriesAndCurrentCountryQuery>;
export type CountriesAndCurrentCountryLazyQueryHookResult = ReturnType<typeof useCountriesAndCurrentCountryLazyQuery>;
export type CountriesAndCurrentCountrySuspenseQueryHookResult = ReturnType<typeof useCountriesAndCurrentCountrySuspenseQuery>;
export type CountriesAndCurrentCountryQueryResult = Apollo.QueryResult<CountriesAndCurrentCountryQuery, CountriesAndCurrentCountryQueryVariables>;
export const IntegrationConfigurationDocument = gql`
    query IntegrationConfiguration($id: String!) {
  integrationConfiguration(integrationId: $id) {
    ...IntegrationConfiguration
  }
}
    ${IntegrationConfigurationFragmentDoc}`;

/**
 * __useIntegrationConfigurationQuery__
 *
 * To run a query within a React component, call `useIntegrationConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationConfigurationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntegrationConfigurationQuery(baseOptions: Apollo.QueryHookOptions<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables> & ({ variables: IntegrationConfigurationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>(IntegrationConfigurationDocument, options);
      }
export function useIntegrationConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>(IntegrationConfigurationDocument, options);
        }
export function useIntegrationConfigurationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>(IntegrationConfigurationDocument, options);
        }
export type IntegrationConfigurationQueryHookResult = ReturnType<typeof useIntegrationConfigurationQuery>;
export type IntegrationConfigurationLazyQueryHookResult = ReturnType<typeof useIntegrationConfigurationLazyQuery>;
export type IntegrationConfigurationSuspenseQueryHookResult = ReturnType<typeof useIntegrationConfigurationSuspenseQuery>;
export type IntegrationConfigurationQueryResult = Apollo.QueryResult<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>;
export const GetSetupGuideUrlDocument = gql`
    query GetSetupGuideUrl($integrationId: String!, $isDatawarehouse: Boolean!) {
  getSetupGuideUrl(
    integrationId: $integrationId
    isDatawarehouse: $isDatawarehouse
  )
}
    `;

/**
 * __useGetSetupGuideUrlQuery__
 *
 * To run a query within a React component, call `useGetSetupGuideUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSetupGuideUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSetupGuideUrlQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      isDatawarehouse: // value for 'isDatawarehouse'
 *   },
 * });
 */
export function useGetSetupGuideUrlQuery(baseOptions: Apollo.QueryHookOptions<GetSetupGuideUrlQuery, GetSetupGuideUrlQueryVariables> & ({ variables: GetSetupGuideUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSetupGuideUrlQuery, GetSetupGuideUrlQueryVariables>(GetSetupGuideUrlDocument, options);
      }
export function useGetSetupGuideUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSetupGuideUrlQuery, GetSetupGuideUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSetupGuideUrlQuery, GetSetupGuideUrlQueryVariables>(GetSetupGuideUrlDocument, options);
        }
export function useGetSetupGuideUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSetupGuideUrlQuery, GetSetupGuideUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSetupGuideUrlQuery, GetSetupGuideUrlQueryVariables>(GetSetupGuideUrlDocument, options);
        }
export type GetSetupGuideUrlQueryHookResult = ReturnType<typeof useGetSetupGuideUrlQuery>;
export type GetSetupGuideUrlLazyQueryHookResult = ReturnType<typeof useGetSetupGuideUrlLazyQuery>;
export type GetSetupGuideUrlSuspenseQueryHookResult = ReturnType<typeof useGetSetupGuideUrlSuspenseQuery>;
export type GetSetupGuideUrlQueryResult = Apollo.QueryResult<GetSetupGuideUrlQuery, GetSetupGuideUrlQueryVariables>;
export const AvailableIntegrationsDocument = gql`
    query AvailableIntegrations {
  availableIntegrations {
    ...AvailableIntegration
  }
}
    ${AvailableIntegrationFragmentDoc}`;

/**
 * __useAvailableIntegrationsQuery__
 *
 * To run a query within a React component, call `useAvailableIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>(AvailableIntegrationsDocument, options);
      }
export function useAvailableIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>(AvailableIntegrationsDocument, options);
        }
export function useAvailableIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>(AvailableIntegrationsDocument, options);
        }
export type AvailableIntegrationsQueryHookResult = ReturnType<typeof useAvailableIntegrationsQuery>;
export type AvailableIntegrationsLazyQueryHookResult = ReturnType<typeof useAvailableIntegrationsLazyQuery>;
export type AvailableIntegrationsSuspenseQueryHookResult = ReturnType<typeof useAvailableIntegrationsSuspenseQuery>;
export type AvailableIntegrationsQueryResult = Apollo.QueryResult<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>;
export const DestinationIntegrationsDocument = gql`
    query DestinationIntegrations {
  destinationIntegrations {
    ...AvailableIntegration
  }
}
    ${AvailableIntegrationFragmentDoc}`;

/**
 * __useDestinationIntegrationsQuery__
 *
 * To run a query within a React component, call `useDestinationIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDestinationIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDestinationIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDestinationIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<DestinationIntegrationsQuery, DestinationIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DestinationIntegrationsQuery, DestinationIntegrationsQueryVariables>(DestinationIntegrationsDocument, options);
      }
export function useDestinationIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DestinationIntegrationsQuery, DestinationIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DestinationIntegrationsQuery, DestinationIntegrationsQueryVariables>(DestinationIntegrationsDocument, options);
        }
export function useDestinationIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DestinationIntegrationsQuery, DestinationIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DestinationIntegrationsQuery, DestinationIntegrationsQueryVariables>(DestinationIntegrationsDocument, options);
        }
export type DestinationIntegrationsQueryHookResult = ReturnType<typeof useDestinationIntegrationsQuery>;
export type DestinationIntegrationsLazyQueryHookResult = ReturnType<typeof useDestinationIntegrationsLazyQuery>;
export type DestinationIntegrationsSuspenseQueryHookResult = ReturnType<typeof useDestinationIntegrationsSuspenseQuery>;
export type DestinationIntegrationsQueryResult = Apollo.QueryResult<DestinationIntegrationsQuery, DestinationIntegrationsQueryVariables>;
export const CreateModelTestDocument = gql`
    mutation CreateModelTest($createModelTestInput: CreateModelTestInput!) {
  createModelTest(createModelTestInput: $createModelTestInput) {
    id
  }
}
    `;
export type CreateModelTestMutationFn = Apollo.MutationFunction<CreateModelTestMutation, CreateModelTestMutationVariables>;

/**
 * __useCreateModelTestMutation__
 *
 * To run a mutation, you first call `useCreateModelTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModelTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModelTestMutation, { data, loading, error }] = useCreateModelTestMutation({
 *   variables: {
 *      createModelTestInput: // value for 'createModelTestInput'
 *   },
 * });
 */
export function useCreateModelTestMutation(baseOptions?: Apollo.MutationHookOptions<CreateModelTestMutation, CreateModelTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModelTestMutation, CreateModelTestMutationVariables>(CreateModelTestDocument, options);
      }
export type CreateModelTestMutationHookResult = ReturnType<typeof useCreateModelTestMutation>;
export type CreateModelTestMutationResult = Apollo.MutationResult<CreateModelTestMutation>;
export type CreateModelTestMutationOptions = Apollo.BaseMutationOptions<CreateModelTestMutation, CreateModelTestMutationVariables>;
export const UpdateModelTestDocument = gql`
    mutation UpdateModelTest($updateModelTestInput: UpdateModelTestInput!) {
  updateModelTest(updateModelTestInput: $updateModelTestInput) {
    id
  }
}
    `;
export type UpdateModelTestMutationFn = Apollo.MutationFunction<UpdateModelTestMutation, UpdateModelTestMutationVariables>;

/**
 * __useUpdateModelTestMutation__
 *
 * To run a mutation, you first call `useUpdateModelTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModelTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModelTestMutation, { data, loading, error }] = useUpdateModelTestMutation({
 *   variables: {
 *      updateModelTestInput: // value for 'updateModelTestInput'
 *   },
 * });
 */
export function useUpdateModelTestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModelTestMutation, UpdateModelTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModelTestMutation, UpdateModelTestMutationVariables>(UpdateModelTestDocument, options);
      }
export type UpdateModelTestMutationHookResult = ReturnType<typeof useUpdateModelTestMutation>;
export type UpdateModelTestMutationResult = Apollo.MutationResult<UpdateModelTestMutation>;
export type UpdateModelTestMutationOptions = Apollo.BaseMutationOptions<UpdateModelTestMutation, UpdateModelTestMutationVariables>;
export const RemoveModelTestDocument = gql`
    mutation RemoveModelTest($id: String!) {
  removeModelTest(id: $id) {
    id
  }
}
    `;
export type RemoveModelTestMutationFn = Apollo.MutationFunction<RemoveModelTestMutation, RemoveModelTestMutationVariables>;

/**
 * __useRemoveModelTestMutation__
 *
 * To run a mutation, you first call `useRemoveModelTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveModelTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeModelTestMutation, { data, loading, error }] = useRemoveModelTestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveModelTestMutation(baseOptions?: Apollo.MutationHookOptions<RemoveModelTestMutation, RemoveModelTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveModelTestMutation, RemoveModelTestMutationVariables>(RemoveModelTestDocument, options);
      }
export type RemoveModelTestMutationHookResult = ReturnType<typeof useRemoveModelTestMutation>;
export type RemoveModelTestMutationResult = Apollo.MutationResult<RemoveModelTestMutation>;
export type RemoveModelTestMutationOptions = Apollo.BaseMutationOptions<RemoveModelTestMutation, RemoveModelTestMutationVariables>;
export const ModelTestsByModelDocument = gql`
    query ModelTestsByModel($modelId: String!) {
  model(id: $modelId) {
    id
    modelTests {
      id
      column
      type
    }
  }
}
    `;

/**
 * __useModelTestsByModelQuery__
 *
 * To run a query within a React component, call `useModelTestsByModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelTestsByModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelTestsByModelQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useModelTestsByModelQuery(baseOptions: Apollo.QueryHookOptions<ModelTestsByModelQuery, ModelTestsByModelQueryVariables> & ({ variables: ModelTestsByModelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelTestsByModelQuery, ModelTestsByModelQueryVariables>(ModelTestsByModelDocument, options);
      }
export function useModelTestsByModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelTestsByModelQuery, ModelTestsByModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelTestsByModelQuery, ModelTestsByModelQueryVariables>(ModelTestsByModelDocument, options);
        }
export function useModelTestsByModelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ModelTestsByModelQuery, ModelTestsByModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModelTestsByModelQuery, ModelTestsByModelQueryVariables>(ModelTestsByModelDocument, options);
        }
export type ModelTestsByModelQueryHookResult = ReturnType<typeof useModelTestsByModelQuery>;
export type ModelTestsByModelLazyQueryHookResult = ReturnType<typeof useModelTestsByModelLazyQuery>;
export type ModelTestsByModelSuspenseQueryHookResult = ReturnType<typeof useModelTestsByModelSuspenseQuery>;
export type ModelTestsByModelQueryResult = Apollo.QueryResult<ModelTestsByModelQuery, ModelTestsByModelQueryVariables>;
export const StartTestDocument = gql`
    query StartTest($modelTestId: ID!) {
  startTest(modelTestId: $modelTestId) {
    modelTestId
    status
    queryExecutionId
    modelTestWeldSql
    failedRows
    error
  }
}
    `;

/**
 * __useStartTestQuery__
 *
 * To run a query within a React component, call `useStartTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartTestQuery({
 *   variables: {
 *      modelTestId: // value for 'modelTestId'
 *   },
 * });
 */
export function useStartTestQuery(baseOptions: Apollo.QueryHookOptions<StartTestQuery, StartTestQueryVariables> & ({ variables: StartTestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StartTestQuery, StartTestQueryVariables>(StartTestDocument, options);
      }
export function useStartTestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StartTestQuery, StartTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StartTestQuery, StartTestQueryVariables>(StartTestDocument, options);
        }
export function useStartTestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StartTestQuery, StartTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StartTestQuery, StartTestQueryVariables>(StartTestDocument, options);
        }
export type StartTestQueryHookResult = ReturnType<typeof useStartTestQuery>;
export type StartTestLazyQueryHookResult = ReturnType<typeof useStartTestLazyQuery>;
export type StartTestSuspenseQueryHookResult = ReturnType<typeof useStartTestSuspenseQuery>;
export type StartTestQueryResult = Apollo.QueryResult<StartTestQuery, StartTestQueryVariables>;
export const GetTestResultDocument = gql`
    query GetTestResult($modelTestId: ID!, $queryExecutionId: String!, $sourceConnectionId: String!) {
  getTestResult(
    modelTestId: $modelTestId
    queryExecutionId: $queryExecutionId
    sourceConnectionId: $sourceConnectionId
  ) {
    modelTestId
    status
    queryExecutionId
    failedRows
    error
  }
}
    `;

/**
 * __useGetTestResultQuery__
 *
 * To run a query within a React component, call `useGetTestResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestResultQuery({
 *   variables: {
 *      modelTestId: // value for 'modelTestId'
 *      queryExecutionId: // value for 'queryExecutionId'
 *      sourceConnectionId: // value for 'sourceConnectionId'
 *   },
 * });
 */
export function useGetTestResultQuery(baseOptions: Apollo.QueryHookOptions<GetTestResultQuery, GetTestResultQueryVariables> & ({ variables: GetTestResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTestResultQuery, GetTestResultQueryVariables>(GetTestResultDocument, options);
      }
export function useGetTestResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTestResultQuery, GetTestResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTestResultQuery, GetTestResultQueryVariables>(GetTestResultDocument, options);
        }
export function useGetTestResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTestResultQuery, GetTestResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTestResultQuery, GetTestResultQueryVariables>(GetTestResultDocument, options);
        }
export type GetTestResultQueryHookResult = ReturnType<typeof useGetTestResultQuery>;
export type GetTestResultLazyQueryHookResult = ReturnType<typeof useGetTestResultLazyQuery>;
export type GetTestResultSuspenseQueryHookResult = ReturnType<typeof useGetTestResultSuspenseQuery>;
export type GetTestResultQueryResult = Apollo.QueryResult<GetTestResultQuery, GetTestResultQueryVariables>;
export const CreateDraftModelDocument = gql`
    mutation CreateDraftModel($name: String!, $sourceConnectionId: String!, $weldSql: String!, $dashboardId: String) {
  createDraftModel(
    input: {name: $name, sourceConnectionId: $sourceConnectionId, weldSql: $weldSql, dashboardId: $dashboardId}
  ) {
    ...ModelListItem
  }
}
    ${ModelListItemFragmentDoc}`;
export type CreateDraftModelMutationFn = Apollo.MutationFunction<CreateDraftModelMutation, CreateDraftModelMutationVariables>;

/**
 * __useCreateDraftModelMutation__
 *
 * To run a mutation, you first call `useCreateDraftModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDraftModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDraftModelMutation, { data, loading, error }] = useCreateDraftModelMutation({
 *   variables: {
 *      name: // value for 'name'
 *      sourceConnectionId: // value for 'sourceConnectionId'
 *      weldSql: // value for 'weldSql'
 *      dashboardId: // value for 'dashboardId'
 *   },
 * });
 */
export function useCreateDraftModelMutation(baseOptions?: Apollo.MutationHookOptions<CreateDraftModelMutation, CreateDraftModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDraftModelMutation, CreateDraftModelMutationVariables>(CreateDraftModelDocument, options);
      }
export type CreateDraftModelMutationHookResult = ReturnType<typeof useCreateDraftModelMutation>;
export type CreateDraftModelMutationResult = Apollo.MutationResult<CreateDraftModelMutation>;
export type CreateDraftModelMutationOptions = Apollo.BaseMutationOptions<CreateDraftModelMutation, CreateDraftModelMutationVariables>;
export const CreateModelFromTemplateDocument = gql`
    mutation CreateModelFromTemplate($input: CreateFromTemplateInput!) {
  createModelFromTemplate(input: $input) {
    modelId
    weldTag
  }
}
    `;
export type CreateModelFromTemplateMutationFn = Apollo.MutationFunction<CreateModelFromTemplateMutation, CreateModelFromTemplateMutationVariables>;

/**
 * __useCreateModelFromTemplateMutation__
 *
 * To run a mutation, you first call `useCreateModelFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModelFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModelFromTemplateMutation, { data, loading, error }] = useCreateModelFromTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateModelFromTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateModelFromTemplateMutation, CreateModelFromTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModelFromTemplateMutation, CreateModelFromTemplateMutationVariables>(CreateModelFromTemplateDocument, options);
      }
export type CreateModelFromTemplateMutationHookResult = ReturnType<typeof useCreateModelFromTemplateMutation>;
export type CreateModelFromTemplateMutationResult = Apollo.MutationResult<CreateModelFromTemplateMutation>;
export type CreateModelFromTemplateMutationOptions = Apollo.BaseMutationOptions<CreateModelFromTemplateMutation, CreateModelFromTemplateMutationVariables>;
export const PublishModelAsyncDocument = gql`
    mutation PublishModelAsync($id: String!, $name: String!, $query: QueryInput!, $materializationType: MaterializationType!, $materializationSchedule: String, $modelFolderId: String!, $orchestrationScheduler: OrchestrationSchedulerType, $orchestrationWorkflowId: ID, $isUnsavedModel: Boolean!, $sourceConnectionId: String!) {
  publishModelAsync(
    input: {id: $id, name: $name, query: $query, materializationType: $materializationType, materializationSchedule: $materializationSchedule, modelFolderId: $modelFolderId, orchestrationScheduler: $orchestrationScheduler, orchestrationWorkflowId: $orchestrationWorkflowId, isUnsavedModel: $isUnsavedModel, sourceConnectionId: $sourceConnectionId}
  )
}
    `;
export type PublishModelAsyncMutationFn = Apollo.MutationFunction<PublishModelAsyncMutation, PublishModelAsyncMutationVariables>;

/**
 * __usePublishModelAsyncMutation__
 *
 * To run a mutation, you first call `usePublishModelAsyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishModelAsyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishModelAsyncMutation, { data, loading, error }] = usePublishModelAsyncMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      query: // value for 'query'
 *      materializationType: // value for 'materializationType'
 *      materializationSchedule: // value for 'materializationSchedule'
 *      modelFolderId: // value for 'modelFolderId'
 *      orchestrationScheduler: // value for 'orchestrationScheduler'
 *      orchestrationWorkflowId: // value for 'orchestrationWorkflowId'
 *      isUnsavedModel: // value for 'isUnsavedModel'
 *      sourceConnectionId: // value for 'sourceConnectionId'
 *   },
 * });
 */
export function usePublishModelAsyncMutation(baseOptions?: Apollo.MutationHookOptions<PublishModelAsyncMutation, PublishModelAsyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishModelAsyncMutation, PublishModelAsyncMutationVariables>(PublishModelAsyncDocument, options);
      }
export type PublishModelAsyncMutationHookResult = ReturnType<typeof usePublishModelAsyncMutation>;
export type PublishModelAsyncMutationResult = Apollo.MutationResult<PublishModelAsyncMutation>;
export type PublishModelAsyncMutationOptions = Apollo.BaseMutationOptions<PublishModelAsyncMutation, PublishModelAsyncMutationVariables>;
export const UpdatePublishedModelQueryAsyncDocument = gql`
    mutation UpdatePublishedModelQueryAsync($id: String!, $query: QueryInput!) {
  updatePublishedModelQueryAsync(input: {id: $id, query: $query})
}
    `;
export type UpdatePublishedModelQueryAsyncMutationFn = Apollo.MutationFunction<UpdatePublishedModelQueryAsyncMutation, UpdatePublishedModelQueryAsyncMutationVariables>;

/**
 * __useUpdatePublishedModelQueryAsyncMutation__
 *
 * To run a mutation, you first call `useUpdatePublishedModelQueryAsyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublishedModelQueryAsyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublishedModelQueryAsyncMutation, { data, loading, error }] = useUpdatePublishedModelQueryAsyncMutation({
 *   variables: {
 *      id: // value for 'id'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useUpdatePublishedModelQueryAsyncMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePublishedModelQueryAsyncMutation, UpdatePublishedModelQueryAsyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePublishedModelQueryAsyncMutation, UpdatePublishedModelQueryAsyncMutationVariables>(UpdatePublishedModelQueryAsyncDocument, options);
      }
export type UpdatePublishedModelQueryAsyncMutationHookResult = ReturnType<typeof useUpdatePublishedModelQueryAsyncMutation>;
export type UpdatePublishedModelQueryAsyncMutationResult = Apollo.MutationResult<UpdatePublishedModelQueryAsyncMutation>;
export type UpdatePublishedModelQueryAsyncMutationOptions = Apollo.BaseMutationOptions<UpdatePublishedModelQueryAsyncMutation, UpdatePublishedModelQueryAsyncMutationVariables>;
export const UpdatePublishedModelMaterializationDocument = gql`
    mutation UpdatePublishedModelMaterialization($id: String!, $materializationType: MaterializationType!, $materializationSchedule: String, $orchestrationScheduler: OrchestrationSchedulerType, $orchestrationWorkflowId: ID) {
  updatePublishedModelMaterialization(
    input: {id: $id, materializationType: $materializationType, materializationSchedule: $materializationSchedule, orchestrationScheduler: $orchestrationScheduler, orchestrationWorkflowId: $orchestrationWorkflowId}
  ) {
    ...ModelListItem
  }
}
    ${ModelListItemFragmentDoc}`;
export type UpdatePublishedModelMaterializationMutationFn = Apollo.MutationFunction<UpdatePublishedModelMaterializationMutation, UpdatePublishedModelMaterializationMutationVariables>;

/**
 * __useUpdatePublishedModelMaterializationMutation__
 *
 * To run a mutation, you first call `useUpdatePublishedModelMaterializationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublishedModelMaterializationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublishedModelMaterializationMutation, { data, loading, error }] = useUpdatePublishedModelMaterializationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      materializationType: // value for 'materializationType'
 *      materializationSchedule: // value for 'materializationSchedule'
 *      orchestrationScheduler: // value for 'orchestrationScheduler'
 *      orchestrationWorkflowId: // value for 'orchestrationWorkflowId'
 *   },
 * });
 */
export function useUpdatePublishedModelMaterializationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePublishedModelMaterializationMutation, UpdatePublishedModelMaterializationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePublishedModelMaterializationMutation, UpdatePublishedModelMaterializationMutationVariables>(UpdatePublishedModelMaterializationDocument, options);
      }
export type UpdatePublishedModelMaterializationMutationHookResult = ReturnType<typeof useUpdatePublishedModelMaterializationMutation>;
export type UpdatePublishedModelMaterializationMutationResult = Apollo.MutationResult<UpdatePublishedModelMaterializationMutation>;
export type UpdatePublishedModelMaterializationMutationOptions = Apollo.BaseMutationOptions<UpdatePublishedModelMaterializationMutation, UpdatePublishedModelMaterializationMutationVariables>;
export const UpdateDraftModelNameDocument = gql`
    mutation UpdateDraftModelName($id: String!, $name: String!) {
  updateDraftModelName(input: {id: $id, name: $name}) {
    id
    name
  }
}
    `;
export type UpdateDraftModelNameMutationFn = Apollo.MutationFunction<UpdateDraftModelNameMutation, UpdateDraftModelNameMutationVariables>;

/**
 * __useUpdateDraftModelNameMutation__
 *
 * To run a mutation, you first call `useUpdateDraftModelNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftModelNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftModelNameMutation, { data, loading, error }] = useUpdateDraftModelNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateDraftModelNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftModelNameMutation, UpdateDraftModelNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftModelNameMutation, UpdateDraftModelNameMutationVariables>(UpdateDraftModelNameDocument, options);
      }
export type UpdateDraftModelNameMutationHookResult = ReturnType<typeof useUpdateDraftModelNameMutation>;
export type UpdateDraftModelNameMutationResult = Apollo.MutationResult<UpdateDraftModelNameMutation>;
export type UpdateDraftModelNameMutationOptions = Apollo.BaseMutationOptions<UpdateDraftModelNameMutation, UpdateDraftModelNameMutationVariables>;
export const UpdateUnpublishedModelQueryDocument = gql`
    mutation UpdateUnpublishedModelQuery($id: String!, $query: QueryInput!) {
  updateUnpublishedModelSqlQuery(input: {id: $id, query: $query}) {
    id
  }
}
    `;
export type UpdateUnpublishedModelQueryMutationFn = Apollo.MutationFunction<UpdateUnpublishedModelQueryMutation, UpdateUnpublishedModelQueryMutationVariables>;

/**
 * __useUpdateUnpublishedModelQueryMutation__
 *
 * To run a mutation, you first call `useUpdateUnpublishedModelQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUnpublishedModelQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUnpublishedModelQueryMutation, { data, loading, error }] = useUpdateUnpublishedModelQueryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useUpdateUnpublishedModelQueryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUnpublishedModelQueryMutation, UpdateUnpublishedModelQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUnpublishedModelQueryMutation, UpdateUnpublishedModelQueryMutationVariables>(UpdateUnpublishedModelQueryDocument, options);
      }
export type UpdateUnpublishedModelQueryMutationHookResult = ReturnType<typeof useUpdateUnpublishedModelQueryMutation>;
export type UpdateUnpublishedModelQueryMutationResult = Apollo.MutationResult<UpdateUnpublishedModelQueryMutation>;
export type UpdateUnpublishedModelQueryMutationOptions = Apollo.BaseMutationOptions<UpdateUnpublishedModelQueryMutation, UpdateUnpublishedModelQueryMutationVariables>;
export const UpdateModelDocumentationDocument = gql`
    mutation UpdateModelDocumentation($id: String!, $documentation: String!) {
  updateModelDocumentation(input: {id: $id, documentation: $documentation}) {
    id
    documentation
  }
}
    `;
export type UpdateModelDocumentationMutationFn = Apollo.MutationFunction<UpdateModelDocumentationMutation, UpdateModelDocumentationMutationVariables>;

/**
 * __useUpdateModelDocumentationMutation__
 *
 * To run a mutation, you first call `useUpdateModelDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModelDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModelDocumentationMutation, { data, loading, error }] = useUpdateModelDocumentationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      documentation: // value for 'documentation'
 *   },
 * });
 */
export function useUpdateModelDocumentationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModelDocumentationMutation, UpdateModelDocumentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModelDocumentationMutation, UpdateModelDocumentationMutationVariables>(UpdateModelDocumentationDocument, options);
      }
export type UpdateModelDocumentationMutationHookResult = ReturnType<typeof useUpdateModelDocumentationMutation>;
export type UpdateModelDocumentationMutationResult = Apollo.MutationResult<UpdateModelDocumentationMutation>;
export type UpdateModelDocumentationMutationOptions = Apollo.BaseMutationOptions<UpdateModelDocumentationMutation, UpdateModelDocumentationMutationVariables>;
export const MoveModelDocument = gql`
    mutation MoveModel($id: String!, $modelFolderId: String!, $name: String!) {
  moveModel(input: {id: $id, modelFolderId: $modelFolderId, name: $name}) {
    ...ModelListItem
  }
}
    ${ModelListItemFragmentDoc}`;
export type MoveModelMutationFn = Apollo.MutationFunction<MoveModelMutation, MoveModelMutationVariables>;

/**
 * __useMoveModelMutation__
 *
 * To run a mutation, you first call `useMoveModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveModelMutation, { data, loading, error }] = useMoveModelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      modelFolderId: // value for 'modelFolderId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useMoveModelMutation(baseOptions?: Apollo.MutationHookOptions<MoveModelMutation, MoveModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveModelMutation, MoveModelMutationVariables>(MoveModelDocument, options);
      }
export type MoveModelMutationHookResult = ReturnType<typeof useMoveModelMutation>;
export type MoveModelMutationResult = Apollo.MutationResult<MoveModelMutation>;
export type MoveModelMutationOptions = Apollo.BaseMutationOptions<MoveModelMutation, MoveModelMutationVariables>;
export const RemoveModelDocument = gql`
    mutation RemoveModel($modelId: String!) {
  removeModel(id: $modelId) {
    id
  }
}
    `;
export type RemoveModelMutationFn = Apollo.MutationFunction<RemoveModelMutation, RemoveModelMutationVariables>;

/**
 * __useRemoveModelMutation__
 *
 * To run a mutation, you first call `useRemoveModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeModelMutation, { data, loading, error }] = useRemoveModelMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useRemoveModelMutation(baseOptions?: Apollo.MutationHookOptions<RemoveModelMutation, RemoveModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveModelMutation, RemoveModelMutationVariables>(RemoveModelDocument, options);
      }
export type RemoveModelMutationHookResult = ReturnType<typeof useRemoveModelMutation>;
export type RemoveModelMutationResult = Apollo.MutationResult<RemoveModelMutation>;
export type RemoveModelMutationOptions = Apollo.BaseMutationOptions<RemoveModelMutation, RemoveModelMutationVariables>;
export const RemoveDashboardModelsDocument = gql`
    mutation RemoveDashboardModels($dashboardId: String!) {
  removeDashboardModels(dashboardId: $dashboardId) {
    id
  }
}
    `;
export type RemoveDashboardModelsMutationFn = Apollo.MutationFunction<RemoveDashboardModelsMutation, RemoveDashboardModelsMutationVariables>;

/**
 * __useRemoveDashboardModelsMutation__
 *
 * To run a mutation, you first call `useRemoveDashboardModelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDashboardModelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDashboardModelsMutation, { data, loading, error }] = useRemoveDashboardModelsMutation({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *   },
 * });
 */
export function useRemoveDashboardModelsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDashboardModelsMutation, RemoveDashboardModelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDashboardModelsMutation, RemoveDashboardModelsMutationVariables>(RemoveDashboardModelsDocument, options);
      }
export type RemoveDashboardModelsMutationHookResult = ReturnType<typeof useRemoveDashboardModelsMutation>;
export type RemoveDashboardModelsMutationResult = Apollo.MutationResult<RemoveDashboardModelsMutation>;
export type RemoveDashboardModelsMutationOptions = Apollo.BaseMutationOptions<RemoveDashboardModelsMutation, RemoveDashboardModelsMutationVariables>;
export const RematerializeNowDocument = gql`
    mutation RematerializeNow($modelId: String!) {
  rematerializeNow(modelId: $modelId) {
    id
    dwTable {
      ...MaterializedTableReferenceFragment
    }
  }
}
    ${MaterializedTableReferenceFragmentFragmentDoc}`;
export type RematerializeNowMutationFn = Apollo.MutationFunction<RematerializeNowMutation, RematerializeNowMutationVariables>;

/**
 * __useRematerializeNowMutation__
 *
 * To run a mutation, you first call `useRematerializeNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRematerializeNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rematerializeNowMutation, { data, loading, error }] = useRematerializeNowMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useRematerializeNowMutation(baseOptions?: Apollo.MutationHookOptions<RematerializeNowMutation, RematerializeNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RematerializeNowMutation, RematerializeNowMutationVariables>(RematerializeNowDocument, options);
      }
export type RematerializeNowMutationHookResult = ReturnType<typeof useRematerializeNowMutation>;
export type RematerializeNowMutationResult = Apollo.MutationResult<RematerializeNowMutation>;
export type RematerializeNowMutationOptions = Apollo.BaseMutationOptions<RematerializeNowMutation, RematerializeNowMutationVariables>;
export const UpdateModelEmojiDocument = gql`
    mutation UpdateModelEmoji($modelId: String!, $emoji: String) {
  updateModelEmoji(modelId: $modelId, emoji: $emoji) {
    id
    emoji
  }
}
    `;
export type UpdateModelEmojiMutationFn = Apollo.MutationFunction<UpdateModelEmojiMutation, UpdateModelEmojiMutationVariables>;

/**
 * __useUpdateModelEmojiMutation__
 *
 * To run a mutation, you first call `useUpdateModelEmojiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModelEmojiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModelEmojiMutation, { data, loading, error }] = useUpdateModelEmojiMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      emoji: // value for 'emoji'
 *   },
 * });
 */
export function useUpdateModelEmojiMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModelEmojiMutation, UpdateModelEmojiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModelEmojiMutation, UpdateModelEmojiMutationVariables>(UpdateModelEmojiDocument, options);
      }
export type UpdateModelEmojiMutationHookResult = ReturnType<typeof useUpdateModelEmojiMutation>;
export type UpdateModelEmojiMutationResult = Apollo.MutationResult<UpdateModelEmojiMutation>;
export type UpdateModelEmojiMutationOptions = Apollo.BaseMutationOptions<UpdateModelEmojiMutation, UpdateModelEmojiMutationVariables>;
export const UpdateFolderEmojiDocument = gql`
    mutation UpdateFolderEmoji($folderId: String!, $emoji: String) {
  updateFolderEmoji(folderId: $folderId, emoji: $emoji)
}
    `;
export type UpdateFolderEmojiMutationFn = Apollo.MutationFunction<UpdateFolderEmojiMutation, UpdateFolderEmojiMutationVariables>;

/**
 * __useUpdateFolderEmojiMutation__
 *
 * To run a mutation, you first call `useUpdateFolderEmojiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFolderEmojiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFolderEmojiMutation, { data, loading, error }] = useUpdateFolderEmojiMutation({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      emoji: // value for 'emoji'
 *   },
 * });
 */
export function useUpdateFolderEmojiMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFolderEmojiMutation, UpdateFolderEmojiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFolderEmojiMutation, UpdateFolderEmojiMutationVariables>(UpdateFolderEmojiDocument, options);
      }
export type UpdateFolderEmojiMutationHookResult = ReturnType<typeof useUpdateFolderEmojiMutation>;
export type UpdateFolderEmojiMutationResult = Apollo.MutationResult<UpdateFolderEmojiMutation>;
export type UpdateFolderEmojiMutationOptions = Apollo.BaseMutationOptions<UpdateFolderEmojiMutation, UpdateFolderEmojiMutationVariables>;
export const ModelDocument = gql`
    query Model($modelId: String!) {
  model(id: $modelId) {
    ...ModelListItem
  }
}
    ${ModelListItemFragmentDoc}`;

/**
 * __useModelQuery__
 *
 * To run a query within a React component, call `useModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useModelQuery(baseOptions: Apollo.QueryHookOptions<ModelQuery, ModelQueryVariables> & ({ variables: ModelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelQuery, ModelQueryVariables>(ModelDocument, options);
      }
export function useModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelQuery, ModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelQuery, ModelQueryVariables>(ModelDocument, options);
        }
export function useModelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ModelQuery, ModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModelQuery, ModelQueryVariables>(ModelDocument, options);
        }
export type ModelQueryHookResult = ReturnType<typeof useModelQuery>;
export type ModelLazyQueryHookResult = ReturnType<typeof useModelLazyQuery>;
export type ModelSuspenseQueryHookResult = ReturnType<typeof useModelSuspenseQuery>;
export type ModelQueryResult = Apollo.QueryResult<ModelQuery, ModelQueryVariables>;
export const ModelsByIdsDocument = gql`
    query ModelsByIds($modelIds: [String!]!) {
  modelsByIds(ids: $modelIds) {
    ...ModelListItem
  }
}
    ${ModelListItemFragmentDoc}`;

/**
 * __useModelsByIdsQuery__
 *
 * To run a query within a React component, call `useModelsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelsByIdsQuery({
 *   variables: {
 *      modelIds: // value for 'modelIds'
 *   },
 * });
 */
export function useModelsByIdsQuery(baseOptions: Apollo.QueryHookOptions<ModelsByIdsQuery, ModelsByIdsQueryVariables> & ({ variables: ModelsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelsByIdsQuery, ModelsByIdsQueryVariables>(ModelsByIdsDocument, options);
      }
export function useModelsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelsByIdsQuery, ModelsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelsByIdsQuery, ModelsByIdsQueryVariables>(ModelsByIdsDocument, options);
        }
export function useModelsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ModelsByIdsQuery, ModelsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModelsByIdsQuery, ModelsByIdsQueryVariables>(ModelsByIdsDocument, options);
        }
export type ModelsByIdsQueryHookResult = ReturnType<typeof useModelsByIdsQuery>;
export type ModelsByIdsLazyQueryHookResult = ReturnType<typeof useModelsByIdsLazyQuery>;
export type ModelsByIdsSuspenseQueryHookResult = ReturnType<typeof useModelsByIdsSuspenseQuery>;
export type ModelsByIdsQueryResult = Apollo.QueryResult<ModelsByIdsQuery, ModelsByIdsQueryVariables>;
export const PublishedModelsDocument = gql`
    query PublishedModels {
  publishedModels {
    ...ModelListItem
  }
}
    ${ModelListItemFragmentDoc}`;

/**
 * __usePublishedModelsQuery__
 *
 * To run a query within a React component, call `usePublishedModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishedModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishedModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublishedModelsQuery(baseOptions?: Apollo.QueryHookOptions<PublishedModelsQuery, PublishedModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishedModelsQuery, PublishedModelsQueryVariables>(PublishedModelsDocument, options);
      }
export function usePublishedModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishedModelsQuery, PublishedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishedModelsQuery, PublishedModelsQueryVariables>(PublishedModelsDocument, options);
        }
export function usePublishedModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublishedModelsQuery, PublishedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublishedModelsQuery, PublishedModelsQueryVariables>(PublishedModelsDocument, options);
        }
export type PublishedModelsQueryHookResult = ReturnType<typeof usePublishedModelsQuery>;
export type PublishedModelsLazyQueryHookResult = ReturnType<typeof usePublishedModelsLazyQuery>;
export type PublishedModelsSuspenseQueryHookResult = ReturnType<typeof usePublishedModelsSuspenseQuery>;
export type PublishedModelsQueryResult = Apollo.QueryResult<PublishedModelsQuery, PublishedModelsQueryVariables>;
export const SavedDraftModelsDocument = gql`
    query SavedDraftModels {
  savedDrafts {
    ...ModelBase
  }
}
    ${ModelBaseFragmentDoc}`;

/**
 * __useSavedDraftModelsQuery__
 *
 * To run a query within a React component, call `useSavedDraftModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedDraftModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedDraftModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSavedDraftModelsQuery(baseOptions?: Apollo.QueryHookOptions<SavedDraftModelsQuery, SavedDraftModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedDraftModelsQuery, SavedDraftModelsQueryVariables>(SavedDraftModelsDocument, options);
      }
export function useSavedDraftModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedDraftModelsQuery, SavedDraftModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedDraftModelsQuery, SavedDraftModelsQueryVariables>(SavedDraftModelsDocument, options);
        }
export function useSavedDraftModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SavedDraftModelsQuery, SavedDraftModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SavedDraftModelsQuery, SavedDraftModelsQueryVariables>(SavedDraftModelsDocument, options);
        }
export type SavedDraftModelsQueryHookResult = ReturnType<typeof useSavedDraftModelsQuery>;
export type SavedDraftModelsLazyQueryHookResult = ReturnType<typeof useSavedDraftModelsLazyQuery>;
export type SavedDraftModelsSuspenseQueryHookResult = ReturnType<typeof useSavedDraftModelsSuspenseQuery>;
export type SavedDraftModelsQueryResult = Apollo.QueryResult<SavedDraftModelsQuery, SavedDraftModelsQueryVariables>;
export const MostRecentPublishedModelsDocument = gql`
    query MostRecentPublishedModels {
  mostRecentPublishedModels {
    ...ModelListItem
  }
}
    ${ModelListItemFragmentDoc}`;

/**
 * __useMostRecentPublishedModelsQuery__
 *
 * To run a query within a React component, call `useMostRecentPublishedModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMostRecentPublishedModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMostRecentPublishedModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMostRecentPublishedModelsQuery(baseOptions?: Apollo.QueryHookOptions<MostRecentPublishedModelsQuery, MostRecentPublishedModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MostRecentPublishedModelsQuery, MostRecentPublishedModelsQueryVariables>(MostRecentPublishedModelsDocument, options);
      }
export function useMostRecentPublishedModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MostRecentPublishedModelsQuery, MostRecentPublishedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MostRecentPublishedModelsQuery, MostRecentPublishedModelsQueryVariables>(MostRecentPublishedModelsDocument, options);
        }
export function useMostRecentPublishedModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MostRecentPublishedModelsQuery, MostRecentPublishedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MostRecentPublishedModelsQuery, MostRecentPublishedModelsQueryVariables>(MostRecentPublishedModelsDocument, options);
        }
export type MostRecentPublishedModelsQueryHookResult = ReturnType<typeof useMostRecentPublishedModelsQuery>;
export type MostRecentPublishedModelsLazyQueryHookResult = ReturnType<typeof useMostRecentPublishedModelsLazyQuery>;
export type MostRecentPublishedModelsSuspenseQueryHookResult = ReturnType<typeof useMostRecentPublishedModelsSuspenseQuery>;
export type MostRecentPublishedModelsQueryResult = Apollo.QueryResult<MostRecentPublishedModelsQuery, MostRecentPublishedModelsQueryVariables>;
export const ModelUsageSummaryDocument = gql`
    query ModelUsageSummary {
  modelUsageSummary {
    publishedModels
    draftModels
  }
}
    `;

/**
 * __useModelUsageSummaryQuery__
 *
 * To run a query within a React component, call `useModelUsageSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelUsageSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelUsageSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useModelUsageSummaryQuery(baseOptions?: Apollo.QueryHookOptions<ModelUsageSummaryQuery, ModelUsageSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelUsageSummaryQuery, ModelUsageSummaryQueryVariables>(ModelUsageSummaryDocument, options);
      }
export function useModelUsageSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelUsageSummaryQuery, ModelUsageSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelUsageSummaryQuery, ModelUsageSummaryQueryVariables>(ModelUsageSummaryDocument, options);
        }
export function useModelUsageSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ModelUsageSummaryQuery, ModelUsageSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModelUsageSummaryQuery, ModelUsageSummaryQueryVariables>(ModelUsageSummaryDocument, options);
        }
export type ModelUsageSummaryQueryHookResult = ReturnType<typeof useModelUsageSummaryQuery>;
export type ModelUsageSummaryLazyQueryHookResult = ReturnType<typeof useModelUsageSummaryLazyQuery>;
export type ModelUsageSummarySuspenseQueryHookResult = ReturnType<typeof useModelUsageSummarySuspenseQuery>;
export type ModelUsageSummaryQueryResult = Apollo.QueryResult<ModelUsageSummaryQuery, ModelUsageSummaryQueryVariables>;
export const SearchModelsDocument = gql`
    query SearchModels($query: String!, $publishedOnly: Boolean!) {
  searchModels(query: $query, publishedOnly: $publishedOnly) {
    ...ModelSearchResult
  }
}
    ${ModelSearchResultFragmentDoc}`;

/**
 * __useSearchModelsQuery__
 *
 * To run a query within a React component, call `useSearchModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchModelsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      publishedOnly: // value for 'publishedOnly'
 *   },
 * });
 */
export function useSearchModelsQuery(baseOptions: Apollo.QueryHookOptions<SearchModelsQuery, SearchModelsQueryVariables> & ({ variables: SearchModelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchModelsQuery, SearchModelsQueryVariables>(SearchModelsDocument, options);
      }
export function useSearchModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchModelsQuery, SearchModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchModelsQuery, SearchModelsQueryVariables>(SearchModelsDocument, options);
        }
export function useSearchModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchModelsQuery, SearchModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchModelsQuery, SearchModelsQueryVariables>(SearchModelsDocument, options);
        }
export type SearchModelsQueryHookResult = ReturnType<typeof useSearchModelsQuery>;
export type SearchModelsLazyQueryHookResult = ReturnType<typeof useSearchModelsLazyQuery>;
export type SearchModelsSuspenseQueryHookResult = ReturnType<typeof useSearchModelsSuspenseQuery>;
export type SearchModelsQueryResult = Apollo.QueryResult<SearchModelsQuery, SearchModelsQueryVariables>;
export const ListDeletedModelsDocument = gql`
    query ListDeletedModels {
  deletedModels {
    id
    name
    integrationId
    createdAt
    userId
    emoji
  }
}
    `;

/**
 * __useListDeletedModelsQuery__
 *
 * To run a query within a React component, call `useListDeletedModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDeletedModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDeletedModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListDeletedModelsQuery(baseOptions?: Apollo.QueryHookOptions<ListDeletedModelsQuery, ListDeletedModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDeletedModelsQuery, ListDeletedModelsQueryVariables>(ListDeletedModelsDocument, options);
      }
export function useListDeletedModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDeletedModelsQuery, ListDeletedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDeletedModelsQuery, ListDeletedModelsQueryVariables>(ListDeletedModelsDocument, options);
        }
export function useListDeletedModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListDeletedModelsQuery, ListDeletedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDeletedModelsQuery, ListDeletedModelsQueryVariables>(ListDeletedModelsDocument, options);
        }
export type ListDeletedModelsQueryHookResult = ReturnType<typeof useListDeletedModelsQuery>;
export type ListDeletedModelsLazyQueryHookResult = ReturnType<typeof useListDeletedModelsLazyQuery>;
export type ListDeletedModelsSuspenseQueryHookResult = ReturnType<typeof useListDeletedModelsSuspenseQuery>;
export type ListDeletedModelsQueryResult = Apollo.QueryResult<ListDeletedModelsQuery, ListDeletedModelsQueryVariables>;
export const HasDeletedModelsDocument = gql`
    query HasDeletedModels {
  hasDeletedModels {
    value
  }
}
    `;

/**
 * __useHasDeletedModelsQuery__
 *
 * To run a query within a React component, call `useHasDeletedModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasDeletedModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasDeletedModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasDeletedModelsQuery(baseOptions?: Apollo.QueryHookOptions<HasDeletedModelsQuery, HasDeletedModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasDeletedModelsQuery, HasDeletedModelsQueryVariables>(HasDeletedModelsDocument, options);
      }
export function useHasDeletedModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasDeletedModelsQuery, HasDeletedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasDeletedModelsQuery, HasDeletedModelsQueryVariables>(HasDeletedModelsDocument, options);
        }
export function useHasDeletedModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HasDeletedModelsQuery, HasDeletedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HasDeletedModelsQuery, HasDeletedModelsQueryVariables>(HasDeletedModelsDocument, options);
        }
export type HasDeletedModelsQueryHookResult = ReturnType<typeof useHasDeletedModelsQuery>;
export type HasDeletedModelsLazyQueryHookResult = ReturnType<typeof useHasDeletedModelsLazyQuery>;
export type HasDeletedModelsSuspenseQueryHookResult = ReturnType<typeof useHasDeletedModelsSuspenseQuery>;
export type HasDeletedModelsQueryResult = Apollo.QueryResult<HasDeletedModelsQuery, HasDeletedModelsQueryVariables>;
export const RestoreDeletedModelDocument = gql`
    mutation RestoreDeletedModel($modelId: String!) {
  restoreDeletedModel(id: $modelId) {
    ...ModelListItem
  }
}
    ${ModelListItemFragmentDoc}`;
export type RestoreDeletedModelMutationFn = Apollo.MutationFunction<RestoreDeletedModelMutation, RestoreDeletedModelMutationVariables>;

/**
 * __useRestoreDeletedModelMutation__
 *
 * To run a mutation, you first call `useRestoreDeletedModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDeletedModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDeletedModelMutation, { data, loading, error }] = useRestoreDeletedModelMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useRestoreDeletedModelMutation(baseOptions?: Apollo.MutationHookOptions<RestoreDeletedModelMutation, RestoreDeletedModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreDeletedModelMutation, RestoreDeletedModelMutationVariables>(RestoreDeletedModelDocument, options);
      }
export type RestoreDeletedModelMutationHookResult = ReturnType<typeof useRestoreDeletedModelMutation>;
export type RestoreDeletedModelMutationResult = Apollo.MutationResult<RestoreDeletedModelMutation>;
export type RestoreDeletedModelMutationOptions = Apollo.BaseMutationOptions<RestoreDeletedModelMutation, RestoreDeletedModelMutationVariables>;
export const UpdateModelTableReferencesDocument = gql`
    query UpdateModelTableReferences {
  publishedModels {
    dwTable {
      ...MaterializedTableReferenceFragment
    }
  }
}
    ${MaterializedTableReferenceFragmentFragmentDoc}`;

/**
 * __useUpdateModelTableReferencesQuery__
 *
 * To run a query within a React component, call `useUpdateModelTableReferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateModelTableReferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateModelTableReferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpdateModelTableReferencesQuery(baseOptions?: Apollo.QueryHookOptions<UpdateModelTableReferencesQuery, UpdateModelTableReferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateModelTableReferencesQuery, UpdateModelTableReferencesQueryVariables>(UpdateModelTableReferencesDocument, options);
      }
export function useUpdateModelTableReferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateModelTableReferencesQuery, UpdateModelTableReferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateModelTableReferencesQuery, UpdateModelTableReferencesQueryVariables>(UpdateModelTableReferencesDocument, options);
        }
export function useUpdateModelTableReferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpdateModelTableReferencesQuery, UpdateModelTableReferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpdateModelTableReferencesQuery, UpdateModelTableReferencesQueryVariables>(UpdateModelTableReferencesDocument, options);
        }
export type UpdateModelTableReferencesQueryHookResult = ReturnType<typeof useUpdateModelTableReferencesQuery>;
export type UpdateModelTableReferencesLazyQueryHookResult = ReturnType<typeof useUpdateModelTableReferencesLazyQuery>;
export type UpdateModelTableReferencesSuspenseQueryHookResult = ReturnType<typeof useUpdateModelTableReferencesSuspenseQuery>;
export type UpdateModelTableReferencesQueryResult = Apollo.QueryResult<UpdateModelTableReferencesQuery, UpdateModelTableReferencesQueryVariables>;
export const GetLocalMaterializationJobDocument = gql`
    query getLocalMaterializationJob($modelId: String!) {
  model(id: $modelId) {
    id
    localMaterializationJob {
      modelId
      queryId
      status
      lastRun
      nextRun
      startedAt
      cronExpression
      latestErrorMessage
    }
  }
}
    `;

/**
 * __useGetLocalMaterializationJobQuery__
 *
 * To run a query within a React component, call `useGetLocalMaterializationJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalMaterializationJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalMaterializationJobQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useGetLocalMaterializationJobQuery(baseOptions: Apollo.QueryHookOptions<GetLocalMaterializationJobQuery, GetLocalMaterializationJobQueryVariables> & ({ variables: GetLocalMaterializationJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocalMaterializationJobQuery, GetLocalMaterializationJobQueryVariables>(GetLocalMaterializationJobDocument, options);
      }
export function useGetLocalMaterializationJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocalMaterializationJobQuery, GetLocalMaterializationJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocalMaterializationJobQuery, GetLocalMaterializationJobQueryVariables>(GetLocalMaterializationJobDocument, options);
        }
export function useGetLocalMaterializationJobSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocalMaterializationJobQuery, GetLocalMaterializationJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocalMaterializationJobQuery, GetLocalMaterializationJobQueryVariables>(GetLocalMaterializationJobDocument, options);
        }
export type GetLocalMaterializationJobQueryHookResult = ReturnType<typeof useGetLocalMaterializationJobQuery>;
export type GetLocalMaterializationJobLazyQueryHookResult = ReturnType<typeof useGetLocalMaterializationJobLazyQuery>;
export type GetLocalMaterializationJobSuspenseQueryHookResult = ReturnType<typeof useGetLocalMaterializationJobSuspenseQuery>;
export type GetLocalMaterializationJobQueryResult = Apollo.QueryResult<GetLocalMaterializationJobQuery, GetLocalMaterializationJobQueryVariables>;
export const GetMaterializationTableDocument = gql`
    query getMaterializationTable($modelId: String!) {
  model(id: $modelId) {
    id
    dwTable {
      accountId
      modelId
      queryId
      type
      path
      weldTag
      dwSqlReference
      createdAt
      latestSyncTime
      status
      latestRunErrorMessage
    }
  }
}
    `;

/**
 * __useGetMaterializationTableQuery__
 *
 * To run a query within a React component, call `useGetMaterializationTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterializationTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterializationTableQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useGetMaterializationTableQuery(baseOptions: Apollo.QueryHookOptions<GetMaterializationTableQuery, GetMaterializationTableQueryVariables> & ({ variables: GetMaterializationTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterializationTableQuery, GetMaterializationTableQueryVariables>(GetMaterializationTableDocument, options);
      }
export function useGetMaterializationTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterializationTableQuery, GetMaterializationTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterializationTableQuery, GetMaterializationTableQueryVariables>(GetMaterializationTableDocument, options);
        }
export function useGetMaterializationTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMaterializationTableQuery, GetMaterializationTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMaterializationTableQuery, GetMaterializationTableQueryVariables>(GetMaterializationTableDocument, options);
        }
export type GetMaterializationTableQueryHookResult = ReturnType<typeof useGetMaterializationTableQuery>;
export type GetMaterializationTableLazyQueryHookResult = ReturnType<typeof useGetMaterializationTableLazyQuery>;
export type GetMaterializationTableSuspenseQueryHookResult = ReturnType<typeof useGetMaterializationTableSuspenseQuery>;
export type GetMaterializationTableQueryResult = Apollo.QueryResult<GetMaterializationTableQuery, GetMaterializationTableQueryVariables>;
export const SqlQueryDocument = gql`
    query SqlQuery($modelId: String!) {
  model(id: $modelId) {
    id
    publishedQuery {
      ...PublishedQueryWithSQLFragment
    }
  }
}
    ${PublishedQueryWithSqlFragmentFragmentDoc}`;

/**
 * __useSqlQueryQuery__
 *
 * To run a query within a React component, call `useSqlQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSqlQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSqlQueryQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useSqlQueryQuery(baseOptions: Apollo.QueryHookOptions<SqlQueryQuery, SqlQueryQueryVariables> & ({ variables: SqlQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SqlQueryQuery, SqlQueryQueryVariables>(SqlQueryDocument, options);
      }
export function useSqlQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SqlQueryQuery, SqlQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SqlQueryQuery, SqlQueryQueryVariables>(SqlQueryDocument, options);
        }
export function useSqlQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SqlQueryQuery, SqlQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SqlQueryQuery, SqlQueryQueryVariables>(SqlQueryDocument, options);
        }
export type SqlQueryQueryHookResult = ReturnType<typeof useSqlQueryQuery>;
export type SqlQueryLazyQueryHookResult = ReturnType<typeof useSqlQueryLazyQuery>;
export type SqlQuerySuspenseQueryHookResult = ReturnType<typeof useSqlQuerySuspenseQuery>;
export type SqlQueryQueryResult = Apollo.QueryResult<SqlQueryQuery, SqlQueryQueryVariables>;
export const ModelDocumentationDocument = gql`
    query ModelDocumentation($modelId: String!) {
  model(id: $modelId) {
    documentation
  }
}
    `;

/**
 * __useModelDocumentationQuery__
 *
 * To run a query within a React component, call `useModelDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelDocumentationQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useModelDocumentationQuery(baseOptions: Apollo.QueryHookOptions<ModelDocumentationQuery, ModelDocumentationQueryVariables> & ({ variables: ModelDocumentationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelDocumentationQuery, ModelDocumentationQueryVariables>(ModelDocumentationDocument, options);
      }
export function useModelDocumentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelDocumentationQuery, ModelDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelDocumentationQuery, ModelDocumentationQueryVariables>(ModelDocumentationDocument, options);
        }
export function useModelDocumentationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ModelDocumentationQuery, ModelDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModelDocumentationQuery, ModelDocumentationQueryVariables>(ModelDocumentationDocument, options);
        }
export type ModelDocumentationQueryHookResult = ReturnType<typeof useModelDocumentationQuery>;
export type ModelDocumentationLazyQueryHookResult = ReturnType<typeof useModelDocumentationLazyQuery>;
export type ModelDocumentationSuspenseQueryHookResult = ReturnType<typeof useModelDocumentationSuspenseQuery>;
export type ModelDocumentationQueryResult = Apollo.QueryResult<ModelDocumentationQuery, ModelDocumentationQueryVariables>;
export const FindQueryHistoryDocument = gql`
    query FindQueryHistory($modelId: String!) {
  model(id: $modelId) {
    id
    sqlQueries {
      id
      data
      weldSql
      dependencies {
        dwItemId
        type
        weldTag
      }
      createdAt
      user {
        firstName
        lastName
        email
      }
    }
  }
}
    `;

/**
 * __useFindQueryHistoryQuery__
 *
 * To run a query within a React component, call `useFindQueryHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindQueryHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindQueryHistoryQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useFindQueryHistoryQuery(baseOptions: Apollo.QueryHookOptions<FindQueryHistoryQuery, FindQueryHistoryQueryVariables> & ({ variables: FindQueryHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindQueryHistoryQuery, FindQueryHistoryQueryVariables>(FindQueryHistoryDocument, options);
      }
export function useFindQueryHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindQueryHistoryQuery, FindQueryHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindQueryHistoryQuery, FindQueryHistoryQueryVariables>(FindQueryHistoryDocument, options);
        }
export function useFindQueryHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindQueryHistoryQuery, FindQueryHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindQueryHistoryQuery, FindQueryHistoryQueryVariables>(FindQueryHistoryDocument, options);
        }
export type FindQueryHistoryQueryHookResult = ReturnType<typeof useFindQueryHistoryQuery>;
export type FindQueryHistoryLazyQueryHookResult = ReturnType<typeof useFindQueryHistoryLazyQuery>;
export type FindQueryHistorySuspenseQueryHookResult = ReturnType<typeof useFindQueryHistorySuspenseQuery>;
export type FindQueryHistoryQueryResult = Apollo.QueryResult<FindQueryHistoryQuery, FindQueryHistoryQueryVariables>;
export const GetDwDirectoryDocument = gql`
    query getDWDirectory($input: GetDWDirectoryInput!) {
  getDWDirectory(input: $input) {
    typename
    children
    hasNext
  }
}
    `;

/**
 * __useGetDwDirectoryQuery__
 *
 * To run a query within a React component, call `useGetDwDirectoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDwDirectoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDwDirectoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDwDirectoryQuery(baseOptions: Apollo.QueryHookOptions<GetDwDirectoryQuery, GetDwDirectoryQueryVariables> & ({ variables: GetDwDirectoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDwDirectoryQuery, GetDwDirectoryQueryVariables>(GetDwDirectoryDocument, options);
      }
export function useGetDwDirectoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDwDirectoryQuery, GetDwDirectoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDwDirectoryQuery, GetDwDirectoryQueryVariables>(GetDwDirectoryDocument, options);
        }
export function useGetDwDirectorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDwDirectoryQuery, GetDwDirectoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDwDirectoryQuery, GetDwDirectoryQueryVariables>(GetDwDirectoryDocument, options);
        }
export type GetDwDirectoryQueryHookResult = ReturnType<typeof useGetDwDirectoryQuery>;
export type GetDwDirectoryLazyQueryHookResult = ReturnType<typeof useGetDwDirectoryLazyQuery>;
export type GetDwDirectorySuspenseQueryHookResult = ReturnType<typeof useGetDwDirectorySuspenseQuery>;
export type GetDwDirectoryQueryResult = Apollo.QueryResult<GetDwDirectoryQuery, GetDwDirectoryQueryVariables>;
export const GetDwDirectoryItemsDocument = gql`
    query getDWDirectoryItems($input: GetDWDirectoryItemsInput!) {
  getDWDirectoryItems(input: $input) {
    path
  }
}
    `;

/**
 * __useGetDwDirectoryItemsQuery__
 *
 * To run a query within a React component, call `useGetDwDirectoryItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDwDirectoryItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDwDirectoryItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDwDirectoryItemsQuery(baseOptions: Apollo.QueryHookOptions<GetDwDirectoryItemsQuery, GetDwDirectoryItemsQueryVariables> & ({ variables: GetDwDirectoryItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDwDirectoryItemsQuery, GetDwDirectoryItemsQueryVariables>(GetDwDirectoryItemsDocument, options);
      }
export function useGetDwDirectoryItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDwDirectoryItemsQuery, GetDwDirectoryItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDwDirectoryItemsQuery, GetDwDirectoryItemsQueryVariables>(GetDwDirectoryItemsDocument, options);
        }
export function useGetDwDirectoryItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDwDirectoryItemsQuery, GetDwDirectoryItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDwDirectoryItemsQuery, GetDwDirectoryItemsQueryVariables>(GetDwDirectoryItemsDocument, options);
        }
export type GetDwDirectoryItemsQueryHookResult = ReturnType<typeof useGetDwDirectoryItemsQuery>;
export type GetDwDirectoryItemsLazyQueryHookResult = ReturnType<typeof useGetDwDirectoryItemsLazyQuery>;
export type GetDwDirectoryItemsSuspenseQueryHookResult = ReturnType<typeof useGetDwDirectoryItemsSuspenseQuery>;
export type GetDwDirectoryItemsQueryResult = Apollo.QueryResult<GetDwDirectoryItemsQuery, GetDwDirectoryItemsQueryVariables>;
export const ImportDwDirectoryDocument = gql`
    mutation importDWDirectory($input: ImportDWDirectoryInput!) {
  importDWDirectory(input: $input) {
    path
    error
  }
}
    `;
export type ImportDwDirectoryMutationFn = Apollo.MutationFunction<ImportDwDirectoryMutation, ImportDwDirectoryMutationVariables>;

/**
 * __useImportDwDirectoryMutation__
 *
 * To run a mutation, you first call `useImportDwDirectoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportDwDirectoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importDwDirectoryMutation, { data, loading, error }] = useImportDwDirectoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportDwDirectoryMutation(baseOptions?: Apollo.MutationHookOptions<ImportDwDirectoryMutation, ImportDwDirectoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportDwDirectoryMutation, ImportDwDirectoryMutationVariables>(ImportDwDirectoryDocument, options);
      }
export type ImportDwDirectoryMutationHookResult = ReturnType<typeof useImportDwDirectoryMutation>;
export type ImportDwDirectoryMutationResult = Apollo.MutationResult<ImportDwDirectoryMutation>;
export type ImportDwDirectoryMutationOptions = Apollo.BaseMutationOptions<ImportDwDirectoryMutation, ImportDwDirectoryMutationVariables>;
export const ListModelFoldersDocument = gql`
    query listModelFolders {
  listModelFolders {
    id
    name
    emoji
    type
    parentId
    DWName
  }
}
    `;

/**
 * __useListModelFoldersQuery__
 *
 * To run a query within a React component, call `useListModelFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListModelFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListModelFoldersQuery({
 *   variables: {
 *   },
 * });
 */
export function useListModelFoldersQuery(baseOptions?: Apollo.QueryHookOptions<ListModelFoldersQuery, ListModelFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListModelFoldersQuery, ListModelFoldersQueryVariables>(ListModelFoldersDocument, options);
      }
export function useListModelFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListModelFoldersQuery, ListModelFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListModelFoldersQuery, ListModelFoldersQueryVariables>(ListModelFoldersDocument, options);
        }
export function useListModelFoldersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListModelFoldersQuery, ListModelFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListModelFoldersQuery, ListModelFoldersQueryVariables>(ListModelFoldersDocument, options);
        }
export type ListModelFoldersQueryHookResult = ReturnType<typeof useListModelFoldersQuery>;
export type ListModelFoldersLazyQueryHookResult = ReturnType<typeof useListModelFoldersLazyQuery>;
export type ListModelFoldersSuspenseQueryHookResult = ReturnType<typeof useListModelFoldersSuspenseQuery>;
export type ListModelFoldersQueryResult = Apollo.QueryResult<ListModelFoldersQuery, ListModelFoldersQueryVariables>;
export const VerifyUnpublishedChangesDocument = gql`
    query VerifyUnpublishedChanges($modelId: String!) {
  verifyUnpublishedChanges(modelId: $modelId) {
    hasUnpublishedChanges
  }
}
    `;

/**
 * __useVerifyUnpublishedChangesQuery__
 *
 * To run a query within a React component, call `useVerifyUnpublishedChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyUnpublishedChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyUnpublishedChangesQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useVerifyUnpublishedChangesQuery(baseOptions: Apollo.QueryHookOptions<VerifyUnpublishedChangesQuery, VerifyUnpublishedChangesQueryVariables> & ({ variables: VerifyUnpublishedChangesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifyUnpublishedChangesQuery, VerifyUnpublishedChangesQueryVariables>(VerifyUnpublishedChangesDocument, options);
      }
export function useVerifyUnpublishedChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifyUnpublishedChangesQuery, VerifyUnpublishedChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifyUnpublishedChangesQuery, VerifyUnpublishedChangesQueryVariables>(VerifyUnpublishedChangesDocument, options);
        }
export function useVerifyUnpublishedChangesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VerifyUnpublishedChangesQuery, VerifyUnpublishedChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerifyUnpublishedChangesQuery, VerifyUnpublishedChangesQueryVariables>(VerifyUnpublishedChangesDocument, options);
        }
export type VerifyUnpublishedChangesQueryHookResult = ReturnType<typeof useVerifyUnpublishedChangesQuery>;
export type VerifyUnpublishedChangesLazyQueryHookResult = ReturnType<typeof useVerifyUnpublishedChangesLazyQuery>;
export type VerifyUnpublishedChangesSuspenseQueryHookResult = ReturnType<typeof useVerifyUnpublishedChangesSuspenseQuery>;
export type VerifyUnpublishedChangesQueryResult = Apollo.QueryResult<VerifyUnpublishedChangesQuery, VerifyUnpublishedChangesQueryVariables>;
export const CreateModelFolderDocument = gql`
    mutation createModelFolder($input: CreateFolderInput!) {
  createModelFolder(createFolderInput: $input) {
    name
    type
    DWName
    id
  }
}
    `;
export type CreateModelFolderMutationFn = Apollo.MutationFunction<CreateModelFolderMutation, CreateModelFolderMutationVariables>;

/**
 * __useCreateModelFolderMutation__
 *
 * To run a mutation, you first call `useCreateModelFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModelFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModelFolderMutation, { data, loading, error }] = useCreateModelFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateModelFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateModelFolderMutation, CreateModelFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModelFolderMutation, CreateModelFolderMutationVariables>(CreateModelFolderDocument, options);
      }
export type CreateModelFolderMutationHookResult = ReturnType<typeof useCreateModelFolderMutation>;
export type CreateModelFolderMutationResult = Apollo.MutationResult<CreateModelFolderMutation>;
export type CreateModelFolderMutationOptions = Apollo.BaseMutationOptions<CreateModelFolderMutation, CreateModelFolderMutationVariables>;
export const InitiateModelFoldersDocument = gql`
    mutation initiateModelFolders($input: [CreateFolderInput!]!) {
  initiateModelFolders(initiateFoldersInput: $input) {
    name
    type
    DWName
    id
  }
}
    `;
export type InitiateModelFoldersMutationFn = Apollo.MutationFunction<InitiateModelFoldersMutation, InitiateModelFoldersMutationVariables>;

/**
 * __useInitiateModelFoldersMutation__
 *
 * To run a mutation, you first call `useInitiateModelFoldersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateModelFoldersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateModelFoldersMutation, { data, loading, error }] = useInitiateModelFoldersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateModelFoldersMutation(baseOptions?: Apollo.MutationHookOptions<InitiateModelFoldersMutation, InitiateModelFoldersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateModelFoldersMutation, InitiateModelFoldersMutationVariables>(InitiateModelFoldersDocument, options);
      }
export type InitiateModelFoldersMutationHookResult = ReturnType<typeof useInitiateModelFoldersMutation>;
export type InitiateModelFoldersMutationResult = Apollo.MutationResult<InitiateModelFoldersMutation>;
export type InitiateModelFoldersMutationOptions = Apollo.BaseMutationOptions<InitiateModelFoldersMutation, InitiateModelFoldersMutationVariables>;
export const DeleteModelFolderDocument = gql`
    mutation deleteModelFolder($folderId: String!) {
  deleteModelFolder(folderId: $folderId) {
    name
    type
  }
}
    `;
export type DeleteModelFolderMutationFn = Apollo.MutationFunction<DeleteModelFolderMutation, DeleteModelFolderMutationVariables>;

/**
 * __useDeleteModelFolderMutation__
 *
 * To run a mutation, you first call `useDeleteModelFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModelFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModelFolderMutation, { data, loading, error }] = useDeleteModelFolderMutation({
 *   variables: {
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useDeleteModelFolderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteModelFolderMutation, DeleteModelFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteModelFolderMutation, DeleteModelFolderMutationVariables>(DeleteModelFolderDocument, options);
      }
export type DeleteModelFolderMutationHookResult = ReturnType<typeof useDeleteModelFolderMutation>;
export type DeleteModelFolderMutationResult = Apollo.MutationResult<DeleteModelFolderMutation>;
export type DeleteModelFolderMutationOptions = Apollo.BaseMutationOptions<DeleteModelFolderMutation, DeleteModelFolderMutationVariables>;
export const DeleteFolderWithContentDocument = gql`
    mutation deleteFolderWithContent($folderId: String!) {
  deleteFolderWithContent(folderId: $folderId)
}
    `;
export type DeleteFolderWithContentMutationFn = Apollo.MutationFunction<DeleteFolderWithContentMutation, DeleteFolderWithContentMutationVariables>;

/**
 * __useDeleteFolderWithContentMutation__
 *
 * To run a mutation, you first call `useDeleteFolderWithContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFolderWithContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFolderWithContentMutation, { data, loading, error }] = useDeleteFolderWithContentMutation({
 *   variables: {
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useDeleteFolderWithContentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFolderWithContentMutation, DeleteFolderWithContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFolderWithContentMutation, DeleteFolderWithContentMutationVariables>(DeleteFolderWithContentDocument, options);
      }
export type DeleteFolderWithContentMutationHookResult = ReturnType<typeof useDeleteFolderWithContentMutation>;
export type DeleteFolderWithContentMutationResult = Apollo.MutationResult<DeleteFolderWithContentMutation>;
export type DeleteFolderWithContentMutationOptions = Apollo.BaseMutationOptions<DeleteFolderWithContentMutation, DeleteFolderWithContentMutationVariables>;
export const UnpublishModelDocument = gql`
    mutation UnpublishModel($modelId: String!) {
  unpublishModel(id: $modelId) {
    ...ModelListItem
  }
}
    ${ModelListItemFragmentDoc}`;
export type UnpublishModelMutationFn = Apollo.MutationFunction<UnpublishModelMutation, UnpublishModelMutationVariables>;

/**
 * __useUnpublishModelMutation__
 *
 * To run a mutation, you first call `useUnpublishModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishModelMutation, { data, loading, error }] = useUnpublishModelMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useUnpublishModelMutation(baseOptions?: Apollo.MutationHookOptions<UnpublishModelMutation, UnpublishModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpublishModelMutation, UnpublishModelMutationVariables>(UnpublishModelDocument, options);
      }
export type UnpublishModelMutationHookResult = ReturnType<typeof useUnpublishModelMutation>;
export type UnpublishModelMutationResult = Apollo.MutationResult<UnpublishModelMutation>;
export type UnpublishModelMutationOptions = Apollo.BaseMutationOptions<UnpublishModelMutation, UnpublishModelMutationVariables>;
export const DeleteRawViewDocument = gql`
    mutation deleteRawView($viewId: String!) {
  deleteRawView(viewId: $viewId)
}
    `;
export type DeleteRawViewMutationFn = Apollo.MutationFunction<DeleteRawViewMutation, DeleteRawViewMutationVariables>;

/**
 * __useDeleteRawViewMutation__
 *
 * To run a mutation, you first call `useDeleteRawViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRawViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRawViewMutation, { data, loading, error }] = useDeleteRawViewMutation({
 *   variables: {
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useDeleteRawViewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRawViewMutation, DeleteRawViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRawViewMutation, DeleteRawViewMutationVariables>(DeleteRawViewDocument, options);
      }
export type DeleteRawViewMutationHookResult = ReturnType<typeof useDeleteRawViewMutation>;
export type DeleteRawViewMutationResult = Apollo.MutationResult<DeleteRawViewMutation>;
export type DeleteRawViewMutationOptions = Apollo.BaseMutationOptions<DeleteRawViewMutation, DeleteRawViewMutationVariables>;
export const FailedTablesDocument = gql`
    query FailedTables {
  failedTables {
    latestRunErrorMessage
    modelId
    weldTag
    latestSyncTime
  }
}
    `;

/**
 * __useFailedTablesQuery__
 *
 * To run a query within a React component, call `useFailedTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFailedTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFailedTablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFailedTablesQuery(baseOptions?: Apollo.QueryHookOptions<FailedTablesQuery, FailedTablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FailedTablesQuery, FailedTablesQueryVariables>(FailedTablesDocument, options);
      }
export function useFailedTablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FailedTablesQuery, FailedTablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FailedTablesQuery, FailedTablesQueryVariables>(FailedTablesDocument, options);
        }
export function useFailedTablesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FailedTablesQuery, FailedTablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FailedTablesQuery, FailedTablesQueryVariables>(FailedTablesDocument, options);
        }
export type FailedTablesQueryHookResult = ReturnType<typeof useFailedTablesQuery>;
export type FailedTablesLazyQueryHookResult = ReturnType<typeof useFailedTablesLazyQuery>;
export type FailedTablesSuspenseQueryHookResult = ReturnType<typeof useFailedTablesSuspenseQuery>;
export type FailedTablesQueryResult = Apollo.QueryResult<FailedTablesQuery, FailedTablesQueryVariables>;
export const QueryModelDocument = gql`
    query QueryModel($modelId: String!) {
  queryModel(modelId: $modelId) {
    id
    response
    dwSql
  }
}
    `;

/**
 * __useQueryModelQuery__
 *
 * To run a query within a React component, call `useQueryModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryModelQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useQueryModelQuery(baseOptions: Apollo.QueryHookOptions<QueryModelQuery, QueryModelQueryVariables> & ({ variables: QueryModelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryModelQuery, QueryModelQueryVariables>(QueryModelDocument, options);
      }
export function useQueryModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryModelQuery, QueryModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryModelQuery, QueryModelQueryVariables>(QueryModelDocument, options);
        }
export function useQueryModelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryModelQuery, QueryModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryModelQuery, QueryModelQueryVariables>(QueryModelDocument, options);
        }
export type QueryModelQueryHookResult = ReturnType<typeof useQueryModelQuery>;
export type QueryModelLazyQueryHookResult = ReturnType<typeof useQueryModelLazyQuery>;
export type QueryModelSuspenseQueryHookResult = ReturnType<typeof useQueryModelSuspenseQuery>;
export type QueryModelQueryResult = Apollo.QueryResult<QueryModelQuery, QueryModelQueryVariables>;
export const ListObjectTypesDocument = gql`
    query ListObjectTypes($connectionId: String!) {
  objectTypes(connectionId: $connectionId) {
    ...ObjectType
  }
}
    ${ObjectTypeFragmentDoc}`;

/**
 * __useListObjectTypesQuery__
 *
 * To run a query within a React component, call `useListObjectTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListObjectTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListObjectTypesQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useListObjectTypesQuery(baseOptions: Apollo.QueryHookOptions<ListObjectTypesQuery, ListObjectTypesQueryVariables> & ({ variables: ListObjectTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListObjectTypesQuery, ListObjectTypesQueryVariables>(ListObjectTypesDocument, options);
      }
export function useListObjectTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListObjectTypesQuery, ListObjectTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListObjectTypesQuery, ListObjectTypesQueryVariables>(ListObjectTypesDocument, options);
        }
export function useListObjectTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListObjectTypesQuery, ListObjectTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListObjectTypesQuery, ListObjectTypesQueryVariables>(ListObjectTypesDocument, options);
        }
export type ListObjectTypesQueryHookResult = ReturnType<typeof useListObjectTypesQuery>;
export type ListObjectTypesLazyQueryHookResult = ReturnType<typeof useListObjectTypesLazyQuery>;
export type ListObjectTypesSuspenseQueryHookResult = ReturnType<typeof useListObjectTypesSuspenseQuery>;
export type ListObjectTypesQueryResult = Apollo.QueryResult<ListObjectTypesQuery, ListObjectTypesQueryVariables>;
export const UnresolvedIncidentsDocument = gql`
    query UnresolvedIncidents {
  unresolvedIncidents {
    ...Incident
  }
}
    ${IncidentFragmentDoc}`;

/**
 * __useUnresolvedIncidentsQuery__
 *
 * To run a query within a React component, call `useUnresolvedIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnresolvedIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnresolvedIncidentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnresolvedIncidentsQuery(baseOptions?: Apollo.QueryHookOptions<UnresolvedIncidentsQuery, UnresolvedIncidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnresolvedIncidentsQuery, UnresolvedIncidentsQueryVariables>(UnresolvedIncidentsDocument, options);
      }
export function useUnresolvedIncidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnresolvedIncidentsQuery, UnresolvedIncidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnresolvedIncidentsQuery, UnresolvedIncidentsQueryVariables>(UnresolvedIncidentsDocument, options);
        }
export function useUnresolvedIncidentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnresolvedIncidentsQuery, UnresolvedIncidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnresolvedIncidentsQuery, UnresolvedIncidentsQueryVariables>(UnresolvedIncidentsDocument, options);
        }
export type UnresolvedIncidentsQueryHookResult = ReturnType<typeof useUnresolvedIncidentsQuery>;
export type UnresolvedIncidentsLazyQueryHookResult = ReturnType<typeof useUnresolvedIncidentsLazyQuery>;
export type UnresolvedIncidentsSuspenseQueryHookResult = ReturnType<typeof useUnresolvedIncidentsSuspenseQuery>;
export type UnresolvedIncidentsQueryResult = Apollo.QueryResult<UnresolvedIncidentsQuery, UnresolvedIncidentsQueryVariables>;
export const ScheduledIncidentsDocument = gql`
    query ScheduledIncidents {
  scheduledIncidents {
    ...Incident
  }
}
    ${IncidentFragmentDoc}`;

/**
 * __useScheduledIncidentsQuery__
 *
 * To run a query within a React component, call `useScheduledIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledIncidentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useScheduledIncidentsQuery(baseOptions?: Apollo.QueryHookOptions<ScheduledIncidentsQuery, ScheduledIncidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledIncidentsQuery, ScheduledIncidentsQueryVariables>(ScheduledIncidentsDocument, options);
      }
export function useScheduledIncidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledIncidentsQuery, ScheduledIncidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledIncidentsQuery, ScheduledIncidentsQueryVariables>(ScheduledIncidentsDocument, options);
        }
export function useScheduledIncidentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduledIncidentsQuery, ScheduledIncidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduledIncidentsQuery, ScheduledIncidentsQueryVariables>(ScheduledIncidentsDocument, options);
        }
export type ScheduledIncidentsQueryHookResult = ReturnType<typeof useScheduledIncidentsQuery>;
export type ScheduledIncidentsLazyQueryHookResult = ReturnType<typeof useScheduledIncidentsLazyQuery>;
export type ScheduledIncidentsSuspenseQueryHookResult = ReturnType<typeof useScheduledIncidentsSuspenseQuery>;
export type ScheduledIncidentsQueryResult = Apollo.QueryResult<ScheduledIncidentsQuery, ScheduledIncidentsQueryVariables>;
export const FindAvailableOperationsDocument = gql`
    query FindAvailableOperations($connectionId: String!, $objectType: String!) {
  findAllAvailableOperations(connectionId: $connectionId, objectType: $objectType) {
    ...OperationModeOption
  }
}
    ${OperationModeOptionFragmentDoc}`;

/**
 * __useFindAvailableOperationsQuery__
 *
 * To run a query within a React component, call `useFindAvailableOperationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAvailableOperationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAvailableOperationsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      objectType: // value for 'objectType'
 *   },
 * });
 */
export function useFindAvailableOperationsQuery(baseOptions: Apollo.QueryHookOptions<FindAvailableOperationsQuery, FindAvailableOperationsQueryVariables> & ({ variables: FindAvailableOperationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAvailableOperationsQuery, FindAvailableOperationsQueryVariables>(FindAvailableOperationsDocument, options);
      }
export function useFindAvailableOperationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAvailableOperationsQuery, FindAvailableOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAvailableOperationsQuery, FindAvailableOperationsQueryVariables>(FindAvailableOperationsDocument, options);
        }
export function useFindAvailableOperationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAvailableOperationsQuery, FindAvailableOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAvailableOperationsQuery, FindAvailableOperationsQueryVariables>(FindAvailableOperationsDocument, options);
        }
export type FindAvailableOperationsQueryHookResult = ReturnType<typeof useFindAvailableOperationsQuery>;
export type FindAvailableOperationsLazyQueryHookResult = ReturnType<typeof useFindAvailableOperationsLazyQuery>;
export type FindAvailableOperationsSuspenseQueryHookResult = ReturnType<typeof useFindAvailableOperationsSuspenseQuery>;
export type FindAvailableOperationsQueryResult = Apollo.QueryResult<FindAvailableOperationsQuery, FindAvailableOperationsQueryVariables>;
export const CreateWorkflowDocument = gql`
    mutation CreateWorkflow($cronExpression: String!, $name: String!) {
  createWorkflow(cronExpression: $cronExpression, name: $name) {
    id
    nextRun {
      id
    }
  }
}
    `;
export type CreateWorkflowMutationFn = Apollo.MutationFunction<CreateWorkflowMutation, CreateWorkflowMutationVariables>;

/**
 * __useCreateWorkflowMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowMutation, { data, loading, error }] = useCreateWorkflowMutation({
 *   variables: {
 *      cronExpression: // value for 'cronExpression'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkflowMutation, CreateWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkflowMutation, CreateWorkflowMutationVariables>(CreateWorkflowDocument, options);
      }
export type CreateWorkflowMutationHookResult = ReturnType<typeof useCreateWorkflowMutation>;
export type CreateWorkflowMutationResult = Apollo.MutationResult<CreateWorkflowMutation>;
export type CreateWorkflowMutationOptions = Apollo.BaseMutationOptions<CreateWorkflowMutation, CreateWorkflowMutationVariables>;
export const EditWorkflowDocument = gql`
    mutation EditWorkflow($cronExpression: String!, $workflowId: ID!) {
  editWorkflow(cronExpression: $cronExpression, workflowId: $workflowId) {
    nextRun {
      id
    }
  }
}
    `;
export type EditWorkflowMutationFn = Apollo.MutationFunction<EditWorkflowMutation, EditWorkflowMutationVariables>;

/**
 * __useEditWorkflowMutation__
 *
 * To run a mutation, you first call `useEditWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editWorkflowMutation, { data, loading, error }] = useEditWorkflowMutation({
 *   variables: {
 *      cronExpression: // value for 'cronExpression'
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useEditWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<EditWorkflowMutation, EditWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditWorkflowMutation, EditWorkflowMutationVariables>(EditWorkflowDocument, options);
      }
export type EditWorkflowMutationHookResult = ReturnType<typeof useEditWorkflowMutation>;
export type EditWorkflowMutationResult = Apollo.MutationResult<EditWorkflowMutation>;
export type EditWorkflowMutationOptions = Apollo.BaseMutationOptions<EditWorkflowMutation, EditWorkflowMutationVariables>;
export const DeleteWorkflowDocument = gql`
    mutation DeleteWorkflow($workflowId: ID!, $cronSchedule: String!) {
  deleteWorkflow(workflowId: $workflowId, cronSchedule: $cronSchedule)
}
    `;
export type DeleteWorkflowMutationFn = Apollo.MutationFunction<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>;

/**
 * __useDeleteWorkflowMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowMutation, { data, loading, error }] = useDeleteWorkflowMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      cronSchedule: // value for 'cronSchedule'
 *   },
 * });
 */
export function useDeleteWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>(DeleteWorkflowDocument, options);
      }
export type DeleteWorkflowMutationHookResult = ReturnType<typeof useDeleteWorkflowMutation>;
export type DeleteWorkflowMutationResult = Apollo.MutationResult<DeleteWorkflowMutation>;
export type DeleteWorkflowMutationOptions = Apollo.BaseMutationOptions<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>;
export const OrchestrationWorkflowHistoryDocument = gql`
    query OrchestrationWorkflowHistory($workflowId: ID!) {
  orchestrationWorkflow(workflowId: $workflowId) {
    id
    accountId
    cronExpression
    runs {
      ...OrchestrationWorkflowRun
    }
  }
}
    ${OrchestrationWorkflowRunFragmentDoc}`;

/**
 * __useOrchestrationWorkflowHistoryQuery__
 *
 * To run a query within a React component, call `useOrchestrationWorkflowHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrchestrationWorkflowHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrchestrationWorkflowHistoryQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useOrchestrationWorkflowHistoryQuery(baseOptions: Apollo.QueryHookOptions<OrchestrationWorkflowHistoryQuery, OrchestrationWorkflowHistoryQueryVariables> & ({ variables: OrchestrationWorkflowHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrchestrationWorkflowHistoryQuery, OrchestrationWorkflowHistoryQueryVariables>(OrchestrationWorkflowHistoryDocument, options);
      }
export function useOrchestrationWorkflowHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrchestrationWorkflowHistoryQuery, OrchestrationWorkflowHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrchestrationWorkflowHistoryQuery, OrchestrationWorkflowHistoryQueryVariables>(OrchestrationWorkflowHistoryDocument, options);
        }
export function useOrchestrationWorkflowHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrchestrationWorkflowHistoryQuery, OrchestrationWorkflowHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrchestrationWorkflowHistoryQuery, OrchestrationWorkflowHistoryQueryVariables>(OrchestrationWorkflowHistoryDocument, options);
        }
export type OrchestrationWorkflowHistoryQueryHookResult = ReturnType<typeof useOrchestrationWorkflowHistoryQuery>;
export type OrchestrationWorkflowHistoryLazyQueryHookResult = ReturnType<typeof useOrchestrationWorkflowHistoryLazyQuery>;
export type OrchestrationWorkflowHistorySuspenseQueryHookResult = ReturnType<typeof useOrchestrationWorkflowHistorySuspenseQuery>;
export type OrchestrationWorkflowHistoryQueryResult = Apollo.QueryResult<OrchestrationWorkflowHistoryQuery, OrchestrationWorkflowHistoryQueryVariables>;
export const ListOrchestrationWorkflowsDocument = gql`
    query ListOrchestrationWorkflows {
  orchestrationWorkflows {
    id
    name
    cronExpression
    currentRun {
      ...OrchestrationWorkflowRun
      jobs {
        ...OrchestrationJob
      }
    }
    nextRun {
      ...OrchestrationWorkflowRun
      jobs {
        ...OrchestrationJob
      }
    }
  }
}
    ${OrchestrationWorkflowRunFragmentDoc}
${OrchestrationJobFragmentDoc}`;

/**
 * __useListOrchestrationWorkflowsQuery__
 *
 * To run a query within a React component, call `useListOrchestrationWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrchestrationWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrchestrationWorkflowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListOrchestrationWorkflowsQuery(baseOptions?: Apollo.QueryHookOptions<ListOrchestrationWorkflowsQuery, ListOrchestrationWorkflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrchestrationWorkflowsQuery, ListOrchestrationWorkflowsQueryVariables>(ListOrchestrationWorkflowsDocument, options);
      }
export function useListOrchestrationWorkflowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrchestrationWorkflowsQuery, ListOrchestrationWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrchestrationWorkflowsQuery, ListOrchestrationWorkflowsQueryVariables>(ListOrchestrationWorkflowsDocument, options);
        }
export function useListOrchestrationWorkflowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListOrchestrationWorkflowsQuery, ListOrchestrationWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOrchestrationWorkflowsQuery, ListOrchestrationWorkflowsQueryVariables>(ListOrchestrationWorkflowsDocument, options);
        }
export type ListOrchestrationWorkflowsQueryHookResult = ReturnType<typeof useListOrchestrationWorkflowsQuery>;
export type ListOrchestrationWorkflowsLazyQueryHookResult = ReturnType<typeof useListOrchestrationWorkflowsLazyQuery>;
export type ListOrchestrationWorkflowsSuspenseQueryHookResult = ReturnType<typeof useListOrchestrationWorkflowsSuspenseQuery>;
export type ListOrchestrationWorkflowsQueryResult = Apollo.QueryResult<ListOrchestrationWorkflowsQuery, ListOrchestrationWorkflowsQueryVariables>;
export const OrchestrationWorkflowDocument = gql`
    query OrchestrationWorkflow($workflowId: ID!) {
  orchestrationWorkflow(workflowId: $workflowId) {
    id
    name
    cronExpression
    currentRun {
      ...OrchestrationWorkflowRun
      jobs {
        ...OrchestrationJob
        target {
          ... on MaterializedTableReference {
            modelId
            modelTestRuns {
              ...ModelTestRun
            }
          }
          ... on ModelViewReference {
            modelId
            modelTestRuns {
              ...ModelTestRun
            }
          }
        }
      }
    }
    nextRun {
      ...OrchestrationWorkflowRun
      jobs {
        ...OrchestrationJob
      }
    }
  }
}
    ${OrchestrationWorkflowRunFragmentDoc}
${OrchestrationJobFragmentDoc}
${ModelTestRunFragmentDoc}`;

/**
 * __useOrchestrationWorkflowQuery__
 *
 * To run a query within a React component, call `useOrchestrationWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrchestrationWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrchestrationWorkflowQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useOrchestrationWorkflowQuery(baseOptions: Apollo.QueryHookOptions<OrchestrationWorkflowQuery, OrchestrationWorkflowQueryVariables> & ({ variables: OrchestrationWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrchestrationWorkflowQuery, OrchestrationWorkflowQueryVariables>(OrchestrationWorkflowDocument, options);
      }
export function useOrchestrationWorkflowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrchestrationWorkflowQuery, OrchestrationWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrchestrationWorkflowQuery, OrchestrationWorkflowQueryVariables>(OrchestrationWorkflowDocument, options);
        }
export function useOrchestrationWorkflowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrchestrationWorkflowQuery, OrchestrationWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrchestrationWorkflowQuery, OrchestrationWorkflowQueryVariables>(OrchestrationWorkflowDocument, options);
        }
export type OrchestrationWorkflowQueryHookResult = ReturnType<typeof useOrchestrationWorkflowQuery>;
export type OrchestrationWorkflowLazyQueryHookResult = ReturnType<typeof useOrchestrationWorkflowLazyQuery>;
export type OrchestrationWorkflowSuspenseQueryHookResult = ReturnType<typeof useOrchestrationWorkflowSuspenseQuery>;
export type OrchestrationWorkflowQueryResult = Apollo.QueryResult<OrchestrationWorkflowQuery, OrchestrationWorkflowQueryVariables>;
export const OrchestrationWorkflowRunDocument = gql`
    query OrchestrationWorkflowRun($runId: ID!) {
  orchestrationWorkflowRun(runId: $runId) {
    ...OrchestrationWorkflowRun
    jobs {
      ...OrchestrationJob
      target {
        ... on MaterializedTableReference {
          modelId
          modelTestRuns {
            ...ModelTestRun
          }
        }
        ... on ModelViewReference {
          modelId
          modelTestRuns {
            ...ModelTestRun
          }
        }
      }
    }
  }
}
    ${OrchestrationWorkflowRunFragmentDoc}
${OrchestrationJobFragmentDoc}
${ModelTestRunFragmentDoc}`;

/**
 * __useOrchestrationWorkflowRunQuery__
 *
 * To run a query within a React component, call `useOrchestrationWorkflowRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrchestrationWorkflowRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrchestrationWorkflowRunQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useOrchestrationWorkflowRunQuery(baseOptions: Apollo.QueryHookOptions<OrchestrationWorkflowRunQuery, OrchestrationWorkflowRunQueryVariables> & ({ variables: OrchestrationWorkflowRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrchestrationWorkflowRunQuery, OrchestrationWorkflowRunQueryVariables>(OrchestrationWorkflowRunDocument, options);
      }
export function useOrchestrationWorkflowRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrchestrationWorkflowRunQuery, OrchestrationWorkflowRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrchestrationWorkflowRunQuery, OrchestrationWorkflowRunQueryVariables>(OrchestrationWorkflowRunDocument, options);
        }
export function useOrchestrationWorkflowRunSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrchestrationWorkflowRunQuery, OrchestrationWorkflowRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrchestrationWorkflowRunQuery, OrchestrationWorkflowRunQueryVariables>(OrchestrationWorkflowRunDocument, options);
        }
export type OrchestrationWorkflowRunQueryHookResult = ReturnType<typeof useOrchestrationWorkflowRunQuery>;
export type OrchestrationWorkflowRunLazyQueryHookResult = ReturnType<typeof useOrchestrationWorkflowRunLazyQuery>;
export type OrchestrationWorkflowRunSuspenseQueryHookResult = ReturnType<typeof useOrchestrationWorkflowRunSuspenseQuery>;
export type OrchestrationWorkflowRunQueryResult = Apollo.QueryResult<OrchestrationWorkflowRunQuery, OrchestrationWorkflowRunQueryVariables>;
export const StartWorkflowNowDocument = gql`
    mutation StartWorkflowNow($workflowId: ID!) {
  runOrchestrationWorkflowNow(workflowId: $workflowId) {
    nextRun {
      id
    }
  }
}
    `;
export type StartWorkflowNowMutationFn = Apollo.MutationFunction<StartWorkflowNowMutation, StartWorkflowNowMutationVariables>;

/**
 * __useStartWorkflowNowMutation__
 *
 * To run a mutation, you first call `useStartWorkflowNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartWorkflowNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startWorkflowNowMutation, { data, loading, error }] = useStartWorkflowNowMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useStartWorkflowNowMutation(baseOptions?: Apollo.MutationHookOptions<StartWorkflowNowMutation, StartWorkflowNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartWorkflowNowMutation, StartWorkflowNowMutationVariables>(StartWorkflowNowDocument, options);
      }
export type StartWorkflowNowMutationHookResult = ReturnType<typeof useStartWorkflowNowMutation>;
export type StartWorkflowNowMutationResult = Apollo.MutationResult<StartWorkflowNowMutation>;
export type StartWorkflowNowMutationOptions = Apollo.BaseMutationOptions<StartWorkflowNowMutation, StartWorkflowNowMutationVariables>;
export const CancelCurrentWorkflowRunDocument = gql`
    mutation CancelCurrentWorkflowRun($workflowId: ID!) {
  cancelCurrentWorkflowRun(workflowId: $workflowId) {
    nextRun {
      id
    }
  }
}
    `;
export type CancelCurrentWorkflowRunMutationFn = Apollo.MutationFunction<CancelCurrentWorkflowRunMutation, CancelCurrentWorkflowRunMutationVariables>;

/**
 * __useCancelCurrentWorkflowRunMutation__
 *
 * To run a mutation, you first call `useCancelCurrentWorkflowRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCurrentWorkflowRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCurrentWorkflowRunMutation, { data, loading, error }] = useCancelCurrentWorkflowRunMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useCancelCurrentWorkflowRunMutation(baseOptions?: Apollo.MutationHookOptions<CancelCurrentWorkflowRunMutation, CancelCurrentWorkflowRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelCurrentWorkflowRunMutation, CancelCurrentWorkflowRunMutationVariables>(CancelCurrentWorkflowRunDocument, options);
      }
export type CancelCurrentWorkflowRunMutationHookResult = ReturnType<typeof useCancelCurrentWorkflowRunMutation>;
export type CancelCurrentWorkflowRunMutationResult = Apollo.MutationResult<CancelCurrentWorkflowRunMutation>;
export type CancelCurrentWorkflowRunMutationOptions = Apollo.BaseMutationOptions<CancelCurrentWorkflowRunMutation, CancelCurrentWorkflowRunMutationVariables>;
export const SourcePropertiesDocument = gql`
    query SourceProperties($modelId: String!) {
  sourceProperties(modelId: $modelId) {
    dataSchema {
      ...SourceProperty
    }
  }
}
    ${SourcePropertyFragmentDoc}`;

/**
 * __useSourcePropertiesQuery__
 *
 * To run a query within a React component, call `useSourcePropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourcePropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourcePropertiesQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useSourcePropertiesQuery(baseOptions: Apollo.QueryHookOptions<SourcePropertiesQuery, SourcePropertiesQueryVariables> & ({ variables: SourcePropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourcePropertiesQuery, SourcePropertiesQueryVariables>(SourcePropertiesDocument, options);
      }
export function useSourcePropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourcePropertiesQuery, SourcePropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourcePropertiesQuery, SourcePropertiesQueryVariables>(SourcePropertiesDocument, options);
        }
export function useSourcePropertiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SourcePropertiesQuery, SourcePropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SourcePropertiesQuery, SourcePropertiesQueryVariables>(SourcePropertiesDocument, options);
        }
export type SourcePropertiesQueryHookResult = ReturnType<typeof useSourcePropertiesQuery>;
export type SourcePropertiesLazyQueryHookResult = ReturnType<typeof useSourcePropertiesLazyQuery>;
export type SourcePropertiesSuspenseQueryHookResult = ReturnType<typeof useSourcePropertiesSuspenseQuery>;
export type SourcePropertiesQueryResult = Apollo.QueryResult<SourcePropertiesQuery, SourcePropertiesQueryVariables>;
export const DestinationPropertiesDocument = gql`
    query DestinationProperties($destinationConnectionId: String!, $objectType: String!, $operationMode: String!, $readonly: Boolean, $modelId: String) {
  destinationProperties(
    input: {destinationConnectionId: $destinationConnectionId, objectType: $objectType, operationMode: $operationMode, readonly: $readonly, modelId: $modelId}
  ) {
    ...DestinationProperty
  }
}
    ${DestinationPropertyFragmentDoc}`;

/**
 * __useDestinationPropertiesQuery__
 *
 * To run a query within a React component, call `useDestinationPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDestinationPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDestinationPropertiesQuery({
 *   variables: {
 *      destinationConnectionId: // value for 'destinationConnectionId'
 *      objectType: // value for 'objectType'
 *      operationMode: // value for 'operationMode'
 *      readonly: // value for 'readonly'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useDestinationPropertiesQuery(baseOptions: Apollo.QueryHookOptions<DestinationPropertiesQuery, DestinationPropertiesQueryVariables> & ({ variables: DestinationPropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DestinationPropertiesQuery, DestinationPropertiesQueryVariables>(DestinationPropertiesDocument, options);
      }
export function useDestinationPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DestinationPropertiesQuery, DestinationPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DestinationPropertiesQuery, DestinationPropertiesQueryVariables>(DestinationPropertiesDocument, options);
        }
export function useDestinationPropertiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DestinationPropertiesQuery, DestinationPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DestinationPropertiesQuery, DestinationPropertiesQueryVariables>(DestinationPropertiesDocument, options);
        }
export type DestinationPropertiesQueryHookResult = ReturnType<typeof useDestinationPropertiesQuery>;
export type DestinationPropertiesLazyQueryHookResult = ReturnType<typeof useDestinationPropertiesLazyQuery>;
export type DestinationPropertiesSuspenseQueryHookResult = ReturnType<typeof useDestinationPropertiesSuspenseQuery>;
export type DestinationPropertiesQueryResult = Apollo.QueryResult<DestinationPropertiesQuery, DestinationPropertiesQueryVariables>;
export const SaveSignupQuestionnaireResultDocument = gql`
    mutation SaveSignupQuestionnaireResult($input: SaveSignupQuestionnaireResultInput!) {
  saveSignupQuestionnaireResult(input: $input)
}
    `;
export type SaveSignupQuestionnaireResultMutationFn = Apollo.MutationFunction<SaveSignupQuestionnaireResultMutation, SaveSignupQuestionnaireResultMutationVariables>;

/**
 * __useSaveSignupQuestionnaireResultMutation__
 *
 * To run a mutation, you first call `useSaveSignupQuestionnaireResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSignupQuestionnaireResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSignupQuestionnaireResultMutation, { data, loading, error }] = useSaveSignupQuestionnaireResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSignupQuestionnaireResultMutation(baseOptions?: Apollo.MutationHookOptions<SaveSignupQuestionnaireResultMutation, SaveSignupQuestionnaireResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSignupQuestionnaireResultMutation, SaveSignupQuestionnaireResultMutationVariables>(SaveSignupQuestionnaireResultDocument, options);
      }
export type SaveSignupQuestionnaireResultMutationHookResult = ReturnType<typeof useSaveSignupQuestionnaireResultMutation>;
export type SaveSignupQuestionnaireResultMutationResult = Apollo.MutationResult<SaveSignupQuestionnaireResultMutation>;
export type SaveSignupQuestionnaireResultMutationOptions = Apollo.BaseMutationOptions<SaveSignupQuestionnaireResultMutation, SaveSignupQuestionnaireResultMutationVariables>;
export const GetSignupQuestionnaireResultDocument = gql`
    query GetSignupQuestionnaireResult {
  getSignupQuestionnaireResult {
    result {
      userId
      result
      timestamp
    }
  }
}
    `;

/**
 * __useGetSignupQuestionnaireResultQuery__
 *
 * To run a query within a React component, call `useGetSignupQuestionnaireResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignupQuestionnaireResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignupQuestionnaireResultQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSignupQuestionnaireResultQuery(baseOptions?: Apollo.QueryHookOptions<GetSignupQuestionnaireResultQuery, GetSignupQuestionnaireResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignupQuestionnaireResultQuery, GetSignupQuestionnaireResultQueryVariables>(GetSignupQuestionnaireResultDocument, options);
      }
export function useGetSignupQuestionnaireResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignupQuestionnaireResultQuery, GetSignupQuestionnaireResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignupQuestionnaireResultQuery, GetSignupQuestionnaireResultQueryVariables>(GetSignupQuestionnaireResultDocument, options);
        }
export function useGetSignupQuestionnaireResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSignupQuestionnaireResultQuery, GetSignupQuestionnaireResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSignupQuestionnaireResultQuery, GetSignupQuestionnaireResultQueryVariables>(GetSignupQuestionnaireResultDocument, options);
        }
export type GetSignupQuestionnaireResultQueryHookResult = ReturnType<typeof useGetSignupQuestionnaireResultQuery>;
export type GetSignupQuestionnaireResultLazyQueryHookResult = ReturnType<typeof useGetSignupQuestionnaireResultLazyQuery>;
export type GetSignupQuestionnaireResultSuspenseQueryHookResult = ReturnType<typeof useGetSignupQuestionnaireResultSuspenseQuery>;
export type GetSignupQuestionnaireResultQueryResult = Apollo.QueryResult<GetSignupQuestionnaireResultQuery, GetSignupQuestionnaireResultQueryVariables>;
export const StripeSubscriptionDocument = gql`
    query StripeSubscription($slug: String!) {
  accountBySlug(slug: $slug) {
    id
    slug
    stripeCustomer {
      ...StripeCustomer
    }
    stripeSubscription {
      stripeSubscriptionDetails {
        id
        items {
          ...StripeSubscriptionItem
        }
        status
        createdDate
        trialEndDate
        cancelDate
        currentPeriodStartDate
        currentPeriodEndDate
        planName
      }
    }
  }
}
    ${StripeCustomerFragmentDoc}
${StripeSubscriptionItemFragmentDoc}`;

/**
 * __useStripeSubscriptionQuery__
 *
 * To run a query within a React component, call `useStripeSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeSubscriptionQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useStripeSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<StripeSubscriptionQuery, StripeSubscriptionQueryVariables> & ({ variables: StripeSubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>(StripeSubscriptionDocument, options);
      }
export function useStripeSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>(StripeSubscriptionDocument, options);
        }
export function useStripeSubscriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>(StripeSubscriptionDocument, options);
        }
export type StripeSubscriptionQueryHookResult = ReturnType<typeof useStripeSubscriptionQuery>;
export type StripeSubscriptionLazyQueryHookResult = ReturnType<typeof useStripeSubscriptionLazyQuery>;
export type StripeSubscriptionSuspenseQueryHookResult = ReturnType<typeof useStripeSubscriptionSuspenseQuery>;
export type StripeSubscriptionQueryResult = Apollo.QueryResult<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>;
export const StripeCustomerDocument = gql`
    query StripeCustomer($slug: String!) {
  accountBySlug(slug: $slug) {
    stripeCustomer {
      ...StripeCustomer
    }
  }
}
    ${StripeCustomerFragmentDoc}`;

/**
 * __useStripeCustomerQuery__
 *
 * To run a query within a React component, call `useStripeCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeCustomerQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useStripeCustomerQuery(baseOptions: Apollo.QueryHookOptions<StripeCustomerQuery, StripeCustomerQueryVariables> & ({ variables: StripeCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeCustomerQuery, StripeCustomerQueryVariables>(StripeCustomerDocument, options);
      }
export function useStripeCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeCustomerQuery, StripeCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeCustomerQuery, StripeCustomerQueryVariables>(StripeCustomerDocument, options);
        }
export function useStripeCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StripeCustomerQuery, StripeCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StripeCustomerQuery, StripeCustomerQueryVariables>(StripeCustomerDocument, options);
        }
export type StripeCustomerQueryHookResult = ReturnType<typeof useStripeCustomerQuery>;
export type StripeCustomerLazyQueryHookResult = ReturnType<typeof useStripeCustomerLazyQuery>;
export type StripeCustomerSuspenseQueryHookResult = ReturnType<typeof useStripeCustomerSuspenseQuery>;
export type StripeCustomerQueryResult = Apollo.QueryResult<StripeCustomerQuery, StripeCustomerQueryVariables>;
export const CreateOrUpdateCustomerDocument = gql`
    mutation CreateOrUpdateCustomer($input: CreateOrUpdateCustomerInput!) {
  createOrUpdateCustomer(input: $input) {
    ...StripeCustomer
  }
}
    ${StripeCustomerFragmentDoc}`;
export type CreateOrUpdateCustomerMutationFn = Apollo.MutationFunction<CreateOrUpdateCustomerMutation, CreateOrUpdateCustomerMutationVariables>;

/**
 * __useCreateOrUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateCustomerMutation, { data, loading, error }] = useCreateOrUpdateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateCustomerMutation, CreateOrUpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateCustomerMutation, CreateOrUpdateCustomerMutationVariables>(CreateOrUpdateCustomerDocument, options);
      }
export type CreateOrUpdateCustomerMutationHookResult = ReturnType<typeof useCreateOrUpdateCustomerMutation>;
export type CreateOrUpdateCustomerMutationResult = Apollo.MutationResult<CreateOrUpdateCustomerMutation>;
export type CreateOrUpdateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateCustomerMutation, CreateOrUpdateCustomerMutationVariables>;
export const CreateOrUpdateWeldSubscriptionDocument = gql`
    mutation CreateOrUpdateWeldSubscription($customerId: String!, $priceId: String!, $currency: String!, $numConnectors: Int!, $numUsers: Int!, $paymentMethodId: String) {
  createOrUpdateWeldSubscription(
    customerId: $customerId
    paymentMethodId: $paymentMethodId
    priceId: $priceId
    currency: $currency
    numConnectors: $numConnectors
    numUsers: $numUsers
  ) {
    id
  }
}
    `;
export type CreateOrUpdateWeldSubscriptionMutationFn = Apollo.MutationFunction<CreateOrUpdateWeldSubscriptionMutation, CreateOrUpdateWeldSubscriptionMutationVariables>;

/**
 * __useCreateOrUpdateWeldSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateWeldSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateWeldSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateWeldSubscriptionMutation, { data, loading, error }] = useCreateOrUpdateWeldSubscriptionMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      priceId: // value for 'priceId'
 *      currency: // value for 'currency'
 *      numConnectors: // value for 'numConnectors'
 *      numUsers: // value for 'numUsers'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useCreateOrUpdateWeldSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateWeldSubscriptionMutation, CreateOrUpdateWeldSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateWeldSubscriptionMutation, CreateOrUpdateWeldSubscriptionMutationVariables>(CreateOrUpdateWeldSubscriptionDocument, options);
      }
export type CreateOrUpdateWeldSubscriptionMutationHookResult = ReturnType<typeof useCreateOrUpdateWeldSubscriptionMutation>;
export type CreateOrUpdateWeldSubscriptionMutationResult = Apollo.MutationResult<CreateOrUpdateWeldSubscriptionMutation>;
export type CreateOrUpdateWeldSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateWeldSubscriptionMutation, CreateOrUpdateWeldSubscriptionMutationVariables>;
export const CancelWeldSubscriptionDocument = gql`
    mutation CancelWeldSubscription($input: CancelSubscriptionInput!) {
  cancelWeldSubscription(input: $input) {
    id
  }
}
    `;
export type CancelWeldSubscriptionMutationFn = Apollo.MutationFunction<CancelWeldSubscriptionMutation, CancelWeldSubscriptionMutationVariables>;

/**
 * __useCancelWeldSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelWeldSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelWeldSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelWeldSubscriptionMutation, { data, loading, error }] = useCancelWeldSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelWeldSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelWeldSubscriptionMutation, CancelWeldSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelWeldSubscriptionMutation, CancelWeldSubscriptionMutationVariables>(CancelWeldSubscriptionDocument, options);
      }
export type CancelWeldSubscriptionMutationHookResult = ReturnType<typeof useCancelWeldSubscriptionMutation>;
export type CancelWeldSubscriptionMutationResult = Apollo.MutationResult<CancelWeldSubscriptionMutation>;
export type CancelWeldSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelWeldSubscriptionMutation, CancelWeldSubscriptionMutationVariables>;
export const RevertWeldSubscriptionCancellationDocument = gql`
    mutation RevertWeldSubscriptionCancellation($subscriptionId: String!) {
  revertSubscriptionCancelation(subscriptionId: $subscriptionId) {
    id
  }
}
    `;
export type RevertWeldSubscriptionCancellationMutationFn = Apollo.MutationFunction<RevertWeldSubscriptionCancellationMutation, RevertWeldSubscriptionCancellationMutationVariables>;

/**
 * __useRevertWeldSubscriptionCancellationMutation__
 *
 * To run a mutation, you first call `useRevertWeldSubscriptionCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertWeldSubscriptionCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertWeldSubscriptionCancellationMutation, { data, loading, error }] = useRevertWeldSubscriptionCancellationMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useRevertWeldSubscriptionCancellationMutation(baseOptions?: Apollo.MutationHookOptions<RevertWeldSubscriptionCancellationMutation, RevertWeldSubscriptionCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertWeldSubscriptionCancellationMutation, RevertWeldSubscriptionCancellationMutationVariables>(RevertWeldSubscriptionCancellationDocument, options);
      }
export type RevertWeldSubscriptionCancellationMutationHookResult = ReturnType<typeof useRevertWeldSubscriptionCancellationMutation>;
export type RevertWeldSubscriptionCancellationMutationResult = Apollo.MutationResult<RevertWeldSubscriptionCancellationMutation>;
export type RevertWeldSubscriptionCancellationMutationOptions = Apollo.BaseMutationOptions<RevertWeldSubscriptionCancellationMutation, RevertWeldSubscriptionCancellationMutationVariables>;
export const UpdateSubscriptionAddOnsDocument = gql`
    mutation UpdateSubscriptionAddOns($subscriptionId: String!, $input: UpdateSubscriptionAddOnsInput!) {
  updateSubscriptionAddOns(subscriptionId: $subscriptionId, input: $input) {
    id
  }
}
    `;
export type UpdateSubscriptionAddOnsMutationFn = Apollo.MutationFunction<UpdateSubscriptionAddOnsMutation, UpdateSubscriptionAddOnsMutationVariables>;

/**
 * __useUpdateSubscriptionAddOnsMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionAddOnsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionAddOnsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionAddOnsMutation, { data, loading, error }] = useUpdateSubscriptionAddOnsMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionAddOnsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionAddOnsMutation, UpdateSubscriptionAddOnsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionAddOnsMutation, UpdateSubscriptionAddOnsMutationVariables>(UpdateSubscriptionAddOnsDocument, options);
      }
export type UpdateSubscriptionAddOnsMutationHookResult = ReturnType<typeof useUpdateSubscriptionAddOnsMutation>;
export type UpdateSubscriptionAddOnsMutationResult = Apollo.MutationResult<UpdateSubscriptionAddOnsMutation>;
export type UpdateSubscriptionAddOnsMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionAddOnsMutation, UpdateSubscriptionAddOnsMutationVariables>;
export const UpdatePaymentMethodDocument = gql`
    mutation UpdatePaymentMethod($input: CreatePaymentMethodCheckoutSessionInput!) {
  createPaymentMethodCheckoutSession(input: $input) {
    id
    url
    expiresAt
  }
}
    `;
export type UpdatePaymentMethodMutationFn = Apollo.MutationFunction<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>;

/**
 * __useUpdatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMethodMutation, { data, loading, error }] = useUpdatePaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>(UpdatePaymentMethodDocument, options);
      }
export type UpdatePaymentMethodMutationHookResult = ReturnType<typeof useUpdatePaymentMethodMutation>;
export type UpdatePaymentMethodMutationResult = Apollo.MutationResult<UpdatePaymentMethodMutation>;
export type UpdatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>;
export const UpdateBillingDetailsDocument = gql`
    mutation UpdateBillingDetails($customerId: ID!, $billingDetails: BillingDetailsInput!) {
  updateBillingDetails(customerId: $customerId, billingDetails: $billingDetails) {
    id
    email
  }
}
    `;
export type UpdateBillingDetailsMutationFn = Apollo.MutationFunction<UpdateBillingDetailsMutation, UpdateBillingDetailsMutationVariables>;

/**
 * __useUpdateBillingDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateBillingDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingDetailsMutation, { data, loading, error }] = useUpdateBillingDetailsMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      billingDetails: // value for 'billingDetails'
 *   },
 * });
 */
export function useUpdateBillingDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillingDetailsMutation, UpdateBillingDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillingDetailsMutation, UpdateBillingDetailsMutationVariables>(UpdateBillingDetailsDocument, options);
      }
export type UpdateBillingDetailsMutationHookResult = ReturnType<typeof useUpdateBillingDetailsMutation>;
export type UpdateBillingDetailsMutationResult = Apollo.MutationResult<UpdateBillingDetailsMutation>;
export type UpdateBillingDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateBillingDetailsMutation, UpdateBillingDetailsMutationVariables>;
export const StripePlanProductDocument = gql`
    query StripePlanProduct($planName: String!) {
  getPlanProduct(planName: $planName) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useStripePlanProductQuery__
 *
 * To run a query within a React component, call `useStripePlanProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripePlanProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripePlanProductQuery({
 *   variables: {
 *      planName: // value for 'planName'
 *   },
 * });
 */
export function useStripePlanProductQuery(baseOptions: Apollo.QueryHookOptions<StripePlanProductQuery, StripePlanProductQueryVariables> & ({ variables: StripePlanProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripePlanProductQuery, StripePlanProductQueryVariables>(StripePlanProductDocument, options);
      }
export function useStripePlanProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripePlanProductQuery, StripePlanProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripePlanProductQuery, StripePlanProductQueryVariables>(StripePlanProductDocument, options);
        }
export function useStripePlanProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StripePlanProductQuery, StripePlanProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StripePlanProductQuery, StripePlanProductQueryVariables>(StripePlanProductDocument, options);
        }
export type StripePlanProductQueryHookResult = ReturnType<typeof useStripePlanProductQuery>;
export type StripePlanProductLazyQueryHookResult = ReturnType<typeof useStripePlanProductLazyQuery>;
export type StripePlanProductSuspenseQueryHookResult = ReturnType<typeof useStripePlanProductSuspenseQuery>;
export type StripePlanProductQueryResult = Apollo.QueryResult<StripePlanProductQuery, StripePlanProductQueryVariables>;
export const AvailableAddOnProductsDocument = gql`
    query AvailableAddOnProducts {
  getAvailableAddOnProducts {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useAvailableAddOnProductsQuery__
 *
 * To run a query within a React component, call `useAvailableAddOnProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableAddOnProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableAddOnProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableAddOnProductsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableAddOnProductsQuery, AvailableAddOnProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableAddOnProductsQuery, AvailableAddOnProductsQueryVariables>(AvailableAddOnProductsDocument, options);
      }
export function useAvailableAddOnProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableAddOnProductsQuery, AvailableAddOnProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableAddOnProductsQuery, AvailableAddOnProductsQueryVariables>(AvailableAddOnProductsDocument, options);
        }
export function useAvailableAddOnProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailableAddOnProductsQuery, AvailableAddOnProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableAddOnProductsQuery, AvailableAddOnProductsQueryVariables>(AvailableAddOnProductsDocument, options);
        }
export type AvailableAddOnProductsQueryHookResult = ReturnType<typeof useAvailableAddOnProductsQuery>;
export type AvailableAddOnProductsLazyQueryHookResult = ReturnType<typeof useAvailableAddOnProductsLazyQuery>;
export type AvailableAddOnProductsSuspenseQueryHookResult = ReturnType<typeof useAvailableAddOnProductsSuspenseQuery>;
export type AvailableAddOnProductsQueryResult = Apollo.QueryResult<AvailableAddOnProductsQuery, AvailableAddOnProductsQueryVariables>;
export const AddOnProductsByIdsDocument = gql`
    query AddOnProductsByIds($productIds: [String!]!) {
  getAddOnProductsByIds(productIds: $productIds) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useAddOnProductsByIdsQuery__
 *
 * To run a query within a React component, call `useAddOnProductsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddOnProductsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddOnProductsByIdsQuery({
 *   variables: {
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useAddOnProductsByIdsQuery(baseOptions: Apollo.QueryHookOptions<AddOnProductsByIdsQuery, AddOnProductsByIdsQueryVariables> & ({ variables: AddOnProductsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddOnProductsByIdsQuery, AddOnProductsByIdsQueryVariables>(AddOnProductsByIdsDocument, options);
      }
export function useAddOnProductsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddOnProductsByIdsQuery, AddOnProductsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddOnProductsByIdsQuery, AddOnProductsByIdsQueryVariables>(AddOnProductsByIdsDocument, options);
        }
export function useAddOnProductsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AddOnProductsByIdsQuery, AddOnProductsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddOnProductsByIdsQuery, AddOnProductsByIdsQueryVariables>(AddOnProductsByIdsDocument, options);
        }
export type AddOnProductsByIdsQueryHookResult = ReturnType<typeof useAddOnProductsByIdsQuery>;
export type AddOnProductsByIdsLazyQueryHookResult = ReturnType<typeof useAddOnProductsByIdsLazyQuery>;
export type AddOnProductsByIdsSuspenseQueryHookResult = ReturnType<typeof useAddOnProductsByIdsSuspenseQuery>;
export type AddOnProductsByIdsQueryResult = Apollo.QueryResult<AddOnProductsByIdsQuery, AddOnProductsByIdsQueryVariables>;
export const ProductPriceDocument = gql`
    query ProductPrice($priceId: String!, $currency: String!) {
  getProductPrice(priceId: $priceId, currency: $currency) {
    ...Price
    currencyOptions {
      currency
      price
      tiers {
        price
        upTo
        unitAmount
      }
    }
  }
}
    ${PriceFragmentDoc}`;

/**
 * __useProductPriceQuery__
 *
 * To run a query within a React component, call `useProductPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPriceQuery({
 *   variables: {
 *      priceId: // value for 'priceId'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useProductPriceQuery(baseOptions: Apollo.QueryHookOptions<ProductPriceQuery, ProductPriceQueryVariables> & ({ variables: ProductPriceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPriceQuery, ProductPriceQueryVariables>(ProductPriceDocument, options);
      }
export function useProductPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPriceQuery, ProductPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPriceQuery, ProductPriceQueryVariables>(ProductPriceDocument, options);
        }
export function useProductPriceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductPriceQuery, ProductPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPriceQuery, ProductPriceQueryVariables>(ProductPriceDocument, options);
        }
export type ProductPriceQueryHookResult = ReturnType<typeof useProductPriceQuery>;
export type ProductPriceLazyQueryHookResult = ReturnType<typeof useProductPriceLazyQuery>;
export type ProductPriceSuspenseQueryHookResult = ReturnType<typeof useProductPriceSuspenseQuery>;
export type ProductPriceQueryResult = Apollo.QueryResult<ProductPriceQuery, ProductPriceQueryVariables>;
export const ProductPriceByLookupKeyDocument = gql`
    query ProductPriceByLookupKey($lookupKey: String!, $currency: String!) {
  getProductPriceByLookupKey(lookupKey: $lookupKey, currency: $currency) {
    ...Price
    currencyOptions {
      currency
      price
      tiers {
        price
        upTo
        unitAmount
      }
    }
  }
}
    ${PriceFragmentDoc}`;

/**
 * __useProductPriceByLookupKeyQuery__
 *
 * To run a query within a React component, call `useProductPriceByLookupKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPriceByLookupKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPriceByLookupKeyQuery({
 *   variables: {
 *      lookupKey: // value for 'lookupKey'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useProductPriceByLookupKeyQuery(baseOptions: Apollo.QueryHookOptions<ProductPriceByLookupKeyQuery, ProductPriceByLookupKeyQueryVariables> & ({ variables: ProductPriceByLookupKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPriceByLookupKeyQuery, ProductPriceByLookupKeyQueryVariables>(ProductPriceByLookupKeyDocument, options);
      }
export function useProductPriceByLookupKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPriceByLookupKeyQuery, ProductPriceByLookupKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPriceByLookupKeyQuery, ProductPriceByLookupKeyQueryVariables>(ProductPriceByLookupKeyDocument, options);
        }
export function useProductPriceByLookupKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductPriceByLookupKeyQuery, ProductPriceByLookupKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPriceByLookupKeyQuery, ProductPriceByLookupKeyQueryVariables>(ProductPriceByLookupKeyDocument, options);
        }
export type ProductPriceByLookupKeyQueryHookResult = ReturnType<typeof useProductPriceByLookupKeyQuery>;
export type ProductPriceByLookupKeyLazyQueryHookResult = ReturnType<typeof useProductPriceByLookupKeyLazyQuery>;
export type ProductPriceByLookupKeySuspenseQueryHookResult = ReturnType<typeof useProductPriceByLookupKeySuspenseQuery>;
export type ProductPriceByLookupKeyQueryResult = Apollo.QueryResult<ProductPriceByLookupKeyQuery, ProductPriceByLookupKeyQueryVariables>;
export const InvoicesDocument = gql`
    query Invoices($customerId: String!) {
  invoices(customerId: $customerId) {
    ...StripeInvoice
  }
}
    ${StripeInvoiceFragmentDoc}`;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions: Apollo.QueryHookOptions<InvoicesQuery, InvoicesQueryVariables> & ({ variables: InvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
      }
export function useInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export function useInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesSuspenseQueryHookResult = ReturnType<typeof useInvoicesSuspenseQuery>;
export type InvoicesQueryResult = Apollo.QueryResult<InvoicesQuery, InvoicesQueryVariables>;
export const OverdueInvoicesDocument = gql`
    query OverdueInvoices($customerId: String!) {
  overdueInvoices(customerId: $customerId) {
    id
    dueDate
    hostedInvoiceUrl
  }
}
    `;

/**
 * __useOverdueInvoicesQuery__
 *
 * To run a query within a React component, call `useOverdueInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverdueInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverdueInvoicesQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useOverdueInvoicesQuery(baseOptions: Apollo.QueryHookOptions<OverdueInvoicesQuery, OverdueInvoicesQueryVariables> & ({ variables: OverdueInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverdueInvoicesQuery, OverdueInvoicesQueryVariables>(OverdueInvoicesDocument, options);
      }
export function useOverdueInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverdueInvoicesQuery, OverdueInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverdueInvoicesQuery, OverdueInvoicesQueryVariables>(OverdueInvoicesDocument, options);
        }
export function useOverdueInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OverdueInvoicesQuery, OverdueInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OverdueInvoicesQuery, OverdueInvoicesQueryVariables>(OverdueInvoicesDocument, options);
        }
export type OverdueInvoicesQueryHookResult = ReturnType<typeof useOverdueInvoicesQuery>;
export type OverdueInvoicesLazyQueryHookResult = ReturnType<typeof useOverdueInvoicesLazyQuery>;
export type OverdueInvoicesSuspenseQueryHookResult = ReturnType<typeof useOverdueInvoicesSuspenseQuery>;
export type OverdueInvoicesQueryResult = Apollo.QueryResult<OverdueInvoicesQuery, OverdueInvoicesQueryVariables>;
export const CheckoutPreviewDocument = gql`
    query CheckoutPreview($input: InvoicePreviewInput!) {
  getCheckoutPreview(input: $input) {
    ...UpcomingInvoice
  }
}
    ${UpcomingInvoiceFragmentDoc}`;

/**
 * __useCheckoutPreviewQuery__
 *
 * To run a query within a React component, call `useCheckoutPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckoutPreviewQuery(baseOptions: Apollo.QueryHookOptions<CheckoutPreviewQuery, CheckoutPreviewQueryVariables> & ({ variables: CheckoutPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>(CheckoutPreviewDocument, options);
      }
export function useCheckoutPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>(CheckoutPreviewDocument, options);
        }
export function useCheckoutPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>(CheckoutPreviewDocument, options);
        }
export type CheckoutPreviewQueryHookResult = ReturnType<typeof useCheckoutPreviewQuery>;
export type CheckoutPreviewLazyQueryHookResult = ReturnType<typeof useCheckoutPreviewLazyQuery>;
export type CheckoutPreviewSuspenseQueryHookResult = ReturnType<typeof useCheckoutPreviewSuspenseQuery>;
export type CheckoutPreviewQueryResult = Apollo.QueryResult<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>;
export const StaticCheckoutPreviewDocument = gql`
    query StaticCheckoutPreview($input: StaticInvoicePreviewInput!) {
  getStaticPreview(input: $input) {
    ...UpcomingInvoice
  }
}
    ${UpcomingInvoiceFragmentDoc}`;

/**
 * __useStaticCheckoutPreviewQuery__
 *
 * To run a query within a React component, call `useStaticCheckoutPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaticCheckoutPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaticCheckoutPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStaticCheckoutPreviewQuery(baseOptions: Apollo.QueryHookOptions<StaticCheckoutPreviewQuery, StaticCheckoutPreviewQueryVariables> & ({ variables: StaticCheckoutPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StaticCheckoutPreviewQuery, StaticCheckoutPreviewQueryVariables>(StaticCheckoutPreviewDocument, options);
      }
export function useStaticCheckoutPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaticCheckoutPreviewQuery, StaticCheckoutPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StaticCheckoutPreviewQuery, StaticCheckoutPreviewQueryVariables>(StaticCheckoutPreviewDocument, options);
        }
export function useStaticCheckoutPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StaticCheckoutPreviewQuery, StaticCheckoutPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StaticCheckoutPreviewQuery, StaticCheckoutPreviewQueryVariables>(StaticCheckoutPreviewDocument, options);
        }
export type StaticCheckoutPreviewQueryHookResult = ReturnType<typeof useStaticCheckoutPreviewQuery>;
export type StaticCheckoutPreviewLazyQueryHookResult = ReturnType<typeof useStaticCheckoutPreviewLazyQuery>;
export type StaticCheckoutPreviewSuspenseQueryHookResult = ReturnType<typeof useStaticCheckoutPreviewSuspenseQuery>;
export type StaticCheckoutPreviewQueryResult = Apollo.QueryResult<StaticCheckoutPreviewQuery, StaticCheckoutPreviewQueryVariables>;
export const StaticCheckoutPreviewByLookupKeyDocument = gql`
    query StaticCheckoutPreviewByLookupKey($input: StaticInvoicePreviewByLookupKeyInput!) {
  getStaticPreviewByLookupKey(input: $input) {
    ...UpcomingInvoice
  }
}
    ${UpcomingInvoiceFragmentDoc}`;

/**
 * __useStaticCheckoutPreviewByLookupKeyQuery__
 *
 * To run a query within a React component, call `useStaticCheckoutPreviewByLookupKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaticCheckoutPreviewByLookupKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaticCheckoutPreviewByLookupKeyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStaticCheckoutPreviewByLookupKeyQuery(baseOptions: Apollo.QueryHookOptions<StaticCheckoutPreviewByLookupKeyQuery, StaticCheckoutPreviewByLookupKeyQueryVariables> & ({ variables: StaticCheckoutPreviewByLookupKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StaticCheckoutPreviewByLookupKeyQuery, StaticCheckoutPreviewByLookupKeyQueryVariables>(StaticCheckoutPreviewByLookupKeyDocument, options);
      }
export function useStaticCheckoutPreviewByLookupKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaticCheckoutPreviewByLookupKeyQuery, StaticCheckoutPreviewByLookupKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StaticCheckoutPreviewByLookupKeyQuery, StaticCheckoutPreviewByLookupKeyQueryVariables>(StaticCheckoutPreviewByLookupKeyDocument, options);
        }
export function useStaticCheckoutPreviewByLookupKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StaticCheckoutPreviewByLookupKeyQuery, StaticCheckoutPreviewByLookupKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StaticCheckoutPreviewByLookupKeyQuery, StaticCheckoutPreviewByLookupKeyQueryVariables>(StaticCheckoutPreviewByLookupKeyDocument, options);
        }
export type StaticCheckoutPreviewByLookupKeyQueryHookResult = ReturnType<typeof useStaticCheckoutPreviewByLookupKeyQuery>;
export type StaticCheckoutPreviewByLookupKeyLazyQueryHookResult = ReturnType<typeof useStaticCheckoutPreviewByLookupKeyLazyQuery>;
export type StaticCheckoutPreviewByLookupKeySuspenseQueryHookResult = ReturnType<typeof useStaticCheckoutPreviewByLookupKeySuspenseQuery>;
export type StaticCheckoutPreviewByLookupKeyQueryResult = Apollo.QueryResult<StaticCheckoutPreviewByLookupKeyQuery, StaticCheckoutPreviewByLookupKeyQueryVariables>;
export const UpcomingInvoiceDocument = gql`
    query UpcomingInvoice($customerId: String!, $subscriptionId: String!) {
  upcomingInvoice(customerId: $customerId, subscriptionId: $subscriptionId) {
    ...UpcomingInvoice
  }
}
    ${UpcomingInvoiceFragmentDoc}`;

/**
 * __useUpcomingInvoiceQuery__
 *
 * To run a query within a React component, call `useUpcomingInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingInvoiceQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useUpcomingInvoiceQuery(baseOptions: Apollo.QueryHookOptions<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables> & ({ variables: UpcomingInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>(UpcomingInvoiceDocument, options);
      }
export function useUpcomingInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>(UpcomingInvoiceDocument, options);
        }
export function useUpcomingInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>(UpcomingInvoiceDocument, options);
        }
export type UpcomingInvoiceQueryHookResult = ReturnType<typeof useUpcomingInvoiceQuery>;
export type UpcomingInvoiceLazyQueryHookResult = ReturnType<typeof useUpcomingInvoiceLazyQuery>;
export type UpcomingInvoiceSuspenseQueryHookResult = ReturnType<typeof useUpcomingInvoiceSuspenseQuery>;
export type UpcomingInvoiceQueryResult = Apollo.QueryResult<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>;
export const TaxIdsDataDocument = gql`
    query TaxIdsData {
  taxIdsData {
    country
    countryCode
    enum
    shortName
    description
    example
  }
}
    `;

/**
 * __useTaxIdsDataQuery__
 *
 * To run a query within a React component, call `useTaxIdsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxIdsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxIdsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaxIdsDataQuery(baseOptions?: Apollo.QueryHookOptions<TaxIdsDataQuery, TaxIdsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxIdsDataQuery, TaxIdsDataQueryVariables>(TaxIdsDataDocument, options);
      }
export function useTaxIdsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxIdsDataQuery, TaxIdsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxIdsDataQuery, TaxIdsDataQueryVariables>(TaxIdsDataDocument, options);
        }
export function useTaxIdsDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaxIdsDataQuery, TaxIdsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxIdsDataQuery, TaxIdsDataQueryVariables>(TaxIdsDataDocument, options);
        }
export type TaxIdsDataQueryHookResult = ReturnType<typeof useTaxIdsDataQuery>;
export type TaxIdsDataLazyQueryHookResult = ReturnType<typeof useTaxIdsDataLazyQuery>;
export type TaxIdsDataSuspenseQueryHookResult = ReturnType<typeof useTaxIdsDataSuspenseQuery>;
export type TaxIdsDataQueryResult = Apollo.QueryResult<TaxIdsDataQuery, TaxIdsDataQueryVariables>;
export const CreateFuturePaymentsSetupIntentDocument = gql`
    mutation CreateFuturePaymentsSetupIntent($customerId: String!) {
  createFuturePaymentsSetupIntent(customerId: $customerId) {
    clientSecret
  }
}
    `;
export type CreateFuturePaymentsSetupIntentMutationFn = Apollo.MutationFunction<CreateFuturePaymentsSetupIntentMutation, CreateFuturePaymentsSetupIntentMutationVariables>;

/**
 * __useCreateFuturePaymentsSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateFuturePaymentsSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFuturePaymentsSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFuturePaymentsSetupIntentMutation, { data, loading, error }] = useCreateFuturePaymentsSetupIntentMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCreateFuturePaymentsSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateFuturePaymentsSetupIntentMutation, CreateFuturePaymentsSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFuturePaymentsSetupIntentMutation, CreateFuturePaymentsSetupIntentMutationVariables>(CreateFuturePaymentsSetupIntentDocument, options);
      }
export type CreateFuturePaymentsSetupIntentMutationHookResult = ReturnType<typeof useCreateFuturePaymentsSetupIntentMutation>;
export type CreateFuturePaymentsSetupIntentMutationResult = Apollo.MutationResult<CreateFuturePaymentsSetupIntentMutation>;
export type CreateFuturePaymentsSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateFuturePaymentsSetupIntentMutation, CreateFuturePaymentsSetupIntentMutationVariables>;
export const SubmitProductNpsDocument = gql`
    mutation SubmitProductNPS($input: SubmitSurveyInput!) {
  submitProductNPS(input: $input) {
    id
    surveyId
    score
  }
}
    `;
export type SubmitProductNpsMutationFn = Apollo.MutationFunction<SubmitProductNpsMutation, SubmitProductNpsMutationVariables>;

/**
 * __useSubmitProductNpsMutation__
 *
 * To run a mutation, you first call `useSubmitProductNpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitProductNpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitProductNpsMutation, { data, loading, error }] = useSubmitProductNpsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitProductNpsMutation(baseOptions?: Apollo.MutationHookOptions<SubmitProductNpsMutation, SubmitProductNpsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitProductNpsMutation, SubmitProductNpsMutationVariables>(SubmitProductNpsDocument, options);
      }
export type SubmitProductNpsMutationHookResult = ReturnType<typeof useSubmitProductNpsMutation>;
export type SubmitProductNpsMutationResult = Apollo.MutationResult<SubmitProductNpsMutation>;
export type SubmitProductNpsMutationOptions = Apollo.BaseMutationOptions<SubmitProductNpsMutation, SubmitProductNpsMutationVariables>;
export const DismissProductNpsDocument = gql`
    mutation DismissProductNPS {
  dismissProductNPS {
    id
    surveyId
    score
  }
}
    `;
export type DismissProductNpsMutationFn = Apollo.MutationFunction<DismissProductNpsMutation, DismissProductNpsMutationVariables>;

/**
 * __useDismissProductNpsMutation__
 *
 * To run a mutation, you first call `useDismissProductNpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissProductNpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissProductNpsMutation, { data, loading, error }] = useDismissProductNpsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDismissProductNpsMutation(baseOptions?: Apollo.MutationHookOptions<DismissProductNpsMutation, DismissProductNpsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissProductNpsMutation, DismissProductNpsMutationVariables>(DismissProductNpsDocument, options);
      }
export type DismissProductNpsMutationHookResult = ReturnType<typeof useDismissProductNpsMutation>;
export type DismissProductNpsMutationResult = Apollo.MutationResult<DismissProductNpsMutation>;
export type DismissProductNpsMutationOptions = Apollo.BaseMutationOptions<DismissProductNpsMutation, DismissProductNpsMutationVariables>;
export const GetPromptableProductNpsSurveyDocument = gql`
    query GetPromptableProductNPSSurvey {
  getPromptableProductNPSSurvey {
    survey {
      id
      name
      question
    }
  }
}
    `;

/**
 * __useGetPromptableProductNpsSurveyQuery__
 *
 * To run a query within a React component, call `useGetPromptableProductNpsSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromptableProductNpsSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromptableProductNpsSurveyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPromptableProductNpsSurveyQuery(baseOptions?: Apollo.QueryHookOptions<GetPromptableProductNpsSurveyQuery, GetPromptableProductNpsSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPromptableProductNpsSurveyQuery, GetPromptableProductNpsSurveyQueryVariables>(GetPromptableProductNpsSurveyDocument, options);
      }
export function useGetPromptableProductNpsSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPromptableProductNpsSurveyQuery, GetPromptableProductNpsSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPromptableProductNpsSurveyQuery, GetPromptableProductNpsSurveyQueryVariables>(GetPromptableProductNpsSurveyDocument, options);
        }
export function useGetPromptableProductNpsSurveySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPromptableProductNpsSurveyQuery, GetPromptableProductNpsSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPromptableProductNpsSurveyQuery, GetPromptableProductNpsSurveyQueryVariables>(GetPromptableProductNpsSurveyDocument, options);
        }
export type GetPromptableProductNpsSurveyQueryHookResult = ReturnType<typeof useGetPromptableProductNpsSurveyQuery>;
export type GetPromptableProductNpsSurveyLazyQueryHookResult = ReturnType<typeof useGetPromptableProductNpsSurveyLazyQuery>;
export type GetPromptableProductNpsSurveySuspenseQueryHookResult = ReturnType<typeof useGetPromptableProductNpsSurveySuspenseQuery>;
export type GetPromptableProductNpsSurveyQueryResult = Apollo.QueryResult<GetPromptableProductNpsSurveyQuery, GetPromptableProductNpsSurveyQueryVariables>;
export const FindSyncHistoryDocument = gql`
    query FindSyncHistory($syncId: String!) {
  findReverseEltSyncHistory(syncId: $syncId) {
    ...FindSyncHistoryResponse
  }
}
    ${FindSyncHistoryResponseFragmentDoc}`;

/**
 * __useFindSyncHistoryQuery__
 *
 * To run a query within a React component, call `useFindSyncHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSyncHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSyncHistoryQuery({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useFindSyncHistoryQuery(baseOptions: Apollo.QueryHookOptions<FindSyncHistoryQuery, FindSyncHistoryQueryVariables> & ({ variables: FindSyncHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSyncHistoryQuery, FindSyncHistoryQueryVariables>(FindSyncHistoryDocument, options);
      }
export function useFindSyncHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSyncHistoryQuery, FindSyncHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSyncHistoryQuery, FindSyncHistoryQueryVariables>(FindSyncHistoryDocument, options);
        }
export function useFindSyncHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindSyncHistoryQuery, FindSyncHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindSyncHistoryQuery, FindSyncHistoryQueryVariables>(FindSyncHistoryDocument, options);
        }
export type FindSyncHistoryQueryHookResult = ReturnType<typeof useFindSyncHistoryQuery>;
export type FindSyncHistoryLazyQueryHookResult = ReturnType<typeof useFindSyncHistoryLazyQuery>;
export type FindSyncHistorySuspenseQueryHookResult = ReturnType<typeof useFindSyncHistorySuspenseQuery>;
export type FindSyncHistoryQueryResult = Apollo.QueryResult<FindSyncHistoryQuery, FindSyncHistoryQueryVariables>;
export const EltSyncSnapshotStateDocument = gql`
    query EltSyncSnapshotState($syncId: String!) {
  eltSyncSnapshotState(syncId: $syncId) {
    syncId
    sourceStreams {
      ...SourceStreamSnapshotStates
    }
  }
}
    ${SourceStreamSnapshotStatesFragmentDoc}`;

/**
 * __useEltSyncSnapshotStateQuery__
 *
 * To run a query within a React component, call `useEltSyncSnapshotStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltSyncSnapshotStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltSyncSnapshotStateQuery({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useEltSyncSnapshotStateQuery(baseOptions: Apollo.QueryHookOptions<EltSyncSnapshotStateQuery, EltSyncSnapshotStateQueryVariables> & ({ variables: EltSyncSnapshotStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltSyncSnapshotStateQuery, EltSyncSnapshotStateQueryVariables>(EltSyncSnapshotStateDocument, options);
      }
export function useEltSyncSnapshotStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltSyncSnapshotStateQuery, EltSyncSnapshotStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltSyncSnapshotStateQuery, EltSyncSnapshotStateQueryVariables>(EltSyncSnapshotStateDocument, options);
        }
export function useEltSyncSnapshotStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltSyncSnapshotStateQuery, EltSyncSnapshotStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltSyncSnapshotStateQuery, EltSyncSnapshotStateQueryVariables>(EltSyncSnapshotStateDocument, options);
        }
export type EltSyncSnapshotStateQueryHookResult = ReturnType<typeof useEltSyncSnapshotStateQuery>;
export type EltSyncSnapshotStateLazyQueryHookResult = ReturnType<typeof useEltSyncSnapshotStateLazyQuery>;
export type EltSyncSnapshotStateSuspenseQueryHookResult = ReturnType<typeof useEltSyncSnapshotStateSuspenseQuery>;
export type EltSyncSnapshotStateQueryResult = Apollo.QueryResult<EltSyncSnapshotStateQuery, EltSyncSnapshotStateQueryVariables>;
export const FindManyEltSyncHistoryDocument = gql`
    query FindManyEltSyncHistory($syncId: String!, $sourceStreamName: String!, $excludeEmpty: Boolean! = false) {
  findManyEltSyncHistory(
    syncId: $syncId
    sourceStreamName: $sourceStreamName
    excludeEmpty: $excludeEmpty
  ) {
    ...FindSyncHistoryResponse
  }
}
    ${FindSyncHistoryResponseFragmentDoc}`;

/**
 * __useFindManyEltSyncHistoryQuery__
 *
 * To run a query within a React component, call `useFindManyEltSyncHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyEltSyncHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyEltSyncHistoryQuery({
 *   variables: {
 *      syncId: // value for 'syncId'
 *      sourceStreamName: // value for 'sourceStreamName'
 *      excludeEmpty: // value for 'excludeEmpty'
 *   },
 * });
 */
export function useFindManyEltSyncHistoryQuery(baseOptions: Apollo.QueryHookOptions<FindManyEltSyncHistoryQuery, FindManyEltSyncHistoryQueryVariables> & ({ variables: FindManyEltSyncHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyEltSyncHistoryQuery, FindManyEltSyncHistoryQueryVariables>(FindManyEltSyncHistoryDocument, options);
      }
export function useFindManyEltSyncHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyEltSyncHistoryQuery, FindManyEltSyncHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyEltSyncHistoryQuery, FindManyEltSyncHistoryQueryVariables>(FindManyEltSyncHistoryDocument, options);
        }
export function useFindManyEltSyncHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindManyEltSyncHistoryQuery, FindManyEltSyncHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindManyEltSyncHistoryQuery, FindManyEltSyncHistoryQueryVariables>(FindManyEltSyncHistoryDocument, options);
        }
export type FindManyEltSyncHistoryQueryHookResult = ReturnType<typeof useFindManyEltSyncHistoryQuery>;
export type FindManyEltSyncHistoryLazyQueryHookResult = ReturnType<typeof useFindManyEltSyncHistoryLazyQuery>;
export type FindManyEltSyncHistorySuspenseQueryHookResult = ReturnType<typeof useFindManyEltSyncHistorySuspenseQuery>;
export type FindManyEltSyncHistoryQueryResult = Apollo.QueryResult<FindManyEltSyncHistoryQuery, FindManyEltSyncHistoryQueryVariables>;
export const GetJobLogsDocument = gql`
    query GetJobLogs($jobId: String) {
  getJobLogs(jobId: $jobId) {
    status
    timestamp
    message
  }
}
    `;

/**
 * __useGetJobLogsQuery__
 *
 * To run a query within a React component, call `useGetJobLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobLogsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetJobLogsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobLogsQuery, GetJobLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobLogsQuery, GetJobLogsQueryVariables>(GetJobLogsDocument, options);
      }
export function useGetJobLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobLogsQuery, GetJobLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobLogsQuery, GetJobLogsQueryVariables>(GetJobLogsDocument, options);
        }
export function useGetJobLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJobLogsQuery, GetJobLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobLogsQuery, GetJobLogsQueryVariables>(GetJobLogsDocument, options);
        }
export type GetJobLogsQueryHookResult = ReturnType<typeof useGetJobLogsQuery>;
export type GetJobLogsLazyQueryHookResult = ReturnType<typeof useGetJobLogsLazyQuery>;
export type GetJobLogsSuspenseQueryHookResult = ReturnType<typeof useGetJobLogsSuspenseQuery>;
export type GetJobLogsQueryResult = Apollo.QueryResult<GetJobLogsQuery, GetJobLogsQueryVariables>;
export const ActiveInitialSyncsDocument = gql`
    query ActiveInitialSyncs {
  activeInitialSyncs {
    id
  }
}
    `;

/**
 * __useActiveInitialSyncsQuery__
 *
 * To run a query within a React component, call `useActiveInitialSyncsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveInitialSyncsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveInitialSyncsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveInitialSyncsQuery(baseOptions?: Apollo.QueryHookOptions<ActiveInitialSyncsQuery, ActiveInitialSyncsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveInitialSyncsQuery, ActiveInitialSyncsQueryVariables>(ActiveInitialSyncsDocument, options);
      }
export function useActiveInitialSyncsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveInitialSyncsQuery, ActiveInitialSyncsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveInitialSyncsQuery, ActiveInitialSyncsQueryVariables>(ActiveInitialSyncsDocument, options);
        }
export function useActiveInitialSyncsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActiveInitialSyncsQuery, ActiveInitialSyncsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActiveInitialSyncsQuery, ActiveInitialSyncsQueryVariables>(ActiveInitialSyncsDocument, options);
        }
export type ActiveInitialSyncsQueryHookResult = ReturnType<typeof useActiveInitialSyncsQuery>;
export type ActiveInitialSyncsLazyQueryHookResult = ReturnType<typeof useActiveInitialSyncsLazyQuery>;
export type ActiveInitialSyncsSuspenseQueryHookResult = ReturnType<typeof useActiveInitialSyncsSuspenseQuery>;
export type ActiveInitialSyncsQueryResult = Apollo.QueryResult<ActiveInitialSyncsQuery, ActiveInitialSyncsQueryVariables>;
export const InitialSyncsStatusDocument = gql`
    query InitialSyncsStatus($syncIds: [String!]!) {
  initialSyncsStatus(syncIds: $syncIds) {
    syncId
    integrationId
    status
    startedAt
    finishedAt
    duration
    isChunkedSync
    tableStats {
      running
      completed
      failed
      total
      recordsSynced
      bytesSynced
    }
  }
}
    `;

/**
 * __useInitialSyncsStatusQuery__
 *
 * To run a query within a React component, call `useInitialSyncsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitialSyncsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitialSyncsStatusQuery({
 *   variables: {
 *      syncIds: // value for 'syncIds'
 *   },
 * });
 */
export function useInitialSyncsStatusQuery(baseOptions: Apollo.QueryHookOptions<InitialSyncsStatusQuery, InitialSyncsStatusQueryVariables> & ({ variables: InitialSyncsStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitialSyncsStatusQuery, InitialSyncsStatusQueryVariables>(InitialSyncsStatusDocument, options);
      }
export function useInitialSyncsStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitialSyncsStatusQuery, InitialSyncsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitialSyncsStatusQuery, InitialSyncsStatusQueryVariables>(InitialSyncsStatusDocument, options);
        }
export function useInitialSyncsStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InitialSyncsStatusQuery, InitialSyncsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InitialSyncsStatusQuery, InitialSyncsStatusQueryVariables>(InitialSyncsStatusDocument, options);
        }
export type InitialSyncsStatusQueryHookResult = ReturnType<typeof useInitialSyncsStatusQuery>;
export type InitialSyncsStatusLazyQueryHookResult = ReturnType<typeof useInitialSyncsStatusLazyQuery>;
export type InitialSyncsStatusSuspenseQueryHookResult = ReturnType<typeof useInitialSyncsStatusSuspenseQuery>;
export type InitialSyncsStatusQueryResult = Apollo.QueryResult<InitialSyncsStatusQuery, InitialSyncsStatusQueryVariables>;
export const CreateSyncDocument = gql`
    mutation CreateSync($sourceConnectionId: String!, $destinationConnectionId: String!, $modelId: String!, $operations: [CreateOperationInput!]!, $primaryObject: String!, $syncInterval: String, $config: String, $schedulerType: OrchestrationSchedulerType!, $orchestrationWorkflowId: ID) {
  createSync(
    input: {sourceConnectionId: $sourceConnectionId, destinationConnectionId: $destinationConnectionId, modelId: $modelId, operations: $operations, primaryObject: $primaryObject, syncInterval: $syncInterval, config: $config, schedulerType: $schedulerType, orchestrationWorkflowId: $orchestrationWorkflowId}
  ) {
    ...SyncListItem
  }
}
    ${SyncListItemFragmentDoc}`;
export type CreateSyncMutationFn = Apollo.MutationFunction<CreateSyncMutation, CreateSyncMutationVariables>;

/**
 * __useCreateSyncMutation__
 *
 * To run a mutation, you first call `useCreateSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSyncMutation, { data, loading, error }] = useCreateSyncMutation({
 *   variables: {
 *      sourceConnectionId: // value for 'sourceConnectionId'
 *      destinationConnectionId: // value for 'destinationConnectionId'
 *      modelId: // value for 'modelId'
 *      operations: // value for 'operations'
 *      primaryObject: // value for 'primaryObject'
 *      syncInterval: // value for 'syncInterval'
 *      config: // value for 'config'
 *      schedulerType: // value for 'schedulerType'
 *      orchestrationWorkflowId: // value for 'orchestrationWorkflowId'
 *   },
 * });
 */
export function useCreateSyncMutation(baseOptions?: Apollo.MutationHookOptions<CreateSyncMutation, CreateSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSyncMutation, CreateSyncMutationVariables>(CreateSyncDocument, options);
      }
export type CreateSyncMutationHookResult = ReturnType<typeof useCreateSyncMutation>;
export type CreateSyncMutationResult = Apollo.MutationResult<CreateSyncMutation>;
export type CreateSyncMutationOptions = Apollo.BaseMutationOptions<CreateSyncMutation, CreateSyncMutationVariables>;
export const UpdateSyncDocument = gql`
    mutation UpdateSync($syncId: String!, $operations: [CreateOperationInput!]!, $syncInterval: String, $config: String, $schedulerType: OrchestrationSchedulerType!, $orchestrationWorkflowId: ID) {
  updateSync(
    input: {syncId: $syncId, operations: $operations, syncInterval: $syncInterval, config: $config, schedulerType: $schedulerType, orchestrationWorkflowId: $orchestrationWorkflowId}
  ) {
    id
    sourceConnectionId
    destinationConnectionId
  }
}
    `;
export type UpdateSyncMutationFn = Apollo.MutationFunction<UpdateSyncMutation, UpdateSyncMutationVariables>;

/**
 * __useUpdateSyncMutation__
 *
 * To run a mutation, you first call `useUpdateSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSyncMutation, { data, loading, error }] = useUpdateSyncMutation({
 *   variables: {
 *      syncId: // value for 'syncId'
 *      operations: // value for 'operations'
 *      syncInterval: // value for 'syncInterval'
 *      config: // value for 'config'
 *      schedulerType: // value for 'schedulerType'
 *      orchestrationWorkflowId: // value for 'orchestrationWorkflowId'
 *   },
 * });
 */
export function useUpdateSyncMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSyncMutation, UpdateSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSyncMutation, UpdateSyncMutationVariables>(UpdateSyncDocument, options);
      }
export type UpdateSyncMutationHookResult = ReturnType<typeof useUpdateSyncMutation>;
export type UpdateSyncMutationResult = Apollo.MutationResult<UpdateSyncMutation>;
export type UpdateSyncMutationOptions = Apollo.BaseMutationOptions<UpdateSyncMutation, UpdateSyncMutationVariables>;
export const StartSyncDocument = gql`
    mutation StartSync($syncId: String!) {
  startSync(input: {id: $syncId}) {
    id
  }
}
    `;
export type StartSyncMutationFn = Apollo.MutationFunction<StartSyncMutation, StartSyncMutationVariables>;

/**
 * __useStartSyncMutation__
 *
 * To run a mutation, you first call `useStartSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSyncMutation, { data, loading, error }] = useStartSyncMutation({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useStartSyncMutation(baseOptions?: Apollo.MutationHookOptions<StartSyncMutation, StartSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartSyncMutation, StartSyncMutationVariables>(StartSyncDocument, options);
      }
export type StartSyncMutationHookResult = ReturnType<typeof useStartSyncMutation>;
export type StartSyncMutationResult = Apollo.MutationResult<StartSyncMutation>;
export type StartSyncMutationOptions = Apollo.BaseMutationOptions<StartSyncMutation, StartSyncMutationVariables>;
export const StopSyncDocument = gql`
    mutation StopSync($syncId: String!) {
  stopSync(input: {id: $syncId}) {
    id
  }
}
    `;
export type StopSyncMutationFn = Apollo.MutationFunction<StopSyncMutation, StopSyncMutationVariables>;

/**
 * __useStopSyncMutation__
 *
 * To run a mutation, you first call `useStopSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopSyncMutation, { data, loading, error }] = useStopSyncMutation({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useStopSyncMutation(baseOptions?: Apollo.MutationHookOptions<StopSyncMutation, StopSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopSyncMutation, StopSyncMutationVariables>(StopSyncDocument, options);
      }
export type StopSyncMutationHookResult = ReturnType<typeof useStopSyncMutation>;
export type StopSyncMutationResult = Apollo.MutationResult<StopSyncMutation>;
export type StopSyncMutationOptions = Apollo.BaseMutationOptions<StopSyncMutation, StopSyncMutationVariables>;
export const CheckOnDemandReverseEtlSyncEligibilityDocument = gql`
    query CheckOnDemandReverseETLSyncEligibility($syncId: String!) {
  checkOnDemandReverseEtlSyncEligibility(input: {id: $syncId}) {
    possible
    reason
  }
}
    `;

/**
 * __useCheckOnDemandReverseEtlSyncEligibilityQuery__
 *
 * To run a query within a React component, call `useCheckOnDemandReverseEtlSyncEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckOnDemandReverseEtlSyncEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckOnDemandReverseEtlSyncEligibilityQuery({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useCheckOnDemandReverseEtlSyncEligibilityQuery(baseOptions: Apollo.QueryHookOptions<CheckOnDemandReverseEtlSyncEligibilityQuery, CheckOnDemandReverseEtlSyncEligibilityQueryVariables> & ({ variables: CheckOnDemandReverseEtlSyncEligibilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckOnDemandReverseEtlSyncEligibilityQuery, CheckOnDemandReverseEtlSyncEligibilityQueryVariables>(CheckOnDemandReverseEtlSyncEligibilityDocument, options);
      }
export function useCheckOnDemandReverseEtlSyncEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckOnDemandReverseEtlSyncEligibilityQuery, CheckOnDemandReverseEtlSyncEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckOnDemandReverseEtlSyncEligibilityQuery, CheckOnDemandReverseEtlSyncEligibilityQueryVariables>(CheckOnDemandReverseEtlSyncEligibilityDocument, options);
        }
export function useCheckOnDemandReverseEtlSyncEligibilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckOnDemandReverseEtlSyncEligibilityQuery, CheckOnDemandReverseEtlSyncEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckOnDemandReverseEtlSyncEligibilityQuery, CheckOnDemandReverseEtlSyncEligibilityQueryVariables>(CheckOnDemandReverseEtlSyncEligibilityDocument, options);
        }
export type CheckOnDemandReverseEtlSyncEligibilityQueryHookResult = ReturnType<typeof useCheckOnDemandReverseEtlSyncEligibilityQuery>;
export type CheckOnDemandReverseEtlSyncEligibilityLazyQueryHookResult = ReturnType<typeof useCheckOnDemandReverseEtlSyncEligibilityLazyQuery>;
export type CheckOnDemandReverseEtlSyncEligibilitySuspenseQueryHookResult = ReturnType<typeof useCheckOnDemandReverseEtlSyncEligibilitySuspenseQuery>;
export type CheckOnDemandReverseEtlSyncEligibilityQueryResult = Apollo.QueryResult<CheckOnDemandReverseEtlSyncEligibilityQuery, CheckOnDemandReverseEtlSyncEligibilityQueryVariables>;
export const RunRevEtlSyncNowDocument = gql`
    mutation RunRevEtlSyncNow($syncId: String!) {
  runSyncNow(input: {id: $syncId})
}
    `;
export type RunRevEtlSyncNowMutationFn = Apollo.MutationFunction<RunRevEtlSyncNowMutation, RunRevEtlSyncNowMutationVariables>;

/**
 * __useRunRevEtlSyncNowMutation__
 *
 * To run a mutation, you first call `useRunRevEtlSyncNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunRevEtlSyncNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runRevEtlSyncNowMutation, { data, loading, error }] = useRunRevEtlSyncNowMutation({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useRunRevEtlSyncNowMutation(baseOptions?: Apollo.MutationHookOptions<RunRevEtlSyncNowMutation, RunRevEtlSyncNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunRevEtlSyncNowMutation, RunRevEtlSyncNowMutationVariables>(RunRevEtlSyncNowDocument, options);
      }
export type RunRevEtlSyncNowMutationHookResult = ReturnType<typeof useRunRevEtlSyncNowMutation>;
export type RunRevEtlSyncNowMutationResult = Apollo.MutationResult<RunRevEtlSyncNowMutation>;
export type RunRevEtlSyncNowMutationOptions = Apollo.BaseMutationOptions<RunRevEtlSyncNowMutation, RunRevEtlSyncNowMutationVariables>;
export const RemoveSyncDocument = gql`
    mutation RemoveSync($syncId: String!) {
  removeSync(input: {id: $syncId}) {
    id
  }
}
    `;
export type RemoveSyncMutationFn = Apollo.MutationFunction<RemoveSyncMutation, RemoveSyncMutationVariables>;

/**
 * __useRemoveSyncMutation__
 *
 * To run a mutation, you first call `useRemoveSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSyncMutation, { data, loading, error }] = useRemoveSyncMutation({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useRemoveSyncMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSyncMutation, RemoveSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSyncMutation, RemoveSyncMutationVariables>(RemoveSyncDocument, options);
      }
export type RemoveSyncMutationHookResult = ReturnType<typeof useRemoveSyncMutation>;
export type RemoveSyncMutationResult = Apollo.MutationResult<RemoveSyncMutation>;
export type RemoveSyncMutationOptions = Apollo.BaseMutationOptions<RemoveSyncMutation, RemoveSyncMutationVariables>;
export const ListSyncsDocument = gql`
    query ListSyncs {
  syncs {
    ...SyncListItem
  }
}
    ${SyncListItemFragmentDoc}`;

/**
 * __useListSyncsQuery__
 *
 * To run a query within a React component, call `useListSyncsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSyncsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSyncsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListSyncsQuery(baseOptions?: Apollo.QueryHookOptions<ListSyncsQuery, ListSyncsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSyncsQuery, ListSyncsQueryVariables>(ListSyncsDocument, options);
      }
export function useListSyncsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSyncsQuery, ListSyncsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSyncsQuery, ListSyncsQueryVariables>(ListSyncsDocument, options);
        }
export function useListSyncsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSyncsQuery, ListSyncsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSyncsQuery, ListSyncsQueryVariables>(ListSyncsDocument, options);
        }
export type ListSyncsQueryHookResult = ReturnType<typeof useListSyncsQuery>;
export type ListSyncsLazyQueryHookResult = ReturnType<typeof useListSyncsLazyQuery>;
export type ListSyncsSuspenseQueryHookResult = ReturnType<typeof useListSyncsSuspenseQuery>;
export type ListSyncsQueryResult = Apollo.QueryResult<ListSyncsQuery, ListSyncsQueryVariables>;
export const FindOneSyncDocument = gql`
    query FindOneSync($syncId: String!) {
  findOneSync(id: $syncId) {
    ...ReverseETLSync
  }
}
    ${ReverseEtlSyncFragmentDoc}`;

/**
 * __useFindOneSyncQuery__
 *
 * To run a query within a React component, call `useFindOneSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOneSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOneSyncQuery({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useFindOneSyncQuery(baseOptions: Apollo.QueryHookOptions<FindOneSyncQuery, FindOneSyncQueryVariables> & ({ variables: FindOneSyncQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOneSyncQuery, FindOneSyncQueryVariables>(FindOneSyncDocument, options);
      }
export function useFindOneSyncLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOneSyncQuery, FindOneSyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOneSyncQuery, FindOneSyncQueryVariables>(FindOneSyncDocument, options);
        }
export function useFindOneSyncSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindOneSyncQuery, FindOneSyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindOneSyncQuery, FindOneSyncQueryVariables>(FindOneSyncDocument, options);
        }
export type FindOneSyncQueryHookResult = ReturnType<typeof useFindOneSyncQuery>;
export type FindOneSyncLazyQueryHookResult = ReturnType<typeof useFindOneSyncLazyQuery>;
export type FindOneSyncSuspenseQueryHookResult = ReturnType<typeof useFindOneSyncSuspenseQuery>;
export type FindOneSyncQueryResult = Apollo.QueryResult<FindOneSyncQuery, FindOneSyncQueryVariables>;
export const GetSyncErrorsDocument = gql`
    query GetSyncErrors($id: String!) {
  getErrors(id: $id) {
    objectId
    scheduledJobId
    syncId
    error
  }
}
    `;

/**
 * __useGetSyncErrorsQuery__
 *
 * To run a query within a React component, call `useGetSyncErrorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSyncErrorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSyncErrorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSyncErrorsQuery(baseOptions: Apollo.QueryHookOptions<GetSyncErrorsQuery, GetSyncErrorsQueryVariables> & ({ variables: GetSyncErrorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSyncErrorsQuery, GetSyncErrorsQueryVariables>(GetSyncErrorsDocument, options);
      }
export function useGetSyncErrorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSyncErrorsQuery, GetSyncErrorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSyncErrorsQuery, GetSyncErrorsQueryVariables>(GetSyncErrorsDocument, options);
        }
export function useGetSyncErrorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSyncErrorsQuery, GetSyncErrorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSyncErrorsQuery, GetSyncErrorsQueryVariables>(GetSyncErrorsDocument, options);
        }
export type GetSyncErrorsQueryHookResult = ReturnType<typeof useGetSyncErrorsQuery>;
export type GetSyncErrorsLazyQueryHookResult = ReturnType<typeof useGetSyncErrorsLazyQuery>;
export type GetSyncErrorsSuspenseQueryHookResult = ReturnType<typeof useGetSyncErrorsSuspenseQuery>;
export type GetSyncErrorsQueryResult = Apollo.QueryResult<GetSyncErrorsQuery, GetSyncErrorsQueryVariables>;
export const ResetErrorsDocument = gql`
    mutation ResetErrors($id: String!, $objectIds: [String!]!) {
  resetErrors(id: $id, objectIds: $objectIds)
}
    `;
export type ResetErrorsMutationFn = Apollo.MutationFunction<ResetErrorsMutation, ResetErrorsMutationVariables>;

/**
 * __useResetErrorsMutation__
 *
 * To run a mutation, you first call `useResetErrorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetErrorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetErrorsMutation, { data, loading, error }] = useResetErrorsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      objectIds: // value for 'objectIds'
 *   },
 * });
 */
export function useResetErrorsMutation(baseOptions?: Apollo.MutationHookOptions<ResetErrorsMutation, ResetErrorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetErrorsMutation, ResetErrorsMutationVariables>(ResetErrorsDocument, options);
      }
export type ResetErrorsMutationHookResult = ReturnType<typeof useResetErrorsMutation>;
export type ResetErrorsMutationResult = Apollo.MutationResult<ResetErrorsMutation>;
export type ResetErrorsMutationOptions = Apollo.BaseMutationOptions<ResetErrorsMutation, ResetErrorsMutationVariables>;
export const ResetAllErrorsDocument = gql`
    mutation ResetAllErrors($id: String!) {
  resetAllErrors(id: $id)
}
    `;
export type ResetAllErrorsMutationFn = Apollo.MutationFunction<ResetAllErrorsMutation, ResetAllErrorsMutationVariables>;

/**
 * __useResetAllErrorsMutation__
 *
 * To run a mutation, you first call `useResetAllErrorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetAllErrorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetAllErrorsMutation, { data, loading, error }] = useResetAllErrorsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResetAllErrorsMutation(baseOptions?: Apollo.MutationHookOptions<ResetAllErrorsMutation, ResetAllErrorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetAllErrorsMutation, ResetAllErrorsMutationVariables>(ResetAllErrorsDocument, options);
      }
export type ResetAllErrorsMutationHookResult = ReturnType<typeof useResetAllErrorsMutation>;
export type ResetAllErrorsMutationResult = Apollo.MutationResult<ResetAllErrorsMutation>;
export type ResetAllErrorsMutationOptions = Apollo.BaseMutationOptions<ResetAllErrorsMutation, ResetAllErrorsMutationVariables>;
export const ReverseEtlJobsCompletionStatsDocument = gql`
    query ReverseEtlJobsCompletionStats($from: DateTime, $to: DateTime) {
  reverseEtlJobsCompletionStats(from: $from, to: $to) {
    stats {
      total
      successCount
      successPercent
      failureCount
      failurePercent
    }
  }
}
    `;

/**
 * __useReverseEtlJobsCompletionStatsQuery__
 *
 * To run a query within a React component, call `useReverseEtlJobsCompletionStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReverseEtlJobsCompletionStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReverseEtlJobsCompletionStatsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useReverseEtlJobsCompletionStatsQuery(baseOptions?: Apollo.QueryHookOptions<ReverseEtlJobsCompletionStatsQuery, ReverseEtlJobsCompletionStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReverseEtlJobsCompletionStatsQuery, ReverseEtlJobsCompletionStatsQueryVariables>(ReverseEtlJobsCompletionStatsDocument, options);
      }
export function useReverseEtlJobsCompletionStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReverseEtlJobsCompletionStatsQuery, ReverseEtlJobsCompletionStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReverseEtlJobsCompletionStatsQuery, ReverseEtlJobsCompletionStatsQueryVariables>(ReverseEtlJobsCompletionStatsDocument, options);
        }
export function useReverseEtlJobsCompletionStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReverseEtlJobsCompletionStatsQuery, ReverseEtlJobsCompletionStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReverseEtlJobsCompletionStatsQuery, ReverseEtlJobsCompletionStatsQueryVariables>(ReverseEtlJobsCompletionStatsDocument, options);
        }
export type ReverseEtlJobsCompletionStatsQueryHookResult = ReturnType<typeof useReverseEtlJobsCompletionStatsQuery>;
export type ReverseEtlJobsCompletionStatsLazyQueryHookResult = ReturnType<typeof useReverseEtlJobsCompletionStatsLazyQuery>;
export type ReverseEtlJobsCompletionStatsSuspenseQueryHookResult = ReturnType<typeof useReverseEtlJobsCompletionStatsSuspenseQuery>;
export type ReverseEtlJobsCompletionStatsQueryResult = Apollo.QueryResult<ReverseEtlJobsCompletionStatsQuery, ReverseEtlJobsCompletionStatsQueryVariables>;
export const ReverseEtlJobStatusDocument = gql`
    query ReverseEtlJobStatus($syncId: String!) {
  findOneSync(id: $syncId) {
    job {
      ...RevEtlJobStatus
    }
  }
}
    ${RevEtlJobStatusFragmentDoc}`;

/**
 * __useReverseEtlJobStatusQuery__
 *
 * To run a query within a React component, call `useReverseEtlJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useReverseEtlJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReverseEtlJobStatusQuery({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useReverseEtlJobStatusQuery(baseOptions: Apollo.QueryHookOptions<ReverseEtlJobStatusQuery, ReverseEtlJobStatusQueryVariables> & ({ variables: ReverseEtlJobStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReverseEtlJobStatusQuery, ReverseEtlJobStatusQueryVariables>(ReverseEtlJobStatusDocument, options);
      }
export function useReverseEtlJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReverseEtlJobStatusQuery, ReverseEtlJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReverseEtlJobStatusQuery, ReverseEtlJobStatusQueryVariables>(ReverseEtlJobStatusDocument, options);
        }
export function useReverseEtlJobStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReverseEtlJobStatusQuery, ReverseEtlJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReverseEtlJobStatusQuery, ReverseEtlJobStatusQueryVariables>(ReverseEtlJobStatusDocument, options);
        }
export type ReverseEtlJobStatusQueryHookResult = ReturnType<typeof useReverseEtlJobStatusQuery>;
export type ReverseEtlJobStatusLazyQueryHookResult = ReturnType<typeof useReverseEtlJobStatusLazyQuery>;
export type ReverseEtlJobStatusSuspenseQueryHookResult = ReturnType<typeof useReverseEtlJobStatusSuspenseQuery>;
export type ReverseEtlJobStatusQueryResult = Apollo.QueryResult<ReverseEtlJobStatusQuery, ReverseEtlJobStatusQueryVariables>;
export const CreateTemplateDocument = gql`
    mutation CreateTemplate($accountId: String!, $template: TemplatesEnum!) {
  createTemplate(accountId: $accountId, template: $template) {
    id
    name
    createdAt
    updatedAt
  }
}
    `;
export type CreateTemplateMutationFn = Apollo.MutationFunction<CreateTemplateMutation, CreateTemplateMutationVariables>;

/**
 * __useCreateTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateMutation, { data, loading, error }] = useCreateTemplateMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      template: // value for 'template'
 *   },
 * });
 */
export function useCreateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemplateMutation, CreateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplateMutation, CreateTemplateMutationVariables>(CreateTemplateDocument, options);
      }
export type CreateTemplateMutationHookResult = ReturnType<typeof useCreateTemplateMutation>;
export type CreateTemplateMutationResult = Apollo.MutationResult<CreateTemplateMutation>;
export type CreateTemplateMutationOptions = Apollo.BaseMutationOptions<CreateTemplateMutation, CreateTemplateMutationVariables>;
export const CreateEltSyncFromTemplateDocument = gql`
    mutation CreateEltSyncFromTemplate($input: EltFromTemplateInput!) {
  createEltSyncFromTemplate(input: $input) {
    id
    sourceConnectionId
    destinationConnectionId
  }
}
    `;
export type CreateEltSyncFromTemplateMutationFn = Apollo.MutationFunction<CreateEltSyncFromTemplateMutation, CreateEltSyncFromTemplateMutationVariables>;

/**
 * __useCreateEltSyncFromTemplateMutation__
 *
 * To run a mutation, you first call `useCreateEltSyncFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEltSyncFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEltSyncFromTemplateMutation, { data, loading, error }] = useCreateEltSyncFromTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEltSyncFromTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateEltSyncFromTemplateMutation, CreateEltSyncFromTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEltSyncFromTemplateMutation, CreateEltSyncFromTemplateMutationVariables>(CreateEltSyncFromTemplateDocument, options);
      }
export type CreateEltSyncFromTemplateMutationHookResult = ReturnType<typeof useCreateEltSyncFromTemplateMutation>;
export type CreateEltSyncFromTemplateMutationResult = Apollo.MutationResult<CreateEltSyncFromTemplateMutation>;
export type CreateEltSyncFromTemplateMutationOptions = Apollo.BaseMutationOptions<CreateEltSyncFromTemplateMutation, CreateEltSyncFromTemplateMutationVariables>;
export const GetTemplatesDocument = gql`
    query GetTemplates {
  getTemplates {
    id
    name
    createdAt
    updatedAt
    templateEltSync {
      sourceIntegrationId
      eltSyncId
    }
  }
}
    `;

/**
 * __useGetTemplatesQuery__
 *
 * To run a query within a React component, call `useGetTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
      }
export function useGetTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
        }
export function useGetTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
        }
export type GetTemplatesQueryHookResult = ReturnType<typeof useGetTemplatesQuery>;
export type GetTemplatesLazyQueryHookResult = ReturnType<typeof useGetTemplatesLazyQuery>;
export type GetTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetTemplatesSuspenseQuery>;
export type GetTemplatesQueryResult = Apollo.QueryResult<GetTemplatesQuery, GetTemplatesQueryVariables>;
export const ListTemplateConfigurationsDocument = gql`
    query ListTemplateConfigurations {
  listTemplateConfigurations {
    useCase
    integrations {
      sourceIntegationId
      required
      config {
        destinationSchemaName
        sourceStreams {
          name
          substreams {
            name
          }
          mode
        }
      }
      models {
        templateItemId
        name
        description
      }
    }
    metrics {
      name
      folder
      description
      columns {
        columnName
        columnType
        description
      }
      config {
        templateItemId
      }
      aiInsights
    }
  }
}
    `;

/**
 * __useListTemplateConfigurationsQuery__
 *
 * To run a query within a React component, call `useListTemplateConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTemplateConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTemplateConfigurationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListTemplateConfigurationsQuery(baseOptions?: Apollo.QueryHookOptions<ListTemplateConfigurationsQuery, ListTemplateConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTemplateConfigurationsQuery, ListTemplateConfigurationsQueryVariables>(ListTemplateConfigurationsDocument, options);
      }
export function useListTemplateConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTemplateConfigurationsQuery, ListTemplateConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTemplateConfigurationsQuery, ListTemplateConfigurationsQueryVariables>(ListTemplateConfigurationsDocument, options);
        }
export function useListTemplateConfigurationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListTemplateConfigurationsQuery, ListTemplateConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListTemplateConfigurationsQuery, ListTemplateConfigurationsQueryVariables>(ListTemplateConfigurationsDocument, options);
        }
export type ListTemplateConfigurationsQueryHookResult = ReturnType<typeof useListTemplateConfigurationsQuery>;
export type ListTemplateConfigurationsLazyQueryHookResult = ReturnType<typeof useListTemplateConfigurationsLazyQuery>;
export type ListTemplateConfigurationsSuspenseQueryHookResult = ReturnType<typeof useListTemplateConfigurationsSuspenseQuery>;
export type ListTemplateConfigurationsQueryResult = Apollo.QueryResult<ListTemplateConfigurationsQuery, ListTemplateConfigurationsQueryVariables>;
export const AttachEltSyncToTemplateDocument = gql`
    mutation AttachEltSyncToTemplate($input: AttachEltTemplateInput!) {
  attachEltSyncToTemplate(input: $input) {
    id
    sourceConnectionId
    destinationConnectionId
  }
}
    `;
export type AttachEltSyncToTemplateMutationFn = Apollo.MutationFunction<AttachEltSyncToTemplateMutation, AttachEltSyncToTemplateMutationVariables>;

/**
 * __useAttachEltSyncToTemplateMutation__
 *
 * To run a mutation, you first call `useAttachEltSyncToTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachEltSyncToTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachEltSyncToTemplateMutation, { data, loading, error }] = useAttachEltSyncToTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttachEltSyncToTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AttachEltSyncToTemplateMutation, AttachEltSyncToTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachEltSyncToTemplateMutation, AttachEltSyncToTemplateMutationVariables>(AttachEltSyncToTemplateDocument, options);
      }
export type AttachEltSyncToTemplateMutationHookResult = ReturnType<typeof useAttachEltSyncToTemplateMutation>;
export type AttachEltSyncToTemplateMutationResult = Apollo.MutationResult<AttachEltSyncToTemplateMutation>;
export type AttachEltSyncToTemplateMutationOptions = Apollo.BaseMutationOptions<AttachEltSyncToTemplateMutation, AttachEltSyncToTemplateMutationVariables>;
export const WorkspaceSyncStatsDocument = gql`
    query WorkspaceSyncStats($fromMonth: DateTime!, $toMonth: DateTime) {
  workspaceSyncStats(fromMonth: $fromMonth, toMonth: $toMonth) {
    period {
      ...StatsPeriod
    }
    data {
      ...WorkspaceSyncStats
    }
  }
}
    ${StatsPeriodFragmentDoc}
${WorkspaceSyncStatsFragmentDoc}`;

/**
 * __useWorkspaceSyncStatsQuery__
 *
 * To run a query within a React component, call `useWorkspaceSyncStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceSyncStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceSyncStatsQuery({
 *   variables: {
 *      fromMonth: // value for 'fromMonth'
 *      toMonth: // value for 'toMonth'
 *   },
 * });
 */
export function useWorkspaceSyncStatsQuery(baseOptions: Apollo.QueryHookOptions<WorkspaceSyncStatsQuery, WorkspaceSyncStatsQueryVariables> & ({ variables: WorkspaceSyncStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceSyncStatsQuery, WorkspaceSyncStatsQueryVariables>(WorkspaceSyncStatsDocument, options);
      }
export function useWorkspaceSyncStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceSyncStatsQuery, WorkspaceSyncStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceSyncStatsQuery, WorkspaceSyncStatsQueryVariables>(WorkspaceSyncStatsDocument, options);
        }
export function useWorkspaceSyncStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceSyncStatsQuery, WorkspaceSyncStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceSyncStatsQuery, WorkspaceSyncStatsQueryVariables>(WorkspaceSyncStatsDocument, options);
        }
export type WorkspaceSyncStatsQueryHookResult = ReturnType<typeof useWorkspaceSyncStatsQuery>;
export type WorkspaceSyncStatsLazyQueryHookResult = ReturnType<typeof useWorkspaceSyncStatsLazyQuery>;
export type WorkspaceSyncStatsSuspenseQueryHookResult = ReturnType<typeof useWorkspaceSyncStatsSuspenseQuery>;
export type WorkspaceSyncStatsQueryResult = Apollo.QueryResult<WorkspaceSyncStatsQuery, WorkspaceSyncStatsQueryVariables>;
export const WorkspaceSyncStatsByIntegrationDocument = gql`
    query WorkspaceSyncStatsByIntegration($month: DateTime!) {
  workspaceSyncStatsByIntegration(month: $month) {
    period {
      ...StatsPeriod
    }
    data {
      ...IntegrationSyncStats
    }
  }
}
    ${StatsPeriodFragmentDoc}
${IntegrationSyncStatsFragmentDoc}`;

/**
 * __useWorkspaceSyncStatsByIntegrationQuery__
 *
 * To run a query within a React component, call `useWorkspaceSyncStatsByIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceSyncStatsByIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceSyncStatsByIntegrationQuery({
 *   variables: {
 *      month: // value for 'month'
 *   },
 * });
 */
export function useWorkspaceSyncStatsByIntegrationQuery(baseOptions: Apollo.QueryHookOptions<WorkspaceSyncStatsByIntegrationQuery, WorkspaceSyncStatsByIntegrationQueryVariables> & ({ variables: WorkspaceSyncStatsByIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceSyncStatsByIntegrationQuery, WorkspaceSyncStatsByIntegrationQueryVariables>(WorkspaceSyncStatsByIntegrationDocument, options);
      }
export function useWorkspaceSyncStatsByIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceSyncStatsByIntegrationQuery, WorkspaceSyncStatsByIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceSyncStatsByIntegrationQuery, WorkspaceSyncStatsByIntegrationQueryVariables>(WorkspaceSyncStatsByIntegrationDocument, options);
        }
export function useWorkspaceSyncStatsByIntegrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceSyncStatsByIntegrationQuery, WorkspaceSyncStatsByIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceSyncStatsByIntegrationQuery, WorkspaceSyncStatsByIntegrationQueryVariables>(WorkspaceSyncStatsByIntegrationDocument, options);
        }
export type WorkspaceSyncStatsByIntegrationQueryHookResult = ReturnType<typeof useWorkspaceSyncStatsByIntegrationQuery>;
export type WorkspaceSyncStatsByIntegrationLazyQueryHookResult = ReturnType<typeof useWorkspaceSyncStatsByIntegrationLazyQuery>;
export type WorkspaceSyncStatsByIntegrationSuspenseQueryHookResult = ReturnType<typeof useWorkspaceSyncStatsByIntegrationSuspenseQuery>;
export type WorkspaceSyncStatsByIntegrationQueryResult = Apollo.QueryResult<WorkspaceSyncStatsByIntegrationQuery, WorkspaceSyncStatsByIntegrationQueryVariables>;
export const WorkspaceSyncStatsBySourceStreamDocument = gql`
    query WorkspaceSyncStatsBySourceStream($month: DateTime!) {
  workspaceSyncStatsBySourceStream(month: $month) {
    period {
      ...StatsPeriod
    }
    data {
      ...SourceStreamSyncStats
    }
  }
}
    ${StatsPeriodFragmentDoc}
${SourceStreamSyncStatsFragmentDoc}`;

/**
 * __useWorkspaceSyncStatsBySourceStreamQuery__
 *
 * To run a query within a React component, call `useWorkspaceSyncStatsBySourceStreamQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceSyncStatsBySourceStreamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceSyncStatsBySourceStreamQuery({
 *   variables: {
 *      month: // value for 'month'
 *   },
 * });
 */
export function useWorkspaceSyncStatsBySourceStreamQuery(baseOptions: Apollo.QueryHookOptions<WorkspaceSyncStatsBySourceStreamQuery, WorkspaceSyncStatsBySourceStreamQueryVariables> & ({ variables: WorkspaceSyncStatsBySourceStreamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceSyncStatsBySourceStreamQuery, WorkspaceSyncStatsBySourceStreamQueryVariables>(WorkspaceSyncStatsBySourceStreamDocument, options);
      }
export function useWorkspaceSyncStatsBySourceStreamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceSyncStatsBySourceStreamQuery, WorkspaceSyncStatsBySourceStreamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceSyncStatsBySourceStreamQuery, WorkspaceSyncStatsBySourceStreamQueryVariables>(WorkspaceSyncStatsBySourceStreamDocument, options);
        }
export function useWorkspaceSyncStatsBySourceStreamSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceSyncStatsBySourceStreamQuery, WorkspaceSyncStatsBySourceStreamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceSyncStatsBySourceStreamQuery, WorkspaceSyncStatsBySourceStreamQueryVariables>(WorkspaceSyncStatsBySourceStreamDocument, options);
        }
export type WorkspaceSyncStatsBySourceStreamQueryHookResult = ReturnType<typeof useWorkspaceSyncStatsBySourceStreamQuery>;
export type WorkspaceSyncStatsBySourceStreamLazyQueryHookResult = ReturnType<typeof useWorkspaceSyncStatsBySourceStreamLazyQuery>;
export type WorkspaceSyncStatsBySourceStreamSuspenseQueryHookResult = ReturnType<typeof useWorkspaceSyncStatsBySourceStreamSuspenseQuery>;
export type WorkspaceSyncStatsBySourceStreamQueryResult = Apollo.QueryResult<WorkspaceSyncStatsBySourceStreamQuery, WorkspaceSyncStatsBySourceStreamQueryVariables>;
export const WorkspaceStatsDocument = gql`
    query WorkspaceStats {
  workspaceStats {
    numConnections
    numUsers
  }
}
    `;

/**
 * __useWorkspaceStatsQuery__
 *
 * To run a query within a React component, call `useWorkspaceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceStatsQuery(baseOptions?: Apollo.QueryHookOptions<WorkspaceStatsQuery, WorkspaceStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceStatsQuery, WorkspaceStatsQueryVariables>(WorkspaceStatsDocument, options);
      }
export function useWorkspaceStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceStatsQuery, WorkspaceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceStatsQuery, WorkspaceStatsQueryVariables>(WorkspaceStatsDocument, options);
        }
export function useWorkspaceStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceStatsQuery, WorkspaceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceStatsQuery, WorkspaceStatsQueryVariables>(WorkspaceStatsDocument, options);
        }
export type WorkspaceStatsQueryHookResult = ReturnType<typeof useWorkspaceStatsQuery>;
export type WorkspaceStatsLazyQueryHookResult = ReturnType<typeof useWorkspaceStatsLazyQuery>;
export type WorkspaceStatsSuspenseQueryHookResult = ReturnType<typeof useWorkspaceStatsSuspenseQuery>;
export type WorkspaceStatsQueryResult = Apollo.QueryResult<WorkspaceStatsQuery, WorkspaceStatsQueryVariables>;
export const DailyUsageStatsForMonthDocument = gql`
    query DailyUsageStatsForMonth($referenceDate: DateTime!) {
  dailyUsageStatsForMonth(referenceDate: $referenceDate) {
    period {
      ...StatsPeriod
    }
    data {
      ...WorkspaceSyncStats
    }
  }
}
    ${StatsPeriodFragmentDoc}
${WorkspaceSyncStatsFragmentDoc}`;

/**
 * __useDailyUsageStatsForMonthQuery__
 *
 * To run a query within a React component, call `useDailyUsageStatsForMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyUsageStatsForMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyUsageStatsForMonthQuery({
 *   variables: {
 *      referenceDate: // value for 'referenceDate'
 *   },
 * });
 */
export function useDailyUsageStatsForMonthQuery(baseOptions: Apollo.QueryHookOptions<DailyUsageStatsForMonthQuery, DailyUsageStatsForMonthQueryVariables> & ({ variables: DailyUsageStatsForMonthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyUsageStatsForMonthQuery, DailyUsageStatsForMonthQueryVariables>(DailyUsageStatsForMonthDocument, options);
      }
export function useDailyUsageStatsForMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyUsageStatsForMonthQuery, DailyUsageStatsForMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyUsageStatsForMonthQuery, DailyUsageStatsForMonthQueryVariables>(DailyUsageStatsForMonthDocument, options);
        }
export function useDailyUsageStatsForMonthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DailyUsageStatsForMonthQuery, DailyUsageStatsForMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DailyUsageStatsForMonthQuery, DailyUsageStatsForMonthQueryVariables>(DailyUsageStatsForMonthDocument, options);
        }
export type DailyUsageStatsForMonthQueryHookResult = ReturnType<typeof useDailyUsageStatsForMonthQuery>;
export type DailyUsageStatsForMonthLazyQueryHookResult = ReturnType<typeof useDailyUsageStatsForMonthLazyQuery>;
export type DailyUsageStatsForMonthSuspenseQueryHookResult = ReturnType<typeof useDailyUsageStatsForMonthSuspenseQuery>;
export type DailyUsageStatsForMonthQueryResult = Apollo.QueryResult<DailyUsageStatsForMonthQuery, DailyUsageStatsForMonthQueryVariables>;
export const UsageStatsLast30DaysDocument = gql`
    query UsageStatsLast30Days {
  usageStatsLast30Days {
    period {
      ...StatsPeriod
    }
    data {
      total
      elt
      eltPercentage
      reverseElt
      reverseEltPercentage
    }
  }
}
    ${StatsPeriodFragmentDoc}`;

/**
 * __useUsageStatsLast30DaysQuery__
 *
 * To run a query within a React component, call `useUsageStatsLast30DaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsageStatsLast30DaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsageStatsLast30DaysQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsageStatsLast30DaysQuery(baseOptions?: Apollo.QueryHookOptions<UsageStatsLast30DaysQuery, UsageStatsLast30DaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsageStatsLast30DaysQuery, UsageStatsLast30DaysQueryVariables>(UsageStatsLast30DaysDocument, options);
      }
export function useUsageStatsLast30DaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsageStatsLast30DaysQuery, UsageStatsLast30DaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsageStatsLast30DaysQuery, UsageStatsLast30DaysQueryVariables>(UsageStatsLast30DaysDocument, options);
        }
export function useUsageStatsLast30DaysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsageStatsLast30DaysQuery, UsageStatsLast30DaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsageStatsLast30DaysQuery, UsageStatsLast30DaysQueryVariables>(UsageStatsLast30DaysDocument, options);
        }
export type UsageStatsLast30DaysQueryHookResult = ReturnType<typeof useUsageStatsLast30DaysQuery>;
export type UsageStatsLast30DaysLazyQueryHookResult = ReturnType<typeof useUsageStatsLast30DaysLazyQuery>;
export type UsageStatsLast30DaysSuspenseQueryHookResult = ReturnType<typeof useUsageStatsLast30DaysSuspenseQuery>;
export type UsageStatsLast30DaysQueryResult = Apollo.QueryResult<UsageStatsLast30DaysQuery, UsageStatsLast30DaysQueryVariables>;
export const CurrentMonthUsageForecastDocument = gql`
    query CurrentMonthUsageForecast {
  currentMonthUsageForecast {
    data {
      date
      value
    }
  }
}
    `;

/**
 * __useCurrentMonthUsageForecastQuery__
 *
 * To run a query within a React component, call `useCurrentMonthUsageForecastQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentMonthUsageForecastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentMonthUsageForecastQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentMonthUsageForecastQuery(baseOptions?: Apollo.QueryHookOptions<CurrentMonthUsageForecastQuery, CurrentMonthUsageForecastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentMonthUsageForecastQuery, CurrentMonthUsageForecastQueryVariables>(CurrentMonthUsageForecastDocument, options);
      }
export function useCurrentMonthUsageForecastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentMonthUsageForecastQuery, CurrentMonthUsageForecastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentMonthUsageForecastQuery, CurrentMonthUsageForecastQueryVariables>(CurrentMonthUsageForecastDocument, options);
        }
export function useCurrentMonthUsageForecastSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentMonthUsageForecastQuery, CurrentMonthUsageForecastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentMonthUsageForecastQuery, CurrentMonthUsageForecastQueryVariables>(CurrentMonthUsageForecastDocument, options);
        }
export type CurrentMonthUsageForecastQueryHookResult = ReturnType<typeof useCurrentMonthUsageForecastQuery>;
export type CurrentMonthUsageForecastLazyQueryHookResult = ReturnType<typeof useCurrentMonthUsageForecastLazyQuery>;
export type CurrentMonthUsageForecastSuspenseQueryHookResult = ReturnType<typeof useCurrentMonthUsageForecastSuspenseQuery>;
export type CurrentMonthUsageForecastQueryResult = Apollo.QueryResult<CurrentMonthUsageForecastQuery, CurrentMonthUsageForecastQueryVariables>;
export const BigQueryUsageStatsDocument = gql`
    query BigQueryUsageStats {
  bigQueryUsageStats {
    data {
      datasetId
      tableId
      path
      totalBytesProcessed
      totalBytesBilled
      bqBilledUsd
      metabaseUsage {
        bytesProcessed
        bytesBilled
        bqBilledUsd
      }
      queryUsage {
        bytesProcessed
        bytesBilled
        bqBilledUsd
      }
    }
  }
}
    `;

/**
 * __useBigQueryUsageStatsQuery__
 *
 * To run a query within a React component, call `useBigQueryUsageStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBigQueryUsageStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBigQueryUsageStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBigQueryUsageStatsQuery(baseOptions?: Apollo.QueryHookOptions<BigQueryUsageStatsQuery, BigQueryUsageStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BigQueryUsageStatsQuery, BigQueryUsageStatsQueryVariables>(BigQueryUsageStatsDocument, options);
      }
export function useBigQueryUsageStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BigQueryUsageStatsQuery, BigQueryUsageStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BigQueryUsageStatsQuery, BigQueryUsageStatsQueryVariables>(BigQueryUsageStatsDocument, options);
        }
export function useBigQueryUsageStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BigQueryUsageStatsQuery, BigQueryUsageStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BigQueryUsageStatsQuery, BigQueryUsageStatsQueryVariables>(BigQueryUsageStatsDocument, options);
        }
export type BigQueryUsageStatsQueryHookResult = ReturnType<typeof useBigQueryUsageStatsQuery>;
export type BigQueryUsageStatsLazyQueryHookResult = ReturnType<typeof useBigQueryUsageStatsLazyQuery>;
export type BigQueryUsageStatsSuspenseQueryHookResult = ReturnType<typeof useBigQueryUsageStatsSuspenseQuery>;
export type BigQueryUsageStatsQueryResult = Apollo.QueryResult<BigQueryUsageStatsQuery, BigQueryUsageStatsQueryVariables>;
export const AllWeldPlansDocument = gql`
    query AllWeldPlans {
  allWeldPlans {
    ...WeldPlan
  }
}
    ${WeldPlanFragmentDoc}`;

/**
 * __useAllWeldPlansQuery__
 *
 * To run a query within a React component, call `useAllWeldPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllWeldPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllWeldPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllWeldPlansQuery(baseOptions?: Apollo.QueryHookOptions<AllWeldPlansQuery, AllWeldPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllWeldPlansQuery, AllWeldPlansQueryVariables>(AllWeldPlansDocument, options);
      }
export function useAllWeldPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllWeldPlansQuery, AllWeldPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllWeldPlansQuery, AllWeldPlansQueryVariables>(AllWeldPlansDocument, options);
        }
export function useAllWeldPlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllWeldPlansQuery, AllWeldPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllWeldPlansQuery, AllWeldPlansQueryVariables>(AllWeldPlansDocument, options);
        }
export type AllWeldPlansQueryHookResult = ReturnType<typeof useAllWeldPlansQuery>;
export type AllWeldPlansLazyQueryHookResult = ReturnType<typeof useAllWeldPlansLazyQuery>;
export type AllWeldPlansSuspenseQueryHookResult = ReturnType<typeof useAllWeldPlansSuspenseQuery>;
export type AllWeldPlansQueryResult = Apollo.QueryResult<AllWeldPlansQuery, AllWeldPlansQueryVariables>;
export const WeldPlanDocument = gql`
    query WeldPlan($planName: String!) {
  weldPlan(planName: $planName) {
    ...WeldPlan
  }
}
    ${WeldPlanFragmentDoc}`;

/**
 * __useWeldPlanQuery__
 *
 * To run a query within a React component, call `useWeldPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeldPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeldPlanQuery({
 *   variables: {
 *      planName: // value for 'planName'
 *   },
 * });
 */
export function useWeldPlanQuery(baseOptions: Apollo.QueryHookOptions<WeldPlanQuery, WeldPlanQueryVariables> & ({ variables: WeldPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeldPlanQuery, WeldPlanQueryVariables>(WeldPlanDocument, options);
      }
export function useWeldPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeldPlanQuery, WeldPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeldPlanQuery, WeldPlanQueryVariables>(WeldPlanDocument, options);
        }
export function useWeldPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WeldPlanQuery, WeldPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WeldPlanQuery, WeldPlanQueryVariables>(WeldPlanDocument, options);
        }
export type WeldPlanQueryHookResult = ReturnType<typeof useWeldPlanQuery>;
export type WeldPlanLazyQueryHookResult = ReturnType<typeof useWeldPlanLazyQuery>;
export type WeldPlanSuspenseQueryHookResult = ReturnType<typeof useWeldPlanSuspenseQuery>;
export type WeldPlanQueryResult = Apollo.QueryResult<WeldPlanQuery, WeldPlanQueryVariables>;
export const CurrentWeldPlanDocument = gql`
    query CurrentWeldPlan {
  currentPlan {
    ...WeldPlan
  }
}
    ${WeldPlanFragmentDoc}`;

/**
 * __useCurrentWeldPlanQuery__
 *
 * To run a query within a React component, call `useCurrentWeldPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentWeldPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentWeldPlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentWeldPlanQuery(baseOptions?: Apollo.QueryHookOptions<CurrentWeldPlanQuery, CurrentWeldPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentWeldPlanQuery, CurrentWeldPlanQueryVariables>(CurrentWeldPlanDocument, options);
      }
export function useCurrentWeldPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentWeldPlanQuery, CurrentWeldPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentWeldPlanQuery, CurrentWeldPlanQueryVariables>(CurrentWeldPlanDocument, options);
        }
export function useCurrentWeldPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentWeldPlanQuery, CurrentWeldPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentWeldPlanQuery, CurrentWeldPlanQueryVariables>(CurrentWeldPlanDocument, options);
        }
export type CurrentWeldPlanQueryHookResult = ReturnType<typeof useCurrentWeldPlanQuery>;
export type CurrentWeldPlanLazyQueryHookResult = ReturnType<typeof useCurrentWeldPlanLazyQuery>;
export type CurrentWeldPlanSuspenseQueryHookResult = ReturnType<typeof useCurrentWeldPlanSuspenseQuery>;
export type CurrentWeldPlanQueryResult = Apollo.QueryResult<CurrentWeldPlanQuery, CurrentWeldPlanQueryVariables>;
export const CurrentSubscriptionStateDocument = gql`
    query CurrentSubscriptionState {
  currentSubscriptionState {
    status
    customerId
    subscriptionId
  }
}
    `;

/**
 * __useCurrentSubscriptionStateQuery__
 *
 * To run a query within a React component, call `useCurrentSubscriptionStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentSubscriptionStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentSubscriptionStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentSubscriptionStateQuery(baseOptions?: Apollo.QueryHookOptions<CurrentSubscriptionStateQuery, CurrentSubscriptionStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentSubscriptionStateQuery, CurrentSubscriptionStateQueryVariables>(CurrentSubscriptionStateDocument, options);
      }
export function useCurrentSubscriptionStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentSubscriptionStateQuery, CurrentSubscriptionStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentSubscriptionStateQuery, CurrentSubscriptionStateQueryVariables>(CurrentSubscriptionStateDocument, options);
        }
export function useCurrentSubscriptionStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentSubscriptionStateQuery, CurrentSubscriptionStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentSubscriptionStateQuery, CurrentSubscriptionStateQueryVariables>(CurrentSubscriptionStateDocument, options);
        }
export type CurrentSubscriptionStateQueryHookResult = ReturnType<typeof useCurrentSubscriptionStateQuery>;
export type CurrentSubscriptionStateLazyQueryHookResult = ReturnType<typeof useCurrentSubscriptionStateLazyQuery>;
export type CurrentSubscriptionStateSuspenseQueryHookResult = ReturnType<typeof useCurrentSubscriptionStateSuspenseQuery>;
export type CurrentSubscriptionStateQueryResult = Apollo.QueryResult<CurrentSubscriptionStateQuery, CurrentSubscriptionStateQueryVariables>;
export const PlanLimitsStatusDocument = gql`
    query PlanLimitsStatus {
  getPlanLimitsStatus {
    isConnectionsLimitReached
    isUsersLimitReached
  }
}
    `;

/**
 * __usePlanLimitsStatusQuery__
 *
 * To run a query within a React component, call `usePlanLimitsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanLimitsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanLimitsStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlanLimitsStatusQuery(baseOptions?: Apollo.QueryHookOptions<PlanLimitsStatusQuery, PlanLimitsStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanLimitsStatusQuery, PlanLimitsStatusQueryVariables>(PlanLimitsStatusDocument, options);
      }
export function usePlanLimitsStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanLimitsStatusQuery, PlanLimitsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanLimitsStatusQuery, PlanLimitsStatusQueryVariables>(PlanLimitsStatusDocument, options);
        }
export function usePlanLimitsStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlanLimitsStatusQuery, PlanLimitsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlanLimitsStatusQuery, PlanLimitsStatusQueryVariables>(PlanLimitsStatusDocument, options);
        }
export type PlanLimitsStatusQueryHookResult = ReturnType<typeof usePlanLimitsStatusQuery>;
export type PlanLimitsStatusLazyQueryHookResult = ReturnType<typeof usePlanLimitsStatusLazyQuery>;
export type PlanLimitsStatusSuspenseQueryHookResult = ReturnType<typeof usePlanLimitsStatusSuspenseQuery>;
export type PlanLimitsStatusQueryResult = Apollo.QueryResult<PlanLimitsStatusQuery, PlanLimitsStatusQueryVariables>;
export const ValidateConnectionAdditionDocument = gql`
    query ValidateConnectionAddition($integrationId: String!) {
  validateConnectionAddition(integrationId: $integrationId) {
    valid
    errors {
      errorCode
      reason
    }
  }
}
    `;

/**
 * __useValidateConnectionAdditionQuery__
 *
 * To run a query within a React component, call `useValidateConnectionAdditionQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateConnectionAdditionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateConnectionAdditionQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useValidateConnectionAdditionQuery(baseOptions: Apollo.QueryHookOptions<ValidateConnectionAdditionQuery, ValidateConnectionAdditionQueryVariables> & ({ variables: ValidateConnectionAdditionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateConnectionAdditionQuery, ValidateConnectionAdditionQueryVariables>(ValidateConnectionAdditionDocument, options);
      }
export function useValidateConnectionAdditionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateConnectionAdditionQuery, ValidateConnectionAdditionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateConnectionAdditionQuery, ValidateConnectionAdditionQueryVariables>(ValidateConnectionAdditionDocument, options);
        }
export function useValidateConnectionAdditionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateConnectionAdditionQuery, ValidateConnectionAdditionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateConnectionAdditionQuery, ValidateConnectionAdditionQueryVariables>(ValidateConnectionAdditionDocument, options);
        }
export type ValidateConnectionAdditionQueryHookResult = ReturnType<typeof useValidateConnectionAdditionQuery>;
export type ValidateConnectionAdditionLazyQueryHookResult = ReturnType<typeof useValidateConnectionAdditionLazyQuery>;
export type ValidateConnectionAdditionSuspenseQueryHookResult = ReturnType<typeof useValidateConnectionAdditionSuspenseQuery>;
export type ValidateConnectionAdditionQueryResult = Apollo.QueryResult<ValidateConnectionAdditionQuery, ValidateConnectionAdditionQueryVariables>;
export const ValidateCurrentConnectionUsageAgainstPlanDocument = gql`
    query ValidateCurrentConnectionUsageAgainstPlan($planName: PlanName!) {
  validateCurrentConnectionUsageAgainstPlan(planName: $planName) {
    valid
    connectionCount
    maxConnections
    isConnectorLimitExceeded
    violations {
      ...ConnectorPlanViolation
    }
    dataWarehouseViolation {
      ...ConnectorPlanViolation
    }
  }
}
    ${ConnectorPlanViolationFragmentDoc}`;

/**
 * __useValidateCurrentConnectionUsageAgainstPlanQuery__
 *
 * To run a query within a React component, call `useValidateCurrentConnectionUsageAgainstPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCurrentConnectionUsageAgainstPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCurrentConnectionUsageAgainstPlanQuery({
 *   variables: {
 *      planName: // value for 'planName'
 *   },
 * });
 */
export function useValidateCurrentConnectionUsageAgainstPlanQuery(baseOptions: Apollo.QueryHookOptions<ValidateCurrentConnectionUsageAgainstPlanQuery, ValidateCurrentConnectionUsageAgainstPlanQueryVariables> & ({ variables: ValidateCurrentConnectionUsageAgainstPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateCurrentConnectionUsageAgainstPlanQuery, ValidateCurrentConnectionUsageAgainstPlanQueryVariables>(ValidateCurrentConnectionUsageAgainstPlanDocument, options);
      }
export function useValidateCurrentConnectionUsageAgainstPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateCurrentConnectionUsageAgainstPlanQuery, ValidateCurrentConnectionUsageAgainstPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateCurrentConnectionUsageAgainstPlanQuery, ValidateCurrentConnectionUsageAgainstPlanQueryVariables>(ValidateCurrentConnectionUsageAgainstPlanDocument, options);
        }
export function useValidateCurrentConnectionUsageAgainstPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateCurrentConnectionUsageAgainstPlanQuery, ValidateCurrentConnectionUsageAgainstPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateCurrentConnectionUsageAgainstPlanQuery, ValidateCurrentConnectionUsageAgainstPlanQueryVariables>(ValidateCurrentConnectionUsageAgainstPlanDocument, options);
        }
export type ValidateCurrentConnectionUsageAgainstPlanQueryHookResult = ReturnType<typeof useValidateCurrentConnectionUsageAgainstPlanQuery>;
export type ValidateCurrentConnectionUsageAgainstPlanLazyQueryHookResult = ReturnType<typeof useValidateCurrentConnectionUsageAgainstPlanLazyQuery>;
export type ValidateCurrentConnectionUsageAgainstPlanSuspenseQueryHookResult = ReturnType<typeof useValidateCurrentConnectionUsageAgainstPlanSuspenseQuery>;
export type ValidateCurrentConnectionUsageAgainstPlanQueryResult = Apollo.QueryResult<ValidateCurrentConnectionUsageAgainstPlanQuery, ValidateCurrentConnectionUsageAgainstPlanQueryVariables>;
export const BestFitPlanDocument = gql`
    query BestFitPlan {
  bestFitPlan {
    plan {
      ...WeldPlan
    }
    workspaceStats {
      numConnections
      numUsers
    }
    integrationIds
  }
}
    ${WeldPlanFragmentDoc}`;

/**
 * __useBestFitPlanQuery__
 *
 * To run a query within a React component, call `useBestFitPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useBestFitPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBestFitPlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useBestFitPlanQuery(baseOptions?: Apollo.QueryHookOptions<BestFitPlanQuery, BestFitPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BestFitPlanQuery, BestFitPlanQueryVariables>(BestFitPlanDocument, options);
      }
export function useBestFitPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BestFitPlanQuery, BestFitPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BestFitPlanQuery, BestFitPlanQueryVariables>(BestFitPlanDocument, options);
        }
export function useBestFitPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BestFitPlanQuery, BestFitPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BestFitPlanQuery, BestFitPlanQueryVariables>(BestFitPlanDocument, options);
        }
export type BestFitPlanQueryHookResult = ReturnType<typeof useBestFitPlanQuery>;
export type BestFitPlanLazyQueryHookResult = ReturnType<typeof useBestFitPlanLazyQuery>;
export type BestFitPlanSuspenseQueryHookResult = ReturnType<typeof useBestFitPlanSuspenseQuery>;
export type BestFitPlanQueryResult = Apollo.QueryResult<BestFitPlanQuery, BestFitPlanQueryVariables>;